/*
 * @Descripttion: 
 * @Author: intic
 * @Date: 2022-12-06 14:26:22
 * @LastEditors: intic
 * @LastEditTime: 2022-12-06 14:33:02
 */
export const cityList = [
  {
      re_id: 110000,
      re_parent: 100000,
      re_name: "北京",
      re_level: "1",
      children: [
          {
              re_id: 110100,
              re_parent: 110000,
              re_name: "北京市",
              re_level: "2",
              children: [
                  {
                      re_id: 110101,
                      re_parent: 110100,
                      re_name: "东城区",
                      re_level: "3"
                  },
                  {
                      re_id: 110102,
                      re_parent: 110100,
                      re_name: "西城区",
                      re_level: "3"
                  },
                  {
                      re_id: 110105,
                      re_parent: 110100,
                      re_name: "朝阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 110106,
                      re_parent: 110100,
                      re_name: "丰台区",
                      re_level: "3"
                  },
                  {
                      re_id: 110107,
                      re_parent: 110100,
                      re_name: "石景山区",
                      re_level: "3"
                  },
                  {
                      re_id: 110108,
                      re_parent: 110100,
                      re_name: "海淀区",
                      re_level: "3"
                  },
                  {
                      re_id: 110109,
                      re_parent: 110100,
                      re_name: "门头沟区",
                      re_level: "3"
                  },
                  {
                      re_id: 110111,
                      re_parent: 110100,
                      re_name: "房山区",
                      re_level: "3"
                  },
                  {
                      re_id: 110112,
                      re_parent: 110100,
                      re_name: "通州区",
                      re_level: "3"
                  },
                  {
                      re_id: 110113,
                      re_parent: 110100,
                      re_name: "顺义区",
                      re_level: "3"
                  },
                  {
                      re_id: 110114,
                      re_parent: 110100,
                      re_name: "昌平区",
                      re_level: "3"
                  },
                  {
                      re_id: 110115,
                      re_parent: 110100,
                      re_name: "大兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 110116,
                      re_parent: 110100,
                      re_name: "怀柔区",
                      re_level: "3"
                  },
                  {
                      re_id: 110117,
                      re_parent: 110100,
                      re_name: "平谷区",
                      re_level: "3"
                  },
                  {
                      re_id: 110228,
                      re_parent: 110100,
                      re_name: "密云县",
                      re_level: "3"
                  },
                  {
                      re_id: 110229,
                      re_parent: 110100,
                      re_name: "延庆县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 120000,
      re_parent: 100000,
      re_name: "天津",
      re_level: "1",
      children: [
          {
              re_id: 120100,
              re_parent: 120000,
              re_name: "天津市",
              re_level: "2",
              children: [
                  {
                      re_id: 120101,
                      re_parent: 120100,
                      re_name: "和平区",
                      re_level: "3"
                  },
                  {
                      re_id: 120102,
                      re_parent: 120100,
                      re_name: "河东区",
                      re_level: "3"
                  },
                  {
                      re_id: 120103,
                      re_parent: 120100,
                      re_name: "河西区",
                      re_level: "3"
                  },
                  {
                      re_id: 120104,
                      re_parent: 120100,
                      re_name: "南开区",
                      re_level: "3"
                  },
                  {
                      re_id: 120105,
                      re_parent: 120100,
                      re_name: "河北区",
                      re_level: "3"
                  },
                  {
                      re_id: 120106,
                      re_parent: 120100,
                      re_name: "红桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 120110,
                      re_parent: 120100,
                      re_name: "东丽区",
                      re_level: "3"
                  },
                  {
                      re_id: 120111,
                      re_parent: 120100,
                      re_name: "西青区",
                      re_level: "3"
                  },
                  {
                      re_id: 120112,
                      re_parent: 120100,
                      re_name: "津南区",
                      re_level: "3"
                  },
                  {
                      re_id: 120113,
                      re_parent: 120100,
                      re_name: "北辰区",
                      re_level: "3"
                  },
                  {
                      re_id: 120114,
                      re_parent: 120100,
                      re_name: "武清区",
                      re_level: "3"
                  },
                  {
                      re_id: 120115,
                      re_parent: 120100,
                      re_name: "宝坻区",
                      re_level: "3"
                  },
                  {
                      re_id: 120116,
                      re_parent: 120100,
                      re_name: "滨海新区",
                      re_level: "3"
                  },
                  {
                      re_id: 120221,
                      re_parent: 120100,
                      re_name: "宁河县",
                      re_level: "3"
                  },
                  {
                      re_id: 120223,
                      re_parent: 120100,
                      re_name: "静海县",
                      re_level: "3"
                  },
                  {
                      re_id: 120225,
                      re_parent: 120100,
                      re_name: "蓟县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 130000,
      re_parent: 100000,
      re_name: "河北省",
      re_level: "1",
      children: [
          {
              re_id: 130100,
              re_parent: 130000,
              re_name: "石家庄市",
              re_level: "2",
              children: [
                  {
                      re_id: 130102,
                      re_parent: 130100,
                      re_name: "长安区",
                      re_level: "3"
                  },
                  {
                      re_id: 130104,
                      re_parent: 130100,
                      re_name: "桥西区",
                      re_level: "3"
                  },
                  {
                      re_id: 130105,
                      re_parent: 130100,
                      re_name: "新华区",
                      re_level: "3"
                  },
                  {
                      re_id: 130107,
                      re_parent: 130100,
                      re_name: "井陉矿区",
                      re_level: "3"
                  },
                  {
                      re_id: 130108,
                      re_parent: 130100,
                      re_name: "裕华区",
                      re_level: "3"
                  },
                  {
                      re_id: 130109,
                      re_parent: 130100,
                      re_name: "藁城区",
                      re_level: "3"
                  },
                  {
                      re_id: 130110,
                      re_parent: 130100,
                      re_name: "鹿泉区",
                      re_level: "3"
                  },
                  {
                      re_id: 130111,
                      re_parent: 130100,
                      re_name: "栾城区",
                      re_level: "3"
                  },
                  {
                      re_id: 130121,
                      re_parent: 130100,
                      re_name: "井陉县",
                      re_level: "3"
                  },
                  {
                      re_id: 130123,
                      re_parent: 130100,
                      re_name: "正定县",
                      re_level: "3"
                  },
                  {
                      re_id: 130125,
                      re_parent: 130100,
                      re_name: "行唐县",
                      re_level: "3"
                  },
                  {
                      re_id: 130126,
                      re_parent: 130100,
                      re_name: "灵寿县",
                      re_level: "3"
                  },
                  {
                      re_id: 130127,
                      re_parent: 130100,
                      re_name: "高邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 130128,
                      re_parent: 130100,
                      re_name: "深泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 130129,
                      re_parent: 130100,
                      re_name: "赞皇县",
                      re_level: "3"
                  },
                  {
                      re_id: 130130,
                      re_parent: 130100,
                      re_name: "无极县",
                      re_level: "3"
                  },
                  {
                      re_id: 130131,
                      re_parent: 130100,
                      re_name: "平山县",
                      re_level: "3"
                  },
                  {
                      re_id: 130132,
                      re_parent: 130100,
                      re_name: "元氏县",
                      re_level: "3"
                  },
                  {
                      re_id: 130133,
                      re_parent: 130100,
                      re_name: "赵县",
                      re_level: "3"
                  },
                  {
                      re_id: 130181,
                      re_parent: 130100,
                      re_name: "辛集市",
                      re_level: "3"
                  },
                  {
                      re_id: 130183,
                      re_parent: 130100,
                      re_name: "晋州市",
                      re_level: "3"
                  },
                  {
                      re_id: 130184,
                      re_parent: 130100,
                      re_name: "新乐市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130200,
              re_parent: 130000,
              re_name: "唐山市",
              re_level: "2",
              children: [
                  {
                      re_id: 130202,
                      re_parent: 130200,
                      re_name: "路南区",
                      re_level: "3"
                  },
                  {
                      re_id: 130203,
                      re_parent: 130200,
                      re_name: "路北区",
                      re_level: "3"
                  },
                  {
                      re_id: 130204,
                      re_parent: 130200,
                      re_name: "古冶区",
                      re_level: "3"
                  },
                  {
                      re_id: 130205,
                      re_parent: 130200,
                      re_name: "开平区",
                      re_level: "3"
                  },
                  {
                      re_id: 130207,
                      re_parent: 130200,
                      re_name: "丰南区",
                      re_level: "3"
                  },
                  {
                      re_id: 130208,
                      re_parent: 130200,
                      re_name: "丰润区",
                      re_level: "3"
                  },
                  {
                      re_id: 130209,
                      re_parent: 130200,
                      re_name: "曹妃甸区",
                      re_level: "3"
                  },
                  {
                      re_id: 130223,
                      re_parent: 130200,
                      re_name: "滦县",
                      re_level: "3"
                  },
                  {
                      re_id: 130224,
                      re_parent: 130200,
                      re_name: "滦南县",
                      re_level: "3"
                  },
                  {
                      re_id: 130225,
                      re_parent: 130200,
                      re_name: "乐亭县",
                      re_level: "3"
                  },
                  {
                      re_id: 130227,
                      re_parent: 130200,
                      re_name: "迁西县",
                      re_level: "3"
                  },
                  {
                      re_id: 130229,
                      re_parent: 130200,
                      re_name: "玉田县",
                      re_level: "3"
                  },
                  {
                      re_id: 130281,
                      re_parent: 130200,
                      re_name: "遵化市",
                      re_level: "3"
                  },
                  {
                      re_id: 130283,
                      re_parent: 130200,
                      re_name: "迁安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130300,
              re_parent: 130000,
              re_name: "秦皇岛市",
              re_level: "2",
              children: [
                  {
                      re_id: 130302,
                      re_parent: 130300,
                      re_name: "海港区",
                      re_level: "3"
                  },
                  {
                      re_id: 130303,
                      re_parent: 130300,
                      re_name: "山海关区",
                      re_level: "3"
                  },
                  {
                      re_id: 130304,
                      re_parent: 130300,
                      re_name: "北戴河区",
                      re_level: "3"
                  },
                  {
                      re_id: 130321,
                      re_parent: 130300,
                      re_name: "青龙满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 130322,
                      re_parent: 130300,
                      re_name: "昌黎县",
                      re_level: "3"
                  },
                  {
                      re_id: 130323,
                      re_parent: 130300,
                      re_name: "抚宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 130324,
                      re_parent: 130300,
                      re_name: "卢龙县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130400,
              re_parent: 130000,
              re_name: "邯郸市",
              re_level: "2",
              children: [
                  {
                      re_id: 130402,
                      re_parent: 130400,
                      re_name: "邯山区",
                      re_level: "3"
                  },
                  {
                      re_id: 130403,
                      re_parent: 130400,
                      re_name: "丛台区",
                      re_level: "3"
                  },
                  {
                      re_id: 130404,
                      re_parent: 130400,
                      re_name: "复兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 130406,
                      re_parent: 130400,
                      re_name: "峰峰矿区",
                      re_level: "3"
                  },
                  {
                      re_id: 130421,
                      re_parent: 130400,
                      re_name: "邯郸县",
                      re_level: "3"
                  },
                  {
                      re_id: 130423,
                      re_parent: 130400,
                      re_name: "临漳县",
                      re_level: "3"
                  },
                  {
                      re_id: 130424,
                      re_parent: 130400,
                      re_name: "成安县",
                      re_level: "3"
                  },
                  {
                      re_id: 130425,
                      re_parent: 130400,
                      re_name: "大名县",
                      re_level: "3"
                  },
                  {
                      re_id: 130426,
                      re_parent: 130400,
                      re_name: "涉县",
                      re_level: "3"
                  },
                  {
                      re_id: 130427,
                      re_parent: 130400,
                      re_name: "磁县",
                      re_level: "3"
                  },
                  {
                      re_id: 130428,
                      re_parent: 130400,
                      re_name: "肥乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 130429,
                      re_parent: 130400,
                      re_name: "永年县",
                      re_level: "3"
                  },
                  {
                      re_id: 130430,
                      re_parent: 130400,
                      re_name: "邱县",
                      re_level: "3"
                  },
                  {
                      re_id: 130431,
                      re_parent: 130400,
                      re_name: "鸡泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 130432,
                      re_parent: 130400,
                      re_name: "广平县",
                      re_level: "3"
                  },
                  {
                      re_id: 130433,
                      re_parent: 130400,
                      re_name: "馆陶县",
                      re_level: "3"
                  },
                  {
                      re_id: 130434,
                      re_parent: 130400,
                      re_name: "魏县",
                      re_level: "3"
                  },
                  {
                      re_id: 130435,
                      re_parent: 130400,
                      re_name: "曲周县",
                      re_level: "3"
                  },
                  {
                      re_id: 130481,
                      re_parent: 130400,
                      re_name: "武安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130500,
              re_parent: 130000,
              re_name: "邢台市",
              re_level: "2",
              children: [
                  {
                      re_id: 130502,
                      re_parent: 130500,
                      re_name: "桥东区",
                      re_level: "3"
                  },
                  {
                      re_id: 130503,
                      re_parent: 130500,
                      re_name: "桥西区",
                      re_level: "3"
                  },
                  {
                      re_id: 130521,
                      re_parent: 130500,
                      re_name: "邢台县",
                      re_level: "3"
                  },
                  {
                      re_id: 130522,
                      re_parent: 130500,
                      re_name: "临城县",
                      re_level: "3"
                  },
                  {
                      re_id: 130523,
                      re_parent: 130500,
                      re_name: "内丘县",
                      re_level: "3"
                  },
                  {
                      re_id: 130524,
                      re_parent: 130500,
                      re_name: "柏乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 130525,
                      re_parent: 130500,
                      re_name: "隆尧县",
                      re_level: "3"
                  },
                  {
                      re_id: 130526,
                      re_parent: 130500,
                      re_name: "任县",
                      re_level: "3"
                  },
                  {
                      re_id: 130527,
                      re_parent: 130500,
                      re_name: "南和县",
                      re_level: "3"
                  },
                  {
                      re_id: 130528,
                      re_parent: 130500,
                      re_name: "宁晋县",
                      re_level: "3"
                  },
                  {
                      re_id: 130529,
                      re_parent: 130500,
                      re_name: "巨鹿县",
                      re_level: "3"
                  },
                  {
                      re_id: 130530,
                      re_parent: 130500,
                      re_name: "新河县",
                      re_level: "3"
                  },
                  {
                      re_id: 130531,
                      re_parent: 130500,
                      re_name: "广宗县",
                      re_level: "3"
                  },
                  {
                      re_id: 130532,
                      re_parent: 130500,
                      re_name: "平乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 130533,
                      re_parent: 130500,
                      re_name: "威县",
                      re_level: "3"
                  },
                  {
                      re_id: 130534,
                      re_parent: 130500,
                      re_name: "清河县",
                      re_level: "3"
                  },
                  {
                      re_id: 130535,
                      re_parent: 130500,
                      re_name: "临西县",
                      re_level: "3"
                  },
                  {
                      re_id: 130581,
                      re_parent: 130500,
                      re_name: "南宫市",
                      re_level: "3"
                  },
                  {
                      re_id: 130582,
                      re_parent: 130500,
                      re_name: "沙河市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130600,
              re_parent: 130000,
              re_name: "保定市",
              re_level: "2",
              children: [
                  {
                      re_id: 130602,
                      re_parent: 130600,
                      re_name: "新市区",
                      re_level: "3"
                  },
                  {
                      re_id: 130603,
                      re_parent: 130600,
                      re_name: "北市区",
                      re_level: "3"
                  },
                  {
                      re_id: 130604,
                      re_parent: 130600,
                      re_name: "南市区",
                      re_level: "3"
                  },
                  {
                      re_id: 130621,
                      re_parent: 130600,
                      re_name: "满城县",
                      re_level: "3"
                  },
                  {
                      re_id: 130622,
                      re_parent: 130600,
                      re_name: "清苑县",
                      re_level: "3"
                  },
                  {
                      re_id: 130623,
                      re_parent: 130600,
                      re_name: "涞水县",
                      re_level: "3"
                  },
                  {
                      re_id: 130624,
                      re_parent: 130600,
                      re_name: "阜平县",
                      re_level: "3"
                  },
                  {
                      re_id: 130625,
                      re_parent: 130600,
                      re_name: "徐水县",
                      re_level: "3"
                  },
                  {
                      re_id: 130626,
                      re_parent: 130600,
                      re_name: "定兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 130627,
                      re_parent: 130600,
                      re_name: "唐县",
                      re_level: "3"
                  },
                  {
                      re_id: 130628,
                      re_parent: 130600,
                      re_name: "高阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 130629,
                      re_parent: 130600,
                      re_name: "容城县",
                      re_level: "3"
                  },
                  {
                      re_id: 130630,
                      re_parent: 130600,
                      re_name: "涞源县",
                      re_level: "3"
                  },
                  {
                      re_id: 130631,
                      re_parent: 130600,
                      re_name: "望都县",
                      re_level: "3"
                  },
                  {
                      re_id: 130632,
                      re_parent: 130600,
                      re_name: "安新县",
                      re_level: "3"
                  },
                  {
                      re_id: 130633,
                      re_parent: 130600,
                      re_name: "易县",
                      re_level: "3"
                  },
                  {
                      re_id: 130634,
                      re_parent: 130600,
                      re_name: "曲阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 130635,
                      re_parent: 130600,
                      re_name: "蠡县",
                      re_level: "3"
                  },
                  {
                      re_id: 130636,
                      re_parent: 130600,
                      re_name: "顺平县",
                      re_level: "3"
                  },
                  {
                      re_id: 130637,
                      re_parent: 130600,
                      re_name: "博野县",
                      re_level: "3"
                  },
                  {
                      re_id: 130638,
                      re_parent: 130600,
                      re_name: "雄县",
                      re_level: "3"
                  },
                  {
                      re_id: 130681,
                      re_parent: 130600,
                      re_name: "涿州市",
                      re_level: "3"
                  },
                  {
                      re_id: 130682,
                      re_parent: 130600,
                      re_name: "定州市",
                      re_level: "3"
                  },
                  {
                      re_id: 130683,
                      re_parent: 130600,
                      re_name: "安国市",
                      re_level: "3"
                  },
                  {
                      re_id: 130684,
                      re_parent: 130600,
                      re_name: "高碑店市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130700,
              re_parent: 130000,
              re_name: "张家口市",
              re_level: "2",
              children: [
                  {
                      re_id: 130702,
                      re_parent: 130700,
                      re_name: "桥东区",
                      re_level: "3"
                  },
                  {
                      re_id: 130703,
                      re_parent: 130700,
                      re_name: "桥西区",
                      re_level: "3"
                  },
                  {
                      re_id: 130705,
                      re_parent: 130700,
                      re_name: "宣化区",
                      re_level: "3"
                  },
                  {
                      re_id: 130706,
                      re_parent: 130700,
                      re_name: "下花园区",
                      re_level: "3"
                  },
                  {
                      re_id: 130721,
                      re_parent: 130700,
                      re_name: "宣化县",
                      re_level: "3"
                  },
                  {
                      re_id: 130722,
                      re_parent: 130700,
                      re_name: "张北县",
                      re_level: "3"
                  },
                  {
                      re_id: 130723,
                      re_parent: 130700,
                      re_name: "康保县",
                      re_level: "3"
                  },
                  {
                      re_id: 130724,
                      re_parent: 130700,
                      re_name: "沽源县",
                      re_level: "3"
                  },
                  {
                      re_id: 130725,
                      re_parent: 130700,
                      re_name: "尚义县",
                      re_level: "3"
                  },
                  {
                      re_id: 130726,
                      re_parent: 130700,
                      re_name: "蔚县",
                      re_level: "3"
                  },
                  {
                      re_id: 130727,
                      re_parent: 130700,
                      re_name: "阳原县",
                      re_level: "3"
                  },
                  {
                      re_id: 130728,
                      re_parent: 130700,
                      re_name: "怀安县",
                      re_level: "3"
                  },
                  {
                      re_id: 130729,
                      re_parent: 130700,
                      re_name: "万全县",
                      re_level: "3"
                  },
                  {
                      re_id: 130730,
                      re_parent: 130700,
                      re_name: "怀来县",
                      re_level: "3"
                  },
                  {
                      re_id: 130731,
                      re_parent: 130700,
                      re_name: "涿鹿县",
                      re_level: "3"
                  },
                  {
                      re_id: 130732,
                      re_parent: 130700,
                      re_name: "赤城县",
                      re_level: "3"
                  },
                  {
                      re_id: 130733,
                      re_parent: 130700,
                      re_name: "崇礼县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130800,
              re_parent: 130000,
              re_name: "承德市",
              re_level: "2",
              children: [
                  {
                      re_id: 130802,
                      re_parent: 130800,
                      re_name: "双桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 130803,
                      re_parent: 130800,
                      re_name: "双滦区",
                      re_level: "3"
                  },
                  {
                      re_id: 130804,
                      re_parent: 130800,
                      re_name: "鹰手营子矿区",
                      re_level: "3"
                  },
                  {
                      re_id: 130821,
                      re_parent: 130800,
                      re_name: "承德县",
                      re_level: "3"
                  },
                  {
                      re_id: 130822,
                      re_parent: 130800,
                      re_name: "兴隆县",
                      re_level: "3"
                  },
                  {
                      re_id: 130823,
                      re_parent: 130800,
                      re_name: "平泉县",
                      re_level: "3"
                  },
                  {
                      re_id: 130824,
                      re_parent: 130800,
                      re_name: "滦平县",
                      re_level: "3"
                  },
                  {
                      re_id: 130825,
                      re_parent: 130800,
                      re_name: "隆化县",
                      re_level: "3"
                  },
                  {
                      re_id: 130826,
                      re_parent: 130800,
                      re_name: "丰宁满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 130827,
                      re_parent: 130800,
                      re_name: "宽城满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 130828,
                      re_parent: 130800,
                      re_name: "围场满族蒙古族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 130900,
              re_parent: 130000,
              re_name: "沧州市",
              re_level: "2",
              children: [
                  {
                      re_id: 130902,
                      re_parent: 130900,
                      re_name: "新华区",
                      re_level: "3"
                  },
                  {
                      re_id: 130903,
                      re_parent: 130900,
                      re_name: "运河区",
                      re_level: "3"
                  },
                  {
                      re_id: 130921,
                      re_parent: 130900,
                      re_name: "沧县",
                      re_level: "3"
                  },
                  {
                      re_id: 130922,
                      re_parent: 130900,
                      re_name: "青县",
                      re_level: "3"
                  },
                  {
                      re_id: 130923,
                      re_parent: 130900,
                      re_name: "东光县",
                      re_level: "3"
                  },
                  {
                      re_id: 130924,
                      re_parent: 130900,
                      re_name: "海兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 130925,
                      re_parent: 130900,
                      re_name: "盐山县",
                      re_level: "3"
                  },
                  {
                      re_id: 130926,
                      re_parent: 130900,
                      re_name: "肃宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 130927,
                      re_parent: 130900,
                      re_name: "南皮县",
                      re_level: "3"
                  },
                  {
                      re_id: 130928,
                      re_parent: 130900,
                      re_name: "吴桥县",
                      re_level: "3"
                  },
                  {
                      re_id: 130929,
                      re_parent: 130900,
                      re_name: "献县",
                      re_level: "3"
                  },
                  {
                      re_id: 130930,
                      re_parent: 130900,
                      re_name: "孟村回族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 130981,
                      re_parent: 130900,
                      re_name: "泊头市",
                      re_level: "3"
                  },
                  {
                      re_id: 130982,
                      re_parent: 130900,
                      re_name: "任丘市",
                      re_level: "3"
                  },
                  {
                      re_id: 130983,
                      re_parent: 130900,
                      re_name: "黄骅市",
                      re_level: "3"
                  },
                  {
                      re_id: 130984,
                      re_parent: 130900,
                      re_name: "河间市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 131000,
              re_parent: 130000,
              re_name: "廊坊市",
              re_level: "2",
              children: [
                  {
                      re_id: 131002,
                      re_parent: 131000,
                      re_name: "安次区",
                      re_level: "3"
                  },
                  {
                      re_id: 131003,
                      re_parent: 131000,
                      re_name: "广阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 131022,
                      re_parent: 131000,
                      re_name: "固安县",
                      re_level: "3"
                  },
                  {
                      re_id: 131023,
                      re_parent: 131000,
                      re_name: "永清县",
                      re_level: "3"
                  },
                  {
                      re_id: 131024,
                      re_parent: 131000,
                      re_name: "香河县",
                      re_level: "3"
                  },
                  {
                      re_id: 131025,
                      re_parent: 131000,
                      re_name: "大城县",
                      re_level: "3"
                  },
                  {
                      re_id: 131026,
                      re_parent: 131000,
                      re_name: "文安县",
                      re_level: "3"
                  },
                  {
                      re_id: 131028,
                      re_parent: 131000,
                      re_name: "大厂回族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 131081,
                      re_parent: 131000,
                      re_name: "霸州市",
                      re_level: "3"
                  },
                  {
                      re_id: 131082,
                      re_parent: 131000,
                      re_name: "三河市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 131100,
              re_parent: 130000,
              re_name: "衡水市",
              re_level: "2",
              children: [
                  {
                      re_id: 131102,
                      re_parent: 131100,
                      re_name: "桃城区",
                      re_level: "3"
                  },
                  {
                      re_id: 131121,
                      re_parent: 131100,
                      re_name: "枣强县",
                      re_level: "3"
                  },
                  {
                      re_id: 131122,
                      re_parent: 131100,
                      re_name: "武邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 131123,
                      re_parent: 131100,
                      re_name: "武强县",
                      re_level: "3"
                  },
                  {
                      re_id: 131124,
                      re_parent: 131100,
                      re_name: "饶阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 131125,
                      re_parent: 131100,
                      re_name: "安平县",
                      re_level: "3"
                  },
                  {
                      re_id: 131126,
                      re_parent: 131100,
                      re_name: "故城县",
                      re_level: "3"
                  },
                  {
                      re_id: 131127,
                      re_parent: 131100,
                      re_name: "景县",
                      re_level: "3"
                  },
                  {
                      re_id: 131128,
                      re_parent: 131100,
                      re_name: "阜城县",
                      re_level: "3"
                  },
                  {
                      re_id: 131181,
                      re_parent: 131100,
                      re_name: "冀州市",
                      re_level: "3"
                  },
                  {
                      re_id: 131182,
                      re_parent: 131100,
                      re_name: "深州市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 140000,
      re_parent: 100000,
      re_name: "山西省",
      re_level: "1",
      children: [
          {
              re_id: 140100,
              re_parent: 140000,
              re_name: "太原市",
              re_level: "2",
              children: [
                  {
                      re_id: 140105,
                      re_parent: 140100,
                      re_name: "小店区",
                      re_level: "3"
                  },
                  {
                      re_id: 140106,
                      re_parent: 140100,
                      re_name: "迎泽区",
                      re_level: "3"
                  },
                  {
                      re_id: 140107,
                      re_parent: 140100,
                      re_name: "杏花岭区",
                      re_level: "3"
                  },
                  {
                      re_id: 140108,
                      re_parent: 140100,
                      re_name: "尖草坪区",
                      re_level: "3"
                  },
                  {
                      re_id: 140109,
                      re_parent: 140100,
                      re_name: "万柏林区",
                      re_level: "3"
                  },
                  {
                      re_id: 140110,
                      re_parent: 140100,
                      re_name: "晋源区",
                      re_level: "3"
                  },
                  {
                      re_id: 140121,
                      re_parent: 140100,
                      re_name: "清徐县",
                      re_level: "3"
                  },
                  {
                      re_id: 140122,
                      re_parent: 140100,
                      re_name: "阳曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 140123,
                      re_parent: 140100,
                      re_name: "娄烦县",
                      re_level: "3"
                  },
                  {
                      re_id: 140181,
                      re_parent: 140100,
                      re_name: "古交市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140200,
              re_parent: 140000,
              re_name: "大同市",
              re_level: "2",
              children: [
                  {
                      re_id: 140202,
                      re_parent: 140200,
                      re_name: "城区",
                      re_level: "3"
                  },
                  {
                      re_id: 140203,
                      re_parent: 140200,
                      re_name: "矿区",
                      re_level: "3"
                  },
                  {
                      re_id: 140211,
                      re_parent: 140200,
                      re_name: "南郊区",
                      re_level: "3"
                  },
                  {
                      re_id: 140212,
                      re_parent: 140200,
                      re_name: "新荣区",
                      re_level: "3"
                  },
                  {
                      re_id: 140221,
                      re_parent: 140200,
                      re_name: "阳高县",
                      re_level: "3"
                  },
                  {
                      re_id: 140222,
                      re_parent: 140200,
                      re_name: "天镇县",
                      re_level: "3"
                  },
                  {
                      re_id: 140223,
                      re_parent: 140200,
                      re_name: "广灵县",
                      re_level: "3"
                  },
                  {
                      re_id: 140224,
                      re_parent: 140200,
                      re_name: "灵丘县",
                      re_level: "3"
                  },
                  {
                      re_id: 140225,
                      re_parent: 140200,
                      re_name: "浑源县",
                      re_level: "3"
                  },
                  {
                      re_id: 140226,
                      re_parent: 140200,
                      re_name: "左云县",
                      re_level: "3"
                  },
                  {
                      re_id: 140227,
                      re_parent: 140200,
                      re_name: "大同县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140300,
              re_parent: 140000,
              re_name: "阳泉市",
              re_level: "2",
              children: [
                  {
                      re_id: 140302,
                      re_parent: 140300,
                      re_name: "城区",
                      re_level: "3"
                  },
                  {
                      re_id: 140303,
                      re_parent: 140300,
                      re_name: "矿区",
                      re_level: "3"
                  },
                  {
                      re_id: 140311,
                      re_parent: 140300,
                      re_name: "郊区",
                      re_level: "3"
                  },
                  {
                      re_id: 140321,
                      re_parent: 140300,
                      re_name: "平定县",
                      re_level: "3"
                  },
                  {
                      re_id: 140322,
                      re_parent: 140300,
                      re_name: "盂县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140400,
              re_parent: 140000,
              re_name: "长治市",
              re_level: "2",
              children: [
                  {
                      re_id: 140402,
                      re_parent: 140400,
                      re_name: "城区",
                      re_level: "3"
                  },
                  {
                      re_id: 140411,
                      re_parent: 140400,
                      re_name: "郊区",
                      re_level: "3"
                  },
                  {
                      re_id: 140421,
                      re_parent: 140400,
                      re_name: "长治县",
                      re_level: "3"
                  },
                  {
                      re_id: 140423,
                      re_parent: 140400,
                      re_name: "襄垣县",
                      re_level: "3"
                  },
                  {
                      re_id: 140424,
                      re_parent: 140400,
                      re_name: "屯留县",
                      re_level: "3"
                  },
                  {
                      re_id: 140425,
                      re_parent: 140400,
                      re_name: "平顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 140426,
                      re_parent: 140400,
                      re_name: "黎城县",
                      re_level: "3"
                  },
                  {
                      re_id: 140427,
                      re_parent: 140400,
                      re_name: "壶关县",
                      re_level: "3"
                  },
                  {
                      re_id: 140428,
                      re_parent: 140400,
                      re_name: "长子县",
                      re_level: "3"
                  },
                  {
                      re_id: 140429,
                      re_parent: 140400,
                      re_name: "武乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 140430,
                      re_parent: 140400,
                      re_name: "沁县",
                      re_level: "3"
                  },
                  {
                      re_id: 140431,
                      re_parent: 140400,
                      re_name: "沁源县",
                      re_level: "3"
                  },
                  {
                      re_id: 140481,
                      re_parent: 140400,
                      re_name: "潞城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140500,
              re_parent: 140000,
              re_name: "晋城市",
              re_level: "2",
              children: [
                  {
                      re_id: 140502,
                      re_parent: 140500,
                      re_name: "城区",
                      re_level: "3"
                  },
                  {
                      re_id: 140521,
                      re_parent: 140500,
                      re_name: "沁水县",
                      re_level: "3"
                  },
                  {
                      re_id: 140522,
                      re_parent: 140500,
                      re_name: "阳城县",
                      re_level: "3"
                  },
                  {
                      re_id: 140524,
                      re_parent: 140500,
                      re_name: "陵川县",
                      re_level: "3"
                  },
                  {
                      re_id: 140525,
                      re_parent: 140500,
                      re_name: "泽州县",
                      re_level: "3"
                  },
                  {
                      re_id: 140581,
                      re_parent: 140500,
                      re_name: "高平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140600,
              re_parent: 140000,
              re_name: "朔州市",
              re_level: "2",
              children: [
                  {
                      re_id: 140602,
                      re_parent: 140600,
                      re_name: "朔城区",
                      re_level: "3"
                  },
                  {
                      re_id: 140603,
                      re_parent: 140600,
                      re_name: "平鲁区",
                      re_level: "3"
                  },
                  {
                      re_id: 140621,
                      re_parent: 140600,
                      re_name: "山阴县",
                      re_level: "3"
                  },
                  {
                      re_id: 140622,
                      re_parent: 140600,
                      re_name: "应县",
                      re_level: "3"
                  },
                  {
                      re_id: 140623,
                      re_parent: 140600,
                      re_name: "右玉县",
                      re_level: "3"
                  },
                  {
                      re_id: 140624,
                      re_parent: 140600,
                      re_name: "怀仁县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140700,
              re_parent: 140000,
              re_name: "晋中市",
              re_level: "2",
              children: [
                  {
                      re_id: 140702,
                      re_parent: 140700,
                      re_name: "榆次区",
                      re_level: "3"
                  },
                  {
                      re_id: 140721,
                      re_parent: 140700,
                      re_name: "榆社县",
                      re_level: "3"
                  },
                  {
                      re_id: 140722,
                      re_parent: 140700,
                      re_name: "左权县",
                      re_level: "3"
                  },
                  {
                      re_id: 140723,
                      re_parent: 140700,
                      re_name: "和顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 140724,
                      re_parent: 140700,
                      re_name: "昔阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 140725,
                      re_parent: 140700,
                      re_name: "寿阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 140726,
                      re_parent: 140700,
                      re_name: "太谷县",
                      re_level: "3"
                  },
                  {
                      re_id: 140727,
                      re_parent: 140700,
                      re_name: "祁县",
                      re_level: "3"
                  },
                  {
                      re_id: 140728,
                      re_parent: 140700,
                      re_name: "平遥县",
                      re_level: "3"
                  },
                  {
                      re_id: 140729,
                      re_parent: 140700,
                      re_name: "灵石县",
                      re_level: "3"
                  },
                  {
                      re_id: 140781,
                      re_parent: 140700,
                      re_name: "介休市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140800,
              re_parent: 140000,
              re_name: "运城市",
              re_level: "2",
              children: [
                  {
                      re_id: 140802,
                      re_parent: 140800,
                      re_name: "盐湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 140821,
                      re_parent: 140800,
                      re_name: "临猗县",
                      re_level: "3"
                  },
                  {
                      re_id: 140822,
                      re_parent: 140800,
                      re_name: "万荣县",
                      re_level: "3"
                  },
                  {
                      re_id: 140823,
                      re_parent: 140800,
                      re_name: "闻喜县",
                      re_level: "3"
                  },
                  {
                      re_id: 140824,
                      re_parent: 140800,
                      re_name: "稷山县",
                      re_level: "3"
                  },
                  {
                      re_id: 140825,
                      re_parent: 140800,
                      re_name: "新绛县",
                      re_level: "3"
                  },
                  {
                      re_id: 140826,
                      re_parent: 140800,
                      re_name: "绛县",
                      re_level: "3"
                  },
                  {
                      re_id: 140827,
                      re_parent: 140800,
                      re_name: "垣曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 140828,
                      re_parent: 140800,
                      re_name: "夏县",
                      re_level: "3"
                  },
                  {
                      re_id: 140829,
                      re_parent: 140800,
                      re_name: "平陆县",
                      re_level: "3"
                  },
                  {
                      re_id: 140830,
                      re_parent: 140800,
                      re_name: "芮城县",
                      re_level: "3"
                  },
                  {
                      re_id: 140881,
                      re_parent: 140800,
                      re_name: "永济市",
                      re_level: "3"
                  },
                  {
                      re_id: 140882,
                      re_parent: 140800,
                      re_name: "河津市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 140900,
              re_parent: 140000,
              re_name: "忻州市",
              re_level: "2",
              children: [
                  {
                      re_id: 140902,
                      re_parent: 140900,
                      re_name: "忻府区",
                      re_level: "3"
                  },
                  {
                      re_id: 140921,
                      re_parent: 140900,
                      re_name: "定襄县",
                      re_level: "3"
                  },
                  {
                      re_id: 140922,
                      re_parent: 140900,
                      re_name: "五台县",
                      re_level: "3"
                  },
                  {
                      re_id: 140923,
                      re_parent: 140900,
                      re_name: "代县",
                      re_level: "3"
                  },
                  {
                      re_id: 140924,
                      re_parent: 140900,
                      re_name: "繁峙县",
                      re_level: "3"
                  },
                  {
                      re_id: 140925,
                      re_parent: 140900,
                      re_name: "宁武县",
                      re_level: "3"
                  },
                  {
                      re_id: 140926,
                      re_parent: 140900,
                      re_name: "静乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 140927,
                      re_parent: 140900,
                      re_name: "神池县",
                      re_level: "3"
                  },
                  {
                      re_id: 140928,
                      re_parent: 140900,
                      re_name: "五寨县",
                      re_level: "3"
                  },
                  {
                      re_id: 140929,
                      re_parent: 140900,
                      re_name: "岢岚县",
                      re_level: "3"
                  },
                  {
                      re_id: 140930,
                      re_parent: 140900,
                      re_name: "河曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 140931,
                      re_parent: 140900,
                      re_name: "保德县",
                      re_level: "3"
                  },
                  {
                      re_id: 140932,
                      re_parent: 140900,
                      re_name: "偏关县",
                      re_level: "3"
                  },
                  {
                      re_id: 140981,
                      re_parent: 140900,
                      re_name: "原平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 141000,
              re_parent: 140000,
              re_name: "临汾市",
              re_level: "2",
              children: [
                  {
                      re_id: 141002,
                      re_parent: 141000,
                      re_name: "尧都区",
                      re_level: "3"
                  },
                  {
                      re_id: 141021,
                      re_parent: 141000,
                      re_name: "曲沃县",
                      re_level: "3"
                  },
                  {
                      re_id: 141022,
                      re_parent: 141000,
                      re_name: "翼城县",
                      re_level: "3"
                  },
                  {
                      re_id: 141023,
                      re_parent: 141000,
                      re_name: "襄汾县",
                      re_level: "3"
                  },
                  {
                      re_id: 141024,
                      re_parent: 141000,
                      re_name: "洪洞县",
                      re_level: "3"
                  },
                  {
                      re_id: 141025,
                      re_parent: 141000,
                      re_name: "古县",
                      re_level: "3"
                  },
                  {
                      re_id: 141026,
                      re_parent: 141000,
                      re_name: "安泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 141027,
                      re_parent: 141000,
                      re_name: "浮山县",
                      re_level: "3"
                  },
                  {
                      re_id: 141028,
                      re_parent: 141000,
                      re_name: "吉县",
                      re_level: "3"
                  },
                  {
                      re_id: 141029,
                      re_parent: 141000,
                      re_name: "乡宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 141030,
                      re_parent: 141000,
                      re_name: "大宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 141031,
                      re_parent: 141000,
                      re_name: "隰县",
                      re_level: "3"
                  },
                  {
                      re_id: 141032,
                      re_parent: 141000,
                      re_name: "永和县",
                      re_level: "3"
                  },
                  {
                      re_id: 141033,
                      re_parent: 141000,
                      re_name: "蒲县",
                      re_level: "3"
                  },
                  {
                      re_id: 141034,
                      re_parent: 141000,
                      re_name: "汾西县",
                      re_level: "3"
                  },
                  {
                      re_id: 141081,
                      re_parent: 141000,
                      re_name: "侯马市",
                      re_level: "3"
                  },
                  {
                      re_id: 141082,
                      re_parent: 141000,
                      re_name: "霍州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 141100,
              re_parent: 140000,
              re_name: "吕梁市",
              re_level: "2",
              children: [
                  {
                      re_id: 141102,
                      re_parent: 141100,
                      re_name: "离石区",
                      re_level: "3"
                  },
                  {
                      re_id: 141121,
                      re_parent: 141100,
                      re_name: "文水县",
                      re_level: "3"
                  },
                  {
                      re_id: 141122,
                      re_parent: 141100,
                      re_name: "交城县",
                      re_level: "3"
                  },
                  {
                      re_id: 141123,
                      re_parent: 141100,
                      re_name: "兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 141124,
                      re_parent: 141100,
                      re_name: "临县",
                      re_level: "3"
                  },
                  {
                      re_id: 141125,
                      re_parent: 141100,
                      re_name: "柳林县",
                      re_level: "3"
                  },
                  {
                      re_id: 141126,
                      re_parent: 141100,
                      re_name: "石楼县",
                      re_level: "3"
                  },
                  {
                      re_id: 141127,
                      re_parent: 141100,
                      re_name: "岚县",
                      re_level: "3"
                  },
                  {
                      re_id: 141128,
                      re_parent: 141100,
                      re_name: "方山县",
                      re_level: "3"
                  },
                  {
                      re_id: 141129,
                      re_parent: 141100,
                      re_name: "中阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 141130,
                      re_parent: 141100,
                      re_name: "交口县",
                      re_level: "3"
                  },
                  {
                      re_id: 141181,
                      re_parent: 141100,
                      re_name: "孝义市",
                      re_level: "3"
                  },
                  {
                      re_id: 141182,
                      re_parent: 141100,
                      re_name: "汾阳市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 150000,
      re_parent: 100000,
      re_name: "内蒙古自治区",
      re_level: "1",
      children: [
          {
              re_id: 150100,
              re_parent: 150000,
              re_name: "呼和浩特市",
              re_level: "2",
              children: [
                  {
                      re_id: 150102,
                      re_parent: 150100,
                      re_name: "新城区",
                      re_level: "3"
                  },
                  {
                      re_id: 150103,
                      re_parent: 150100,
                      re_name: "回民区",
                      re_level: "3"
                  },
                  {
                      re_id: 150104,
                      re_parent: 150100,
                      re_name: "玉泉区",
                      re_level: "3"
                  },
                  {
                      re_id: 150105,
                      re_parent: 150100,
                      re_name: "赛罕区",
                      re_level: "3"
                  },
                  {
                      re_id: 150121,
                      re_parent: 150100,
                      re_name: "土默特左旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150122,
                      re_parent: 150100,
                      re_name: "托克托县",
                      re_level: "3"
                  },
                  {
                      re_id: 150123,
                      re_parent: 150100,
                      re_name: "和林格尔县",
                      re_level: "3"
                  },
                  {
                      re_id: 150124,
                      re_parent: 150100,
                      re_name: "清水河县",
                      re_level: "3"
                  },
                  {
                      re_id: 150125,
                      re_parent: 150100,
                      re_name: "武川县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150200,
              re_parent: 150000,
              re_name: "包头市",
              re_level: "2",
              children: [
                  {
                      re_id: 150202,
                      re_parent: 150200,
                      re_name: "东河区",
                      re_level: "3"
                  },
                  {
                      re_id: 150203,
                      re_parent: 150200,
                      re_name: "昆都仑区",
                      re_level: "3"
                  },
                  {
                      re_id: 150204,
                      re_parent: 150200,
                      re_name: "青山区",
                      re_level: "3"
                  },
                  {
                      re_id: 150205,
                      re_parent: 150200,
                      re_name: "石拐区",
                      re_level: "3"
                  },
                  {
                      re_id: 150206,
                      re_parent: 150200,
                      re_name: "白云鄂博矿区",
                      re_level: "3"
                  },
                  {
                      re_id: 150207,
                      re_parent: 150200,
                      re_name: "九原区",
                      re_level: "3"
                  },
                  {
                      re_id: 150221,
                      re_parent: 150200,
                      re_name: "土默特右旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150222,
                      re_parent: 150200,
                      re_name: "固阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 150223,
                      re_parent: 150200,
                      re_name: "达尔罕茂明安联合旗",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150300,
              re_parent: 150000,
              re_name: "乌海市",
              re_level: "2",
              children: [
                  {
                      re_id: 150302,
                      re_parent: 150300,
                      re_name: "海勃湾区",
                      re_level: "3"
                  },
                  {
                      re_id: 150303,
                      re_parent: 150300,
                      re_name: "海南区",
                      re_level: "3"
                  },
                  {
                      re_id: 150304,
                      re_parent: 150300,
                      re_name: "乌达区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150400,
              re_parent: 150000,
              re_name: "赤峰市",
              re_level: "2",
              children: [
                  {
                      re_id: 150402,
                      re_parent: 150400,
                      re_name: "红山区",
                      re_level: "3"
                  },
                  {
                      re_id: 150403,
                      re_parent: 150400,
                      re_name: "元宝山区",
                      re_level: "3"
                  },
                  {
                      re_id: 150404,
                      re_parent: 150400,
                      re_name: "松山区",
                      re_level: "3"
                  },
                  {
                      re_id: 150421,
                      re_parent: 150400,
                      re_name: "阿鲁科尔沁旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150422,
                      re_parent: 150400,
                      re_name: "巴林左旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150423,
                      re_parent: 150400,
                      re_name: "巴林右旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150424,
                      re_parent: 150400,
                      re_name: "林西县",
                      re_level: "3"
                  },
                  {
                      re_id: 150425,
                      re_parent: 150400,
                      re_name: "克什克腾旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150426,
                      re_parent: 150400,
                      re_name: "翁牛特旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150428,
                      re_parent: 150400,
                      re_name: "喀喇沁旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150429,
                      re_parent: 150400,
                      re_name: "宁城县",
                      re_level: "3"
                  },
                  {
                      re_id: 150430,
                      re_parent: 150400,
                      re_name: "敖汉旗",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150500,
              re_parent: 150000,
              re_name: "通辽市",
              re_level: "2",
              children: [
                  {
                      re_id: 150502,
                      re_parent: 150500,
                      re_name: "科尔沁区",
                      re_level: "3"
                  },
                  {
                      re_id: 150521,
                      re_parent: 150500,
                      re_name: "科尔沁左翼中旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150522,
                      re_parent: 150500,
                      re_name: "科尔沁左翼后旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150523,
                      re_parent: 150500,
                      re_name: "开鲁县",
                      re_level: "3"
                  },
                  {
                      re_id: 150524,
                      re_parent: 150500,
                      re_name: "库伦旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150525,
                      re_parent: 150500,
                      re_name: "奈曼旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150526,
                      re_parent: 150500,
                      re_name: "扎鲁特旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150581,
                      re_parent: 150500,
                      re_name: "霍林郭勒市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150600,
              re_parent: 150000,
              re_name: "鄂尔多斯市",
              re_level: "2",
              children: [
                  {
                      re_id: 150602,
                      re_parent: 150600,
                      re_name: "东胜区",
                      re_level: "3"
                  },
                  {
                      re_id: 150621,
                      re_parent: 150600,
                      re_name: "达拉特旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150622,
                      re_parent: 150600,
                      re_name: "准格尔旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150623,
                      re_parent: 150600,
                      re_name: "鄂托克前旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150624,
                      re_parent: 150600,
                      re_name: "鄂托克旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150625,
                      re_parent: 150600,
                      re_name: "杭锦旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150626,
                      re_parent: 150600,
                      re_name: "乌审旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150627,
                      re_parent: 150600,
                      re_name: "伊金霍洛旗",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150700,
              re_parent: 150000,
              re_name: "呼伦贝尔市",
              re_level: "2",
              children: [
                  {
                      re_id: 150702,
                      re_parent: 150700,
                      re_name: "海拉尔区",
                      re_level: "3"
                  },
                  {
                      re_id: 150703,
                      re_parent: 150700,
                      re_name: "扎赉诺尔区",
                      re_level: "3"
                  },
                  {
                      re_id: 150721,
                      re_parent: 150700,
                      re_name: "阿荣旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150722,
                      re_parent: 150700,
                      re_name: "莫力达瓦达斡尔族自治旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150723,
                      re_parent: 150700,
                      re_name: "鄂伦春自治旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150724,
                      re_parent: 150700,
                      re_name: "鄂温克族自治旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150725,
                      re_parent: 150700,
                      re_name: "陈巴尔虎旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150726,
                      re_parent: 150700,
                      re_name: "新巴尔虎左旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150727,
                      re_parent: 150700,
                      re_name: "新巴尔虎右旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150781,
                      re_parent: 150700,
                      re_name: "满洲里市",
                      re_level: "3"
                  },
                  {
                      re_id: 150782,
                      re_parent: 150700,
                      re_name: "牙克石市",
                      re_level: "3"
                  },
                  {
                      re_id: 150783,
                      re_parent: 150700,
                      re_name: "扎兰屯市",
                      re_level: "3"
                  },
                  {
                      re_id: 150784,
                      re_parent: 150700,
                      re_name: "额尔古纳市",
                      re_level: "3"
                  },
                  {
                      re_id: 150785,
                      re_parent: 150700,
                      re_name: "根河市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150800,
              re_parent: 150000,
              re_name: "巴彦淖尔市",
              re_level: "2",
              children: [
                  {
                      re_id: 150802,
                      re_parent: 150800,
                      re_name: "临河区",
                      re_level: "3"
                  },
                  {
                      re_id: 150821,
                      re_parent: 150800,
                      re_name: "五原县",
                      re_level: "3"
                  },
                  {
                      re_id: 150822,
                      re_parent: 150800,
                      re_name: "磴口县",
                      re_level: "3"
                  },
                  {
                      re_id: 150823,
                      re_parent: 150800,
                      re_name: "乌拉特前旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150824,
                      re_parent: 150800,
                      re_name: "乌拉特中旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150825,
                      re_parent: 150800,
                      re_name: "乌拉特后旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150826,
                      re_parent: 150800,
                      re_name: "杭锦后旗",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 150900,
              re_parent: 150000,
              re_name: "乌兰察布市",
              re_level: "2",
              children: [
                  {
                      re_id: 150902,
                      re_parent: 150900,
                      re_name: "集宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 150921,
                      re_parent: 150900,
                      re_name: "卓资县",
                      re_level: "3"
                  },
                  {
                      re_id: 150922,
                      re_parent: 150900,
                      re_name: "化德县",
                      re_level: "3"
                  },
                  {
                      re_id: 150923,
                      re_parent: 150900,
                      re_name: "商都县",
                      re_level: "3"
                  },
                  {
                      re_id: 150924,
                      re_parent: 150900,
                      re_name: "兴和县",
                      re_level: "3"
                  },
                  {
                      re_id: 150925,
                      re_parent: 150900,
                      re_name: "凉城县",
                      re_level: "3"
                  },
                  {
                      re_id: 150926,
                      re_parent: 150900,
                      re_name: "察哈尔右翼前旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150927,
                      re_parent: 150900,
                      re_name: "察哈尔右翼中旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150928,
                      re_parent: 150900,
                      re_name: "察哈尔右翼后旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150929,
                      re_parent: 150900,
                      re_name: "四子王旗",
                      re_level: "3"
                  },
                  {
                      re_id: 150981,
                      re_parent: 150900,
                      re_name: "丰镇市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 152200,
              re_parent: 150000,
              re_name: "兴安盟",
              re_level: "2",
              children: [
                  {
                      re_id: 152201,
                      re_parent: 152200,
                      re_name: "乌兰浩特市",
                      re_level: "3"
                  },
                  {
                      re_id: 152202,
                      re_parent: 152200,
                      re_name: "阿尔山市",
                      re_level: "3"
                  },
                  {
                      re_id: 152221,
                      re_parent: 152200,
                      re_name: "科尔沁右翼前旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152222,
                      re_parent: 152200,
                      re_name: "科尔沁右翼中旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152223,
                      re_parent: 152200,
                      re_name: "扎赉特旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152224,
                      re_parent: 152200,
                      re_name: "突泉县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 152500,
              re_parent: 150000,
              re_name: "锡林郭勒盟",
              re_level: "2",
              children: [
                  {
                      re_id: 152501,
                      re_parent: 152500,
                      re_name: "二连浩特市",
                      re_level: "3"
                  },
                  {
                      re_id: 152502,
                      re_parent: 152500,
                      re_name: "锡林浩特市",
                      re_level: "3"
                  },
                  {
                      re_id: 152522,
                      re_parent: 152500,
                      re_name: "阿巴嘎旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152523,
                      re_parent: 152500,
                      re_name: "苏尼特左旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152524,
                      re_parent: 152500,
                      re_name: "苏尼特右旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152525,
                      re_parent: 152500,
                      re_name: "东乌珠穆沁旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152526,
                      re_parent: 152500,
                      re_name: "西乌珠穆沁旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152527,
                      re_parent: 152500,
                      re_name: "太仆寺旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152528,
                      re_parent: 152500,
                      re_name: "镶黄旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152529,
                      re_parent: 152500,
                      re_name: "正镶白旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152530,
                      re_parent: 152500,
                      re_name: "正蓝旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152531,
                      re_parent: 152500,
                      re_name: "多伦县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 152900,
              re_parent: 150000,
              re_name: "阿拉善盟",
              re_level: "2",
              children: [
                  {
                      re_id: 152921,
                      re_parent: 152900,
                      re_name: "阿拉善左旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152922,
                      re_parent: 152900,
                      re_name: "阿拉善右旗",
                      re_level: "3"
                  },
                  {
                      re_id: 152923,
                      re_parent: 152900,
                      re_name: "额济纳旗",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 210000,
      re_parent: 100000,
      re_name: "辽宁省",
      re_level: "1",
      children: [
          {
              re_id: 210100,
              re_parent: 210000,
              re_name: "沈阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 210102,
                      re_parent: 210100,
                      re_name: "和平区",
                      re_level: "3"
                  },
                  {
                      re_id: 210103,
                      re_parent: 210100,
                      re_name: "沈河区",
                      re_level: "3"
                  },
                  {
                      re_id: 210104,
                      re_parent: 210100,
                      re_name: "大东区",
                      re_level: "3"
                  },
                  {
                      re_id: 210105,
                      re_parent: 210100,
                      re_name: "皇姑区",
                      re_level: "3"
                  },
                  {
                      re_id: 210106,
                      re_parent: 210100,
                      re_name: "铁西区",
                      re_level: "3"
                  },
                  {
                      re_id: 210111,
                      re_parent: 210100,
                      re_name: "苏家屯区",
                      re_level: "3"
                  },
                  {
                      re_id: 210112,
                      re_parent: 210100,
                      re_name: "浑南区",
                      re_level: "3"
                  },
                  {
                      re_id: 210113,
                      re_parent: 210100,
                      re_name: "沈北新区",
                      re_level: "3"
                  },
                  {
                      re_id: 210114,
                      re_parent: 210100,
                      re_name: "于洪区",
                      re_level: "3"
                  },
                  {
                      re_id: 210122,
                      re_parent: 210100,
                      re_name: "辽中县",
                      re_level: "3"
                  },
                  {
                      re_id: 210123,
                      re_parent: 210100,
                      re_name: "康平县",
                      re_level: "3"
                  },
                  {
                      re_id: 210124,
                      re_parent: 210100,
                      re_name: "法库县",
                      re_level: "3"
                  },
                  {
                      re_id: 210181,
                      re_parent: 210100,
                      re_name: "新民市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210200,
              re_parent: 210000,
              re_name: "大连市",
              re_level: "2",
              children: [
                  {
                      re_id: 210202,
                      re_parent: 210200,
                      re_name: "中山区",
                      re_level: "3"
                  },
                  {
                      re_id: 210203,
                      re_parent: 210200,
                      re_name: "西岗区",
                      re_level: "3"
                  },
                  {
                      re_id: 210204,
                      re_parent: 210200,
                      re_name: "沙河口区",
                      re_level: "3"
                  },
                  {
                      re_id: 210211,
                      re_parent: 210200,
                      re_name: "甘井子区",
                      re_level: "3"
                  },
                  {
                      re_id: 210212,
                      re_parent: 210200,
                      re_name: "旅顺口区",
                      re_level: "3"
                  },
                  {
                      re_id: 210213,
                      re_parent: 210200,
                      re_name: "金州区",
                      re_level: "3"
                  },
                  {
                      re_id: 210224,
                      re_parent: 210200,
                      re_name: "长海县",
                      re_level: "3"
                  },
                  {
                      re_id: 210281,
                      re_parent: 210200,
                      re_name: "瓦房店市",
                      re_level: "3"
                  },
                  {
                      re_id: 210282,
                      re_parent: 210200,
                      re_name: "普兰店市",
                      re_level: "3"
                  },
                  {
                      re_id: 210283,
                      re_parent: 210200,
                      re_name: "庄河市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210300,
              re_parent: 210000,
              re_name: "鞍山市",
              re_level: "2",
              children: [
                  {
                      re_id: 210302,
                      re_parent: 210300,
                      re_name: "铁东区",
                      re_level: "3"
                  },
                  {
                      re_id: 210303,
                      re_parent: 210300,
                      re_name: "铁西区",
                      re_level: "3"
                  },
                  {
                      re_id: 210304,
                      re_parent: 210300,
                      re_name: "立山区",
                      re_level: "3"
                  },
                  {
                      re_id: 210311,
                      re_parent: 210300,
                      re_name: "千山区",
                      re_level: "3"
                  },
                  {
                      re_id: 210321,
                      re_parent: 210300,
                      re_name: "台安县",
                      re_level: "3"
                  },
                  {
                      re_id: 210323,
                      re_parent: 210300,
                      re_name: "岫岩满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 210381,
                      re_parent: 210300,
                      re_name: "海城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210400,
              re_parent: 210000,
              re_name: "抚顺市",
              re_level: "2",
              children: [
                  {
                      re_id: 210402,
                      re_parent: 210400,
                      re_name: "新抚区",
                      re_level: "3"
                  },
                  {
                      re_id: 210403,
                      re_parent: 210400,
                      re_name: "东洲区",
                      re_level: "3"
                  },
                  {
                      re_id: 210404,
                      re_parent: 210400,
                      re_name: "望花区",
                      re_level: "3"
                  },
                  {
                      re_id: 210411,
                      re_parent: 210400,
                      re_name: "顺城区",
                      re_level: "3"
                  },
                  {
                      re_id: 210421,
                      re_parent: 210400,
                      re_name: "抚顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 210422,
                      re_parent: 210400,
                      re_name: "新宾满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 210423,
                      re_parent: 210400,
                      re_name: "清原满族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210500,
              re_parent: 210000,
              re_name: "本溪市",
              re_level: "2",
              children: [
                  {
                      re_id: 210502,
                      re_parent: 210500,
                      re_name: "平山区",
                      re_level: "3"
                  },
                  {
                      re_id: 210503,
                      re_parent: 210500,
                      re_name: "溪湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 210504,
                      re_parent: 210500,
                      re_name: "明山区",
                      re_level: "3"
                  },
                  {
                      re_id: 210505,
                      re_parent: 210500,
                      re_name: "南芬区",
                      re_level: "3"
                  },
                  {
                      re_id: 210521,
                      re_parent: 210500,
                      re_name: "本溪满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 210522,
                      re_parent: 210500,
                      re_name: "桓仁满族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210600,
              re_parent: 210000,
              re_name: "丹东市",
              re_level: "2",
              children: [
                  {
                      re_id: 210602,
                      re_parent: 210600,
                      re_name: "元宝区",
                      re_level: "3"
                  },
                  {
                      re_id: 210603,
                      re_parent: 210600,
                      re_name: "振兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 210604,
                      re_parent: 210600,
                      re_name: "振安区",
                      re_level: "3"
                  },
                  {
                      re_id: 210624,
                      re_parent: 210600,
                      re_name: "宽甸满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 210681,
                      re_parent: 210600,
                      re_name: "东港市",
                      re_level: "3"
                  },
                  {
                      re_id: 210682,
                      re_parent: 210600,
                      re_name: "凤城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210700,
              re_parent: 210000,
              re_name: "锦州市",
              re_level: "2",
              children: [
                  {
                      re_id: 210702,
                      re_parent: 210700,
                      re_name: "古塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 210703,
                      re_parent: 210700,
                      re_name: "凌河区",
                      re_level: "3"
                  },
                  {
                      re_id: 210711,
                      re_parent: 210700,
                      re_name: "太和区",
                      re_level: "3"
                  },
                  {
                      re_id: 210726,
                      re_parent: 210700,
                      re_name: "黑山县",
                      re_level: "3"
                  },
                  {
                      re_id: 210727,
                      re_parent: 210700,
                      re_name: "义县",
                      re_level: "3"
                  },
                  {
                      re_id: 210781,
                      re_parent: 210700,
                      re_name: "凌海市",
                      re_level: "3"
                  },
                  {
                      re_id: 210782,
                      re_parent: 210700,
                      re_name: "北镇市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210800,
              re_parent: 210000,
              re_name: "营口市",
              re_level: "2",
              children: [
                  {
                      re_id: 210802,
                      re_parent: 210800,
                      re_name: "站前区",
                      re_level: "3"
                  },
                  {
                      re_id: 210803,
                      re_parent: 210800,
                      re_name: "西市区",
                      re_level: "3"
                  },
                  {
                      re_id: 210804,
                      re_parent: 210800,
                      re_name: "鲅鱼圈区",
                      re_level: "3"
                  },
                  {
                      re_id: 210811,
                      re_parent: 210800,
                      re_name: "老边区",
                      re_level: "3"
                  },
                  {
                      re_id: 210881,
                      re_parent: 210800,
                      re_name: "盖州市",
                      re_level: "3"
                  },
                  {
                      re_id: 210882,
                      re_parent: 210800,
                      re_name: "大石桥市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 210900,
              re_parent: 210000,
              re_name: "阜新市",
              re_level: "2",
              children: [
                  {
                      re_id: 210902,
                      re_parent: 210900,
                      re_name: "海州区",
                      re_level: "3"
                  },
                  {
                      re_id: 210903,
                      re_parent: 210900,
                      re_name: "新邱区",
                      re_level: "3"
                  },
                  {
                      re_id: 210904,
                      re_parent: 210900,
                      re_name: "太平区",
                      re_level: "3"
                  },
                  {
                      re_id: 210905,
                      re_parent: 210900,
                      re_name: "清河门区",
                      re_level: "3"
                  },
                  {
                      re_id: 210911,
                      re_parent: 210900,
                      re_name: "细河区",
                      re_level: "3"
                  },
                  {
                      re_id: 210921,
                      re_parent: 210900,
                      re_name: "阜新蒙古族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 210922,
                      re_parent: 210900,
                      re_name: "彰武县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 211000,
              re_parent: 210000,
              re_name: "辽阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 211002,
                      re_parent: 211000,
                      re_name: "白塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 211003,
                      re_parent: 211000,
                      re_name: "文圣区",
                      re_level: "3"
                  },
                  {
                      re_id: 211004,
                      re_parent: 211000,
                      re_name: "宏伟区",
                      re_level: "3"
                  },
                  {
                      re_id: 211005,
                      re_parent: 211000,
                      re_name: "弓长岭区",
                      re_level: "3"
                  },
                  {
                      re_id: 211011,
                      re_parent: 211000,
                      re_name: "太子河区",
                      re_level: "3"
                  },
                  {
                      re_id: 211021,
                      re_parent: 211000,
                      re_name: "辽阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 211081,
                      re_parent: 211000,
                      re_name: "灯塔市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 211100,
              re_parent: 210000,
              re_name: "盘锦市",
              re_level: "2",
              children: [
                  {
                      re_id: 211102,
                      re_parent: 211100,
                      re_name: "双台子区",
                      re_level: "3"
                  },
                  {
                      re_id: 211103,
                      re_parent: 211100,
                      re_name: "兴隆台区",
                      re_level: "3"
                  },
                  {
                      re_id: 211121,
                      re_parent: 211100,
                      re_name: "大洼县",
                      re_level: "3"
                  },
                  {
                      re_id: 211122,
                      re_parent: 211100,
                      re_name: "盘山县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 211200,
              re_parent: 210000,
              re_name: "铁岭市",
              re_level: "2",
              children: [
                  {
                      re_id: 211202,
                      re_parent: 211200,
                      re_name: "银州区",
                      re_level: "3"
                  },
                  {
                      re_id: 211204,
                      re_parent: 211200,
                      re_name: "清河区",
                      re_level: "3"
                  },
                  {
                      re_id: 211221,
                      re_parent: 211200,
                      re_name: "铁岭县",
                      re_level: "3"
                  },
                  {
                      re_id: 211223,
                      re_parent: 211200,
                      re_name: "西丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 211224,
                      re_parent: 211200,
                      re_name: "昌图县",
                      re_level: "3"
                  },
                  {
                      re_id: 211281,
                      re_parent: 211200,
                      re_name: "调兵山市",
                      re_level: "3"
                  },
                  {
                      re_id: 211282,
                      re_parent: 211200,
                      re_name: "开原市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 211300,
              re_parent: 210000,
              re_name: "朝阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 211302,
                      re_parent: 211300,
                      re_name: "双塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 211303,
                      re_parent: 211300,
                      re_name: "龙城区",
                      re_level: "3"
                  },
                  {
                      re_id: 211321,
                      re_parent: 211300,
                      re_name: "朝阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 211322,
                      re_parent: 211300,
                      re_name: "建平县",
                      re_level: "3"
                  },
                  {
                      re_id: 211324,
                      re_parent: 211300,
                      re_name: "喀喇沁左翼蒙古族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 211381,
                      re_parent: 211300,
                      re_name: "北票市",
                      re_level: "3"
                  },
                  {
                      re_id: 211382,
                      re_parent: 211300,
                      re_name: "凌源市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 211400,
              re_parent: 210000,
              re_name: "葫芦岛市",
              re_level: "2",
              children: [
                  {
                      re_id: 211402,
                      re_parent: 211400,
                      re_name: "连山区",
                      re_level: "3"
                  },
                  {
                      re_id: 211403,
                      re_parent: 211400,
                      re_name: "龙港区",
                      re_level: "3"
                  },
                  {
                      re_id: 211404,
                      re_parent: 211400,
                      re_name: "南票区",
                      re_level: "3"
                  },
                  {
                      re_id: 211421,
                      re_parent: 211400,
                      re_name: "绥中县",
                      re_level: "3"
                  },
                  {
                      re_id: 211422,
                      re_parent: 211400,
                      re_name: "建昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 211481,
                      re_parent: 211400,
                      re_name: "兴城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 211500,
              re_parent: 210000,
              re_name: "金普新区",
              re_level: "2",
              children: [
                  {
                      re_id: 211501,
                      re_parent: 211500,
                      re_name: "金州新区",
                      re_level: "3"
                  },
                  {
                      re_id: 211502,
                      re_parent: 211500,
                      re_name: "普湾新区",
                      re_level: "3"
                  },
                  {
                      re_id: 211503,
                      re_parent: 211500,
                      re_name: "保税区",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 220000,
      re_parent: 100000,
      re_name: "吉林省",
      re_level: "1",
      children: [
          {
              re_id: 220100,
              re_parent: 220000,
              re_name: "长春市",
              re_level: "2",
              children: [
                  {
                      re_id: 220102,
                      re_parent: 220100,
                      re_name: "南关区",
                      re_level: "3"
                  },
                  {
                      re_id: 220103,
                      re_parent: 220100,
                      re_name: "宽城区",
                      re_level: "3"
                  },
                  {
                      re_id: 220104,
                      re_parent: 220100,
                      re_name: "朝阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 220105,
                      re_parent: 220100,
                      re_name: "二道区",
                      re_level: "3"
                  },
                  {
                      re_id: 220106,
                      re_parent: 220100,
                      re_name: "绿园区",
                      re_level: "3"
                  },
                  {
                      re_id: 220112,
                      re_parent: 220100,
                      re_name: "双阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 220113,
                      re_parent: 220100,
                      re_name: "九台区",
                      re_level: "3"
                  },
                  {
                      re_id: 220122,
                      re_parent: 220100,
                      re_name: "农安县",
                      re_level: "3"
                  },
                  {
                      re_id: 220182,
                      re_parent: 220100,
                      re_name: "榆树市",
                      re_level: "3"
                  },
                  {
                      re_id: 220183,
                      re_parent: 220100,
                      re_name: "德惠市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220200,
              re_parent: 220000,
              re_name: "吉林市",
              re_level: "2",
              children: [
                  {
                      re_id: 220202,
                      re_parent: 220200,
                      re_name: "昌邑区",
                      re_level: "3"
                  },
                  {
                      re_id: 220203,
                      re_parent: 220200,
                      re_name: "龙潭区",
                      re_level: "3"
                  },
                  {
                      re_id: 220204,
                      re_parent: 220200,
                      re_name: "船营区",
                      re_level: "3"
                  },
                  {
                      re_id: 220211,
                      re_parent: 220200,
                      re_name: "丰满区",
                      re_level: "3"
                  },
                  {
                      re_id: 220221,
                      re_parent: 220200,
                      re_name: "永吉县",
                      re_level: "3"
                  },
                  {
                      re_id: 220281,
                      re_parent: 220200,
                      re_name: "蛟河市",
                      re_level: "3"
                  },
                  {
                      re_id: 220282,
                      re_parent: 220200,
                      re_name: "桦甸市",
                      re_level: "3"
                  },
                  {
                      re_id: 220283,
                      re_parent: 220200,
                      re_name: "舒兰市",
                      re_level: "3"
                  },
                  {
                      re_id: 220284,
                      re_parent: 220200,
                      re_name: "磐石市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220300,
              re_parent: 220000,
              re_name: "四平市",
              re_level: "2",
              children: [
                  {
                      re_id: 220302,
                      re_parent: 220300,
                      re_name: "铁西区",
                      re_level: "3"
                  },
                  {
                      re_id: 220303,
                      re_parent: 220300,
                      re_name: "铁东区",
                      re_level: "3"
                  },
                  {
                      re_id: 220322,
                      re_parent: 220300,
                      re_name: "梨树县",
                      re_level: "3"
                  },
                  {
                      re_id: 220323,
                      re_parent: 220300,
                      re_name: "伊通满族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 220381,
                      re_parent: 220300,
                      re_name: "公主岭市",
                      re_level: "3"
                  },
                  {
                      re_id: 220382,
                      re_parent: 220300,
                      re_name: "双辽市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220400,
              re_parent: 220000,
              re_name: "辽源市",
              re_level: "2",
              children: [
                  {
                      re_id: 220402,
                      re_parent: 220400,
                      re_name: "龙山区",
                      re_level: "3"
                  },
                  {
                      re_id: 220403,
                      re_parent: 220400,
                      re_name: "西安区",
                      re_level: "3"
                  },
                  {
                      re_id: 220421,
                      re_parent: 220400,
                      re_name: "东丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 220422,
                      re_parent: 220400,
                      re_name: "东辽县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220500,
              re_parent: 220000,
              re_name: "通化市",
              re_level: "2",
              children: [
                  {
                      re_id: 220502,
                      re_parent: 220500,
                      re_name: "东昌区",
                      re_level: "3"
                  },
                  {
                      re_id: 220503,
                      re_parent: 220500,
                      re_name: "二道江区",
                      re_level: "3"
                  },
                  {
                      re_id: 220521,
                      re_parent: 220500,
                      re_name: "通化县",
                      re_level: "3"
                  },
                  {
                      re_id: 220523,
                      re_parent: 220500,
                      re_name: "辉南县",
                      re_level: "3"
                  },
                  {
                      re_id: 220524,
                      re_parent: 220500,
                      re_name: "柳河县",
                      re_level: "3"
                  },
                  {
                      re_id: 220581,
                      re_parent: 220500,
                      re_name: "梅河口市",
                      re_level: "3"
                  },
                  {
                      re_id: 220582,
                      re_parent: 220500,
                      re_name: "集安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220600,
              re_parent: 220000,
              re_name: "白山市",
              re_level: "2",
              children: [
                  {
                      re_id: 220602,
                      re_parent: 220600,
                      re_name: "浑江区",
                      re_level: "3"
                  },
                  {
                      re_id: 220605,
                      re_parent: 220600,
                      re_name: "江源区",
                      re_level: "3"
                  },
                  {
                      re_id: 220621,
                      re_parent: 220600,
                      re_name: "抚松县",
                      re_level: "3"
                  },
                  {
                      re_id: 220622,
                      re_parent: 220600,
                      re_name: "靖宇县",
                      re_level: "3"
                  },
                  {
                      re_id: 220623,
                      re_parent: 220600,
                      re_name: "长白朝鲜族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 220681,
                      re_parent: 220600,
                      re_name: "临江市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220700,
              re_parent: 220000,
              re_name: "松原市",
              re_level: "2",
              children: [
                  {
                      re_id: 220702,
                      re_parent: 220700,
                      re_name: "宁江区",
                      re_level: "3"
                  },
                  {
                      re_id: 220721,
                      re_parent: 220700,
                      re_name: "前郭尔罗斯蒙古族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 220722,
                      re_parent: 220700,
                      re_name: "长岭县",
                      re_level: "3"
                  },
                  {
                      re_id: 220723,
                      re_parent: 220700,
                      re_name: "乾安县",
                      re_level: "3"
                  },
                  {
                      re_id: 220781,
                      re_parent: 220700,
                      re_name: "扶余市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 220800,
              re_parent: 220000,
              re_name: "白城市",
              re_level: "2",
              children: [
                  {
                      re_id: 220802,
                      re_parent: 220800,
                      re_name: "洮北区",
                      re_level: "3"
                  },
                  {
                      re_id: 220821,
                      re_parent: 220800,
                      re_name: "镇赉县",
                      re_level: "3"
                  },
                  {
                      re_id: 220822,
                      re_parent: 220800,
                      re_name: "通榆县",
                      re_level: "3"
                  },
                  {
                      re_id: 220881,
                      re_parent: 220800,
                      re_name: "洮南市",
                      re_level: "3"
                  },
                  {
                      re_id: 220882,
                      re_parent: 220800,
                      re_name: "大安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 222400,
              re_parent: 220000,
              re_name: "延边朝鲜族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 222401,
                      re_parent: 222400,
                      re_name: "延吉市",
                      re_level: "3"
                  },
                  {
                      re_id: 222402,
                      re_parent: 222400,
                      re_name: "图们市",
                      re_level: "3"
                  },
                  {
                      re_id: 222403,
                      re_parent: 222400,
                      re_name: "敦化市",
                      re_level: "3"
                  },
                  {
                      re_id: 222404,
                      re_parent: 222400,
                      re_name: "珲春市",
                      re_level: "3"
                  },
                  {
                      re_id: 222405,
                      re_parent: 222400,
                      re_name: "龙井市",
                      re_level: "3"
                  },
                  {
                      re_id: 222406,
                      re_parent: 222400,
                      re_name: "和龙市",
                      re_level: "3"
                  },
                  {
                      re_id: 222424,
                      re_parent: 222400,
                      re_name: "汪清县",
                      re_level: "3"
                  },
                  {
                      re_id: 222426,
                      re_parent: 222400,
                      re_name: "安图县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 230000,
      re_parent: 100000,
      re_name: "黑龙江省",
      re_level: "1",
      children: [
          {
              re_id: 230100,
              re_parent: 230000,
              re_name: "哈尔滨市",
              re_level: "2",
              children: [
                  {
                      re_id: 230102,
                      re_parent: 230100,
                      re_name: "道里区",
                      re_level: "3"
                  },
                  {
                      re_id: 230103,
                      re_parent: 230100,
                      re_name: "南岗区",
                      re_level: "3"
                  },
                  {
                      re_id: 230104,
                      re_parent: 230100,
                      re_name: "道外区",
                      re_level: "3"
                  },
                  {
                      re_id: 230108,
                      re_parent: 230100,
                      re_name: "平房区",
                      re_level: "3"
                  },
                  {
                      re_id: 230109,
                      re_parent: 230100,
                      re_name: "松北区",
                      re_level: "3"
                  },
                  {
                      re_id: 230110,
                      re_parent: 230100,
                      re_name: "香坊区",
                      re_level: "3"
                  },
                  {
                      re_id: 230111,
                      re_parent: 230100,
                      re_name: "呼兰区",
                      re_level: "3"
                  },
                  {
                      re_id: 230112,
                      re_parent: 230100,
                      re_name: "阿城区",
                      re_level: "3"
                  },
                  {
                      re_id: 230113,
                      re_parent: 230100,
                      re_name: "双城区",
                      re_level: "3"
                  },
                  {
                      re_id: 230123,
                      re_parent: 230100,
                      re_name: "依兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 230124,
                      re_parent: 230100,
                      re_name: "方正县",
                      re_level: "3"
                  },
                  {
                      re_id: 230125,
                      re_parent: 230100,
                      re_name: "宾县",
                      re_level: "3"
                  },
                  {
                      re_id: 230126,
                      re_parent: 230100,
                      re_name: "巴彦县",
                      re_level: "3"
                  },
                  {
                      re_id: 230127,
                      re_parent: 230100,
                      re_name: "木兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 230128,
                      re_parent: 230100,
                      re_name: "通河县",
                      re_level: "3"
                  },
                  {
                      re_id: 230129,
                      re_parent: 230100,
                      re_name: "延寿县",
                      re_level: "3"
                  },
                  {
                      re_id: 230183,
                      re_parent: 230100,
                      re_name: "尚志市",
                      re_level: "3"
                  },
                  {
                      re_id: 230184,
                      re_parent: 230100,
                      re_name: "五常市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230200,
              re_parent: 230000,
              re_name: "齐齐哈尔市",
              re_level: "2",
              children: [
                  {
                      re_id: 230202,
                      re_parent: 230200,
                      re_name: "龙沙区",
                      re_level: "3"
                  },
                  {
                      re_id: 230203,
                      re_parent: 230200,
                      re_name: "建华区",
                      re_level: "3"
                  },
                  {
                      re_id: 230204,
                      re_parent: 230200,
                      re_name: "铁锋区",
                      re_level: "3"
                  },
                  {
                      re_id: 230205,
                      re_parent: 230200,
                      re_name: "昂昂溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 230206,
                      re_parent: 230200,
                      re_name: "富拉尔基区",
                      re_level: "3"
                  },
                  {
                      re_id: 230207,
                      re_parent: 230200,
                      re_name: "碾子山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230208,
                      re_parent: 230200,
                      re_name: "梅里斯达斡尔族区",
                      re_level: "3"
                  },
                  {
                      re_id: 230221,
                      re_parent: 230200,
                      re_name: "龙江县",
                      re_level: "3"
                  },
                  {
                      re_id: 230223,
                      re_parent: 230200,
                      re_name: "依安县",
                      re_level: "3"
                  },
                  {
                      re_id: 230224,
                      re_parent: 230200,
                      re_name: "泰来县",
                      re_level: "3"
                  },
                  {
                      re_id: 230225,
                      re_parent: 230200,
                      re_name: "甘南县",
                      re_level: "3"
                  },
                  {
                      re_id: 230227,
                      re_parent: 230200,
                      re_name: "富裕县",
                      re_level: "3"
                  },
                  {
                      re_id: 230229,
                      re_parent: 230200,
                      re_name: "克山县",
                      re_level: "3"
                  },
                  {
                      re_id: 230230,
                      re_parent: 230200,
                      re_name: "克东县",
                      re_level: "3"
                  },
                  {
                      re_id: 230231,
                      re_parent: 230200,
                      re_name: "拜泉县",
                      re_level: "3"
                  },
                  {
                      re_id: 230281,
                      re_parent: 230200,
                      re_name: "讷河市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230300,
              re_parent: 230000,
              re_name: "鸡西市",
              re_level: "2",
              children: [
                  {
                      re_id: 230302,
                      re_parent: 230300,
                      re_name: "鸡冠区",
                      re_level: "3"
                  },
                  {
                      re_id: 230303,
                      re_parent: 230300,
                      re_name: "恒山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230304,
                      re_parent: 230300,
                      re_name: "滴道区",
                      re_level: "3"
                  },
                  {
                      re_id: 230305,
                      re_parent: 230300,
                      re_name: "梨树区",
                      re_level: "3"
                  },
                  {
                      re_id: 230306,
                      re_parent: 230300,
                      re_name: "城子河区",
                      re_level: "3"
                  },
                  {
                      re_id: 230307,
                      re_parent: 230300,
                      re_name: "麻山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230321,
                      re_parent: 230300,
                      re_name: "鸡东县",
                      re_level: "3"
                  },
                  {
                      re_id: 230381,
                      re_parent: 230300,
                      re_name: "虎林市",
                      re_level: "3"
                  },
                  {
                      re_id: 230382,
                      re_parent: 230300,
                      re_name: "密山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230400,
              re_parent: 230000,
              re_name: "鹤岗市",
              re_level: "2",
              children: [
                  {
                      re_id: 230402,
                      re_parent: 230400,
                      re_name: "向阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 230403,
                      re_parent: 230400,
                      re_name: "工农区",
                      re_level: "3"
                  },
                  {
                      re_id: 230404,
                      re_parent: 230400,
                      re_name: "南山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230405,
                      re_parent: 230400,
                      re_name: "兴安区",
                      re_level: "3"
                  },
                  {
                      re_id: 230406,
                      re_parent: 230400,
                      re_name: "东山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230407,
                      re_parent: 230400,
                      re_name: "兴山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230421,
                      re_parent: 230400,
                      re_name: "萝北县",
                      re_level: "3"
                  },
                  {
                      re_id: 230422,
                      re_parent: 230400,
                      re_name: "绥滨县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230500,
              re_parent: 230000,
              re_name: "双鸭山市",
              re_level: "2",
              children: [
                  {
                      re_id: 230502,
                      re_parent: 230500,
                      re_name: "尖山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230503,
                      re_parent: 230500,
                      re_name: "岭东区",
                      re_level: "3"
                  },
                  {
                      re_id: 230505,
                      re_parent: 230500,
                      re_name: "四方台区",
                      re_level: "3"
                  },
                  {
                      re_id: 230506,
                      re_parent: 230500,
                      re_name: "宝山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230521,
                      re_parent: 230500,
                      re_name: "集贤县",
                      re_level: "3"
                  },
                  {
                      re_id: 230522,
                      re_parent: 230500,
                      re_name: "友谊县",
                      re_level: "3"
                  },
                  {
                      re_id: 230523,
                      re_parent: 230500,
                      re_name: "宝清县",
                      re_level: "3"
                  },
                  {
                      re_id: 230524,
                      re_parent: 230500,
                      re_name: "饶河县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230600,
              re_parent: 230000,
              re_name: "大庆市",
              re_level: "2",
              children: [
                  {
                      re_id: 230602,
                      re_parent: 230600,
                      re_name: "萨尔图区",
                      re_level: "3"
                  },
                  {
                      re_id: 230603,
                      re_parent: 230600,
                      re_name: "龙凤区",
                      re_level: "3"
                  },
                  {
                      re_id: 230604,
                      re_parent: 230600,
                      re_name: "让胡路区",
                      re_level: "3"
                  },
                  {
                      re_id: 230605,
                      re_parent: 230600,
                      re_name: "红岗区",
                      re_level: "3"
                  },
                  {
                      re_id: 230606,
                      re_parent: 230600,
                      re_name: "大同区",
                      re_level: "3"
                  },
                  {
                      re_id: 230621,
                      re_parent: 230600,
                      re_name: "肇州县",
                      re_level: "3"
                  },
                  {
                      re_id: 230622,
                      re_parent: 230600,
                      re_name: "肇源县",
                      re_level: "3"
                  },
                  {
                      re_id: 230623,
                      re_parent: 230600,
                      re_name: "林甸县",
                      re_level: "3"
                  },
                  {
                      re_id: 230624,
                      re_parent: 230600,
                      re_name: "杜尔伯特蒙古族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230700,
              re_parent: 230000,
              re_name: "伊春市",
              re_level: "2",
              children: [
                  {
                      re_id: 230702,
                      re_parent: 230700,
                      re_name: "伊春区",
                      re_level: "3"
                  },
                  {
                      re_id: 230703,
                      re_parent: 230700,
                      re_name: "南岔区",
                      re_level: "3"
                  },
                  {
                      re_id: 230704,
                      re_parent: 230700,
                      re_name: "友好区",
                      re_level: "3"
                  },
                  {
                      re_id: 230705,
                      re_parent: 230700,
                      re_name: "西林区",
                      re_level: "3"
                  },
                  {
                      re_id: 230706,
                      re_parent: 230700,
                      re_name: "翠峦区",
                      re_level: "3"
                  },
                  {
                      re_id: 230707,
                      re_parent: 230700,
                      re_name: "新青区",
                      re_level: "3"
                  },
                  {
                      re_id: 230708,
                      re_parent: 230700,
                      re_name: "美溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 230709,
                      re_parent: 230700,
                      re_name: "金山屯区",
                      re_level: "3"
                  },
                  {
                      re_id: 230710,
                      re_parent: 230700,
                      re_name: "五营区",
                      re_level: "3"
                  },
                  {
                      re_id: 230711,
                      re_parent: 230700,
                      re_name: "乌马河区",
                      re_level: "3"
                  },
                  {
                      re_id: 230712,
                      re_parent: 230700,
                      re_name: "汤旺河区",
                      re_level: "3"
                  },
                  {
                      re_id: 230713,
                      re_parent: 230700,
                      re_name: "带岭区",
                      re_level: "3"
                  },
                  {
                      re_id: 230714,
                      re_parent: 230700,
                      re_name: "乌伊岭区",
                      re_level: "3"
                  },
                  {
                      re_id: 230715,
                      re_parent: 230700,
                      re_name: "红星区",
                      re_level: "3"
                  },
                  {
                      re_id: 230716,
                      re_parent: 230700,
                      re_name: "上甘岭区",
                      re_level: "3"
                  },
                  {
                      re_id: 230722,
                      re_parent: 230700,
                      re_name: "嘉荫县",
                      re_level: "3"
                  },
                  {
                      re_id: 230781,
                      re_parent: 230700,
                      re_name: "铁力市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230800,
              re_parent: 230000,
              re_name: "佳木斯市",
              re_level: "2",
              children: [
                  {
                      re_id: 230803,
                      re_parent: 230800,
                      re_name: "向阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 230804,
                      re_parent: 230800,
                      re_name: "前进区",
                      re_level: "3"
                  },
                  {
                      re_id: 230805,
                      re_parent: 230800,
                      re_name: "东风区",
                      re_level: "3"
                  },
                  {
                      re_id: 230811,
                      re_parent: 230800,
                      re_name: "郊区",
                      re_level: "3"
                  },
                  {
                      re_id: 230822,
                      re_parent: 230800,
                      re_name: "桦南县",
                      re_level: "3"
                  },
                  {
                      re_id: 230826,
                      re_parent: 230800,
                      re_name: "桦川县",
                      re_level: "3"
                  },
                  {
                      re_id: 230828,
                      re_parent: 230800,
                      re_name: "汤原县",
                      re_level: "3"
                  },
                  {
                      re_id: 230833,
                      re_parent: 230800,
                      re_name: "抚远县",
                      re_level: "3"
                  },
                  {
                      re_id: 230881,
                      re_parent: 230800,
                      re_name: "同江市",
                      re_level: "3"
                  },
                  {
                      re_id: 230882,
                      re_parent: 230800,
                      re_name: "富锦市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 230900,
              re_parent: 230000,
              re_name: "七台河市",
              re_level: "2",
              children: [
                  {
                      re_id: 230902,
                      re_parent: 230900,
                      re_name: "新兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 230903,
                      re_parent: 230900,
                      re_name: "桃山区",
                      re_level: "3"
                  },
                  {
                      re_id: 230904,
                      re_parent: 230900,
                      re_name: "茄子河区",
                      re_level: "3"
                  },
                  {
                      re_id: 230921,
                      re_parent: 230900,
                      re_name: "勃利县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 231000,
              re_parent: 230000,
              re_name: "牡丹江市",
              re_level: "2",
              children: [
                  {
                      re_id: 231002,
                      re_parent: 231000,
                      re_name: "东安区",
                      re_level: "3"
                  },
                  {
                      re_id: 231003,
                      re_parent: 231000,
                      re_name: "阳明区",
                      re_level: "3"
                  },
                  {
                      re_id: 231004,
                      re_parent: 231000,
                      re_name: "爱民区",
                      re_level: "3"
                  },
                  {
                      re_id: 231005,
                      re_parent: 231000,
                      re_name: "西安区",
                      re_level: "3"
                  },
                  {
                      re_id: 231024,
                      re_parent: 231000,
                      re_name: "东宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 231025,
                      re_parent: 231000,
                      re_name: "林口县",
                      re_level: "3"
                  },
                  {
                      re_id: 231081,
                      re_parent: 231000,
                      re_name: "绥芬河市",
                      re_level: "3"
                  },
                  {
                      re_id: 231083,
                      re_parent: 231000,
                      re_name: "海林市",
                      re_level: "3"
                  },
                  {
                      re_id: 231084,
                      re_parent: 231000,
                      re_name: "宁安市",
                      re_level: "3"
                  },
                  {
                      re_id: 231085,
                      re_parent: 231000,
                      re_name: "穆棱市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 231100,
              re_parent: 230000,
              re_name: "黑河市",
              re_level: "2",
              children: [
                  {
                      re_id: 231102,
                      re_parent: 231100,
                      re_name: "爱辉区",
                      re_level: "3"
                  },
                  {
                      re_id: 231121,
                      re_parent: 231100,
                      re_name: "嫩江县",
                      re_level: "3"
                  },
                  {
                      re_id: 231123,
                      re_parent: 231100,
                      re_name: "逊克县",
                      re_level: "3"
                  },
                  {
                      re_id: 231124,
                      re_parent: 231100,
                      re_name: "孙吴县",
                      re_level: "3"
                  },
                  {
                      re_id: 231181,
                      re_parent: 231100,
                      re_name: "北安市",
                      re_level: "3"
                  },
                  {
                      re_id: 231182,
                      re_parent: 231100,
                      re_name: "五大连池市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 231200,
              re_parent: 230000,
              re_name: "绥化市",
              re_level: "2",
              children: [
                  {
                      re_id: 231202,
                      re_parent: 231200,
                      re_name: "北林区",
                      re_level: "3"
                  },
                  {
                      re_id: 231221,
                      re_parent: 231200,
                      re_name: "望奎县",
                      re_level: "3"
                  },
                  {
                      re_id: 231222,
                      re_parent: 231200,
                      re_name: "兰西县",
                      re_level: "3"
                  },
                  {
                      re_id: 231223,
                      re_parent: 231200,
                      re_name: "青冈县",
                      re_level: "3"
                  },
                  {
                      re_id: 231224,
                      re_parent: 231200,
                      re_name: "庆安县",
                      re_level: "3"
                  },
                  {
                      re_id: 231225,
                      re_parent: 231200,
                      re_name: "明水县",
                      re_level: "3"
                  },
                  {
                      re_id: 231226,
                      re_parent: 231200,
                      re_name: "绥棱县",
                      re_level: "3"
                  },
                  {
                      re_id: 231281,
                      re_parent: 231200,
                      re_name: "安达市",
                      re_level: "3"
                  },
                  {
                      re_id: 231282,
                      re_parent: 231200,
                      re_name: "肇东市",
                      re_level: "3"
                  },
                  {
                      re_id: 231283,
                      re_parent: 231200,
                      re_name: "海伦市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 232700,
              re_parent: 230000,
              re_name: "大兴安岭地区",
              re_level: "2",
              children: [
                  {
                      re_id: 232701,
                      re_parent: 232700,
                      re_name: "加格达奇区",
                      re_level: "3"
                  },
                  {
                      re_id: 232702,
                      re_parent: 232700,
                      re_name: "新林区",
                      re_level: "3"
                  },
                  {
                      re_id: 232703,
                      re_parent: 232700,
                      re_name: "松岭区",
                      re_level: "3"
                  },
                  {
                      re_id: 232704,
                      re_parent: 232700,
                      re_name: "呼中区",
                      re_level: "3"
                  },
                  {
                      re_id: 232721,
                      re_parent: 232700,
                      re_name: "呼玛县",
                      re_level: "3"
                  },
                  {
                      re_id: 232722,
                      re_parent: 232700,
                      re_name: "塔河县",
                      re_level: "3"
                  },
                  {
                      re_id: 232723,
                      re_parent: 232700,
                      re_name: "漠河县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 310000,
      re_parent: 100000,
      re_name: "上海",
      re_level: "1",
      children: [
          {
              re_id: 310100,
              re_parent: 310000,
              re_name: "上海市",
              re_level: "2",
              children: [
                  {
                      re_id: 310101,
                      re_parent: 310100,
                      re_name: "黄浦区",
                      re_level: "3"
                  },
                  {
                      re_id: 310104,
                      re_parent: 310100,
                      re_name: "徐汇区",
                      re_level: "3"
                  },
                  {
                      re_id: 310105,
                      re_parent: 310100,
                      re_name: "长宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 310106,
                      re_parent: 310100,
                      re_name: "静安区",
                      re_level: "3"
                  },
                  {
                      re_id: 310107,
                      re_parent: 310100,
                      re_name: "普陀区",
                      re_level: "3"
                  },
                  {
                      re_id: 310108,
                      re_parent: 310100,
                      re_name: "闸北区",
                      re_level: "3"
                  },
                  {
                      re_id: 310109,
                      re_parent: 310100,
                      re_name: "虹口区",
                      re_level: "3"
                  },
                  {
                      re_id: 310110,
                      re_parent: 310100,
                      re_name: "杨浦区",
                      re_level: "3"
                  },
                  {
                      re_id: 310112,
                      re_parent: 310100,
                      re_name: "闵行区",
                      re_level: "3"
                  },
                  {
                      re_id: 310113,
                      re_parent: 310100,
                      re_name: "宝山区",
                      re_level: "3"
                  },
                  {
                      re_id: 310114,
                      re_parent: 310100,
                      re_name: "嘉定区",
                      re_level: "3"
                  },
                  {
                      re_id: 310115,
                      re_parent: 310100,
                      re_name: "浦东新区",
                      re_level: "3"
                  },
                  {
                      re_id: 310116,
                      re_parent: 310100,
                      re_name: "金山区",
                      re_level: "3"
                  },
                  {
                      re_id: 310117,
                      re_parent: 310100,
                      re_name: "松江区",
                      re_level: "3"
                  },
                  {
                      re_id: 310118,
                      re_parent: 310100,
                      re_name: "青浦区",
                      re_level: "3"
                  },
                  {
                      re_id: 310120,
                      re_parent: 310100,
                      re_name: "奉贤区",
                      re_level: "3"
                  },
                  {
                      re_id: 310230,
                      re_parent: 310100,
                      re_name: "崇明县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 320000,
      re_parent: 100000,
      re_name: "江苏省",
      re_level: "1",
      children: [
          {
              re_id: 320100,
              re_parent: 320000,
              re_name: "南京市",
              re_level: "2",
              children: [
                  {
                      re_id: 320102,
                      re_parent: 320100,
                      re_name: "玄武区",
                      re_level: "3"
                  },
                  {
                      re_id: 320104,
                      re_parent: 320100,
                      re_name: "秦淮区",
                      re_level: "3"
                  },
                  {
                      re_id: 320105,
                      re_parent: 320100,
                      re_name: "建邺区",
                      re_level: "3"
                  },
                  {
                      re_id: 320106,
                      re_parent: 320100,
                      re_name: "鼓楼区",
                      re_level: "3"
                  },
                  {
                      re_id: 320111,
                      re_parent: 320100,
                      re_name: "浦口区",
                      re_level: "3"
                  },
                  {
                      re_id: 320113,
                      re_parent: 320100,
                      re_name: "栖霞区",
                      re_level: "3"
                  },
                  {
                      re_id: 320114,
                      re_parent: 320100,
                      re_name: "雨花台区",
                      re_level: "3"
                  },
                  {
                      re_id: 320115,
                      re_parent: 320100,
                      re_name: "江宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 320116,
                      re_parent: 320100,
                      re_name: "六合区",
                      re_level: "3"
                  },
                  {
                      re_id: 320117,
                      re_parent: 320100,
                      re_name: "溧水区",
                      re_level: "3"
                  },
                  {
                      re_id: 320118,
                      re_parent: 320100,
                      re_name: "高淳区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320200,
              re_parent: 320000,
              re_name: "无锡市",
              re_level: "2",
              children: [
                  {
                      re_id: 320202,
                      re_parent: 320200,
                      re_name: "崇安区",
                      re_level: "3"
                  },
                  {
                      re_id: 320203,
                      re_parent: 320200,
                      re_name: "南长区",
                      re_level: "3"
                  },
                  {
                      re_id: 320204,
                      re_parent: 320200,
                      re_name: "北塘区",
                      re_level: "3"
                  },
                  {
                      re_id: 320205,
                      re_parent: 320200,
                      re_name: "锡山区",
                      re_level: "3"
                  },
                  {
                      re_id: 320206,
                      re_parent: 320200,
                      re_name: "惠山区",
                      re_level: "3"
                  },
                  {
                      re_id: 320211,
                      re_parent: 320200,
                      re_name: "滨湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 320281,
                      re_parent: 320200,
                      re_name: "江阴市",
                      re_level: "3"
                  },
                  {
                      re_id: 320282,
                      re_parent: 320200,
                      re_name: "宜兴市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320300,
              re_parent: 320000,
              re_name: "徐州市",
              re_level: "2",
              children: [
                  {
                      re_id: 320302,
                      re_parent: 320300,
                      re_name: "鼓楼区",
                      re_level: "3"
                  },
                  {
                      re_id: 320303,
                      re_parent: 320300,
                      re_name: "云龙区",
                      re_level: "3"
                  },
                  {
                      re_id: 320305,
                      re_parent: 320300,
                      re_name: "贾汪区",
                      re_level: "3"
                  },
                  {
                      re_id: 320311,
                      re_parent: 320300,
                      re_name: "泉山区",
                      re_level: "3"
                  },
                  {
                      re_id: 320312,
                      re_parent: 320300,
                      re_name: "铜山区",
                      re_level: "3"
                  },
                  {
                      re_id: 320321,
                      re_parent: 320300,
                      re_name: "丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 320322,
                      re_parent: 320300,
                      re_name: "沛县",
                      re_level: "3"
                  },
                  {
                      re_id: 320324,
                      re_parent: 320300,
                      re_name: "睢宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 320381,
                      re_parent: 320300,
                      re_name: "新沂市",
                      re_level: "3"
                  },
                  {
                      re_id: 320382,
                      re_parent: 320300,
                      re_name: "邳州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320400,
              re_parent: 320000,
              re_name: "常州市",
              re_level: "2",
              children: [
                  {
                      re_id: 320402,
                      re_parent: 320400,
                      re_name: "天宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 320404,
                      re_parent: 320400,
                      re_name: "钟楼区",
                      re_level: "3"
                  },
                  {
                      re_id: 320405,
                      re_parent: 320400,
                      re_name: "戚墅堰区",
                      re_level: "3"
                  },
                  {
                      re_id: 320411,
                      re_parent: 320400,
                      re_name: "新北区",
                      re_level: "3"
                  },
                  {
                      re_id: 320412,
                      re_parent: 320400,
                      re_name: "武进区",
                      re_level: "3"
                  },
                  {
                      re_id: 320481,
                      re_parent: 320400,
                      re_name: "溧阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 320482,
                      re_parent: 320400,
                      re_name: "金坛市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320500,
              re_parent: 320000,
              re_name: "苏州市",
              re_level: "2",
              children: [
                  {
                      re_id: 320505,
                      re_parent: 320500,
                      re_name: "虎丘区",
                      re_level: "3"
                  },
                  {
                      re_id: 320506,
                      re_parent: 320500,
                      re_name: "吴中区",
                      re_level: "3"
                  },
                  {
                      re_id: 320507,
                      re_parent: 320500,
                      re_name: "相城区",
                      re_level: "3"
                  },
                  {
                      re_id: 320508,
                      re_parent: 320500,
                      re_name: "姑苏区",
                      re_level: "3"
                  },
                  {
                      re_id: 320509,
                      re_parent: 320500,
                      re_name: "吴江区",
                      re_level: "3"
                  },
                  {
                      re_id: 320581,
                      re_parent: 320500,
                      re_name: "常熟市",
                      re_level: "3"
                  },
                  {
                      re_id: 320582,
                      re_parent: 320500,
                      re_name: "张家港市",
                      re_level: "3"
                  },
                  {
                      re_id: 320583,
                      re_parent: 320500,
                      re_name: "昆山市",
                      re_level: "3"
                  },
                  {
                      re_id: 320585,
                      re_parent: 320500,
                      re_name: "太仓市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320600,
              re_parent: 320000,
              re_name: "南通市",
              re_level: "2",
              children: [
                  {
                      re_id: 320602,
                      re_parent: 320600,
                      re_name: "崇川区",
                      re_level: "3"
                  },
                  {
                      re_id: 320611,
                      re_parent: 320600,
                      re_name: "港闸区",
                      re_level: "3"
                  },
                  {
                      re_id: 320612,
                      re_parent: 320600,
                      re_name: "通州区",
                      re_level: "3"
                  },
                  {
                      re_id: 320621,
                      re_parent: 320600,
                      re_name: "海安县",
                      re_level: "3"
                  },
                  {
                      re_id: 320623,
                      re_parent: 320600,
                      re_name: "如东县",
                      re_level: "3"
                  },
                  {
                      re_id: 320681,
                      re_parent: 320600,
                      re_name: "启东市",
                      re_level: "3"
                  },
                  {
                      re_id: 320682,
                      re_parent: 320600,
                      re_name: "如皋市",
                      re_level: "3"
                  },
                  {
                      re_id: 320684,
                      re_parent: 320600,
                      re_name: "海门市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320700,
              re_parent: 320000,
              re_name: "连云港市",
              re_level: "2",
              children: [
                  {
                      re_id: 320703,
                      re_parent: 320700,
                      re_name: "连云区",
                      re_level: "3"
                  },
                  {
                      re_id: 320706,
                      re_parent: 320700,
                      re_name: "海州区",
                      re_level: "3"
                  },
                  {
                      re_id: 320707,
                      re_parent: 320700,
                      re_name: "赣榆区",
                      re_level: "3"
                  },
                  {
                      re_id: 320722,
                      re_parent: 320700,
                      re_name: "东海县",
                      re_level: "3"
                  },
                  {
                      re_id: 320723,
                      re_parent: 320700,
                      re_name: "灌云县",
                      re_level: "3"
                  },
                  {
                      re_id: 320724,
                      re_parent: 320700,
                      re_name: "灌南县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320800,
              re_parent: 320000,
              re_name: "淮安市",
              re_level: "2",
              children: [
                  {
                      re_id: 320802,
                      re_parent: 320800,
                      re_name: "清河区",
                      re_level: "3"
                  },
                  {
                      re_id: 320803,
                      re_parent: 320800,
                      re_name: "淮安区",
                      re_level: "3"
                  },
                  {
                      re_id: 320804,
                      re_parent: 320800,
                      re_name: "淮阴区",
                      re_level: "3"
                  },
                  {
                      re_id: 320811,
                      re_parent: 320800,
                      re_name: "清浦区",
                      re_level: "3"
                  },
                  {
                      re_id: 320826,
                      re_parent: 320800,
                      re_name: "涟水县",
                      re_level: "3"
                  },
                  {
                      re_id: 320829,
                      re_parent: 320800,
                      re_name: "洪泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 320830,
                      re_parent: 320800,
                      re_name: "盱眙县",
                      re_level: "3"
                  },
                  {
                      re_id: 320831,
                      re_parent: 320800,
                      re_name: "金湖县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 320900,
              re_parent: 320000,
              re_name: "盐城市",
              re_level: "2",
              children: [
                  {
                      re_id: 320902,
                      re_parent: 320900,
                      re_name: "亭湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 320903,
                      re_parent: 320900,
                      re_name: "盐都区",
                      re_level: "3"
                  },
                  {
                      re_id: 320921,
                      re_parent: 320900,
                      re_name: "响水县",
                      re_level: "3"
                  },
                  {
                      re_id: 320922,
                      re_parent: 320900,
                      re_name: "滨海县",
                      re_level: "3"
                  },
                  {
                      re_id: 320923,
                      re_parent: 320900,
                      re_name: "阜宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 320924,
                      re_parent: 320900,
                      re_name: "射阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 320925,
                      re_parent: 320900,
                      re_name: "建湖县",
                      re_level: "3"
                  },
                  {
                      re_id: 320981,
                      re_parent: 320900,
                      re_name: "东台市",
                      re_level: "3"
                  },
                  {
                      re_id: 320982,
                      re_parent: 320900,
                      re_name: "大丰市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 321000,
              re_parent: 320000,
              re_name: "扬州市",
              re_level: "2",
              children: [
                  {
                      re_id: 321002,
                      re_parent: 321000,
                      re_name: "广陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 321003,
                      re_parent: 321000,
                      re_name: "邗江区",
                      re_level: "3"
                  },
                  {
                      re_id: 321012,
                      re_parent: 321000,
                      re_name: "江都区",
                      re_level: "3"
                  },
                  {
                      re_id: 321023,
                      re_parent: 321000,
                      re_name: "宝应县",
                      re_level: "3"
                  },
                  {
                      re_id: 321081,
                      re_parent: 321000,
                      re_name: "仪征市",
                      re_level: "3"
                  },
                  {
                      re_id: 321084,
                      re_parent: 321000,
                      re_name: "高邮市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 321100,
              re_parent: 320000,
              re_name: "镇江市",
              re_level: "2",
              children: [
                  {
                      re_id: 321102,
                      re_parent: 321100,
                      re_name: "京口区",
                      re_level: "3"
                  },
                  {
                      re_id: 321111,
                      re_parent: 321100,
                      re_name: "润州区",
                      re_level: "3"
                  },
                  {
                      re_id: 321112,
                      re_parent: 321100,
                      re_name: "丹徒区",
                      re_level: "3"
                  },
                  {
                      re_id: 321181,
                      re_parent: 321100,
                      re_name: "丹阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 321182,
                      re_parent: 321100,
                      re_name: "扬中市",
                      re_level: "3"
                  },
                  {
                      re_id: 321183,
                      re_parent: 321100,
                      re_name: "句容市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 321200,
              re_parent: 320000,
              re_name: "泰州市",
              re_level: "2",
              children: [
                  {
                      re_id: 321202,
                      re_parent: 321200,
                      re_name: "海陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 321203,
                      re_parent: 321200,
                      re_name: "高港区",
                      re_level: "3"
                  },
                  {
                      re_id: 321204,
                      re_parent: 321200,
                      re_name: "姜堰区",
                      re_level: "3"
                  },
                  {
                      re_id: 321281,
                      re_parent: 321200,
                      re_name: "兴化市",
                      re_level: "3"
                  },
                  {
                      re_id: 321282,
                      re_parent: 321200,
                      re_name: "靖江市",
                      re_level: "3"
                  },
                  {
                      re_id: 321283,
                      re_parent: 321200,
                      re_name: "泰兴市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 321300,
              re_parent: 320000,
              re_name: "宿迁市",
              re_level: "2",
              children: [
                  {
                      re_id: 321302,
                      re_parent: 321300,
                      re_name: "宿城区",
                      re_level: "3"
                  },
                  {
                      re_id: 321311,
                      re_parent: 321300,
                      re_name: "宿豫区",
                      re_level: "3"
                  },
                  {
                      re_id: 321322,
                      re_parent: 321300,
                      re_name: "沭阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 321323,
                      re_parent: 321300,
                      re_name: "泗阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 321324,
                      re_parent: 321300,
                      re_name: "泗洪县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 330000,
      re_parent: 100000,
      re_name: "浙江省",
      re_level: "1",
      children: [
          {
              re_id: 330100,
              re_parent: 330000,
              re_name: "杭州市",
              re_level: "2",
              children: [
                  {
                      re_id: 330102,
                      re_parent: 330100,
                      re_name: "上城区",
                      re_level: "3"
                  },
                  {
                      re_id: 330103,
                      re_parent: 330100,
                      re_name: "下城区",
                      re_level: "3"
                  },
                  {
                      re_id: 330104,
                      re_parent: 330100,
                      re_name: "江干区",
                      re_level: "3"
                  },
                  {
                      re_id: 330105,
                      re_parent: 330100,
                      re_name: "拱墅区",
                      re_level: "3"
                  },
                  {
                      re_id: 330106,
                      re_parent: 330100,
                      re_name: "西湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 330108,
                      re_parent: 330100,
                      re_name: "滨江区",
                      re_level: "3"
                  },
                  {
                      re_id: 330109,
                      re_parent: 330100,
                      re_name: "萧山区",
                      re_level: "3"
                  },
                  {
                      re_id: 330110,
                      re_parent: 330100,
                      re_name: "余杭区",
                      re_level: "3"
                  },
                  {
                      re_id: 330122,
                      re_parent: 330100,
                      re_name: "桐庐县",
                      re_level: "3"
                  },
                  {
                      re_id: 330127,
                      re_parent: 330100,
                      re_name: "淳安县",
                      re_level: "3"
                  },
                  {
                      re_id: 330182,
                      re_parent: 330100,
                      re_name: "建德市",
                      re_level: "3"
                  },
                  {
                      re_id: 330183,
                      re_parent: 330100,
                      re_name: "富阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 330185,
                      re_parent: 330100,
                      re_name: "临安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330200,
              re_parent: 330000,
              re_name: "宁波市",
              re_level: "2",
              children: [
                  {
                      re_id: 330203,
                      re_parent: 330200,
                      re_name: "海曙区",
                      re_level: "3"
                  },
                  {
                      re_id: 330204,
                      re_parent: 330200,
                      re_name: "江东区",
                      re_level: "3"
                  },
                  {
                      re_id: 330205,
                      re_parent: 330200,
                      re_name: "江北区",
                      re_level: "3"
                  },
                  {
                      re_id: 330206,
                      re_parent: 330200,
                      re_name: "北仑区",
                      re_level: "3"
                  },
                  {
                      re_id: 330211,
                      re_parent: 330200,
                      re_name: "镇海区",
                      re_level: "3"
                  },
                  {
                      re_id: 330212,
                      re_parent: 330200,
                      re_name: "鄞州区",
                      re_level: "3"
                  },
                  {
                      re_id: 330225,
                      re_parent: 330200,
                      re_name: "象山县",
                      re_level: "3"
                  },
                  {
                      re_id: 330226,
                      re_parent: 330200,
                      re_name: "宁海县",
                      re_level: "3"
                  },
                  {
                      re_id: 330281,
                      re_parent: 330200,
                      re_name: "余姚市",
                      re_level: "3"
                  },
                  {
                      re_id: 330282,
                      re_parent: 330200,
                      re_name: "慈溪市",
                      re_level: "3"
                  },
                  {
                      re_id: 330283,
                      re_parent: 330200,
                      re_name: "奉化市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330300,
              re_parent: 330000,
              re_name: "温州市",
              re_level: "2",
              children: [
                  {
                      re_id: 330302,
                      re_parent: 330300,
                      re_name: "鹿城区",
                      re_level: "3"
                  },
                  {
                      re_id: 330303,
                      re_parent: 330300,
                      re_name: "龙湾区",
                      re_level: "3"
                  },
                  {
                      re_id: 330304,
                      re_parent: 330300,
                      re_name: "瓯海区",
                      re_level: "3"
                  },
                  {
                      re_id: 330322,
                      re_parent: 330300,
                      re_name: "洞头县",
                      re_level: "3"
                  },
                  {
                      re_id: 330324,
                      re_parent: 330300,
                      re_name: "永嘉县",
                      re_level: "3"
                  },
                  {
                      re_id: 330326,
                      re_parent: 330300,
                      re_name: "平阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 330327,
                      re_parent: 330300,
                      re_name: "苍南县",
                      re_level: "3"
                  },
                  {
                      re_id: 330328,
                      re_parent: 330300,
                      re_name: "文成县",
                      re_level: "3"
                  },
                  {
                      re_id: 330329,
                      re_parent: 330300,
                      re_name: "泰顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 330381,
                      re_parent: 330300,
                      re_name: "瑞安市",
                      re_level: "3"
                  },
                  {
                      re_id: 330382,
                      re_parent: 330300,
                      re_name: "乐清市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330400,
              re_parent: 330000,
              re_name: "嘉兴市",
              re_level: "2",
              children: [
                  {
                      re_id: 330402,
                      re_parent: 330400,
                      re_name: "南湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 330411,
                      re_parent: 330400,
                      re_name: "秀洲区",
                      re_level: "3"
                  },
                  {
                      re_id: 330421,
                      re_parent: 330400,
                      re_name: "嘉善县",
                      re_level: "3"
                  },
                  {
                      re_id: 330424,
                      re_parent: 330400,
                      re_name: "海盐县",
                      re_level: "3"
                  },
                  {
                      re_id: 330481,
                      re_parent: 330400,
                      re_name: "海宁市",
                      re_level: "3"
                  },
                  {
                      re_id: 330482,
                      re_parent: 330400,
                      re_name: "平湖市",
                      re_level: "3"
                  },
                  {
                      re_id: 330483,
                      re_parent: 330400,
                      re_name: "桐乡市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330500,
              re_parent: 330000,
              re_name: "湖州市",
              re_level: "2",
              children: [
                  {
                      re_id: 330502,
                      re_parent: 330500,
                      re_name: "吴兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 330503,
                      re_parent: 330500,
                      re_name: "南浔区",
                      re_level: "3"
                  },
                  {
                      re_id: 330521,
                      re_parent: 330500,
                      re_name: "德清县",
                      re_level: "3"
                  },
                  {
                      re_id: 330522,
                      re_parent: 330500,
                      re_name: "长兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 330523,
                      re_parent: 330500,
                      re_name: "安吉县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330600,
              re_parent: 330000,
              re_name: "绍兴市",
              re_level: "2",
              children: [
                  {
                      re_id: 330602,
                      re_parent: 330600,
                      re_name: "越城区",
                      re_level: "3"
                  },
                  {
                      re_id: 330603,
                      re_parent: 330600,
                      re_name: "柯桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 330604,
                      re_parent: 330600,
                      re_name: "上虞区",
                      re_level: "3"
                  },
                  {
                      re_id: 330624,
                      re_parent: 330600,
                      re_name: "新昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 330681,
                      re_parent: 330600,
                      re_name: "诸暨市",
                      re_level: "3"
                  },
                  {
                      re_id: 330683,
                      re_parent: 330600,
                      re_name: "嵊州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330700,
              re_parent: 330000,
              re_name: "金华市",
              re_level: "2",
              children: [
                  {
                      re_id: 330702,
                      re_parent: 330700,
                      re_name: "婺城区",
                      re_level: "3"
                  },
                  {
                      re_id: 330703,
                      re_parent: 330700,
                      re_name: "金东区",
                      re_level: "3"
                  },
                  {
                      re_id: 330723,
                      re_parent: 330700,
                      re_name: "武义县",
                      re_level: "3"
                  },
                  {
                      re_id: 330726,
                      re_parent: 330700,
                      re_name: "浦江县",
                      re_level: "3"
                  },
                  {
                      re_id: 330727,
                      re_parent: 330700,
                      re_name: "磐安县",
                      re_level: "3"
                  },
                  {
                      re_id: 330781,
                      re_parent: 330700,
                      re_name: "兰溪市",
                      re_level: "3"
                  },
                  {
                      re_id: 330782,
                      re_parent: 330700,
                      re_name: "义乌市",
                      re_level: "3"
                  },
                  {
                      re_id: 330783,
                      re_parent: 330700,
                      re_name: "东阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 330784,
                      re_parent: 330700,
                      re_name: "永康市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330800,
              re_parent: 330000,
              re_name: "衢州市",
              re_level: "2",
              children: [
                  {
                      re_id: 330802,
                      re_parent: 330800,
                      re_name: "柯城区",
                      re_level: "3"
                  },
                  {
                      re_id: 330803,
                      re_parent: 330800,
                      re_name: "衢江区",
                      re_level: "3"
                  },
                  {
                      re_id: 330822,
                      re_parent: 330800,
                      re_name: "常山县",
                      re_level: "3"
                  },
                  {
                      re_id: 330824,
                      re_parent: 330800,
                      re_name: "开化县",
                      re_level: "3"
                  },
                  {
                      re_id: 330825,
                      re_parent: 330800,
                      re_name: "龙游县",
                      re_level: "3"
                  },
                  {
                      re_id: 330881,
                      re_parent: 330800,
                      re_name: "江山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 330900,
              re_parent: 330000,
              re_name: "舟山市",
              re_level: "2",
              children: [
                  {
                      re_id: 330902,
                      re_parent: 330900,
                      re_name: "定海区",
                      re_level: "3"
                  },
                  {
                      re_id: 330903,
                      re_parent: 330900,
                      re_name: "普陀区",
                      re_level: "3"
                  },
                  {
                      re_id: 330921,
                      re_parent: 330900,
                      re_name: "岱山县",
                      re_level: "3"
                  },
                  {
                      re_id: 330922,
                      re_parent: 330900,
                      re_name: "嵊泗县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 331000,
              re_parent: 330000,
              re_name: "台州市",
              re_level: "2",
              children: [
                  {
                      re_id: 331002,
                      re_parent: 331000,
                      re_name: "椒江区",
                      re_level: "3"
                  },
                  {
                      re_id: 331003,
                      re_parent: 331000,
                      re_name: "黄岩区",
                      re_level: "3"
                  },
                  {
                      re_id: 331004,
                      re_parent: 331000,
                      re_name: "路桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 331021,
                      re_parent: 331000,
                      re_name: "玉环县",
                      re_level: "3"
                  },
                  {
                      re_id: 331022,
                      re_parent: 331000,
                      re_name: "三门县",
                      re_level: "3"
                  },
                  {
                      re_id: 331023,
                      re_parent: 331000,
                      re_name: "天台县",
                      re_level: "3"
                  },
                  {
                      re_id: 331024,
                      re_parent: 331000,
                      re_name: "仙居县",
                      re_level: "3"
                  },
                  {
                      re_id: 331081,
                      re_parent: 331000,
                      re_name: "温岭市",
                      re_level: "3"
                  },
                  {
                      re_id: 331082,
                      re_parent: 331000,
                      re_name: "临海市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 331100,
              re_parent: 330000,
              re_name: "丽水市",
              re_level: "2",
              children: [
                  {
                      re_id: 331102,
                      re_parent: 331100,
                      re_name: "莲都区",
                      re_level: "3"
                  },
                  {
                      re_id: 331121,
                      re_parent: 331100,
                      re_name: "青田县",
                      re_level: "3"
                  },
                  {
                      re_id: 331122,
                      re_parent: 331100,
                      re_name: "缙云县",
                      re_level: "3"
                  },
                  {
                      re_id: 331123,
                      re_parent: 331100,
                      re_name: "遂昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 331124,
                      re_parent: 331100,
                      re_name: "松阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 331125,
                      re_parent: 331100,
                      re_name: "云和县",
                      re_level: "3"
                  },
                  {
                      re_id: 331126,
                      re_parent: 331100,
                      re_name: "庆元县",
                      re_level: "3"
                  },
                  {
                      re_id: 331127,
                      re_parent: 331100,
                      re_name: "景宁畲族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 331181,
                      re_parent: 331100,
                      re_name: "龙泉市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 331200,
              re_parent: 330000,
              re_name: "舟山群岛新区",
              re_level: "2",
              children: [
                  {
                      re_id: 331201,
                      re_parent: 331200,
                      re_name: "金塘岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331202,
                      re_parent: 331200,
                      re_name: "六横岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331203,
                      re_parent: 331200,
                      re_name: "衢山岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331204,
                      re_parent: 331200,
                      re_name: "舟山本岛西北部",
                      re_level: "3"
                  },
                  {
                      re_id: 331205,
                      re_parent: 331200,
                      re_name: "岱山岛西南部",
                      re_level: "3"
                  },
                  {
                      re_id: 331206,
                      re_parent: 331200,
                      re_name: "泗礁岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331207,
                      re_parent: 331200,
                      re_name: "朱家尖岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331208,
                      re_parent: 331200,
                      re_name: "洋山岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331209,
                      re_parent: 331200,
                      re_name: "长涂岛",
                      re_level: "3"
                  },
                  {
                      re_id: 331210,
                      re_parent: 331200,
                      re_name: "虾峙岛",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 340000,
      re_parent: 100000,
      re_name: "安徽省",
      re_level: "1",
      children: [
          {
              re_id: 340100,
              re_parent: 340000,
              re_name: "合肥市",
              re_level: "2",
              children: [
                  {
                      re_id: 340102,
                      re_parent: 340100,
                      re_name: "瑶海区",
                      re_level: "3"
                  },
                  {
                      re_id: 340103,
                      re_parent: 340100,
                      re_name: "庐阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 340104,
                      re_parent: 340100,
                      re_name: "蜀山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340111,
                      re_parent: 340100,
                      re_name: "包河区",
                      re_level: "3"
                  },
                  {
                      re_id: 340121,
                      re_parent: 340100,
                      re_name: "长丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 340122,
                      re_parent: 340100,
                      re_name: "肥东县",
                      re_level: "3"
                  },
                  {
                      re_id: 340123,
                      re_parent: 340100,
                      re_name: "肥西县",
                      re_level: "3"
                  },
                  {
                      re_id: 340124,
                      re_parent: 340100,
                      re_name: "庐江县",
                      re_level: "3"
                  },
                  {
                      re_id: 340181,
                      re_parent: 340100,
                      re_name: "巢湖市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340200,
              re_parent: 340000,
              re_name: "芜湖市",
              re_level: "2",
              children: [
                  {
                      re_id: 340202,
                      re_parent: 340200,
                      re_name: "镜湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 340203,
                      re_parent: 340200,
                      re_name: "弋江区",
                      re_level: "3"
                  },
                  {
                      re_id: 340207,
                      re_parent: 340200,
                      re_name: "鸠江区",
                      re_level: "3"
                  },
                  {
                      re_id: 340208,
                      re_parent: 340200,
                      re_name: "三山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340221,
                      re_parent: 340200,
                      re_name: "芜湖县",
                      re_level: "3"
                  },
                  {
                      re_id: 340222,
                      re_parent: 340200,
                      re_name: "繁昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 340223,
                      re_parent: 340200,
                      re_name: "南陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 340225,
                      re_parent: 340200,
                      re_name: "无为县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340300,
              re_parent: 340000,
              re_name: "蚌埠市",
              re_level: "2",
              children: [
                  {
                      re_id: 340302,
                      re_parent: 340300,
                      re_name: "龙子湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 340303,
                      re_parent: 340300,
                      re_name: "蚌山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340304,
                      re_parent: 340300,
                      re_name: "禹会区",
                      re_level: "3"
                  },
                  {
                      re_id: 340311,
                      re_parent: 340300,
                      re_name: "淮上区",
                      re_level: "3"
                  },
                  {
                      re_id: 340321,
                      re_parent: 340300,
                      re_name: "怀远县",
                      re_level: "3"
                  },
                  {
                      re_id: 340322,
                      re_parent: 340300,
                      re_name: "五河县",
                      re_level: "3"
                  },
                  {
                      re_id: 340323,
                      re_parent: 340300,
                      re_name: "固镇县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340400,
              re_parent: 340000,
              re_name: "淮南市",
              re_level: "2",
              children: [
                  {
                      re_id: 340402,
                      re_parent: 340400,
                      re_name: "大通区",
                      re_level: "3"
                  },
                  {
                      re_id: 340403,
                      re_parent: 340400,
                      re_name: "田家庵区",
                      re_level: "3"
                  },
                  {
                      re_id: 340404,
                      re_parent: 340400,
                      re_name: "谢家集区",
                      re_level: "3"
                  },
                  {
                      re_id: 340405,
                      re_parent: 340400,
                      re_name: "八公山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340406,
                      re_parent: 340400,
                      re_name: "潘集区",
                      re_level: "3"
                  },
                  {
                      re_id: 340421,
                      re_parent: 340400,
                      re_name: "凤台县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340500,
              re_parent: 340000,
              re_name: "马鞍山市",
              re_level: "2",
              children: [
                  {
                      re_id: 340503,
                      re_parent: 340500,
                      re_name: "花山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340504,
                      re_parent: 340500,
                      re_name: "雨山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340506,
                      re_parent: 340500,
                      re_name: "博望区",
                      re_level: "3"
                  },
                  {
                      re_id: 340521,
                      re_parent: 340500,
                      re_name: "当涂县",
                      re_level: "3"
                  },
                  {
                      re_id: 340522,
                      re_parent: 340500,
                      re_name: "含山县",
                      re_level: "3"
                  },
                  {
                      re_id: 340523,
                      re_parent: 340500,
                      re_name: "和县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340600,
              re_parent: 340000,
              re_name: "淮北市",
              re_level: "2",
              children: [
                  {
                      re_id: 340602,
                      re_parent: 340600,
                      re_name: "杜集区",
                      re_level: "3"
                  },
                  {
                      re_id: 340603,
                      re_parent: 340600,
                      re_name: "相山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340604,
                      re_parent: 340600,
                      re_name: "烈山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340621,
                      re_parent: 340600,
                      re_name: "濉溪县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340700,
              re_parent: 340000,
              re_name: "铜陵市",
              re_level: "2",
              children: [
                  {
                      re_id: 340702,
                      re_parent: 340700,
                      re_name: "铜官山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340703,
                      re_parent: 340700,
                      re_name: "狮子山区",
                      re_level: "3"
                  },
                  {
                      re_id: 340711,
                      re_parent: 340700,
                      re_name: "郊区",
                      re_level: "3"
                  },
                  {
                      re_id: 340721,
                      re_parent: 340700,
                      re_name: "铜陵县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 340800,
              re_parent: 340000,
              re_name: "安庆市",
              re_level: "2",
              children: [
                  {
                      re_id: 340802,
                      re_parent: 340800,
                      re_name: "迎江区",
                      re_level: "3"
                  },
                  {
                      re_id: 340803,
                      re_parent: 340800,
                      re_name: "大观区",
                      re_level: "3"
                  },
                  {
                      re_id: 340811,
                      re_parent: 340800,
                      re_name: "宜秀区",
                      re_level: "3"
                  },
                  {
                      re_id: 340822,
                      re_parent: 340800,
                      re_name: "怀宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 340823,
                      re_parent: 340800,
                      re_name: "枞阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 340824,
                      re_parent: 340800,
                      re_name: "潜山县",
                      re_level: "3"
                  },
                  {
                      re_id: 340825,
                      re_parent: 340800,
                      re_name: "太湖县",
                      re_level: "3"
                  },
                  {
                      re_id: 340826,
                      re_parent: 340800,
                      re_name: "宿松县",
                      re_level: "3"
                  },
                  {
                      re_id: 340827,
                      re_parent: 340800,
                      re_name: "望江县",
                      re_level: "3"
                  },
                  {
                      re_id: 340828,
                      re_parent: 340800,
                      re_name: "岳西县",
                      re_level: "3"
                  },
                  {
                      re_id: 340881,
                      re_parent: 340800,
                      re_name: "桐城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341000,
              re_parent: 340000,
              re_name: "黄山市",
              re_level: "2",
              children: [
                  {
                      re_id: 341002,
                      re_parent: 341000,
                      re_name: "屯溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 341003,
                      re_parent: 341000,
                      re_name: "黄山区",
                      re_level: "3"
                  },
                  {
                      re_id: 341004,
                      re_parent: 341000,
                      re_name: "徽州区",
                      re_level: "3"
                  },
                  {
                      re_id: 341021,
                      re_parent: 341000,
                      re_name: "歙县",
                      re_level: "3"
                  },
                  {
                      re_id: 341022,
                      re_parent: 341000,
                      re_name: "休宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 341023,
                      re_parent: 341000,
                      re_name: "黟县",
                      re_level: "3"
                  },
                  {
                      re_id: 341024,
                      re_parent: 341000,
                      re_name: "祁门县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341100,
              re_parent: 340000,
              re_name: "滁州市",
              re_level: "2",
              children: [
                  {
                      re_id: 341102,
                      re_parent: 341100,
                      re_name: "琅琊区",
                      re_level: "3"
                  },
                  {
                      re_id: 341103,
                      re_parent: 341100,
                      re_name: "南谯区",
                      re_level: "3"
                  },
                  {
                      re_id: 341122,
                      re_parent: 341100,
                      re_name: "来安县",
                      re_level: "3"
                  },
                  {
                      re_id: 341124,
                      re_parent: 341100,
                      re_name: "全椒县",
                      re_level: "3"
                  },
                  {
                      re_id: 341125,
                      re_parent: 341100,
                      re_name: "定远县",
                      re_level: "3"
                  },
                  {
                      re_id: 341126,
                      re_parent: 341100,
                      re_name: "凤阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 341181,
                      re_parent: 341100,
                      re_name: "天长市",
                      re_level: "3"
                  },
                  {
                      re_id: 341182,
                      re_parent: 341100,
                      re_name: "明光市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341200,
              re_parent: 340000,
              re_name: "阜阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 341202,
                      re_parent: 341200,
                      re_name: "颍州区",
                      re_level: "3"
                  },
                  {
                      re_id: 341203,
                      re_parent: 341200,
                      re_name: "颍东区",
                      re_level: "3"
                  },
                  {
                      re_id: 341204,
                      re_parent: 341200,
                      re_name: "颍泉区",
                      re_level: "3"
                  },
                  {
                      re_id: 341221,
                      re_parent: 341200,
                      re_name: "临泉县",
                      re_level: "3"
                  },
                  {
                      re_id: 341222,
                      re_parent: 341200,
                      re_name: "太和县",
                      re_level: "3"
                  },
                  {
                      re_id: 341225,
                      re_parent: 341200,
                      re_name: "阜南县",
                      re_level: "3"
                  },
                  {
                      re_id: 341226,
                      re_parent: 341200,
                      re_name: "颍上县",
                      re_level: "3"
                  },
                  {
                      re_id: 341282,
                      re_parent: 341200,
                      re_name: "界首市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341300,
              re_parent: 340000,
              re_name: "宿州市",
              re_level: "2",
              children: [
                  {
                      re_id: 341302,
                      re_parent: 341300,
                      re_name: "埇桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 341321,
                      re_parent: 341300,
                      re_name: "砀山县",
                      re_level: "3"
                  },
                  {
                      re_id: 341322,
                      re_parent: 341300,
                      re_name: "萧县",
                      re_level: "3"
                  },
                  {
                      re_id: 341323,
                      re_parent: 341300,
                      re_name: "灵璧县",
                      re_level: "3"
                  },
                  {
                      re_id: 341324,
                      re_parent: 341300,
                      re_name: "泗县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341500,
              re_parent: 340000,
              re_name: "六安市",
              re_level: "2",
              children: [
                  {
                      re_id: 341502,
                      re_parent: 341500,
                      re_name: "金安区",
                      re_level: "3"
                  },
                  {
                      re_id: 341503,
                      re_parent: 341500,
                      re_name: "裕安区",
                      re_level: "3"
                  },
                  {
                      re_id: 341521,
                      re_parent: 341500,
                      re_name: "寿县",
                      re_level: "3"
                  },
                  {
                      re_id: 341522,
                      re_parent: 341500,
                      re_name: "霍邱县",
                      re_level: "3"
                  },
                  {
                      re_id: 341523,
                      re_parent: 341500,
                      re_name: "舒城县",
                      re_level: "3"
                  },
                  {
                      re_id: 341524,
                      re_parent: 341500,
                      re_name: "金寨县",
                      re_level: "3"
                  },
                  {
                      re_id: 341525,
                      re_parent: 341500,
                      re_name: "霍山县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341600,
              re_parent: 340000,
              re_name: "亳州市",
              re_level: "2",
              children: [
                  {
                      re_id: 341602,
                      re_parent: 341600,
                      re_name: "谯城区",
                      re_level: "3"
                  },
                  {
                      re_id: 341621,
                      re_parent: 341600,
                      re_name: "涡阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 341622,
                      re_parent: 341600,
                      re_name: "蒙城县",
                      re_level: "3"
                  },
                  {
                      re_id: 341623,
                      re_parent: 341600,
                      re_name: "利辛县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341700,
              re_parent: 340000,
              re_name: "池州市",
              re_level: "2",
              children: [
                  {
                      re_id: 341702,
                      re_parent: 341700,
                      re_name: "贵池区",
                      re_level: "3"
                  },
                  {
                      re_id: 341721,
                      re_parent: 341700,
                      re_name: "东至县",
                      re_level: "3"
                  },
                  {
                      re_id: 341722,
                      re_parent: 341700,
                      re_name: "石台县",
                      re_level: "3"
                  },
                  {
                      re_id: 341723,
                      re_parent: 341700,
                      re_name: "青阳县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 341800,
              re_parent: 340000,
              re_name: "宣城市",
              re_level: "2",
              children: [
                  {
                      re_id: 341802,
                      re_parent: 341800,
                      re_name: "宣州区",
                      re_level: "3"
                  },
                  {
                      re_id: 341821,
                      re_parent: 341800,
                      re_name: "郎溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 341822,
                      re_parent: 341800,
                      re_name: "广德县",
                      re_level: "3"
                  },
                  {
                      re_id: 341823,
                      re_parent: 341800,
                      re_name: "泾县",
                      re_level: "3"
                  },
                  {
                      re_id: 341824,
                      re_parent: 341800,
                      re_name: "绩溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 341825,
                      re_parent: 341800,
                      re_name: "旌德县",
                      re_level: "3"
                  },
                  {
                      re_id: 341881,
                      re_parent: 341800,
                      re_name: "宁国市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 350000,
      re_parent: 100000,
      re_name: "福建省",
      re_level: "1",
      children: [
          {
              re_id: 350100,
              re_parent: 350000,
              re_name: "福州市",
              re_level: "2",
              children: [
                  {
                      re_id: 350102,
                      re_parent: 350100,
                      re_name: "鼓楼区",
                      re_level: "3"
                  },
                  {
                      re_id: 350103,
                      re_parent: 350100,
                      re_name: "台江区",
                      re_level: "3"
                  },
                  {
                      re_id: 350104,
                      re_parent: 350100,
                      re_name: "仓山区",
                      re_level: "3"
                  },
                  {
                      re_id: 350105,
                      re_parent: 350100,
                      re_name: "马尾区",
                      re_level: "3"
                  },
                  {
                      re_id: 350111,
                      re_parent: 350100,
                      re_name: "晋安区",
                      re_level: "3"
                  },
                  {
                      re_id: 350121,
                      re_parent: 350100,
                      re_name: "闽侯县",
                      re_level: "3"
                  },
                  {
                      re_id: 350122,
                      re_parent: 350100,
                      re_name: "连江县",
                      re_level: "3"
                  },
                  {
                      re_id: 350123,
                      re_parent: 350100,
                      re_name: "罗源县",
                      re_level: "3"
                  },
                  {
                      re_id: 350124,
                      re_parent: 350100,
                      re_name: "闽清县",
                      re_level: "3"
                  },
                  {
                      re_id: 350125,
                      re_parent: 350100,
                      re_name: "永泰县",
                      re_level: "3"
                  },
                  {
                      re_id: 350128,
                      re_parent: 350100,
                      re_name: "平潭县",
                      re_level: "3"
                  },
                  {
                      re_id: 350181,
                      re_parent: 350100,
                      re_name: "福清市",
                      re_level: "3"
                  },
                  {
                      re_id: 350182,
                      re_parent: 350100,
                      re_name: "长乐市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350200,
              re_parent: 350000,
              re_name: "厦门市",
              re_level: "2",
              children: [
                  {
                      re_id: 350203,
                      re_parent: 350200,
                      re_name: "思明区",
                      re_level: "3"
                  },
                  {
                      re_id: 350205,
                      re_parent: 350200,
                      re_name: "海沧区",
                      re_level: "3"
                  },
                  {
                      re_id: 350206,
                      re_parent: 350200,
                      re_name: "湖里区",
                      re_level: "3"
                  },
                  {
                      re_id: 350211,
                      re_parent: 350200,
                      re_name: "集美区",
                      re_level: "3"
                  },
                  {
                      re_id: 350212,
                      re_parent: 350200,
                      re_name: "同安区",
                      re_level: "3"
                  },
                  {
                      re_id: 350213,
                      re_parent: 350200,
                      re_name: "翔安区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350300,
              re_parent: 350000,
              re_name: "莆田市",
              re_level: "2",
              children: [
                  {
                      re_id: 350302,
                      re_parent: 350300,
                      re_name: "城厢区",
                      re_level: "3"
                  },
                  {
                      re_id: 350303,
                      re_parent: 350300,
                      re_name: "涵江区",
                      re_level: "3"
                  },
                  {
                      re_id: 350304,
                      re_parent: 350300,
                      re_name: "荔城区",
                      re_level: "3"
                  },
                  {
                      re_id: 350305,
                      re_parent: 350300,
                      re_name: "秀屿区",
                      re_level: "3"
                  },
                  {
                      re_id: 350322,
                      re_parent: 350300,
                      re_name: "仙游县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350400,
              re_parent: 350000,
              re_name: "三明市",
              re_level: "2",
              children: [
                  {
                      re_id: 350402,
                      re_parent: 350400,
                      re_name: "梅列区",
                      re_level: "3"
                  },
                  {
                      re_id: 350403,
                      re_parent: 350400,
                      re_name: "三元区",
                      re_level: "3"
                  },
                  {
                      re_id: 350421,
                      re_parent: 350400,
                      re_name: "明溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 350423,
                      re_parent: 350400,
                      re_name: "清流县",
                      re_level: "3"
                  },
                  {
                      re_id: 350424,
                      re_parent: 350400,
                      re_name: "宁化县",
                      re_level: "3"
                  },
                  {
                      re_id: 350425,
                      re_parent: 350400,
                      re_name: "大田县",
                      re_level: "3"
                  },
                  {
                      re_id: 350426,
                      re_parent: 350400,
                      re_name: "尤溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 350427,
                      re_parent: 350400,
                      re_name: "沙县",
                      re_level: "3"
                  },
                  {
                      re_id: 350428,
                      re_parent: 350400,
                      re_name: "将乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 350429,
                      re_parent: 350400,
                      re_name: "泰宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 350430,
                      re_parent: 350400,
                      re_name: "建宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 350481,
                      re_parent: 350400,
                      re_name: "永安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350500,
              re_parent: 350000,
              re_name: "泉州市",
              re_level: "2",
              children: [
                  {
                      re_id: 350502,
                      re_parent: 350500,
                      re_name: "鲤城区",
                      re_level: "3"
                  },
                  {
                      re_id: 350503,
                      re_parent: 350500,
                      re_name: "丰泽区",
                      re_level: "3"
                  },
                  {
                      re_id: 350504,
                      re_parent: 350500,
                      re_name: "洛江区",
                      re_level: "3"
                  },
                  {
                      re_id: 350505,
                      re_parent: 350500,
                      re_name: "泉港区",
                      re_level: "3"
                  },
                  {
                      re_id: 350521,
                      re_parent: 350500,
                      re_name: "惠安县",
                      re_level: "3"
                  },
                  {
                      re_id: 350524,
                      re_parent: 350500,
                      re_name: "安溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 350525,
                      re_parent: 350500,
                      re_name: "永春县",
                      re_level: "3"
                  },
                  {
                      re_id: 350526,
                      re_parent: 350500,
                      re_name: "德化县",
                      re_level: "3"
                  },
                  {
                      re_id: 350527,
                      re_parent: 350500,
                      re_name: "金门县",
                      re_level: "3"
                  },
                  {
                      re_id: 350581,
                      re_parent: 350500,
                      re_name: "石狮市",
                      re_level: "3"
                  },
                  {
                      re_id: 350582,
                      re_parent: 350500,
                      re_name: "晋江市",
                      re_level: "3"
                  },
                  {
                      re_id: 350583,
                      re_parent: 350500,
                      re_name: "南安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350600,
              re_parent: 350000,
              re_name: "漳州市",
              re_level: "2",
              children: [
                  {
                      re_id: 350602,
                      re_parent: 350600,
                      re_name: "芗城区",
                      re_level: "3"
                  },
                  {
                      re_id: 350603,
                      re_parent: 350600,
                      re_name: "龙文区",
                      re_level: "3"
                  },
                  {
                      re_id: 350622,
                      re_parent: 350600,
                      re_name: "云霄县",
                      re_level: "3"
                  },
                  {
                      re_id: 350623,
                      re_parent: 350600,
                      re_name: "漳浦县",
                      re_level: "3"
                  },
                  {
                      re_id: 350624,
                      re_parent: 350600,
                      re_name: "诏安县",
                      re_level: "3"
                  },
                  {
                      re_id: 350625,
                      re_parent: 350600,
                      re_name: "长泰县",
                      re_level: "3"
                  },
                  {
                      re_id: 350626,
                      re_parent: 350600,
                      re_name: "东山县",
                      re_level: "3"
                  },
                  {
                      re_id: 350627,
                      re_parent: 350600,
                      re_name: "南靖县",
                      re_level: "3"
                  },
                  {
                      re_id: 350628,
                      re_parent: 350600,
                      re_name: "平和县",
                      re_level: "3"
                  },
                  {
                      re_id: 350629,
                      re_parent: 350600,
                      re_name: "华安县",
                      re_level: "3"
                  },
                  {
                      re_id: 350681,
                      re_parent: 350600,
                      re_name: "龙海市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350700,
              re_parent: 350000,
              re_name: "南平市",
              re_level: "2",
              children: [
                  {
                      re_id: 350702,
                      re_parent: 350700,
                      re_name: "延平区",
                      re_level: "3"
                  },
                  {
                      re_id: 350703,
                      re_parent: 350700,
                      re_name: "建阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 350721,
                      re_parent: 350700,
                      re_name: "顺昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 350722,
                      re_parent: 350700,
                      re_name: "浦城县",
                      re_level: "3"
                  },
                  {
                      re_id: 350723,
                      re_parent: 350700,
                      re_name: "光泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 350724,
                      re_parent: 350700,
                      re_name: "松溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 350725,
                      re_parent: 350700,
                      re_name: "政和县",
                      re_level: "3"
                  },
                  {
                      re_id: 350781,
                      re_parent: 350700,
                      re_name: "邵武市",
                      re_level: "3"
                  },
                  {
                      re_id: 350782,
                      re_parent: 350700,
                      re_name: "武夷山市",
                      re_level: "3"
                  },
                  {
                      re_id: 350783,
                      re_parent: 350700,
                      re_name: "建瓯市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350800,
              re_parent: 350000,
              re_name: "龙岩市",
              re_level: "2",
              children: [
                  {
                      re_id: 350802,
                      re_parent: 350800,
                      re_name: "新罗区",
                      re_level: "3"
                  },
                  {
                      re_id: 350821,
                      re_parent: 350800,
                      re_name: "长汀县",
                      re_level: "3"
                  },
                  {
                      re_id: 350822,
                      re_parent: 350800,
                      re_name: "永定区",
                      re_level: "3"
                  },
                  {
                      re_id: 350823,
                      re_parent: 350800,
                      re_name: "上杭县",
                      re_level: "3"
                  },
                  {
                      re_id: 350824,
                      re_parent: 350800,
                      re_name: "武平县",
                      re_level: "3"
                  },
                  {
                      re_id: 350825,
                      re_parent: 350800,
                      re_name: "连城县",
                      re_level: "3"
                  },
                  {
                      re_id: 350881,
                      re_parent: 350800,
                      re_name: "漳平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 350900,
              re_parent: 350000,
              re_name: "宁德市",
              re_level: "2",
              children: [
                  {
                      re_id: 350902,
                      re_parent: 350900,
                      re_name: "蕉城区",
                      re_level: "3"
                  },
                  {
                      re_id: 350921,
                      re_parent: 350900,
                      re_name: "霞浦县",
                      re_level: "3"
                  },
                  {
                      re_id: 350922,
                      re_parent: 350900,
                      re_name: "古田县",
                      re_level: "3"
                  },
                  {
                      re_id: 350923,
                      re_parent: 350900,
                      re_name: "屏南县",
                      re_level: "3"
                  },
                  {
                      re_id: 350924,
                      re_parent: 350900,
                      re_name: "寿宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 350925,
                      re_parent: 350900,
                      re_name: "周宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 350926,
                      re_parent: 350900,
                      re_name: "柘荣县",
                      re_level: "3"
                  },
                  {
                      re_id: 350981,
                      re_parent: 350900,
                      re_name: "福安市",
                      re_level: "3"
                  },
                  {
                      re_id: 350982,
                      re_parent: 350900,
                      re_name: "福鼎市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 360000,
      re_parent: 100000,
      re_name: "江西省",
      re_level: "1",
      children: [
          {
              re_id: 360100,
              re_parent: 360000,
              re_name: "南昌市",
              re_level: "2",
              children: [
                  {
                      re_id: 360102,
                      re_parent: 360100,
                      re_name: "东湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 360103,
                      re_parent: 360100,
                      re_name: "西湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 360104,
                      re_parent: 360100,
                      re_name: "青云谱区",
                      re_level: "3"
                  },
                  {
                      re_id: 360105,
                      re_parent: 360100,
                      re_name: "湾里区",
                      re_level: "3"
                  },
                  {
                      re_id: 360111,
                      re_parent: 360100,
                      re_name: "青山湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 360121,
                      re_parent: 360100,
                      re_name: "南昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 360122,
                      re_parent: 360100,
                      re_name: "新建县",
                      re_level: "3"
                  },
                  {
                      re_id: 360123,
                      re_parent: 360100,
                      re_name: "安义县",
                      re_level: "3"
                  },
                  {
                      re_id: 360124,
                      re_parent: 360100,
                      re_name: "进贤县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360200,
              re_parent: 360000,
              re_name: "景德镇市",
              re_level: "2",
              children: [
                  {
                      re_id: 360202,
                      re_parent: 360200,
                      re_name: "昌江区",
                      re_level: "3"
                  },
                  {
                      re_id: 360203,
                      re_parent: 360200,
                      re_name: "珠山区",
                      re_level: "3"
                  },
                  {
                      re_id: 360222,
                      re_parent: 360200,
                      re_name: "浮梁县",
                      re_level: "3"
                  },
                  {
                      re_id: 360281,
                      re_parent: 360200,
                      re_name: "乐平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360300,
              re_parent: 360000,
              re_name: "萍乡市",
              re_level: "2",
              children: [
                  {
                      re_id: 360302,
                      re_parent: 360300,
                      re_name: "安源区",
                      re_level: "3"
                  },
                  {
                      re_id: 360313,
                      re_parent: 360300,
                      re_name: "湘东区",
                      re_level: "3"
                  },
                  {
                      re_id: 360321,
                      re_parent: 360300,
                      re_name: "莲花县",
                      re_level: "3"
                  },
                  {
                      re_id: 360322,
                      re_parent: 360300,
                      re_name: "上栗县",
                      re_level: "3"
                  },
                  {
                      re_id: 360323,
                      re_parent: 360300,
                      re_name: "芦溪县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360400,
              re_parent: 360000,
              re_name: "九江市",
              re_level: "2",
              children: [
                  {
                      re_id: 360402,
                      re_parent: 360400,
                      re_name: "庐山区",
                      re_level: "3"
                  },
                  {
                      re_id: 360403,
                      re_parent: 360400,
                      re_name: "浔阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 360421,
                      re_parent: 360400,
                      re_name: "九江县",
                      re_level: "3"
                  },
                  {
                      re_id: 360423,
                      re_parent: 360400,
                      re_name: "武宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 360424,
                      re_parent: 360400,
                      re_name: "修水县",
                      re_level: "3"
                  },
                  {
                      re_id: 360425,
                      re_parent: 360400,
                      re_name: "永修县",
                      re_level: "3"
                  },
                  {
                      re_id: 360426,
                      re_parent: 360400,
                      re_name: "德安县",
                      re_level: "3"
                  },
                  {
                      re_id: 360427,
                      re_parent: 360400,
                      re_name: "星子县",
                      re_level: "3"
                  },
                  {
                      re_id: 360428,
                      re_parent: 360400,
                      re_name: "都昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 360429,
                      re_parent: 360400,
                      re_name: "湖口县",
                      re_level: "3"
                  },
                  {
                      re_id: 360430,
                      re_parent: 360400,
                      re_name: "彭泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 360481,
                      re_parent: 360400,
                      re_name: "瑞昌市",
                      re_level: "3"
                  },
                  {
                      re_id: 360482,
                      re_parent: 360400,
                      re_name: "共青城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360500,
              re_parent: 360000,
              re_name: "新余市",
              re_level: "2",
              children: [
                  {
                      re_id: 360502,
                      re_parent: 360500,
                      re_name: "渝水区",
                      re_level: "3"
                  },
                  {
                      re_id: 360521,
                      re_parent: 360500,
                      re_name: "分宜县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360600,
              re_parent: 360000,
              re_name: "鹰潭市",
              re_level: "2",
              children: [
                  {
                      re_id: 360602,
                      re_parent: 360600,
                      re_name: "月湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 360622,
                      re_parent: 360600,
                      re_name: "余江县",
                      re_level: "3"
                  },
                  {
                      re_id: 360681,
                      re_parent: 360600,
                      re_name: "贵溪市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360700,
              re_parent: 360000,
              re_name: "赣州市",
              re_level: "2",
              children: [
                  {
                      re_id: 360702,
                      re_parent: 360700,
                      re_name: "章贡区",
                      re_level: "3"
                  },
                  {
                      re_id: 360703,
                      re_parent: 360700,
                      re_name: "南康区",
                      re_level: "3"
                  },
                  {
                      re_id: 360721,
                      re_parent: 360700,
                      re_name: "赣县",
                      re_level: "3"
                  },
                  {
                      re_id: 360722,
                      re_parent: 360700,
                      re_name: "信丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 360723,
                      re_parent: 360700,
                      re_name: "大余县",
                      re_level: "3"
                  },
                  {
                      re_id: 360724,
                      re_parent: 360700,
                      re_name: "上犹县",
                      re_level: "3"
                  },
                  {
                      re_id: 360725,
                      re_parent: 360700,
                      re_name: "崇义县",
                      re_level: "3"
                  },
                  {
                      re_id: 360726,
                      re_parent: 360700,
                      re_name: "安远县",
                      re_level: "3"
                  },
                  {
                      re_id: 360727,
                      re_parent: 360700,
                      re_name: "龙南县",
                      re_level: "3"
                  },
                  {
                      re_id: 360728,
                      re_parent: 360700,
                      re_name: "定南县",
                      re_level: "3"
                  },
                  {
                      re_id: 360729,
                      re_parent: 360700,
                      re_name: "全南县",
                      re_level: "3"
                  },
                  {
                      re_id: 360730,
                      re_parent: 360700,
                      re_name: "宁都县",
                      re_level: "3"
                  },
                  {
                      re_id: 360731,
                      re_parent: 360700,
                      re_name: "于都县",
                      re_level: "3"
                  },
                  {
                      re_id: 360732,
                      re_parent: 360700,
                      re_name: "兴国县",
                      re_level: "3"
                  },
                  {
                      re_id: 360733,
                      re_parent: 360700,
                      re_name: "会昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 360734,
                      re_parent: 360700,
                      re_name: "寻乌县",
                      re_level: "3"
                  },
                  {
                      re_id: 360735,
                      re_parent: 360700,
                      re_name: "石城县",
                      re_level: "3"
                  },
                  {
                      re_id: 360781,
                      re_parent: 360700,
                      re_name: "瑞金市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360800,
              re_parent: 360000,
              re_name: "吉安市",
              re_level: "2",
              children: [
                  {
                      re_id: 360802,
                      re_parent: 360800,
                      re_name: "吉州区",
                      re_level: "3"
                  },
                  {
                      re_id: 360803,
                      re_parent: 360800,
                      re_name: "青原区",
                      re_level: "3"
                  },
                  {
                      re_id: 360821,
                      re_parent: 360800,
                      re_name: "吉安县",
                      re_level: "3"
                  },
                  {
                      re_id: 360822,
                      re_parent: 360800,
                      re_name: "吉水县",
                      re_level: "3"
                  },
                  {
                      re_id: 360823,
                      re_parent: 360800,
                      re_name: "峡江县",
                      re_level: "3"
                  },
                  {
                      re_id: 360824,
                      re_parent: 360800,
                      re_name: "新干县",
                      re_level: "3"
                  },
                  {
                      re_id: 360825,
                      re_parent: 360800,
                      re_name: "永丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 360826,
                      re_parent: 360800,
                      re_name: "泰和县",
                      re_level: "3"
                  },
                  {
                      re_id: 360827,
                      re_parent: 360800,
                      re_name: "遂川县",
                      re_level: "3"
                  },
                  {
                      re_id: 360828,
                      re_parent: 360800,
                      re_name: "万安县",
                      re_level: "3"
                  },
                  {
                      re_id: 360829,
                      re_parent: 360800,
                      re_name: "安福县",
                      re_level: "3"
                  },
                  {
                      re_id: 360830,
                      re_parent: 360800,
                      re_name: "永新县",
                      re_level: "3"
                  },
                  {
                      re_id: 360881,
                      re_parent: 360800,
                      re_name: "井冈山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 360900,
              re_parent: 360000,
              re_name: "宜春市",
              re_level: "2",
              children: [
                  {
                      re_id: 360902,
                      re_parent: 360900,
                      re_name: "袁州区",
                      re_level: "3"
                  },
                  {
                      re_id: 360921,
                      re_parent: 360900,
                      re_name: "奉新县",
                      re_level: "3"
                  },
                  {
                      re_id: 360922,
                      re_parent: 360900,
                      re_name: "万载县",
                      re_level: "3"
                  },
                  {
                      re_id: 360923,
                      re_parent: 360900,
                      re_name: "上高县",
                      re_level: "3"
                  },
                  {
                      re_id: 360924,
                      re_parent: 360900,
                      re_name: "宜丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 360925,
                      re_parent: 360900,
                      re_name: "靖安县",
                      re_level: "3"
                  },
                  {
                      re_id: 360926,
                      re_parent: 360900,
                      re_name: "铜鼓县",
                      re_level: "3"
                  },
                  {
                      re_id: 360981,
                      re_parent: 360900,
                      re_name: "丰城市",
                      re_level: "3"
                  },
                  {
                      re_id: 360982,
                      re_parent: 360900,
                      re_name: "樟树市",
                      re_level: "3"
                  },
                  {
                      re_id: 360983,
                      re_parent: 360900,
                      re_name: "高安市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 361000,
              re_parent: 360000,
              re_name: "抚州市",
              re_level: "2",
              children: [
                  {
                      re_id: 361002,
                      re_parent: 361000,
                      re_name: "临川区",
                      re_level: "3"
                  },
                  {
                      re_id: 361021,
                      re_parent: 361000,
                      re_name: "南城县",
                      re_level: "3"
                  },
                  {
                      re_id: 361022,
                      re_parent: 361000,
                      re_name: "黎川县",
                      re_level: "3"
                  },
                  {
                      re_id: 361023,
                      re_parent: 361000,
                      re_name: "南丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 361024,
                      re_parent: 361000,
                      re_name: "崇仁县",
                      re_level: "3"
                  },
                  {
                      re_id: 361025,
                      re_parent: 361000,
                      re_name: "乐安县",
                      re_level: "3"
                  },
                  {
                      re_id: 361026,
                      re_parent: 361000,
                      re_name: "宜黄县",
                      re_level: "3"
                  },
                  {
                      re_id: 361027,
                      re_parent: 361000,
                      re_name: "金溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 361028,
                      re_parent: 361000,
                      re_name: "资溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 361029,
                      re_parent: 361000,
                      re_name: "东乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 361030,
                      re_parent: 361000,
                      re_name: "广昌县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 361100,
              re_parent: 360000,
              re_name: "上饶市",
              re_level: "2",
              children: [
                  {
                      re_id: 361102,
                      re_parent: 361100,
                      re_name: "信州区",
                      re_level: "3"
                  },
                  {
                      re_id: 361121,
                      re_parent: 361100,
                      re_name: "上饶县",
                      re_level: "3"
                  },
                  {
                      re_id: 361122,
                      re_parent: 361100,
                      re_name: "广丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 361123,
                      re_parent: 361100,
                      re_name: "玉山县",
                      re_level: "3"
                  },
                  {
                      re_id: 361124,
                      re_parent: 361100,
                      re_name: "铅山县",
                      re_level: "3"
                  },
                  {
                      re_id: 361125,
                      re_parent: 361100,
                      re_name: "横峰县",
                      re_level: "3"
                  },
                  {
                      re_id: 361126,
                      re_parent: 361100,
                      re_name: "弋阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 361127,
                      re_parent: 361100,
                      re_name: "余干县",
                      re_level: "3"
                  },
                  {
                      re_id: 361128,
                      re_parent: 361100,
                      re_name: "鄱阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 361129,
                      re_parent: 361100,
                      re_name: "万年县",
                      re_level: "3"
                  },
                  {
                      re_id: 361130,
                      re_parent: 361100,
                      re_name: "婺源县",
                      re_level: "3"
                  },
                  {
                      re_id: 361181,
                      re_parent: 361100,
                      re_name: "德兴市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 370000,
      re_parent: 100000,
      re_name: "山东省",
      re_level: "1",
      children: [
          {
              re_id: 370100,
              re_parent: 370000,
              re_name: "济南市",
              re_level: "2",
              children: [
                  {
                      re_id: 370102,
                      re_parent: 370100,
                      re_name: "历下区",
                      re_level: "3"
                  },
                  {
                      re_id: 370103,
                      re_parent: 370100,
                      re_name: "市中区",
                      re_level: "3"
                  },
                  {
                      re_id: 370104,
                      re_parent: 370100,
                      re_name: "槐荫区",
                      re_level: "3"
                  },
                  {
                      re_id: 370105,
                      re_parent: 370100,
                      re_name: "天桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 370112,
                      re_parent: 370100,
                      re_name: "历城区",
                      re_level: "3"
                  },
                  {
                      re_id: 370113,
                      re_parent: 370100,
                      re_name: "长清区",
                      re_level: "3"
                  },
                  {
                      re_id: 370124,
                      re_parent: 370100,
                      re_name: "平阴县",
                      re_level: "3"
                  },
                  {
                      re_id: 370125,
                      re_parent: 370100,
                      re_name: "济阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 370126,
                      re_parent: 370100,
                      re_name: "商河县",
                      re_level: "3"
                  },
                  {
                      re_id: 370181,
                      re_parent: 370100,
                      re_name: "章丘市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370200,
              re_parent: 370000,
              re_name: "青岛市",
              re_level: "2",
              children: [
                  {
                      re_id: 370202,
                      re_parent: 370200,
                      re_name: "市南区",
                      re_level: "3"
                  },
                  {
                      re_id: 370203,
                      re_parent: 370200,
                      re_name: "市北区",
                      re_level: "3"
                  },
                  {
                      re_id: 370211,
                      re_parent: 370200,
                      re_name: "黄岛区",
                      re_level: "3"
                  },
                  {
                      re_id: 370212,
                      re_parent: 370200,
                      re_name: "崂山区",
                      re_level: "3"
                  },
                  {
                      re_id: 370213,
                      re_parent: 370200,
                      re_name: "李沧区",
                      re_level: "3"
                  },
                  {
                      re_id: 370214,
                      re_parent: 370200,
                      re_name: "城阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 370281,
                      re_parent: 370200,
                      re_name: "胶州市",
                      re_level: "3"
                  },
                  {
                      re_id: 370282,
                      re_parent: 370200,
                      re_name: "即墨市",
                      re_level: "3"
                  },
                  {
                      re_id: 370283,
                      re_parent: 370200,
                      re_name: "平度市",
                      re_level: "3"
                  },
                  {
                      re_id: 370285,
                      re_parent: 370200,
                      re_name: "莱西市",
                      re_level: "3"
                  },
                  {
                      re_id: 370286,
                      re_parent: 370200,
                      re_name: "西海岸新区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370300,
              re_parent: 370000,
              re_name: "淄博市",
              re_level: "2",
              children: [
                  {
                      re_id: 370302,
                      re_parent: 370300,
                      re_name: "淄川区",
                      re_level: "3"
                  },
                  {
                      re_id: 370303,
                      re_parent: 370300,
                      re_name: "张店区",
                      re_level: "3"
                  },
                  {
                      re_id: 370304,
                      re_parent: 370300,
                      re_name: "博山区",
                      re_level: "3"
                  },
                  {
                      re_id: 370305,
                      re_parent: 370300,
                      re_name: "临淄区",
                      re_level: "3"
                  },
                  {
                      re_id: 370306,
                      re_parent: 370300,
                      re_name: "周村区",
                      re_level: "3"
                  },
                  {
                      re_id: 370321,
                      re_parent: 370300,
                      re_name: "桓台县",
                      re_level: "3"
                  },
                  {
                      re_id: 370322,
                      re_parent: 370300,
                      re_name: "高青县",
                      re_level: "3"
                  },
                  {
                      re_id: 370323,
                      re_parent: 370300,
                      re_name: "沂源县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370400,
              re_parent: 370000,
              re_name: "枣庄市",
              re_level: "2",
              children: [
                  {
                      re_id: 370402,
                      re_parent: 370400,
                      re_name: "市中区",
                      re_level: "3"
                  },
                  {
                      re_id: 370403,
                      re_parent: 370400,
                      re_name: "薛城区",
                      re_level: "3"
                  },
                  {
                      re_id: 370404,
                      re_parent: 370400,
                      re_name: "峄城区",
                      re_level: "3"
                  },
                  {
                      re_id: 370405,
                      re_parent: 370400,
                      re_name: "台儿庄区",
                      re_level: "3"
                  },
                  {
                      re_id: 370406,
                      re_parent: 370400,
                      re_name: "山亭区",
                      re_level: "3"
                  },
                  {
                      re_id: 370481,
                      re_parent: 370400,
                      re_name: "滕州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370500,
              re_parent: 370000,
              re_name: "东营市",
              re_level: "2",
              children: [
                  {
                      re_id: 370502,
                      re_parent: 370500,
                      re_name: "东营区",
                      re_level: "3"
                  },
                  {
                      re_id: 370503,
                      re_parent: 370500,
                      re_name: "河口区",
                      re_level: "3"
                  },
                  {
                      re_id: 370521,
                      re_parent: 370500,
                      re_name: "垦利县",
                      re_level: "3"
                  },
                  {
                      re_id: 370522,
                      re_parent: 370500,
                      re_name: "利津县",
                      re_level: "3"
                  },
                  {
                      re_id: 370523,
                      re_parent: 370500,
                      re_name: "广饶县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370600,
              re_parent: 370000,
              re_name: "烟台市",
              re_level: "2",
              children: [
                  {
                      re_id: 370602,
                      re_parent: 370600,
                      re_name: "芝罘区",
                      re_level: "3"
                  },
                  {
                      re_id: 370611,
                      re_parent: 370600,
                      re_name: "福山区",
                      re_level: "3"
                  },
                  {
                      re_id: 370612,
                      re_parent: 370600,
                      re_name: "牟平区",
                      re_level: "3"
                  },
                  {
                      re_id: 370613,
                      re_parent: 370600,
                      re_name: "莱山区",
                      re_level: "3"
                  },
                  {
                      re_id: 370634,
                      re_parent: 370600,
                      re_name: "长岛县",
                      re_level: "3"
                  },
                  {
                      re_id: 370681,
                      re_parent: 370600,
                      re_name: "龙口市",
                      re_level: "3"
                  },
                  {
                      re_id: 370682,
                      re_parent: 370600,
                      re_name: "莱阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 370683,
                      re_parent: 370600,
                      re_name: "莱州市",
                      re_level: "3"
                  },
                  {
                      re_id: 370684,
                      re_parent: 370600,
                      re_name: "蓬莱市",
                      re_level: "3"
                  },
                  {
                      re_id: 370685,
                      re_parent: 370600,
                      re_name: "招远市",
                      re_level: "3"
                  },
                  {
                      re_id: 370686,
                      re_parent: 370600,
                      re_name: "栖霞市",
                      re_level: "3"
                  },
                  {
                      re_id: 370687,
                      re_parent: 370600,
                      re_name: "海阳市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370700,
              re_parent: 370000,
              re_name: "潍坊市",
              re_level: "2",
              children: [
                  {
                      re_id: 370702,
                      re_parent: 370700,
                      re_name: "潍城区",
                      re_level: "3"
                  },
                  {
                      re_id: 370703,
                      re_parent: 370700,
                      re_name: "寒亭区",
                      re_level: "3"
                  },
                  {
                      re_id: 370704,
                      re_parent: 370700,
                      re_name: "坊子区",
                      re_level: "3"
                  },
                  {
                      re_id: 370705,
                      re_parent: 370700,
                      re_name: "奎文区",
                      re_level: "3"
                  },
                  {
                      re_id: 370724,
                      re_parent: 370700,
                      re_name: "临朐县",
                      re_level: "3"
                  },
                  {
                      re_id: 370725,
                      re_parent: 370700,
                      re_name: "昌乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 370781,
                      re_parent: 370700,
                      re_name: "青州市",
                      re_level: "3"
                  },
                  {
                      re_id: 370782,
                      re_parent: 370700,
                      re_name: "诸城市",
                      re_level: "3"
                  },
                  {
                      re_id: 370783,
                      re_parent: 370700,
                      re_name: "寿光市",
                      re_level: "3"
                  },
                  {
                      re_id: 370784,
                      re_parent: 370700,
                      re_name: "安丘市",
                      re_level: "3"
                  },
                  {
                      re_id: 370785,
                      re_parent: 370700,
                      re_name: "高密市",
                      re_level: "3"
                  },
                  {
                      re_id: 370786,
                      re_parent: 370700,
                      re_name: "昌邑市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370800,
              re_parent: 370000,
              re_name: "济宁市",
              re_level: "2",
              children: [
                  {
                      re_id: 370811,
                      re_parent: 370800,
                      re_name: "任城区",
                      re_level: "3"
                  },
                  {
                      re_id: 370812,
                      re_parent: 370800,
                      re_name: "兖州区",
                      re_level: "3"
                  },
                  {
                      re_id: 370826,
                      re_parent: 370800,
                      re_name: "微山县",
                      re_level: "3"
                  },
                  {
                      re_id: 370827,
                      re_parent: 370800,
                      re_name: "鱼台县",
                      re_level: "3"
                  },
                  {
                      re_id: 370828,
                      re_parent: 370800,
                      re_name: "金乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 370829,
                      re_parent: 370800,
                      re_name: "嘉祥县",
                      re_level: "3"
                  },
                  {
                      re_id: 370830,
                      re_parent: 370800,
                      re_name: "汶上县",
                      re_level: "3"
                  },
                  {
                      re_id: 370831,
                      re_parent: 370800,
                      re_name: "泗水县",
                      re_level: "3"
                  },
                  {
                      re_id: 370832,
                      re_parent: 370800,
                      re_name: "梁山县",
                      re_level: "3"
                  },
                  {
                      re_id: 370881,
                      re_parent: 370800,
                      re_name: "曲阜市",
                      re_level: "3"
                  },
                  {
                      re_id: 370883,
                      re_parent: 370800,
                      re_name: "邹城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 370900,
              re_parent: 370000,
              re_name: "泰安市",
              re_level: "2",
              children: [
                  {
                      re_id: 370902,
                      re_parent: 370900,
                      re_name: "泰山区",
                      re_level: "3"
                  },
                  {
                      re_id: 370911,
                      re_parent: 370900,
                      re_name: "岱岳区",
                      re_level: "3"
                  },
                  {
                      re_id: 370921,
                      re_parent: 370900,
                      re_name: "宁阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 370923,
                      re_parent: 370900,
                      re_name: "东平县",
                      re_level: "3"
                  },
                  {
                      re_id: 370982,
                      re_parent: 370900,
                      re_name: "新泰市",
                      re_level: "3"
                  },
                  {
                      re_id: 370983,
                      re_parent: 370900,
                      re_name: "肥城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371000,
              re_parent: 370000,
              re_name: "威海市",
              re_level: "2",
              children: [
                  {
                      re_id: 371002,
                      re_parent: 371000,
                      re_name: "环翠区",
                      re_level: "3"
                  },
                  {
                      re_id: 371003,
                      re_parent: 371000,
                      re_name: "文登区",
                      re_level: "3"
                  },
                  {
                      re_id: 371082,
                      re_parent: 371000,
                      re_name: "荣成市",
                      re_level: "3"
                  },
                  {
                      re_id: 371083,
                      re_parent: 371000,
                      re_name: "乳山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371100,
              re_parent: 370000,
              re_name: "日照市",
              re_level: "2",
              children: [
                  {
                      re_id: 371102,
                      re_parent: 371100,
                      re_name: "东港区",
                      re_level: "3"
                  },
                  {
                      re_id: 371103,
                      re_parent: 371100,
                      re_name: "岚山区",
                      re_level: "3"
                  },
                  {
                      re_id: 371121,
                      re_parent: 371100,
                      re_name: "五莲县",
                      re_level: "3"
                  },
                  {
                      re_id: 371122,
                      re_parent: 371100,
                      re_name: "莒县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371200,
              re_parent: 370000,
              re_name: "莱芜市",
              re_level: "2",
              children: [
                  {
                      re_id: 371202,
                      re_parent: 371200,
                      re_name: "莱城区",
                      re_level: "3"
                  },
                  {
                      re_id: 371203,
                      re_parent: 371200,
                      re_name: "钢城区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371300,
              re_parent: 370000,
              re_name: "临沂市",
              re_level: "2",
              children: [
                  {
                      re_id: 371302,
                      re_parent: 371300,
                      re_name: "兰山区",
                      re_level: "3"
                  },
                  {
                      re_id: 371311,
                      re_parent: 371300,
                      re_name: "罗庄区",
                      re_level: "3"
                  },
                  {
                      re_id: 371312,
                      re_parent: 371300,
                      re_name: "河东区",
                      re_level: "3"
                  },
                  {
                      re_id: 371321,
                      re_parent: 371300,
                      re_name: "沂南县",
                      re_level: "3"
                  },
                  {
                      re_id: 371322,
                      re_parent: 371300,
                      re_name: "郯城县",
                      re_level: "3"
                  },
                  {
                      re_id: 371323,
                      re_parent: 371300,
                      re_name: "沂水县",
                      re_level: "3"
                  },
                  {
                      re_id: 371324,
                      re_parent: 371300,
                      re_name: "兰陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 371325,
                      re_parent: 371300,
                      re_name: "费县",
                      re_level: "3"
                  },
                  {
                      re_id: 371326,
                      re_parent: 371300,
                      re_name: "平邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 371327,
                      re_parent: 371300,
                      re_name: "莒南县",
                      re_level: "3"
                  },
                  {
                      re_id: 371328,
                      re_parent: 371300,
                      re_name: "蒙阴县",
                      re_level: "3"
                  },
                  {
                      re_id: 371329,
                      re_parent: 371300,
                      re_name: "临沭县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371400,
              re_parent: 370000,
              re_name: "德州市",
              re_level: "2",
              children: [
                  {
                      re_id: 371402,
                      re_parent: 371400,
                      re_name: "德城区",
                      re_level: "3"
                  },
                  {
                      re_id: 371403,
                      re_parent: 371400,
                      re_name: "陵城区",
                      re_level: "3"
                  },
                  {
                      re_id: 371422,
                      re_parent: 371400,
                      re_name: "宁津县",
                      re_level: "3"
                  },
                  {
                      re_id: 371423,
                      re_parent: 371400,
                      re_name: "庆云县",
                      re_level: "3"
                  },
                  {
                      re_id: 371424,
                      re_parent: 371400,
                      re_name: "临邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 371425,
                      re_parent: 371400,
                      re_name: "齐河县",
                      re_level: "3"
                  },
                  {
                      re_id: 371426,
                      re_parent: 371400,
                      re_name: "平原县",
                      re_level: "3"
                  },
                  {
                      re_id: 371427,
                      re_parent: 371400,
                      re_name: "夏津县",
                      re_level: "3"
                  },
                  {
                      re_id: 371428,
                      re_parent: 371400,
                      re_name: "武城县",
                      re_level: "3"
                  },
                  {
                      re_id: 371481,
                      re_parent: 371400,
                      re_name: "乐陵市",
                      re_level: "3"
                  },
                  {
                      re_id: 371482,
                      re_parent: 371400,
                      re_name: "禹城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371500,
              re_parent: 370000,
              re_name: "聊城市",
              re_level: "2",
              children: [
                  {
                      re_id: 371502,
                      re_parent: 371500,
                      re_name: "东昌府区",
                      re_level: "3"
                  },
                  {
                      re_id: 371521,
                      re_parent: 371500,
                      re_name: "阳谷县",
                      re_level: "3"
                  },
                  {
                      re_id: 371522,
                      re_parent: 371500,
                      re_name: "莘县",
                      re_level: "3"
                  },
                  {
                      re_id: 371523,
                      re_parent: 371500,
                      re_name: "茌平县",
                      re_level: "3"
                  },
                  {
                      re_id: 371524,
                      re_parent: 371500,
                      re_name: "东阿县",
                      re_level: "3"
                  },
                  {
                      re_id: 371525,
                      re_parent: 371500,
                      re_name: "冠县",
                      re_level: "3"
                  },
                  {
                      re_id: 371526,
                      re_parent: 371500,
                      re_name: "高唐县",
                      re_level: "3"
                  },
                  {
                      re_id: 371581,
                      re_parent: 371500,
                      re_name: "临清市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371600,
              re_parent: 370000,
              re_name: "滨州市",
              re_level: "2",
              children: [
                  {
                      re_id: 371602,
                      re_parent: 371600,
                      re_name: "滨城区",
                      re_level: "3"
                  },
                  {
                      re_id: 371603,
                      re_parent: 371600,
                      re_name: "沾化区",
                      re_level: "3"
                  },
                  {
                      re_id: 371621,
                      re_parent: 371600,
                      re_name: "惠民县",
                      re_level: "3"
                  },
                  {
                      re_id: 371622,
                      re_parent: 371600,
                      re_name: "阳信县",
                      re_level: "3"
                  },
                  {
                      re_id: 371623,
                      re_parent: 371600,
                      re_name: "无棣县",
                      re_level: "3"
                  },
                  {
                      re_id: 371625,
                      re_parent: 371600,
                      re_name: "博兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 371626,
                      re_parent: 371600,
                      re_name: "邹平县",
                      re_level: "3"
                  },
                  {
                      re_id: 371627,
                      re_parent: 371600,
                      re_name: "北海新区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 371700,
              re_parent: 370000,
              re_name: "菏泽市",
              re_level: "2",
              children: [
                  {
                      re_id: 371702,
                      re_parent: 371700,
                      re_name: "牡丹区",
                      re_level: "3"
                  },
                  {
                      re_id: 371721,
                      re_parent: 371700,
                      re_name: "曹县",
                      re_level: "3"
                  },
                  {
                      re_id: 371722,
                      re_parent: 371700,
                      re_name: "单县",
                      re_level: "3"
                  },
                  {
                      re_id: 371723,
                      re_parent: 371700,
                      re_name: "成武县",
                      re_level: "3"
                  },
                  {
                      re_id: 371724,
                      re_parent: 371700,
                      re_name: "巨野县",
                      re_level: "3"
                  },
                  {
                      re_id: 371725,
                      re_parent: 371700,
                      re_name: "郓城县",
                      re_level: "3"
                  },
                  {
                      re_id: 371726,
                      re_parent: 371700,
                      re_name: "鄄城县",
                      re_level: "3"
                  },
                  {
                      re_id: 371727,
                      re_parent: 371700,
                      re_name: "定陶县",
                      re_level: "3"
                  },
                  {
                      re_id: 371728,
                      re_parent: 371700,
                      re_name: "东明县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 410000,
      re_parent: 100000,
      re_name: "河南省",
      re_level: "1",
      children: [
          {
              re_id: 410100,
              re_parent: 410000,
              re_name: "郑州市",
              re_level: "2",
              children: [
                  {
                      re_id: 410102,
                      re_parent: 410100,
                      re_name: "中原区",
                      re_level: "3"
                  },
                  {
                      re_id: 410103,
                      re_parent: 410100,
                      re_name: "二七区",
                      re_level: "3"
                  },
                  {
                      re_id: 410104,
                      re_parent: 410100,
                      re_name: "管城回族区",
                      re_level: "3"
                  },
                  {
                      re_id: 410105,
                      re_parent: 410100,
                      re_name: "金水区",
                      re_level: "3"
                  },
                  {
                      re_id: 410106,
                      re_parent: 410100,
                      re_name: "上街区",
                      re_level: "3"
                  },
                  {
                      re_id: 410108,
                      re_parent: 410100,
                      re_name: "惠济区",
                      re_level: "3"
                  },
                  {
                      re_id: 410122,
                      re_parent: 410100,
                      re_name: "中牟县",
                      re_level: "3"
                  },
                  {
                      re_id: 410181,
                      re_parent: 410100,
                      re_name: "巩义市",
                      re_level: "3"
                  },
                  {
                      re_id: 410182,
                      re_parent: 410100,
                      re_name: "荥阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 410183,
                      re_parent: 410100,
                      re_name: "新密市",
                      re_level: "3"
                  },
                  {
                      re_id: 410184,
                      re_parent: 410100,
                      re_name: "新郑市",
                      re_level: "3"
                  },
                  {
                      re_id: 410185,
                      re_parent: 410100,
                      re_name: "登封市",
                      re_level: "3"
                  },
                  {
                      re_id: 410186,
                      re_parent: 410100,
                      re_name: "郑东新区",
                      re_level: "3"
                  },
                  {
                      re_id: 410187,
                      re_parent: 410100,
                      re_name: "高新区",
                      re_level: "3"
                  },
                  {
                      re_id: 410188,
                      re_parent: 410100,
                      re_name: "航空港区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410200,
              re_parent: 410000,
              re_name: "开封市",
              re_level: "2",
              children: [
                  {
                      re_id: 410202,
                      re_parent: 410200,
                      re_name: "龙亭区",
                      re_level: "3"
                  },
                  {
                      re_id: 410203,
                      re_parent: 410200,
                      re_name: "顺河回族区",
                      re_level: "3"
                  },
                  {
                      re_id: 410204,
                      re_parent: 410200,
                      re_name: "鼓楼区",
                      re_level: "3"
                  },
                  {
                      re_id: 410205,
                      re_parent: 410200,
                      re_name: "禹王台区",
                      re_level: "3"
                  },
                  {
                      re_id: 410212,
                      re_parent: 410200,
                      re_name: "祥符区",
                      re_level: "3"
                  },
                  {
                      re_id: 410221,
                      re_parent: 410200,
                      re_name: "杞县",
                      re_level: "3"
                  },
                  {
                      re_id: 410222,
                      re_parent: 410200,
                      re_name: "通许县",
                      re_level: "3"
                  },
                  {
                      re_id: 410223,
                      re_parent: 410200,
                      re_name: "尉氏县",
                      re_level: "3"
                  },
                  {
                      re_id: 410225,
                      re_parent: 410200,
                      re_name: "兰考县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410300,
              re_parent: 410000,
              re_name: "洛阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 410302,
                      re_parent: 410300,
                      re_name: "老城区",
                      re_level: "3"
                  },
                  {
                      re_id: 410303,
                      re_parent: 410300,
                      re_name: "西工区",
                      re_level: "3"
                  },
                  {
                      re_id: 410304,
                      re_parent: 410300,
                      re_name: "瀍河回族区",
                      re_level: "3"
                  },
                  {
                      re_id: 410305,
                      re_parent: 410300,
                      re_name: "涧西区",
                      re_level: "3"
                  },
                  {
                      re_id: 410306,
                      re_parent: 410300,
                      re_name: "吉利区",
                      re_level: "3"
                  },
                  {
                      re_id: 410311,
                      re_parent: 410300,
                      re_name: "洛龙区",
                      re_level: "3"
                  },
                  {
                      re_id: 410322,
                      re_parent: 410300,
                      re_name: "孟津县",
                      re_level: "3"
                  },
                  {
                      re_id: 410323,
                      re_parent: 410300,
                      re_name: "新安县",
                      re_level: "3"
                  },
                  {
                      re_id: 410324,
                      re_parent: 410300,
                      re_name: "栾川县",
                      re_level: "3"
                  },
                  {
                      re_id: 410325,
                      re_parent: 410300,
                      re_name: "嵩县",
                      re_level: "3"
                  },
                  {
                      re_id: 410326,
                      re_parent: 410300,
                      re_name: "汝阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 410327,
                      re_parent: 410300,
                      re_name: "宜阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 410328,
                      re_parent: 410300,
                      re_name: "洛宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 410329,
                      re_parent: 410300,
                      re_name: "伊川县",
                      re_level: "3"
                  },
                  {
                      re_id: 410381,
                      re_parent: 410300,
                      re_name: "偃师市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410400,
              re_parent: 410000,
              re_name: "平顶山市",
              re_level: "2",
              children: [
                  {
                      re_id: 410402,
                      re_parent: 410400,
                      re_name: "新华区",
                      re_level: "3"
                  },
                  {
                      re_id: 410403,
                      re_parent: 410400,
                      re_name: "卫东区",
                      re_level: "3"
                  },
                  {
                      re_id: 410404,
                      re_parent: 410400,
                      re_name: "石龙区",
                      re_level: "3"
                  },
                  {
                      re_id: 410411,
                      re_parent: 410400,
                      re_name: "湛河区",
                      re_level: "3"
                  },
                  {
                      re_id: 410421,
                      re_parent: 410400,
                      re_name: "宝丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 410422,
                      re_parent: 410400,
                      re_name: "叶县",
                      re_level: "3"
                  },
                  {
                      re_id: 410423,
                      re_parent: 410400,
                      re_name: "鲁山县",
                      re_level: "3"
                  },
                  {
                      re_id: 410425,
                      re_parent: 410400,
                      re_name: "郏县",
                      re_level: "3"
                  },
                  {
                      re_id: 410481,
                      re_parent: 410400,
                      re_name: "舞钢市",
                      re_level: "3"
                  },
                  {
                      re_id: 410482,
                      re_parent: 410400,
                      re_name: "汝州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410500,
              re_parent: 410000,
              re_name: "安阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 410502,
                      re_parent: 410500,
                      re_name: "文峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 410503,
                      re_parent: 410500,
                      re_name: "北关区",
                      re_level: "3"
                  },
                  {
                      re_id: 410505,
                      re_parent: 410500,
                      re_name: "殷都区",
                      re_level: "3"
                  },
                  {
                      re_id: 410506,
                      re_parent: 410500,
                      re_name: "龙安区",
                      re_level: "3"
                  },
                  {
                      re_id: 410522,
                      re_parent: 410500,
                      re_name: "安阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 410523,
                      re_parent: 410500,
                      re_name: "汤阴县",
                      re_level: "3"
                  },
                  {
                      re_id: 410526,
                      re_parent: 410500,
                      re_name: "滑县",
                      re_level: "3"
                  },
                  {
                      re_id: 410527,
                      re_parent: 410500,
                      re_name: "内黄县",
                      re_level: "3"
                  },
                  {
                      re_id: 410581,
                      re_parent: 410500,
                      re_name: "林州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410600,
              re_parent: 410000,
              re_name: "鹤壁市",
              re_level: "2",
              children: [
                  {
                      re_id: 410602,
                      re_parent: 410600,
                      re_name: "鹤山区",
                      re_level: "3"
                  },
                  {
                      re_id: 410603,
                      re_parent: 410600,
                      re_name: "山城区",
                      re_level: "3"
                  },
                  {
                      re_id: 410611,
                      re_parent: 410600,
                      re_name: "淇滨区",
                      re_level: "3"
                  },
                  {
                      re_id: 410621,
                      re_parent: 410600,
                      re_name: "浚县",
                      re_level: "3"
                  },
                  {
                      re_id: 410622,
                      re_parent: 410600,
                      re_name: "淇县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410700,
              re_parent: 410000,
              re_name: "新乡市",
              re_level: "2",
              children: [
                  {
                      re_id: 410702,
                      re_parent: 410700,
                      re_name: "红旗区",
                      re_level: "3"
                  },
                  {
                      re_id: 410703,
                      re_parent: 410700,
                      re_name: "卫滨区",
                      re_level: "3"
                  },
                  {
                      re_id: 410704,
                      re_parent: 410700,
                      re_name: "凤泉区",
                      re_level: "3"
                  },
                  {
                      re_id: 410711,
                      re_parent: 410700,
                      re_name: "牧野区",
                      re_level: "3"
                  },
                  {
                      re_id: 410721,
                      re_parent: 410700,
                      re_name: "新乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 410724,
                      re_parent: 410700,
                      re_name: "获嘉县",
                      re_level: "3"
                  },
                  {
                      re_id: 410725,
                      re_parent: 410700,
                      re_name: "原阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 410726,
                      re_parent: 410700,
                      re_name: "延津县",
                      re_level: "3"
                  },
                  {
                      re_id: 410727,
                      re_parent: 410700,
                      re_name: "封丘县",
                      re_level: "3"
                  },
                  {
                      re_id: 410728,
                      re_parent: 410700,
                      re_name: "长垣县",
                      re_level: "3"
                  },
                  {
                      re_id: 410781,
                      re_parent: 410700,
                      re_name: "卫辉市",
                      re_level: "3"
                  },
                  {
                      re_id: 410782,
                      re_parent: 410700,
                      re_name: "辉县市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410800,
              re_parent: 410000,
              re_name: "焦作市",
              re_level: "2",
              children: [
                  {
                      re_id: 410802,
                      re_parent: 410800,
                      re_name: "解放区",
                      re_level: "3"
                  },
                  {
                      re_id: 410803,
                      re_parent: 410800,
                      re_name: "中站区",
                      re_level: "3"
                  },
                  {
                      re_id: 410804,
                      re_parent: 410800,
                      re_name: "马村区",
                      re_level: "3"
                  },
                  {
                      re_id: 410811,
                      re_parent: 410800,
                      re_name: "山阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 410821,
                      re_parent: 410800,
                      re_name: "修武县",
                      re_level: "3"
                  },
                  {
                      re_id: 410822,
                      re_parent: 410800,
                      re_name: "博爱县",
                      re_level: "3"
                  },
                  {
                      re_id: 410823,
                      re_parent: 410800,
                      re_name: "武陟县",
                      re_level: "3"
                  },
                  {
                      re_id: 410825,
                      re_parent: 410800,
                      re_name: "温县",
                      re_level: "3"
                  },
                  {
                      re_id: 410882,
                      re_parent: 410800,
                      re_name: "沁阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 410883,
                      re_parent: 410800,
                      re_name: "孟州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 410900,
              re_parent: 410000,
              re_name: "濮阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 410902,
                      re_parent: 410900,
                      re_name: "华龙区",
                      re_level: "3"
                  },
                  {
                      re_id: 410922,
                      re_parent: 410900,
                      re_name: "清丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 410923,
                      re_parent: 410900,
                      re_name: "南乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 410926,
                      re_parent: 410900,
                      re_name: "范县",
                      re_level: "3"
                  },
                  {
                      re_id: 410927,
                      re_parent: 410900,
                      re_name: "台前县",
                      re_level: "3"
                  },
                  {
                      re_id: 410928,
                      re_parent: 410900,
                      re_name: "濮阳县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411000,
              re_parent: 410000,
              re_name: "许昌市",
              re_level: "2",
              children: [
                  {
                      re_id: 411002,
                      re_parent: 411000,
                      re_name: "魏都区",
                      re_level: "3"
                  },
                  {
                      re_id: 411023,
                      re_parent: 411000,
                      re_name: "许昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 411024,
                      re_parent: 411000,
                      re_name: "鄢陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 411025,
                      re_parent: 411000,
                      re_name: "襄城县",
                      re_level: "3"
                  },
                  {
                      re_id: 411081,
                      re_parent: 411000,
                      re_name: "禹州市",
                      re_level: "3"
                  },
                  {
                      re_id: 411082,
                      re_parent: 411000,
                      re_name: "长葛市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411100,
              re_parent: 410000,
              re_name: "漯河市",
              re_level: "2",
              children: [
                  {
                      re_id: 411102,
                      re_parent: 411100,
                      re_name: "源汇区",
                      re_level: "3"
                  },
                  {
                      re_id: 411103,
                      re_parent: 411100,
                      re_name: "郾城区",
                      re_level: "3"
                  },
                  {
                      re_id: 411104,
                      re_parent: 411100,
                      re_name: "召陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 411121,
                      re_parent: 411100,
                      re_name: "舞阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 411122,
                      re_parent: 411100,
                      re_name: "临颍县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411200,
              re_parent: 410000,
              re_name: "三门峡市",
              re_level: "2",
              children: [
                  {
                      re_id: 411202,
                      re_parent: 411200,
                      re_name: "湖滨区",
                      re_level: "3"
                  },
                  {
                      re_id: 411221,
                      re_parent: 411200,
                      re_name: "渑池县",
                      re_level: "3"
                  },
                  {
                      re_id: 411222,
                      re_parent: 411200,
                      re_name: "陕县",
                      re_level: "3"
                  },
                  {
                      re_id: 411224,
                      re_parent: 411200,
                      re_name: "卢氏县",
                      re_level: "3"
                  },
                  {
                      re_id: 411281,
                      re_parent: 411200,
                      re_name: "义马市",
                      re_level: "3"
                  },
                  {
                      re_id: 411282,
                      re_parent: 411200,
                      re_name: "灵宝市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411300,
              re_parent: 410000,
              re_name: "南阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 411302,
                      re_parent: 411300,
                      re_name: "宛城区",
                      re_level: "3"
                  },
                  {
                      re_id: 411303,
                      re_parent: 411300,
                      re_name: "卧龙区",
                      re_level: "3"
                  },
                  {
                      re_id: 411321,
                      re_parent: 411300,
                      re_name: "南召县",
                      re_level: "3"
                  },
                  {
                      re_id: 411322,
                      re_parent: 411300,
                      re_name: "方城县",
                      re_level: "3"
                  },
                  {
                      re_id: 411323,
                      re_parent: 411300,
                      re_name: "西峡县",
                      re_level: "3"
                  },
                  {
                      re_id: 411324,
                      re_parent: 411300,
                      re_name: "镇平县",
                      re_level: "3"
                  },
                  {
                      re_id: 411325,
                      re_parent: 411300,
                      re_name: "内乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 411326,
                      re_parent: 411300,
                      re_name: "淅川县",
                      re_level: "3"
                  },
                  {
                      re_id: 411327,
                      re_parent: 411300,
                      re_name: "社旗县",
                      re_level: "3"
                  },
                  {
                      re_id: 411328,
                      re_parent: 411300,
                      re_name: "唐河县",
                      re_level: "3"
                  },
                  {
                      re_id: 411329,
                      re_parent: 411300,
                      re_name: "新野县",
                      re_level: "3"
                  },
                  {
                      re_id: 411330,
                      re_parent: 411300,
                      re_name: "桐柏县",
                      re_level: "3"
                  },
                  {
                      re_id: 411381,
                      re_parent: 411300,
                      re_name: "邓州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411400,
              re_parent: 410000,
              re_name: "商丘市",
              re_level: "2",
              children: [
                  {
                      re_id: 411402,
                      re_parent: 411400,
                      re_name: "梁园区",
                      re_level: "3"
                  },
                  {
                      re_id: 411403,
                      re_parent: 411400,
                      re_name: "睢阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 411421,
                      re_parent: 411400,
                      re_name: "民权县",
                      re_level: "3"
                  },
                  {
                      re_id: 411422,
                      re_parent: 411400,
                      re_name: "睢县",
                      re_level: "3"
                  },
                  {
                      re_id: 411423,
                      re_parent: 411400,
                      re_name: "宁陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 411424,
                      re_parent: 411400,
                      re_name: "柘城县",
                      re_level: "3"
                  },
                  {
                      re_id: 411425,
                      re_parent: 411400,
                      re_name: "虞城县",
                      re_level: "3"
                  },
                  {
                      re_id: 411426,
                      re_parent: 411400,
                      re_name: "夏邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 411481,
                      re_parent: 411400,
                      re_name: "永城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411500,
              re_parent: 410000,
              re_name: "信阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 411502,
                      re_parent: 411500,
                      re_name: "浉河区",
                      re_level: "3"
                  },
                  {
                      re_id: 411503,
                      re_parent: 411500,
                      re_name: "平桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 411521,
                      re_parent: 411500,
                      re_name: "罗山县",
                      re_level: "3"
                  },
                  {
                      re_id: 411522,
                      re_parent: 411500,
                      re_name: "光山县",
                      re_level: "3"
                  },
                  {
                      re_id: 411523,
                      re_parent: 411500,
                      re_name: "新县",
                      re_level: "3"
                  },
                  {
                      re_id: 411524,
                      re_parent: 411500,
                      re_name: "商城县",
                      re_level: "3"
                  },
                  {
                      re_id: 411525,
                      re_parent: 411500,
                      re_name: "固始县",
                      re_level: "3"
                  },
                  {
                      re_id: 411526,
                      re_parent: 411500,
                      re_name: "潢川县",
                      re_level: "3"
                  },
                  {
                      re_id: 411527,
                      re_parent: 411500,
                      re_name: "淮滨县",
                      re_level: "3"
                  },
                  {
                      re_id: 411528,
                      re_parent: 411500,
                      re_name: "息县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411600,
              re_parent: 410000,
              re_name: "周口市",
              re_level: "2",
              children: [
                  {
                      re_id: 411602,
                      re_parent: 411600,
                      re_name: "川汇区",
                      re_level: "3"
                  },
                  {
                      re_id: 411621,
                      re_parent: 411600,
                      re_name: "扶沟县",
                      re_level: "3"
                  },
                  {
                      re_id: 411622,
                      re_parent: 411600,
                      re_name: "西华县",
                      re_level: "3"
                  },
                  {
                      re_id: 411623,
                      re_parent: 411600,
                      re_name: "商水县",
                      re_level: "3"
                  },
                  {
                      re_id: 411624,
                      re_parent: 411600,
                      re_name: "沈丘县",
                      re_level: "3"
                  },
                  {
                      re_id: 411625,
                      re_parent: 411600,
                      re_name: "郸城县",
                      re_level: "3"
                  },
                  {
                      re_id: 411626,
                      re_parent: 411600,
                      re_name: "淮阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 411627,
                      re_parent: 411600,
                      re_name: "太康县",
                      re_level: "3"
                  },
                  {
                      re_id: 411628,
                      re_parent: 411600,
                      re_name: "鹿邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 411681,
                      re_parent: 411600,
                      re_name: "项城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 411700,
              re_parent: 410000,
              re_name: "驻马店市",
              re_level: "2",
              children: [
                  {
                      re_id: 411702,
                      re_parent: 411700,
                      re_name: "驿城区",
                      re_level: "3"
                  },
                  {
                      re_id: 411721,
                      re_parent: 411700,
                      re_name: "西平县",
                      re_level: "3"
                  },
                  {
                      re_id: 411722,
                      re_parent: 411700,
                      re_name: "上蔡县",
                      re_level: "3"
                  },
                  {
                      re_id: 411723,
                      re_parent: 411700,
                      re_name: "平舆县",
                      re_level: "3"
                  },
                  {
                      re_id: 411724,
                      re_parent: 411700,
                      re_name: "正阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 411725,
                      re_parent: 411700,
                      re_name: "确山县",
                      re_level: "3"
                  },
                  {
                      re_id: 411726,
                      re_parent: 411700,
                      re_name: "泌阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 411727,
                      re_parent: 411700,
                      re_name: "汝南县",
                      re_level: "3"
                  },
                  {
                      re_id: 411728,
                      re_parent: 411700,
                      re_name: "遂平县",
                      re_level: "3"
                  },
                  {
                      re_id: 411729,
                      re_parent: 411700,
                      re_name: "新蔡县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 419000,
              re_parent: 410000,
              re_name: "直辖县级",
              re_level: "2",
              children: [
                  {
                      re_id: 419001,
                      re_parent: 419000,
                      re_name: "济源市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 420000,
      re_parent: 100000,
      re_name: "湖北省",
      re_level: "1",
      children: [
          {
              re_id: 420100,
              re_parent: 420000,
              re_name: "武汉市",
              re_level: "2",
              children: [
                  {
                      re_id: 420102,
                      re_parent: 420100,
                      re_name: "江岸区",
                      re_level: "3"
                  },
                  {
                      re_id: 420103,
                      re_parent: 420100,
                      re_name: "江汉区",
                      re_level: "3"
                  },
                  {
                      re_id: 420104,
                      re_parent: 420100,
                      re_name: "硚口区",
                      re_level: "3"
                  },
                  {
                      re_id: 420105,
                      re_parent: 420100,
                      re_name: "汉阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 420106,
                      re_parent: 420100,
                      re_name: "武昌区",
                      re_level: "3"
                  },
                  {
                      re_id: 420107,
                      re_parent: 420100,
                      re_name: "青山区",
                      re_level: "3"
                  },
                  {
                      re_id: 420111,
                      re_parent: 420100,
                      re_name: "洪山区",
                      re_level: "3"
                  },
                  {
                      re_id: 420112,
                      re_parent: 420100,
                      re_name: "东西湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 420113,
                      re_parent: 420100,
                      re_name: "汉南区",
                      re_level: "3"
                  },
                  {
                      re_id: 420114,
                      re_parent: 420100,
                      re_name: "蔡甸区",
                      re_level: "3"
                  },
                  {
                      re_id: 420115,
                      re_parent: 420100,
                      re_name: "江夏区",
                      re_level: "3"
                  },
                  {
                      re_id: 420116,
                      re_parent: 420100,
                      re_name: "黄陂区",
                      re_level: "3"
                  },
                  {
                      re_id: 420117,
                      re_parent: 420100,
                      re_name: "新洲区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420200,
              re_parent: 420000,
              re_name: "黄石市",
              re_level: "2",
              children: [
                  {
                      re_id: 420202,
                      re_parent: 420200,
                      re_name: "黄石港区",
                      re_level: "3"
                  },
                  {
                      re_id: 420203,
                      re_parent: 420200,
                      re_name: "西塞山区",
                      re_level: "3"
                  },
                  {
                      re_id: 420204,
                      re_parent: 420200,
                      re_name: "下陆区",
                      re_level: "3"
                  },
                  {
                      re_id: 420205,
                      re_parent: 420200,
                      re_name: "铁山区",
                      re_level: "3"
                  },
                  {
                      re_id: 420222,
                      re_parent: 420200,
                      re_name: "阳新县",
                      re_level: "3"
                  },
                  {
                      re_id: 420281,
                      re_parent: 420200,
                      re_name: "大冶市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420300,
              re_parent: 420000,
              re_name: "十堰市",
              re_level: "2",
              children: [
                  {
                      re_id: 420302,
                      re_parent: 420300,
                      re_name: "茅箭区",
                      re_level: "3"
                  },
                  {
                      re_id: 420303,
                      re_parent: 420300,
                      re_name: "张湾区",
                      re_level: "3"
                  },
                  {
                      re_id: 420304,
                      re_parent: 420300,
                      re_name: "郧阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 420322,
                      re_parent: 420300,
                      re_name: "郧西县",
                      re_level: "3"
                  },
                  {
                      re_id: 420323,
                      re_parent: 420300,
                      re_name: "竹山县",
                      re_level: "3"
                  },
                  {
                      re_id: 420324,
                      re_parent: 420300,
                      re_name: "竹溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 420325,
                      re_parent: 420300,
                      re_name: "房县",
                      re_level: "3"
                  },
                  {
                      re_id: 420381,
                      re_parent: 420300,
                      re_name: "丹江口市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420500,
              re_parent: 420000,
              re_name: "宜昌市",
              re_level: "2",
              children: [
                  {
                      re_id: 420502,
                      re_parent: 420500,
                      re_name: "西陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 420503,
                      re_parent: 420500,
                      re_name: "伍家岗区",
                      re_level: "3"
                  },
                  {
                      re_id: 420504,
                      re_parent: 420500,
                      re_name: "点军区",
                      re_level: "3"
                  },
                  {
                      re_id: 420505,
                      re_parent: 420500,
                      re_name: "猇亭区",
                      re_level: "3"
                  },
                  {
                      re_id: 420506,
                      re_parent: 420500,
                      re_name: "夷陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 420525,
                      re_parent: 420500,
                      re_name: "远安县",
                      re_level: "3"
                  },
                  {
                      re_id: 420526,
                      re_parent: 420500,
                      re_name: "兴山县",
                      re_level: "3"
                  },
                  {
                      re_id: 420527,
                      re_parent: 420500,
                      re_name: "秭归县",
                      re_level: "3"
                  },
                  {
                      re_id: 420528,
                      re_parent: 420500,
                      re_name: "长阳土家族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 420529,
                      re_parent: 420500,
                      re_name: "五峰土家族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 420581,
                      re_parent: 420500,
                      re_name: "宜都市",
                      re_level: "3"
                  },
                  {
                      re_id: 420582,
                      re_parent: 420500,
                      re_name: "当阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 420583,
                      re_parent: 420500,
                      re_name: "枝江市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420600,
              re_parent: 420000,
              re_name: "襄阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 420602,
                      re_parent: 420600,
                      re_name: "襄城区",
                      re_level: "3"
                  },
                  {
                      re_id: 420606,
                      re_parent: 420600,
                      re_name: "樊城区",
                      re_level: "3"
                  },
                  {
                      re_id: 420607,
                      re_parent: 420600,
                      re_name: "襄州区",
                      re_level: "3"
                  },
                  {
                      re_id: 420624,
                      re_parent: 420600,
                      re_name: "南漳县",
                      re_level: "3"
                  },
                  {
                      re_id: 420625,
                      re_parent: 420600,
                      re_name: "谷城县",
                      re_level: "3"
                  },
                  {
                      re_id: 420626,
                      re_parent: 420600,
                      re_name: "保康县",
                      re_level: "3"
                  },
                  {
                      re_id: 420682,
                      re_parent: 420600,
                      re_name: "老河口市",
                      re_level: "3"
                  },
                  {
                      re_id: 420683,
                      re_parent: 420600,
                      re_name: "枣阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 420684,
                      re_parent: 420600,
                      re_name: "宜城市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420700,
              re_parent: 420000,
              re_name: "鄂州市",
              re_level: "2",
              children: [
                  {
                      re_id: 420702,
                      re_parent: 420700,
                      re_name: "梁子湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 420703,
                      re_parent: 420700,
                      re_name: "华容区",
                      re_level: "3"
                  },
                  {
                      re_id: 420704,
                      re_parent: 420700,
                      re_name: "鄂城区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420800,
              re_parent: 420000,
              re_name: "荆门市",
              re_level: "2",
              children: [
                  {
                      re_id: 420802,
                      re_parent: 420800,
                      re_name: "东宝区",
                      re_level: "3"
                  },
                  {
                      re_id: 420804,
                      re_parent: 420800,
                      re_name: "掇刀区",
                      re_level: "3"
                  },
                  {
                      re_id: 420821,
                      re_parent: 420800,
                      re_name: "京山县",
                      re_level: "3"
                  },
                  {
                      re_id: 420822,
                      re_parent: 420800,
                      re_name: "沙洋县",
                      re_level: "3"
                  },
                  {
                      re_id: 420881,
                      re_parent: 420800,
                      re_name: "钟祥市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 420900,
              re_parent: 420000,
              re_name: "孝感市",
              re_level: "2",
              children: [
                  {
                      re_id: 420902,
                      re_parent: 420900,
                      re_name: "孝南区",
                      re_level: "3"
                  },
                  {
                      re_id: 420921,
                      re_parent: 420900,
                      re_name: "孝昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 420922,
                      re_parent: 420900,
                      re_name: "大悟县",
                      re_level: "3"
                  },
                  {
                      re_id: 420923,
                      re_parent: 420900,
                      re_name: "云梦县",
                      re_level: "3"
                  },
                  {
                      re_id: 420981,
                      re_parent: 420900,
                      re_name: "应城市",
                      re_level: "3"
                  },
                  {
                      re_id: 420982,
                      re_parent: 420900,
                      re_name: "安陆市",
                      re_level: "3"
                  },
                  {
                      re_id: 420984,
                      re_parent: 420900,
                      re_name: "汉川市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 421000,
              re_parent: 420000,
              re_name: "荆州市",
              re_level: "2",
              children: [
                  {
                      re_id: 421002,
                      re_parent: 421000,
                      re_name: "沙市区",
                      re_level: "3"
                  },
                  {
                      re_id: 421003,
                      re_parent: 421000,
                      re_name: "荆州区",
                      re_level: "3"
                  },
                  {
                      re_id: 421022,
                      re_parent: 421000,
                      re_name: "公安县",
                      re_level: "3"
                  },
                  {
                      re_id: 421023,
                      re_parent: 421000,
                      re_name: "监利县",
                      re_level: "3"
                  },
                  {
                      re_id: 421024,
                      re_parent: 421000,
                      re_name: "江陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 421081,
                      re_parent: 421000,
                      re_name: "石首市",
                      re_level: "3"
                  },
                  {
                      re_id: 421083,
                      re_parent: 421000,
                      re_name: "洪湖市",
                      re_level: "3"
                  },
                  {
                      re_id: 421087,
                      re_parent: 421000,
                      re_name: "松滋市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 421100,
              re_parent: 420000,
              re_name: "黄冈市",
              re_level: "2",
              children: [
                  {
                      re_id: 421102,
                      re_parent: 421100,
                      re_name: "黄州区",
                      re_level: "3"
                  },
                  {
                      re_id: 421121,
                      re_parent: 421100,
                      re_name: "团风县",
                      re_level: "3"
                  },
                  {
                      re_id: 421122,
                      re_parent: 421100,
                      re_name: "红安县",
                      re_level: "3"
                  },
                  {
                      re_id: 421123,
                      re_parent: 421100,
                      re_name: "罗田县",
                      re_level: "3"
                  },
                  {
                      re_id: 421124,
                      re_parent: 421100,
                      re_name: "英山县",
                      re_level: "3"
                  },
                  {
                      re_id: 421125,
                      re_parent: 421100,
                      re_name: "浠水县",
                      re_level: "3"
                  },
                  {
                      re_id: 421126,
                      re_parent: 421100,
                      re_name: "蕲春县",
                      re_level: "3"
                  },
                  {
                      re_id: 421127,
                      re_parent: 421100,
                      re_name: "黄梅县",
                      re_level: "3"
                  },
                  {
                      re_id: 421181,
                      re_parent: 421100,
                      re_name: "麻城市",
                      re_level: "3"
                  },
                  {
                      re_id: 421182,
                      re_parent: 421100,
                      re_name: "武穴市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 421200,
              re_parent: 420000,
              re_name: "咸宁市",
              re_level: "2",
              children: [
                  {
                      re_id: 421202,
                      re_parent: 421200,
                      re_name: "咸安区",
                      re_level: "3"
                  },
                  {
                      re_id: 421221,
                      re_parent: 421200,
                      re_name: "嘉鱼县",
                      re_level: "3"
                  },
                  {
                      re_id: 421222,
                      re_parent: 421200,
                      re_name: "通城县",
                      re_level: "3"
                  },
                  {
                      re_id: 421223,
                      re_parent: 421200,
                      re_name: "崇阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 421224,
                      re_parent: 421200,
                      re_name: "通山县",
                      re_level: "3"
                  },
                  {
                      re_id: 421281,
                      re_parent: 421200,
                      re_name: "赤壁市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 421300,
              re_parent: 420000,
              re_name: "随州市",
              re_level: "2",
              children: [
                  {
                      re_id: 421303,
                      re_parent: 421300,
                      re_name: "曾都区",
                      re_level: "3"
                  },
                  {
                      re_id: 421321,
                      re_parent: 421300,
                      re_name: "随县",
                      re_level: "3"
                  },
                  {
                      re_id: 421381,
                      re_parent: 421300,
                      re_name: "广水市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 422800,
              re_parent: 420000,
              re_name: "恩施土家族苗族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 422801,
                      re_parent: 422800,
                      re_name: "恩施市",
                      re_level: "3"
                  },
                  {
                      re_id: 422802,
                      re_parent: 422800,
                      re_name: "利川市",
                      re_level: "3"
                  },
                  {
                      re_id: 422822,
                      re_parent: 422800,
                      re_name: "建始县",
                      re_level: "3"
                  },
                  {
                      re_id: 422823,
                      re_parent: 422800,
                      re_name: "巴东县",
                      re_level: "3"
                  },
                  {
                      re_id: 422825,
                      re_parent: 422800,
                      re_name: "宣恩县",
                      re_level: "3"
                  },
                  {
                      re_id: 422826,
                      re_parent: 422800,
                      re_name: "咸丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 422827,
                      re_parent: 422800,
                      re_name: "来凤县",
                      re_level: "3"
                  },
                  {
                      re_id: 422828,
                      re_parent: 422800,
                      re_name: "鹤峰县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 429000,
              re_parent: 420000,
              re_name: "直辖县级",
              re_level: "2",
              children: [
                  {
                      re_id: 429004,
                      re_parent: 429000,
                      re_name: "仙桃市",
                      re_level: "3"
                  },
                  {
                      re_id: 429005,
                      re_parent: 429000,
                      re_name: "潜江市",
                      re_level: "3"
                  },
                  {
                      re_id: 429006,
                      re_parent: 429000,
                      re_name: "天门市",
                      re_level: "3"
                  },
                  {
                      re_id: 429021,
                      re_parent: 429000,
                      re_name: "神农架林区",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 430000,
      re_parent: 100000,
      re_name: "湖南省",
      re_level: "1",
      children: [
          {
              re_id: 430100,
              re_parent: 430000,
              re_name: "长沙市",
              re_level: "2",
              children: [
                  {
                      re_id: 430102,
                      re_parent: 430100,
                      re_name: "芙蓉区",
                      re_level: "3"
                  },
                  {
                      re_id: 430103,
                      re_parent: 430100,
                      re_name: "天心区",
                      re_level: "3"
                  },
                  {
                      re_id: 430104,
                      re_parent: 430100,
                      re_name: "岳麓区",
                      re_level: "3"
                  },
                  {
                      re_id: 430105,
                      re_parent: 430100,
                      re_name: "开福区",
                      re_level: "3"
                  },
                  {
                      re_id: 430111,
                      re_parent: 430100,
                      re_name: "雨花区",
                      re_level: "3"
                  },
                  {
                      re_id: 430112,
                      re_parent: 430100,
                      re_name: "望城区",
                      re_level: "3"
                  },
                  {
                      re_id: 430121,
                      re_parent: 430100,
                      re_name: "长沙县",
                      re_level: "3"
                  },
                  {
                      re_id: 430124,
                      re_parent: 430100,
                      re_name: "宁乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 430181,
                      re_parent: 430100,
                      re_name: "浏阳市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430200,
              re_parent: 430000,
              re_name: "株洲市",
              re_level: "2",
              children: [
                  {
                      re_id: 430202,
                      re_parent: 430200,
                      re_name: "荷塘区",
                      re_level: "3"
                  },
                  {
                      re_id: 430203,
                      re_parent: 430200,
                      re_name: "芦淞区",
                      re_level: "3"
                  },
                  {
                      re_id: 430204,
                      re_parent: 430200,
                      re_name: "石峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 430211,
                      re_parent: 430200,
                      re_name: "天元区",
                      re_level: "3"
                  },
                  {
                      re_id: 430221,
                      re_parent: 430200,
                      re_name: "株洲县",
                      re_level: "3"
                  },
                  {
                      re_id: 430223,
                      re_parent: 430200,
                      re_name: "攸县",
                      re_level: "3"
                  },
                  {
                      re_id: 430224,
                      re_parent: 430200,
                      re_name: "茶陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 430225,
                      re_parent: 430200,
                      re_name: "炎陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 430281,
                      re_parent: 430200,
                      re_name: "醴陵市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430300,
              re_parent: 430000,
              re_name: "湘潭市",
              re_level: "2",
              children: [
                  {
                      re_id: 430302,
                      re_parent: 430300,
                      re_name: "雨湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 430304,
                      re_parent: 430300,
                      re_name: "岳塘区",
                      re_level: "3"
                  },
                  {
                      re_id: 430321,
                      re_parent: 430300,
                      re_name: "湘潭县",
                      re_level: "3"
                  },
                  {
                      re_id: 430381,
                      re_parent: 430300,
                      re_name: "湘乡市",
                      re_level: "3"
                  },
                  {
                      re_id: 430382,
                      re_parent: 430300,
                      re_name: "韶山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430400,
              re_parent: 430000,
              re_name: "衡阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 430405,
                      re_parent: 430400,
                      re_name: "珠晖区",
                      re_level: "3"
                  },
                  {
                      re_id: 430406,
                      re_parent: 430400,
                      re_name: "雁峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 430407,
                      re_parent: 430400,
                      re_name: "石鼓区",
                      re_level: "3"
                  },
                  {
                      re_id: 430408,
                      re_parent: 430400,
                      re_name: "蒸湘区",
                      re_level: "3"
                  },
                  {
                      re_id: 430412,
                      re_parent: 430400,
                      re_name: "南岳区",
                      re_level: "3"
                  },
                  {
                      re_id: 430421,
                      re_parent: 430400,
                      re_name: "衡阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 430422,
                      re_parent: 430400,
                      re_name: "衡南县",
                      re_level: "3"
                  },
                  {
                      re_id: 430423,
                      re_parent: 430400,
                      re_name: "衡山县",
                      re_level: "3"
                  },
                  {
                      re_id: 430424,
                      re_parent: 430400,
                      re_name: "衡东县",
                      re_level: "3"
                  },
                  {
                      re_id: 430426,
                      re_parent: 430400,
                      re_name: "祁东县",
                      re_level: "3"
                  },
                  {
                      re_id: 430481,
                      re_parent: 430400,
                      re_name: "耒阳市",
                      re_level: "3"
                  },
                  {
                      re_id: 430482,
                      re_parent: 430400,
                      re_name: "常宁市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430500,
              re_parent: 430000,
              re_name: "邵阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 430502,
                      re_parent: 430500,
                      re_name: "双清区",
                      re_level: "3"
                  },
                  {
                      re_id: 430503,
                      re_parent: 430500,
                      re_name: "大祥区",
                      re_level: "3"
                  },
                  {
                      re_id: 430511,
                      re_parent: 430500,
                      re_name: "北塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 430521,
                      re_parent: 430500,
                      re_name: "邵东县",
                      re_level: "3"
                  },
                  {
                      re_id: 430522,
                      re_parent: 430500,
                      re_name: "新邵县",
                      re_level: "3"
                  },
                  {
                      re_id: 430523,
                      re_parent: 430500,
                      re_name: "邵阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 430524,
                      re_parent: 430500,
                      re_name: "隆回县",
                      re_level: "3"
                  },
                  {
                      re_id: 430525,
                      re_parent: 430500,
                      re_name: "洞口县",
                      re_level: "3"
                  },
                  {
                      re_id: 430527,
                      re_parent: 430500,
                      re_name: "绥宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 430528,
                      re_parent: 430500,
                      re_name: "新宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 430529,
                      re_parent: 430500,
                      re_name: "城步苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 430581,
                      re_parent: 430500,
                      re_name: "武冈市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430600,
              re_parent: 430000,
              re_name: "岳阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 430602,
                      re_parent: 430600,
                      re_name: "岳阳楼区",
                      re_level: "3"
                  },
                  {
                      re_id: 430603,
                      re_parent: 430600,
                      re_name: "云溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 430611,
                      re_parent: 430600,
                      re_name: "君山区",
                      re_level: "3"
                  },
                  {
                      re_id: 430621,
                      re_parent: 430600,
                      re_name: "岳阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 430623,
                      re_parent: 430600,
                      re_name: "华容县",
                      re_level: "3"
                  },
                  {
                      re_id: 430624,
                      re_parent: 430600,
                      re_name: "湘阴县",
                      re_level: "3"
                  },
                  {
                      re_id: 430626,
                      re_parent: 430600,
                      re_name: "平江县",
                      re_level: "3"
                  },
                  {
                      re_id: 430681,
                      re_parent: 430600,
                      re_name: "汨罗市",
                      re_level: "3"
                  },
                  {
                      re_id: 430682,
                      re_parent: 430600,
                      re_name: "临湘市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430700,
              re_parent: 430000,
              re_name: "常德市",
              re_level: "2",
              children: [
                  {
                      re_id: 430702,
                      re_parent: 430700,
                      re_name: "武陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 430703,
                      re_parent: 430700,
                      re_name: "鼎城区",
                      re_level: "3"
                  },
                  {
                      re_id: 430721,
                      re_parent: 430700,
                      re_name: "安乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 430722,
                      re_parent: 430700,
                      re_name: "汉寿县",
                      re_level: "3"
                  },
                  {
                      re_id: 430723,
                      re_parent: 430700,
                      re_name: "澧县",
                      re_level: "3"
                  },
                  {
                      re_id: 430724,
                      re_parent: 430700,
                      re_name: "临澧县",
                      re_level: "3"
                  },
                  {
                      re_id: 430725,
                      re_parent: 430700,
                      re_name: "桃源县",
                      re_level: "3"
                  },
                  {
                      re_id: 430726,
                      re_parent: 430700,
                      re_name: "石门县",
                      re_level: "3"
                  },
                  {
                      re_id: 430781,
                      re_parent: 430700,
                      re_name: "津市市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430800,
              re_parent: 430000,
              re_name: "张家界市",
              re_level: "2",
              children: [
                  {
                      re_id: 430802,
                      re_parent: 430800,
                      re_name: "永定区",
                      re_level: "3"
                  },
                  {
                      re_id: 430811,
                      re_parent: 430800,
                      re_name: "武陵源区",
                      re_level: "3"
                  },
                  {
                      re_id: 430821,
                      re_parent: 430800,
                      re_name: "慈利县",
                      re_level: "3"
                  },
                  {
                      re_id: 430822,
                      re_parent: 430800,
                      re_name: "桑植县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 430900,
              re_parent: 430000,
              re_name: "益阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 430902,
                      re_parent: 430900,
                      re_name: "资阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 430903,
                      re_parent: 430900,
                      re_name: "赫山区",
                      re_level: "3"
                  },
                  {
                      re_id: 430921,
                      re_parent: 430900,
                      re_name: "南县",
                      re_level: "3"
                  },
                  {
                      re_id: 430922,
                      re_parent: 430900,
                      re_name: "桃江县",
                      re_level: "3"
                  },
                  {
                      re_id: 430923,
                      re_parent: 430900,
                      re_name: "安化县",
                      re_level: "3"
                  },
                  {
                      re_id: 430981,
                      re_parent: 430900,
                      re_name: "沅江市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 431000,
              re_parent: 430000,
              re_name: "郴州市",
              re_level: "2",
              children: [
                  {
                      re_id: 431002,
                      re_parent: 431000,
                      re_name: "北湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 431003,
                      re_parent: 431000,
                      re_name: "苏仙区",
                      re_level: "3"
                  },
                  {
                      re_id: 431021,
                      re_parent: 431000,
                      re_name: "桂阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 431022,
                      re_parent: 431000,
                      re_name: "宜章县",
                      re_level: "3"
                  },
                  {
                      re_id: 431023,
                      re_parent: 431000,
                      re_name: "永兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 431024,
                      re_parent: 431000,
                      re_name: "嘉禾县",
                      re_level: "3"
                  },
                  {
                      re_id: 431025,
                      re_parent: 431000,
                      re_name: "临武县",
                      re_level: "3"
                  },
                  {
                      re_id: 431026,
                      re_parent: 431000,
                      re_name: "汝城县",
                      re_level: "3"
                  },
                  {
                      re_id: 431027,
                      re_parent: 431000,
                      re_name: "桂东县",
                      re_level: "3"
                  },
                  {
                      re_id: 431028,
                      re_parent: 431000,
                      re_name: "安仁县",
                      re_level: "3"
                  },
                  {
                      re_id: 431081,
                      re_parent: 431000,
                      re_name: "资兴市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 431100,
              re_parent: 430000,
              re_name: "永州市",
              re_level: "2",
              children: [
                  {
                      re_id: 431102,
                      re_parent: 431100,
                      re_name: "零陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 431103,
                      re_parent: 431100,
                      re_name: "冷水滩区",
                      re_level: "3"
                  },
                  {
                      re_id: 431121,
                      re_parent: 431100,
                      re_name: "祁阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 431122,
                      re_parent: 431100,
                      re_name: "东安县",
                      re_level: "3"
                  },
                  {
                      re_id: 431123,
                      re_parent: 431100,
                      re_name: "双牌县",
                      re_level: "3"
                  },
                  {
                      re_id: 431124,
                      re_parent: 431100,
                      re_name: "道县",
                      re_level: "3"
                  },
                  {
                      re_id: 431125,
                      re_parent: 431100,
                      re_name: "江永县",
                      re_level: "3"
                  },
                  {
                      re_id: 431126,
                      re_parent: 431100,
                      re_name: "宁远县",
                      re_level: "3"
                  },
                  {
                      re_id: 431127,
                      re_parent: 431100,
                      re_name: "蓝山县",
                      re_level: "3"
                  },
                  {
                      re_id: 431128,
                      re_parent: 431100,
                      re_name: "新田县",
                      re_level: "3"
                  },
                  {
                      re_id: 431129,
                      re_parent: 431100,
                      re_name: "江华瑶族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 431200,
              re_parent: 430000,
              re_name: "怀化市",
              re_level: "2",
              children: [
                  {
                      re_id: 431202,
                      re_parent: 431200,
                      re_name: "鹤城区",
                      re_level: "3"
                  },
                  {
                      re_id: 431221,
                      re_parent: 431200,
                      re_name: "中方县",
                      re_level: "3"
                  },
                  {
                      re_id: 431222,
                      re_parent: 431200,
                      re_name: "沅陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 431223,
                      re_parent: 431200,
                      re_name: "辰溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 431224,
                      re_parent: 431200,
                      re_name: "溆浦县",
                      re_level: "3"
                  },
                  {
                      re_id: 431225,
                      re_parent: 431200,
                      re_name: "会同县",
                      re_level: "3"
                  },
                  {
                      re_id: 431226,
                      re_parent: 431200,
                      re_name: "麻阳苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 431227,
                      re_parent: 431200,
                      re_name: "新晃侗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 431228,
                      re_parent: 431200,
                      re_name: "芷江侗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 431229,
                      re_parent: 431200,
                      re_name: "靖州苗族侗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 431230,
                      re_parent: 431200,
                      re_name: "通道侗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 431281,
                      re_parent: 431200,
                      re_name: "洪江市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 431300,
              re_parent: 430000,
              re_name: "娄底市",
              re_level: "2",
              children: [
                  {
                      re_id: 431302,
                      re_parent: 431300,
                      re_name: "娄星区",
                      re_level: "3"
                  },
                  {
                      re_id: 431321,
                      re_parent: 431300,
                      re_name: "双峰县",
                      re_level: "3"
                  },
                  {
                      re_id: 431322,
                      re_parent: 431300,
                      re_name: "新化县",
                      re_level: "3"
                  },
                  {
                      re_id: 431381,
                      re_parent: 431300,
                      re_name: "冷水江市",
                      re_level: "3"
                  },
                  {
                      re_id: 431382,
                      re_parent: 431300,
                      re_name: "涟源市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 433100,
              re_parent: 430000,
              re_name: "湘西土家族苗族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 433101,
                      re_parent: 433100,
                      re_name: "吉首市",
                      re_level: "3"
                  },
                  {
                      re_id: 433122,
                      re_parent: 433100,
                      re_name: "泸溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 433123,
                      re_parent: 433100,
                      re_name: "凤凰县",
                      re_level: "3"
                  },
                  {
                      re_id: 433124,
                      re_parent: 433100,
                      re_name: "花垣县",
                      re_level: "3"
                  },
                  {
                      re_id: 433125,
                      re_parent: 433100,
                      re_name: "保靖县",
                      re_level: "3"
                  },
                  {
                      re_id: 433126,
                      re_parent: 433100,
                      re_name: "古丈县",
                      re_level: "3"
                  },
                  {
                      re_id: 433127,
                      re_parent: 433100,
                      re_name: "永顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 433130,
                      re_parent: 433100,
                      re_name: "龙山县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 440000,
      re_parent: 100000,
      re_name: "广东省",
      re_level: "1",
      children: [
          {
              re_id: 440100,
              re_parent: 440000,
              re_name: "广州市",
              re_level: "2",
              children: [
                  {
                      re_id: 440103,
                      re_parent: 440100,
                      re_name: "荔湾区",
                      re_level: "3"
                  },
                  {
                      re_id: 440104,
                      re_parent: 440100,
                      re_name: "越秀区",
                      re_level: "3"
                  },
                  {
                      re_id: 440105,
                      re_parent: 440100,
                      re_name: "海珠区",
                      re_level: "3"
                  },
                  {
                      re_id: 440106,
                      re_parent: 440100,
                      re_name: "天河区",
                      re_level: "3"
                  },
                  {
                      re_id: 440111,
                      re_parent: 440100,
                      re_name: "白云区",
                      re_level: "3"
                  },
                  {
                      re_id: 440112,
                      re_parent: 440100,
                      re_name: "黄埔区",
                      re_level: "3"
                  },
                  {
                      re_id: 440113,
                      re_parent: 440100,
                      re_name: "番禺区",
                      re_level: "3"
                  },
                  {
                      re_id: 440114,
                      re_parent: 440100,
                      re_name: "花都区",
                      re_level: "3"
                  },
                  {
                      re_id: 440115,
                      re_parent: 440100,
                      re_name: "南沙区",
                      re_level: "3"
                  },
                  {
                      re_id: 440117,
                      re_parent: 440100,
                      re_name: "从化区",
                      re_level: "3"
                  },
                  {
                      re_id: 440118,
                      re_parent: 440100,
                      re_name: "增城区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440200,
              re_parent: 440000,
              re_name: "韶关市",
              re_level: "2",
              children: [
                  {
                      re_id: 440203,
                      re_parent: 440200,
                      re_name: "武江区",
                      re_level: "3"
                  },
                  {
                      re_id: 440204,
                      re_parent: 440200,
                      re_name: "浈江区",
                      re_level: "3"
                  },
                  {
                      re_id: 440205,
                      re_parent: 440200,
                      re_name: "曲江区",
                      re_level: "3"
                  },
                  {
                      re_id: 440222,
                      re_parent: 440200,
                      re_name: "始兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 440224,
                      re_parent: 440200,
                      re_name: "仁化县",
                      re_level: "3"
                  },
                  {
                      re_id: 440229,
                      re_parent: 440200,
                      re_name: "翁源县",
                      re_level: "3"
                  },
                  {
                      re_id: 440232,
                      re_parent: 440200,
                      re_name: "乳源瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 440233,
                      re_parent: 440200,
                      re_name: "新丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 440281,
                      re_parent: 440200,
                      re_name: "乐昌市",
                      re_level: "3"
                  },
                  {
                      re_id: 440282,
                      re_parent: 440200,
                      re_name: "南雄市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440300,
              re_parent: 440000,
              re_name: "深圳市",
              re_level: "2",
              children: [
                  {
                      re_id: 440303,
                      re_parent: 440300,
                      re_name: "罗湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 440304,
                      re_parent: 440300,
                      re_name: "福田区",
                      re_level: "3"
                  },
                  {
                      re_id: 440305,
                      re_parent: 440300,
                      re_name: "南山区",
                      re_level: "3"
                  },
                  {
                      re_id: 440306,
                      re_parent: 440300,
                      re_name: "宝安区",
                      re_level: "3"
                  },
                  {
                      re_id: 440307,
                      re_parent: 440300,
                      re_name: "龙岗区",
                      re_level: "3"
                  },
                  {
                      re_id: 440308,
                      re_parent: 440300,
                      re_name: "盐田区",
                      re_level: "3"
                  },
                  {
                      re_id: 440309,
                      re_parent: 440300,
                      re_name: "光明新区",
                      re_level: "3"
                  },
                  {
                      re_id: 440310,
                      re_parent: 440300,
                      re_name: "坪山新区",
                      re_level: "3"
                  },
                  {
                      re_id: 440311,
                      re_parent: 440300,
                      re_name: "大鹏新区",
                      re_level: "3"
                  },
                  {
                      re_id: 440312,
                      re_parent: 440300,
                      re_name: "龙华新区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440400,
              re_parent: 440000,
              re_name: "珠海市",
              re_level: "2",
              children: [
                  {
                      re_id: 440402,
                      re_parent: 440400,
                      re_name: "香洲区",
                      re_level: "3"
                  },
                  {
                      re_id: 440403,
                      re_parent: 440400,
                      re_name: "斗门区",
                      re_level: "3"
                  },
                  {
                      re_id: 440404,
                      re_parent: 440400,
                      re_name: "金湾区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440500,
              re_parent: 440000,
              re_name: "汕头市",
              re_level: "2",
              children: [
                  {
                      re_id: 440507,
                      re_parent: 440500,
                      re_name: "龙湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 440511,
                      re_parent: 440500,
                      re_name: "金平区",
                      re_level: "3"
                  },
                  {
                      re_id: 440512,
                      re_parent: 440500,
                      re_name: "濠江区",
                      re_level: "3"
                  },
                  {
                      re_id: 440513,
                      re_parent: 440500,
                      re_name: "潮阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 440514,
                      re_parent: 440500,
                      re_name: "潮南区",
                      re_level: "3"
                  },
                  {
                      re_id: 440515,
                      re_parent: 440500,
                      re_name: "澄海区",
                      re_level: "3"
                  },
                  {
                      re_id: 440523,
                      re_parent: 440500,
                      re_name: "南澳县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440600,
              re_parent: 440000,
              re_name: "佛山市",
              re_level: "2",
              children: [
                  {
                      re_id: 440604,
                      re_parent: 440600,
                      re_name: "禅城区",
                      re_level: "3"
                  },
                  {
                      re_id: 440605,
                      re_parent: 440600,
                      re_name: "南海区",
                      re_level: "3"
                  },
                  {
                      re_id: 440606,
                      re_parent: 440600,
                      re_name: "顺德区",
                      re_level: "3"
                  },
                  {
                      re_id: 440607,
                      re_parent: 440600,
                      re_name: "三水区",
                      re_level: "3"
                  },
                  {
                      re_id: 440608,
                      re_parent: 440600,
                      re_name: "高明区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440700,
              re_parent: 440000,
              re_name: "江门市",
              re_level: "2",
              children: [
                  {
                      re_id: 440703,
                      re_parent: 440700,
                      re_name: "蓬江区",
                      re_level: "3"
                  },
                  {
                      re_id: 440704,
                      re_parent: 440700,
                      re_name: "江海区",
                      re_level: "3"
                  },
                  {
                      re_id: 440705,
                      re_parent: 440700,
                      re_name: "新会区",
                      re_level: "3"
                  },
                  {
                      re_id: 440781,
                      re_parent: 440700,
                      re_name: "台山市",
                      re_level: "3"
                  },
                  {
                      re_id: 440783,
                      re_parent: 440700,
                      re_name: "开平市",
                      re_level: "3"
                  },
                  {
                      re_id: 440784,
                      re_parent: 440700,
                      re_name: "鹤山市",
                      re_level: "3"
                  },
                  {
                      re_id: 440785,
                      re_parent: 440700,
                      re_name: "恩平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440800,
              re_parent: 440000,
              re_name: "湛江市",
              re_level: "2",
              children: [
                  {
                      re_id: 440802,
                      re_parent: 440800,
                      re_name: "赤坎区",
                      re_level: "3"
                  },
                  {
                      re_id: 440803,
                      re_parent: 440800,
                      re_name: "霞山区",
                      re_level: "3"
                  },
                  {
                      re_id: 440804,
                      re_parent: 440800,
                      re_name: "坡头区",
                      re_level: "3"
                  },
                  {
                      re_id: 440811,
                      re_parent: 440800,
                      re_name: "麻章区",
                      re_level: "3"
                  },
                  {
                      re_id: 440823,
                      re_parent: 440800,
                      re_name: "遂溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 440825,
                      re_parent: 440800,
                      re_name: "徐闻县",
                      re_level: "3"
                  },
                  {
                      re_id: 440881,
                      re_parent: 440800,
                      re_name: "廉江市",
                      re_level: "3"
                  },
                  {
                      re_id: 440882,
                      re_parent: 440800,
                      re_name: "雷州市",
                      re_level: "3"
                  },
                  {
                      re_id: 440883,
                      re_parent: 440800,
                      re_name: "吴川市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 440900,
              re_parent: 440000,
              re_name: "茂名市",
              re_level: "2",
              children: [
                  {
                      re_id: 440902,
                      re_parent: 440900,
                      re_name: "茂南区",
                      re_level: "3"
                  },
                  {
                      re_id: 440904,
                      re_parent: 440900,
                      re_name: "电白区",
                      re_level: "3"
                  },
                  {
                      re_id: 440981,
                      re_parent: 440900,
                      re_name: "高州市",
                      re_level: "3"
                  },
                  {
                      re_id: 440982,
                      re_parent: 440900,
                      re_name: "化州市",
                      re_level: "3"
                  },
                  {
                      re_id: 440983,
                      re_parent: 440900,
                      re_name: "信宜市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441200,
              re_parent: 440000,
              re_name: "肇庆市",
              re_level: "2",
              children: [
                  {
                      re_id: 441202,
                      re_parent: 441200,
                      re_name: "端州区",
                      re_level: "3"
                  },
                  {
                      re_id: 441203,
                      re_parent: 441200,
                      re_name: "鼎湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 441223,
                      re_parent: 441200,
                      re_name: "广宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 441224,
                      re_parent: 441200,
                      re_name: "怀集县",
                      re_level: "3"
                  },
                  {
                      re_id: 441225,
                      re_parent: 441200,
                      re_name: "封开县",
                      re_level: "3"
                  },
                  {
                      re_id: 441226,
                      re_parent: 441200,
                      re_name: "德庆县",
                      re_level: "3"
                  },
                  {
                      re_id: 441283,
                      re_parent: 441200,
                      re_name: "高要市",
                      re_level: "3"
                  },
                  {
                      re_id: 441284,
                      re_parent: 441200,
                      re_name: "四会市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441300,
              re_parent: 440000,
              re_name: "惠州市",
              re_level: "2",
              children: [
                  {
                      re_id: 441302,
                      re_parent: 441300,
                      re_name: "惠城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441303,
                      re_parent: 441300,
                      re_name: "惠阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 441322,
                      re_parent: 441300,
                      re_name: "博罗县",
                      re_level: "3"
                  },
                  {
                      re_id: 441323,
                      re_parent: 441300,
                      re_name: "惠东县",
                      re_level: "3"
                  },
                  {
                      re_id: 441324,
                      re_parent: 441300,
                      re_name: "龙门县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441400,
              re_parent: 440000,
              re_name: "梅州市",
              re_level: "2",
              children: [
                  {
                      re_id: 441402,
                      re_parent: 441400,
                      re_name: "梅江区",
                      re_level: "3"
                  },
                  {
                      re_id: 441403,
                      re_parent: 441400,
                      re_name: "梅县区",
                      re_level: "3"
                  },
                  {
                      re_id: 441422,
                      re_parent: 441400,
                      re_name: "大埔县",
                      re_level: "3"
                  },
                  {
                      re_id: 441423,
                      re_parent: 441400,
                      re_name: "丰顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 441424,
                      re_parent: 441400,
                      re_name: "五华县",
                      re_level: "3"
                  },
                  {
                      re_id: 441426,
                      re_parent: 441400,
                      re_name: "平远县",
                      re_level: "3"
                  },
                  {
                      re_id: 441427,
                      re_parent: 441400,
                      re_name: "蕉岭县",
                      re_level: "3"
                  },
                  {
                      re_id: 441481,
                      re_parent: 441400,
                      re_name: "兴宁市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441500,
              re_parent: 440000,
              re_name: "汕尾市",
              re_level: "2",
              children: [
                  {
                      re_id: 441502,
                      re_parent: 441500,
                      re_name: "城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441521,
                      re_parent: 441500,
                      re_name: "海丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 441523,
                      re_parent: 441500,
                      re_name: "陆河县",
                      re_level: "3"
                  },
                  {
                      re_id: 441581,
                      re_parent: 441500,
                      re_name: "陆丰市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441600,
              re_parent: 440000,
              re_name: "河源市",
              re_level: "2",
              children: [
                  {
                      re_id: 441602,
                      re_parent: 441600,
                      re_name: "源城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441621,
                      re_parent: 441600,
                      re_name: "紫金县",
                      re_level: "3"
                  },
                  {
                      re_id: 441622,
                      re_parent: 441600,
                      re_name: "龙川县",
                      re_level: "3"
                  },
                  {
                      re_id: 441623,
                      re_parent: 441600,
                      re_name: "连平县",
                      re_level: "3"
                  },
                  {
                      re_id: 441624,
                      re_parent: 441600,
                      re_name: "和平县",
                      re_level: "3"
                  },
                  {
                      re_id: 441625,
                      re_parent: 441600,
                      re_name: "东源县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441700,
              re_parent: 440000,
              re_name: "阳江市",
              re_level: "2",
              children: [
                  {
                      re_id: 441702,
                      re_parent: 441700,
                      re_name: "江城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441704,
                      re_parent: 441700,
                      re_name: "阳东区",
                      re_level: "3"
                  },
                  {
                      re_id: 441721,
                      re_parent: 441700,
                      re_name: "阳西县",
                      re_level: "3"
                  },
                  {
                      re_id: 441781,
                      re_parent: 441700,
                      re_name: "阳春市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441800,
              re_parent: 440000,
              re_name: "清远市",
              re_level: "2",
              children: [
                  {
                      re_id: 441802,
                      re_parent: 441800,
                      re_name: "清城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441803,
                      re_parent: 441800,
                      re_name: "清新区",
                      re_level: "3"
                  },
                  {
                      re_id: 441821,
                      re_parent: 441800,
                      re_name: "佛冈县",
                      re_level: "3"
                  },
                  {
                      re_id: 441823,
                      re_parent: 441800,
                      re_name: "阳山县",
                      re_level: "3"
                  },
                  {
                      re_id: 441825,
                      re_parent: 441800,
                      re_name: "连山壮族瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 441826,
                      re_parent: 441800,
                      re_name: "连南瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 441881,
                      re_parent: 441800,
                      re_name: "英德市",
                      re_level: "3"
                  },
                  {
                      re_id: 441882,
                      re_parent: 441800,
                      re_name: "连州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 441900,
              re_parent: 440000,
              re_name: "东莞市",
              re_level: "2",
              children: [
                  {
                      re_id: 441901,
                      re_parent: 441900,
                      re_name: "莞城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441902,
                      re_parent: 441900,
                      re_name: "南城区",
                      re_level: "3"
                  },
                  {
                      re_id: 441904,
                      re_parent: 441900,
                      re_name: "万江区",
                      re_level: "3"
                  },
                  {
                      re_id: 441905,
                      re_parent: 441900,
                      re_name: "石碣镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441906,
                      re_parent: 441900,
                      re_name: "石龙镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441907,
                      re_parent: 441900,
                      re_name: "茶山镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441908,
                      re_parent: 441900,
                      re_name: "石排镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441909,
                      re_parent: 441900,
                      re_name: "企石镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441910,
                      re_parent: 441900,
                      re_name: "横沥镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441911,
                      re_parent: 441900,
                      re_name: "桥头镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441912,
                      re_parent: 441900,
                      re_name: "谢岗镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441913,
                      re_parent: 441900,
                      re_name: "东坑镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441914,
                      re_parent: 441900,
                      re_name: "常平镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441915,
                      re_parent: 441900,
                      re_name: "寮步镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441916,
                      re_parent: 441900,
                      re_name: "大朗镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441917,
                      re_parent: 441900,
                      re_name: "麻涌镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441918,
                      re_parent: 441900,
                      re_name: "中堂镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441919,
                      re_parent: 441900,
                      re_name: "高埗镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441920,
                      re_parent: 441900,
                      re_name: "樟木头镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441921,
                      re_parent: 441900,
                      re_name: "大岭山镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441922,
                      re_parent: 441900,
                      re_name: "望牛墩镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441923,
                      re_parent: 441900,
                      re_name: "黄江镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441924,
                      re_parent: 441900,
                      re_name: "洪梅镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441925,
                      re_parent: 441900,
                      re_name: "清溪镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441926,
                      re_parent: 441900,
                      re_name: "沙田镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441927,
                      re_parent: 441900,
                      re_name: "道滘镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441928,
                      re_parent: 441900,
                      re_name: "塘厦镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441929,
                      re_parent: 441900,
                      re_name: "虎门镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441930,
                      re_parent: 441900,
                      re_name: "厚街镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441931,
                      re_parent: 441900,
                      re_name: "凤岗镇",
                      re_level: "3"
                  },
                  {
                      re_id: 441932,
                      re_parent: 441900,
                      re_name: "长安镇",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 442000,
              re_parent: 440000,
              re_name: "中山市",
              re_level: "2",
              children: [
                  {
                      re_id: 442001,
                      re_parent: 442000,
                      re_name: "石岐区",
                      re_level: "3"
                  },
                  {
                      re_id: 442004,
                      re_parent: 442000,
                      re_name: "南区",
                      re_level: "3"
                  },
                  {
                      re_id: 442005,
                      re_parent: 442000,
                      re_name: "五桂山区",
                      re_level: "3"
                  },
                  {
                      re_id: 442006,
                      re_parent: 442000,
                      re_name: "火炬开发区",
                      re_level: "3"
                  },
                  {
                      re_id: 442007,
                      re_parent: 442000,
                      re_name: "黄圃镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442008,
                      re_parent: 442000,
                      re_name: "南头镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442009,
                      re_parent: 442000,
                      re_name: "东凤镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442010,
                      re_parent: 442000,
                      re_name: "阜沙镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442011,
                      re_parent: 442000,
                      re_name: "小榄镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442012,
                      re_parent: 442000,
                      re_name: "东升镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442013,
                      re_parent: 442000,
                      re_name: "古镇镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442014,
                      re_parent: 442000,
                      re_name: "横栏镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442015,
                      re_parent: 442000,
                      re_name: "三角镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442016,
                      re_parent: 442000,
                      re_name: "民众镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442017,
                      re_parent: 442000,
                      re_name: "南朗镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442018,
                      re_parent: 442000,
                      re_name: "港口镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442019,
                      re_parent: 442000,
                      re_name: "大涌镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442020,
                      re_parent: 442000,
                      re_name: "沙溪镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442021,
                      re_parent: 442000,
                      re_name: "三乡镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442022,
                      re_parent: 442000,
                      re_name: "板芙镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442023,
                      re_parent: 442000,
                      re_name: "神湾镇",
                      re_level: "3"
                  },
                  {
                      re_id: 442024,
                      re_parent: 442000,
                      re_name: "坦洲镇",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 445100,
              re_parent: 440000,
              re_name: "潮州市",
              re_level: "2",
              children: [
                  {
                      re_id: 445102,
                      re_parent: 445100,
                      re_name: "湘桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 445103,
                      re_parent: 445100,
                      re_name: "潮安区",
                      re_level: "3"
                  },
                  {
                      re_id: 445122,
                      re_parent: 445100,
                      re_name: "饶平县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 445200,
              re_parent: 440000,
              re_name: "揭阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 445202,
                      re_parent: 445200,
                      re_name: "榕城区",
                      re_level: "3"
                  },
                  {
                      re_id: 445203,
                      re_parent: 445200,
                      re_name: "揭东区",
                      re_level: "3"
                  },
                  {
                      re_id: 445222,
                      re_parent: 445200,
                      re_name: "揭西县",
                      re_level: "3"
                  },
                  {
                      re_id: 445224,
                      re_parent: 445200,
                      re_name: "惠来县",
                      re_level: "3"
                  },
                  {
                      re_id: 445281,
                      re_parent: 445200,
                      re_name: "普宁市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 445300,
              re_parent: 440000,
              re_name: "云浮市",
              re_level: "2",
              children: [
                  {
                      re_id: 445302,
                      re_parent: 445300,
                      re_name: "云城区",
                      re_level: "3"
                  },
                  {
                      re_id: 445303,
                      re_parent: 445300,
                      re_name: "云安区",
                      re_level: "3"
                  },
                  {
                      re_id: 445321,
                      re_parent: 445300,
                      re_name: "新兴县",
                      re_level: "3"
                  },
                  {
                      re_id: 445322,
                      re_parent: 445300,
                      re_name: "郁南县",
                      re_level: "3"
                  },
                  {
                      re_id: 445381,
                      re_parent: 445300,
                      re_name: "罗定市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 450000,
      re_parent: 100000,
      re_name: "广西壮族自治区",
      re_level: "1",
      children: [
          {
              re_id: 450100,
              re_parent: 450000,
              re_name: "南宁市",
              re_level: "2",
              children: [
                  {
                      re_id: 450102,
                      re_parent: 450100,
                      re_name: "兴宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 450103,
                      re_parent: 450100,
                      re_name: "青秀区",
                      re_level: "3"
                  },
                  {
                      re_id: 450105,
                      re_parent: 450100,
                      re_name: "江南区",
                      re_level: "3"
                  },
                  {
                      re_id: 450107,
                      re_parent: 450100,
                      re_name: "西乡塘区",
                      re_level: "3"
                  },
                  {
                      re_id: 450108,
                      re_parent: 450100,
                      re_name: "良庆区",
                      re_level: "3"
                  },
                  {
                      re_id: 450109,
                      re_parent: 450100,
                      re_name: "邕宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 450122,
                      re_parent: 450100,
                      re_name: "武鸣县",
                      re_level: "3"
                  },
                  {
                      re_id: 450123,
                      re_parent: 450100,
                      re_name: "隆安县",
                      re_level: "3"
                  },
                  {
                      re_id: 450124,
                      re_parent: 450100,
                      re_name: "马山县",
                      re_level: "3"
                  },
                  {
                      re_id: 450125,
                      re_parent: 450100,
                      re_name: "上林县",
                      re_level: "3"
                  },
                  {
                      re_id: 450126,
                      re_parent: 450100,
                      re_name: "宾阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 450127,
                      re_parent: 450100,
                      re_name: "横县",
                      re_level: "3"
                  },
                  {
                      re_id: 450128,
                      re_parent: 450100,
                      re_name: "埌东新区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450200,
              re_parent: 450000,
              re_name: "柳州市",
              re_level: "2",
              children: [
                  {
                      re_id: 450202,
                      re_parent: 450200,
                      re_name: "城中区",
                      re_level: "3"
                  },
                  {
                      re_id: 450203,
                      re_parent: 450200,
                      re_name: "鱼峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 450204,
                      re_parent: 450200,
                      re_name: "柳南区",
                      re_level: "3"
                  },
                  {
                      re_id: 450205,
                      re_parent: 450200,
                      re_name: "柳北区",
                      re_level: "3"
                  },
                  {
                      re_id: 450221,
                      re_parent: 450200,
                      re_name: "柳江县",
                      re_level: "3"
                  },
                  {
                      re_id: 450222,
                      re_parent: 450200,
                      re_name: "柳城县",
                      re_level: "3"
                  },
                  {
                      re_id: 450223,
                      re_parent: 450200,
                      re_name: "鹿寨县",
                      re_level: "3"
                  },
                  {
                      re_id: 450224,
                      re_parent: 450200,
                      re_name: "融安县",
                      re_level: "3"
                  },
                  {
                      re_id: 450225,
                      re_parent: 450200,
                      re_name: "融水苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 450226,
                      re_parent: 450200,
                      re_name: "三江侗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 450227,
                      re_parent: 450200,
                      re_name: "柳东新区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450300,
              re_parent: 450000,
              re_name: "桂林市",
              re_level: "2",
              children: [
                  {
                      re_id: 450302,
                      re_parent: 450300,
                      re_name: "秀峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 450303,
                      re_parent: 450300,
                      re_name: "叠彩区",
                      re_level: "3"
                  },
                  {
                      re_id: 450304,
                      re_parent: 450300,
                      re_name: "象山区",
                      re_level: "3"
                  },
                  {
                      re_id: 450305,
                      re_parent: 450300,
                      re_name: "七星区",
                      re_level: "3"
                  },
                  {
                      re_id: 450311,
                      re_parent: 450300,
                      re_name: "雁山区",
                      re_level: "3"
                  },
                  {
                      re_id: 450312,
                      re_parent: 450300,
                      re_name: "临桂区",
                      re_level: "3"
                  },
                  {
                      re_id: 450321,
                      re_parent: 450300,
                      re_name: "阳朔县",
                      re_level: "3"
                  },
                  {
                      re_id: 450323,
                      re_parent: 450300,
                      re_name: "灵川县",
                      re_level: "3"
                  },
                  {
                      re_id: 450324,
                      re_parent: 450300,
                      re_name: "全州县",
                      re_level: "3"
                  },
                  {
                      re_id: 450325,
                      re_parent: 450300,
                      re_name: "兴安县",
                      re_level: "3"
                  },
                  {
                      re_id: 450326,
                      re_parent: 450300,
                      re_name: "永福县",
                      re_level: "3"
                  },
                  {
                      re_id: 450327,
                      re_parent: 450300,
                      re_name: "灌阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 450328,
                      re_parent: 450300,
                      re_name: "龙胜各族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 450329,
                      re_parent: 450300,
                      re_name: "资源县",
                      re_level: "3"
                  },
                  {
                      re_id: 450330,
                      re_parent: 450300,
                      re_name: "平乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 450331,
                      re_parent: 450300,
                      re_name: "荔浦县",
                      re_level: "3"
                  },
                  {
                      re_id: 450332,
                      re_parent: 450300,
                      re_name: "恭城瑶族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450400,
              re_parent: 450000,
              re_name: "梧州市",
              re_level: "2",
              children: [
                  {
                      re_id: 450403,
                      re_parent: 450400,
                      re_name: "万秀区",
                      re_level: "3"
                  },
                  {
                      re_id: 450405,
                      re_parent: 450400,
                      re_name: "长洲区",
                      re_level: "3"
                  },
                  {
                      re_id: 450406,
                      re_parent: 450400,
                      re_name: "龙圩区",
                      re_level: "3"
                  },
                  {
                      re_id: 450421,
                      re_parent: 450400,
                      re_name: "苍梧县",
                      re_level: "3"
                  },
                  {
                      re_id: 450422,
                      re_parent: 450400,
                      re_name: "藤县",
                      re_level: "3"
                  },
                  {
                      re_id: 450423,
                      re_parent: 450400,
                      re_name: "蒙山县",
                      re_level: "3"
                  },
                  {
                      re_id: 450481,
                      re_parent: 450400,
                      re_name: "岑溪市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450500,
              re_parent: 450000,
              re_name: "北海市",
              re_level: "2",
              children: [
                  {
                      re_id: 450502,
                      re_parent: 450500,
                      re_name: "海城区",
                      re_level: "3"
                  },
                  {
                      re_id: 450503,
                      re_parent: 450500,
                      re_name: "银海区",
                      re_level: "3"
                  },
                  {
                      re_id: 450512,
                      re_parent: 450500,
                      re_name: "铁山港区",
                      re_level: "3"
                  },
                  {
                      re_id: 450521,
                      re_parent: 450500,
                      re_name: "合浦县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450600,
              re_parent: 450000,
              re_name: "防城港市",
              re_level: "2",
              children: [
                  {
                      re_id: 450602,
                      re_parent: 450600,
                      re_name: "港口区",
                      re_level: "3"
                  },
                  {
                      re_id: 450603,
                      re_parent: 450600,
                      re_name: "防城区",
                      re_level: "3"
                  },
                  {
                      re_id: 450621,
                      re_parent: 450600,
                      re_name: "上思县",
                      re_level: "3"
                  },
                  {
                      re_id: 450681,
                      re_parent: 450600,
                      re_name: "东兴市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450700,
              re_parent: 450000,
              re_name: "钦州市",
              re_level: "2",
              children: [
                  {
                      re_id: 450702,
                      re_parent: 450700,
                      re_name: "钦南区",
                      re_level: "3"
                  },
                  {
                      re_id: 450703,
                      re_parent: 450700,
                      re_name: "钦北区",
                      re_level: "3"
                  },
                  {
                      re_id: 450721,
                      re_parent: 450700,
                      re_name: "灵山县",
                      re_level: "3"
                  },
                  {
                      re_id: 450722,
                      re_parent: 450700,
                      re_name: "浦北县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450800,
              re_parent: 450000,
              re_name: "贵港市",
              re_level: "2",
              children: [
                  {
                      re_id: 450802,
                      re_parent: 450800,
                      re_name: "港北区",
                      re_level: "3"
                  },
                  {
                      re_id: 450803,
                      re_parent: 450800,
                      re_name: "港南区",
                      re_level: "3"
                  },
                  {
                      re_id: 450804,
                      re_parent: 450800,
                      re_name: "覃塘区",
                      re_level: "3"
                  },
                  {
                      re_id: 450821,
                      re_parent: 450800,
                      re_name: "平南县",
                      re_level: "3"
                  },
                  {
                      re_id: 450881,
                      re_parent: 450800,
                      re_name: "桂平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 450900,
              re_parent: 450000,
              re_name: "玉林市",
              re_level: "2",
              children: [
                  {
                      re_id: 450902,
                      re_parent: 450900,
                      re_name: "玉州区",
                      re_level: "3"
                  },
                  {
                      re_id: 450903,
                      re_parent: 450900,
                      re_name: "福绵区",
                      re_level: "3"
                  },
                  {
                      re_id: 450904,
                      re_parent: 450900,
                      re_name: "玉东新区",
                      re_level: "3"
                  },
                  {
                      re_id: 450921,
                      re_parent: 450900,
                      re_name: "容县",
                      re_level: "3"
                  },
                  {
                      re_id: 450922,
                      re_parent: 450900,
                      re_name: "陆川县",
                      re_level: "3"
                  },
                  {
                      re_id: 450923,
                      re_parent: 450900,
                      re_name: "博白县",
                      re_level: "3"
                  },
                  {
                      re_id: 450924,
                      re_parent: 450900,
                      re_name: "兴业县",
                      re_level: "3"
                  },
                  {
                      re_id: 450981,
                      re_parent: 450900,
                      re_name: "北流市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 451000,
              re_parent: 450000,
              re_name: "百色市",
              re_level: "2",
              children: [
                  {
                      re_id: 451002,
                      re_parent: 451000,
                      re_name: "右江区",
                      re_level: "3"
                  },
                  {
                      re_id: 451021,
                      re_parent: 451000,
                      re_name: "田阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 451022,
                      re_parent: 451000,
                      re_name: "田东县",
                      re_level: "3"
                  },
                  {
                      re_id: 451023,
                      re_parent: 451000,
                      re_name: "平果县",
                      re_level: "3"
                  },
                  {
                      re_id: 451024,
                      re_parent: 451000,
                      re_name: "德保县",
                      re_level: "3"
                  },
                  {
                      re_id: 451025,
                      re_parent: 451000,
                      re_name: "靖西县",
                      re_level: "3"
                  },
                  {
                      re_id: 451026,
                      re_parent: 451000,
                      re_name: "那坡县",
                      re_level: "3"
                  },
                  {
                      re_id: 451027,
                      re_parent: 451000,
                      re_name: "凌云县",
                      re_level: "3"
                  },
                  {
                      re_id: 451028,
                      re_parent: 451000,
                      re_name: "乐业县",
                      re_level: "3"
                  },
                  {
                      re_id: 451029,
                      re_parent: 451000,
                      re_name: "田林县",
                      re_level: "3"
                  },
                  {
                      re_id: 451030,
                      re_parent: 451000,
                      re_name: "西林县",
                      re_level: "3"
                  },
                  {
                      re_id: 451031,
                      re_parent: 451000,
                      re_name: "隆林各族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 451100,
              re_parent: 450000,
              re_name: "贺州市",
              re_level: "2",
              children: [
                  {
                      re_id: 451102,
                      re_parent: 451100,
                      re_name: "八步区",
                      re_level: "3"
                  },
                  {
                      re_id: 451121,
                      re_parent: 451100,
                      re_name: "昭平县",
                      re_level: "3"
                  },
                  {
                      re_id: 451122,
                      re_parent: 451100,
                      re_name: "钟山县",
                      re_level: "3"
                  },
                  {
                      re_id: 451123,
                      re_parent: 451100,
                      re_name: "富川瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451124,
                      re_parent: 451100,
                      re_name: "平桂管理区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 451200,
              re_parent: 450000,
              re_name: "河池市",
              re_level: "2",
              children: [
                  {
                      re_id: 451202,
                      re_parent: 451200,
                      re_name: "金城江区",
                      re_level: "3"
                  },
                  {
                      re_id: 451221,
                      re_parent: 451200,
                      re_name: "南丹县",
                      re_level: "3"
                  },
                  {
                      re_id: 451222,
                      re_parent: 451200,
                      re_name: "天峨县",
                      re_level: "3"
                  },
                  {
                      re_id: 451223,
                      re_parent: 451200,
                      re_name: "凤山县",
                      re_level: "3"
                  },
                  {
                      re_id: 451224,
                      re_parent: 451200,
                      re_name: "东兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 451225,
                      re_parent: 451200,
                      re_name: "罗城仫佬族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451226,
                      re_parent: 451200,
                      re_name: "环江毛南族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451227,
                      re_parent: 451200,
                      re_name: "巴马瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451228,
                      re_parent: 451200,
                      re_name: "都安瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451229,
                      re_parent: 451200,
                      re_name: "大化瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451281,
                      re_parent: 451200,
                      re_name: "宜州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 451300,
              re_parent: 450000,
              re_name: "来宾市",
              re_level: "2",
              children: [
                  {
                      re_id: 451302,
                      re_parent: 451300,
                      re_name: "兴宾区",
                      re_level: "3"
                  },
                  {
                      re_id: 451321,
                      re_parent: 451300,
                      re_name: "忻城县",
                      re_level: "3"
                  },
                  {
                      re_id: 451322,
                      re_parent: 451300,
                      re_name: "象州县",
                      re_level: "3"
                  },
                  {
                      re_id: 451323,
                      re_parent: 451300,
                      re_name: "武宣县",
                      re_level: "3"
                  },
                  {
                      re_id: 451324,
                      re_parent: 451300,
                      re_name: "金秀瑶族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 451381,
                      re_parent: 451300,
                      re_name: "合山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 451400,
              re_parent: 450000,
              re_name: "崇左市",
              re_level: "2",
              children: [
                  {
                      re_id: 451402,
                      re_parent: 451400,
                      re_name: "江州区",
                      re_level: "3"
                  },
                  {
                      re_id: 451421,
                      re_parent: 451400,
                      re_name: "扶绥县",
                      re_level: "3"
                  },
                  {
                      re_id: 451422,
                      re_parent: 451400,
                      re_name: "宁明县",
                      re_level: "3"
                  },
                  {
                      re_id: 451423,
                      re_parent: 451400,
                      re_name: "龙州县",
                      re_level: "3"
                  },
                  {
                      re_id: 451424,
                      re_parent: 451400,
                      re_name: "大新县",
                      re_level: "3"
                  },
                  {
                      re_id: 451425,
                      re_parent: 451400,
                      re_name: "天等县",
                      re_level: "3"
                  },
                  {
                      re_id: 451481,
                      re_parent: 451400,
                      re_name: "凭祥市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 460000,
      re_parent: 100000,
      re_name: "海南省",
      re_level: "1",
      children: [
          {
              re_id: 460100,
              re_parent: 460000,
              re_name: "海口市",
              re_level: "2",
              children: [
                  {
                      re_id: 460105,
                      re_parent: 460100,
                      re_name: "秀英区",
                      re_level: "3"
                  },
                  {
                      re_id: 460106,
                      re_parent: 460100,
                      re_name: "龙华区",
                      re_level: "3"
                  },
                  {
                      re_id: 460107,
                      re_parent: 460100,
                      re_name: "琼山区",
                      re_level: "3"
                  },
                  {
                      re_id: 460108,
                      re_parent: 460100,
                      re_name: "美兰区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 460200,
              re_parent: 460000,
              re_name: "三亚市",
              re_level: "2",
              children: [
                  {
                      re_id: 460202,
                      re_parent: 460200,
                      re_name: "海棠区",
                      re_level: "3"
                  },
                  {
                      re_id: 460203,
                      re_parent: 460200,
                      re_name: "吉阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 460204,
                      re_parent: 460200,
                      re_name: "天涯区",
                      re_level: "3"
                  },
                  {
                      re_id: 460205,
                      re_parent: 460200,
                      re_name: "崖州区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 460300,
              re_parent: 460000,
              re_name: "三沙市",
              re_level: "2",
              children: [
                  {
                      re_id: 460321,
                      re_parent: 460300,
                      re_name: "西沙群岛",
                      re_level: "3"
                  },
                  {
                      re_id: 460322,
                      re_parent: 460300,
                      re_name: "南沙群岛",
                      re_level: "3"
                  },
                  {
                      re_id: 460323,
                      re_parent: 460300,
                      re_name: "中沙群岛",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 469000,
              re_parent: 460000,
              re_name: "直辖县级",
              re_level: "2",
              children: [
                  {
                      re_id: 469001,
                      re_parent: 469000,
                      re_name: "五指山市",
                      re_level: "3"
                  },
                  {
                      re_id: 469002,
                      re_parent: 469000,
                      re_name: "琼海市",
                      re_level: "3"
                  },
                  {
                      re_id: 469003,
                      re_parent: 469000,
                      re_name: "儋州市",
                      re_level: "3"
                  },
                  {
                      re_id: 469005,
                      re_parent: 469000,
                      re_name: "文昌市",
                      re_level: "3"
                  },
                  {
                      re_id: 469006,
                      re_parent: 469000,
                      re_name: "万宁市",
                      re_level: "3"
                  },
                  {
                      re_id: 469007,
                      re_parent: 469000,
                      re_name: "东方市",
                      re_level: "3"
                  },
                  {
                      re_id: 469021,
                      re_parent: 469000,
                      re_name: "定安县",
                      re_level: "3"
                  },
                  {
                      re_id: 469022,
                      re_parent: 469000,
                      re_name: "屯昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 469023,
                      re_parent: 469000,
                      re_name: "澄迈县",
                      re_level: "3"
                  },
                  {
                      re_id: 469024,
                      re_parent: 469000,
                      re_name: "临高县",
                      re_level: "3"
                  },
                  {
                      re_id: 469025,
                      re_parent: 469000,
                      re_name: "白沙黎族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 469026,
                      re_parent: 469000,
                      re_name: "昌江黎族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 469027,
                      re_parent: 469000,
                      re_name: "乐东黎族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 469028,
                      re_parent: 469000,
                      re_name: "陵水黎族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 469029,
                      re_parent: 469000,
                      re_name: "保亭黎族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 469030,
                      re_parent: 469000,
                      re_name: "琼中黎族苗族自治县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 500000,
      re_parent: 100000,
      re_name: "重庆",
      re_level: "1",
      children: [
          {
              re_id: 500100,
              re_parent: 500000,
              re_name: "重庆市",
              re_level: "2",
              children: [
                  {
                      re_id: 500101,
                      re_parent: 500100,
                      re_name: "万州区",
                      re_level: "3"
                  },
                  {
                      re_id: 500102,
                      re_parent: 500100,
                      re_name: "涪陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 500103,
                      re_parent: 500100,
                      re_name: "渝中区",
                      re_level: "3"
                  },
                  {
                      re_id: 500104,
                      re_parent: 500100,
                      re_name: "大渡口区",
                      re_level: "3"
                  },
                  {
                      re_id: 500105,
                      re_parent: 500100,
                      re_name: "江北区",
                      re_level: "3"
                  },
                  {
                      re_id: 500106,
                      re_parent: 500100,
                      re_name: "沙坪坝区",
                      re_level: "3"
                  },
                  {
                      re_id: 500107,
                      re_parent: 500100,
                      re_name: "九龙坡区",
                      re_level: "3"
                  },
                  {
                      re_id: 500108,
                      re_parent: 500100,
                      re_name: "南岸区",
                      re_level: "3"
                  },
                  {
                      re_id: 500109,
                      re_parent: 500100,
                      re_name: "北碚区",
                      re_level: "3"
                  },
                  {
                      re_id: 500110,
                      re_parent: 500100,
                      re_name: "綦江区",
                      re_level: "3"
                  },
                  {
                      re_id: 500111,
                      re_parent: 500100,
                      re_name: "大足区",
                      re_level: "3"
                  },
                  {
                      re_id: 500112,
                      re_parent: 500100,
                      re_name: "渝北区",
                      re_level: "3"
                  },
                  {
                      re_id: 500113,
                      re_parent: 500100,
                      re_name: "巴南区",
                      re_level: "3"
                  },
                  {
                      re_id: 500114,
                      re_parent: 500100,
                      re_name: "黔江区",
                      re_level: "3"
                  },
                  {
                      re_id: 500115,
                      re_parent: 500100,
                      re_name: "长寿区",
                      re_level: "3"
                  },
                  {
                      re_id: 500116,
                      re_parent: 500100,
                      re_name: "江津区",
                      re_level: "3"
                  },
                  {
                      re_id: 500117,
                      re_parent: 500100,
                      re_name: "合川区",
                      re_level: "3"
                  },
                  {
                      re_id: 500118,
                      re_parent: 500100,
                      re_name: "永川区",
                      re_level: "3"
                  },
                  {
                      re_id: 500119,
                      re_parent: 500100,
                      re_name: "南川区",
                      re_level: "3"
                  },
                  {
                      re_id: 500120,
                      re_parent: 500100,
                      re_name: "璧山区",
                      re_level: "3"
                  },
                  {
                      re_id: 500151,
                      re_parent: 500100,
                      re_name: "铜梁区",
                      re_level: "3"
                  },
                  {
                      re_id: 500223,
                      re_parent: 500100,
                      re_name: "潼南县",
                      re_level: "3"
                  },
                  {
                      re_id: 500226,
                      re_parent: 500100,
                      re_name: "荣昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 500228,
                      re_parent: 500100,
                      re_name: "梁平县",
                      re_level: "3"
                  },
                  {
                      re_id: 500229,
                      re_parent: 500100,
                      re_name: "城口县",
                      re_level: "3"
                  },
                  {
                      re_id: 500230,
                      re_parent: 500100,
                      re_name: "丰都县",
                      re_level: "3"
                  },
                  {
                      re_id: 500231,
                      re_parent: 500100,
                      re_name: "垫江县",
                      re_level: "3"
                  },
                  {
                      re_id: 500232,
                      re_parent: 500100,
                      re_name: "武隆县",
                      re_level: "3"
                  },
                  {
                      re_id: 500233,
                      re_parent: 500100,
                      re_name: "忠县",
                      re_level: "3"
                  },
                  {
                      re_id: 500234,
                      re_parent: 500100,
                      re_name: "开县",
                      re_level: "3"
                  },
                  {
                      re_id: 500235,
                      re_parent: 500100,
                      re_name: "云阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 500236,
                      re_parent: 500100,
                      re_name: "奉节县",
                      re_level: "3"
                  },
                  {
                      re_id: 500237,
                      re_parent: 500100,
                      re_name: "巫山县",
                      re_level: "3"
                  },
                  {
                      re_id: 500238,
                      re_parent: 500100,
                      re_name: "巫溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 500240,
                      re_parent: 500100,
                      re_name: "石柱土家族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 500241,
                      re_parent: 500100,
                      re_name: "秀山土家族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 500242,
                      re_parent: 500100,
                      re_name: "酉阳土家族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 500243,
                      re_parent: 500100,
                      re_name: "彭水苗族土家族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 500300,
              re_parent: 500000,
              re_name: "两江新区",
              re_level: "2",
              children: [
                  {
                      re_id: 500301,
                      re_parent: 500300,
                      re_name: "北部新区",
                      re_level: "3"
                  },
                  {
                      re_id: 500302,
                      re_parent: 500300,
                      re_name: "保税港区",
                      re_level: "3"
                  },
                  {
                      re_id: 500303,
                      re_parent: 500300,
                      re_name: "工业园区",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 510000,
      re_parent: 100000,
      re_name: "四川省",
      re_level: "1",
      children: [
          {
              re_id: 510100,
              re_parent: 510000,
              re_name: "成都市",
              re_level: "2",
              children: [
                  {
                      re_id: 510104,
                      re_parent: 510100,
                      re_name: "锦江区",
                      re_level: "3"
                  },
                  {
                      re_id: 510105,
                      re_parent: 510100,
                      re_name: "青羊区",
                      re_level: "3"
                  },
                  {
                      re_id: 510106,
                      re_parent: 510100,
                      re_name: "金牛区",
                      re_level: "3"
                  },
                  {
                      re_id: 510107,
                      re_parent: 510100,
                      re_name: "武侯区",
                      re_level: "3"
                  },
                  {
                      re_id: 510108,
                      re_parent: 510100,
                      re_name: "成华区",
                      re_level: "3"
                  },
                  {
                      re_id: 510112,
                      re_parent: 510100,
                      re_name: "龙泉驿区",
                      re_level: "3"
                  },
                  {
                      re_id: 510113,
                      re_parent: 510100,
                      re_name: "青白江区",
                      re_level: "3"
                  },
                  {
                      re_id: 510114,
                      re_parent: 510100,
                      re_name: "新都区",
                      re_level: "3"
                  },
                  {
                      re_id: 510115,
                      re_parent: 510100,
                      re_name: "温江区",
                      re_level: "3"
                  },
                  {
                      re_id: 510121,
                      re_parent: 510100,
                      re_name: "金堂县",
                      re_level: "3"
                  },
                  {
                      re_id: 510122,
                      re_parent: 510100,
                      re_name: "双流县",
                      re_level: "3"
                  },
                  {
                      re_id: 510124,
                      re_parent: 510100,
                      re_name: "郫县",
                      re_level: "3"
                  },
                  {
                      re_id: 510129,
                      re_parent: 510100,
                      re_name: "大邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 510131,
                      re_parent: 510100,
                      re_name: "蒲江县",
                      re_level: "3"
                  },
                  {
                      re_id: 510132,
                      re_parent: 510100,
                      re_name: "新津县",
                      re_level: "3"
                  },
                  {
                      re_id: 510181,
                      re_parent: 510100,
                      re_name: "都江堰市",
                      re_level: "3"
                  },
                  {
                      re_id: 510182,
                      re_parent: 510100,
                      re_name: "彭州市",
                      re_level: "3"
                  },
                  {
                      re_id: 510183,
                      re_parent: 510100,
                      re_name: "邛崃市",
                      re_level: "3"
                  },
                  {
                      re_id: 510184,
                      re_parent: 510100,
                      re_name: "崇州市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510300,
              re_parent: 510000,
              re_name: "自贡市",
              re_level: "2",
              children: [
                  {
                      re_id: 510302,
                      re_parent: 510300,
                      re_name: "自流井区",
                      re_level: "3"
                  },
                  {
                      re_id: 510303,
                      re_parent: 510300,
                      re_name: "贡井区",
                      re_level: "3"
                  },
                  {
                      re_id: 510304,
                      re_parent: 510300,
                      re_name: "大安区",
                      re_level: "3"
                  },
                  {
                      re_id: 510311,
                      re_parent: 510300,
                      re_name: "沿滩区",
                      re_level: "3"
                  },
                  {
                      re_id: 510321,
                      re_parent: 510300,
                      re_name: "荣县",
                      re_level: "3"
                  },
                  {
                      re_id: 510322,
                      re_parent: 510300,
                      re_name: "富顺县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510400,
              re_parent: 510000,
              re_name: "攀枝花市",
              re_level: "2",
              children: [
                  {
                      re_id: 510402,
                      re_parent: 510400,
                      re_name: "东区",
                      re_level: "3"
                  },
                  {
                      re_id: 510403,
                      re_parent: 510400,
                      re_name: "西区",
                      re_level: "3"
                  },
                  {
                      re_id: 510411,
                      re_parent: 510400,
                      re_name: "仁和区",
                      re_level: "3"
                  },
                  {
                      re_id: 510421,
                      re_parent: 510400,
                      re_name: "米易县",
                      re_level: "3"
                  },
                  {
                      re_id: 510422,
                      re_parent: 510400,
                      re_name: "盐边县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510500,
              re_parent: 510000,
              re_name: "泸州市",
              re_level: "2",
              children: [
                  {
                      re_id: 510502,
                      re_parent: 510500,
                      re_name: "江阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 510503,
                      re_parent: 510500,
                      re_name: "纳溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 510504,
                      re_parent: 510500,
                      re_name: "龙马潭区",
                      re_level: "3"
                  },
                  {
                      re_id: 510521,
                      re_parent: 510500,
                      re_name: "泸县",
                      re_level: "3"
                  },
                  {
                      re_id: 510522,
                      re_parent: 510500,
                      re_name: "合江县",
                      re_level: "3"
                  },
                  {
                      re_id: 510524,
                      re_parent: 510500,
                      re_name: "叙永县",
                      re_level: "3"
                  },
                  {
                      re_id: 510525,
                      re_parent: 510500,
                      re_name: "古蔺县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510600,
              re_parent: 510000,
              re_name: "德阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 510603,
                      re_parent: 510600,
                      re_name: "旌阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 510623,
                      re_parent: 510600,
                      re_name: "中江县",
                      re_level: "3"
                  },
                  {
                      re_id: 510626,
                      re_parent: 510600,
                      re_name: "罗江县",
                      re_level: "3"
                  },
                  {
                      re_id: 510681,
                      re_parent: 510600,
                      re_name: "广汉市",
                      re_level: "3"
                  },
                  {
                      re_id: 510682,
                      re_parent: 510600,
                      re_name: "什邡市",
                      re_level: "3"
                  },
                  {
                      re_id: 510683,
                      re_parent: 510600,
                      re_name: "绵竹市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510700,
              re_parent: 510000,
              re_name: "绵阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 510703,
                      re_parent: 510700,
                      re_name: "涪城区",
                      re_level: "3"
                  },
                  {
                      re_id: 510704,
                      re_parent: 510700,
                      re_name: "游仙区",
                      re_level: "3"
                  },
                  {
                      re_id: 510722,
                      re_parent: 510700,
                      re_name: "三台县",
                      re_level: "3"
                  },
                  {
                      re_id: 510723,
                      re_parent: 510700,
                      re_name: "盐亭县",
                      re_level: "3"
                  },
                  {
                      re_id: 510724,
                      re_parent: 510700,
                      re_name: "安县",
                      re_level: "3"
                  },
                  {
                      re_id: 510725,
                      re_parent: 510700,
                      re_name: "梓潼县",
                      re_level: "3"
                  },
                  {
                      re_id: 510726,
                      re_parent: 510700,
                      re_name: "北川羌族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 510727,
                      re_parent: 510700,
                      re_name: "平武县",
                      re_level: "3"
                  },
                  {
                      re_id: 510781,
                      re_parent: 510700,
                      re_name: "江油市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510800,
              re_parent: 510000,
              re_name: "广元市",
              re_level: "2",
              children: [
                  {
                      re_id: 510802,
                      re_parent: 510800,
                      re_name: "利州区",
                      re_level: "3"
                  },
                  {
                      re_id: 510811,
                      re_parent: 510800,
                      re_name: "昭化区",
                      re_level: "3"
                  },
                  {
                      re_id: 510812,
                      re_parent: 510800,
                      re_name: "朝天区",
                      re_level: "3"
                  },
                  {
                      re_id: 510821,
                      re_parent: 510800,
                      re_name: "旺苍县",
                      re_level: "3"
                  },
                  {
                      re_id: 510822,
                      re_parent: 510800,
                      re_name: "青川县",
                      re_level: "3"
                  },
                  {
                      re_id: 510823,
                      re_parent: 510800,
                      re_name: "剑阁县",
                      re_level: "3"
                  },
                  {
                      re_id: 510824,
                      re_parent: 510800,
                      re_name: "苍溪县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 510900,
              re_parent: 510000,
              re_name: "遂宁市",
              re_level: "2",
              children: [
                  {
                      re_id: 510903,
                      re_parent: 510900,
                      re_name: "船山区",
                      re_level: "3"
                  },
                  {
                      re_id: 510904,
                      re_parent: 510900,
                      re_name: "安居区",
                      re_level: "3"
                  },
                  {
                      re_id: 510921,
                      re_parent: 510900,
                      re_name: "蓬溪县",
                      re_level: "3"
                  },
                  {
                      re_id: 510922,
                      re_parent: 510900,
                      re_name: "射洪县",
                      re_level: "3"
                  },
                  {
                      re_id: 510923,
                      re_parent: 510900,
                      re_name: "大英县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511000,
              re_parent: 510000,
              re_name: "内江市",
              re_level: "2",
              children: [
                  {
                      re_id: 511002,
                      re_parent: 511000,
                      re_name: "市中区",
                      re_level: "3"
                  },
                  {
                      re_id: 511011,
                      re_parent: 511000,
                      re_name: "东兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 511024,
                      re_parent: 511000,
                      re_name: "威远县",
                      re_level: "3"
                  },
                  {
                      re_id: 511025,
                      re_parent: 511000,
                      re_name: "资中县",
                      re_level: "3"
                  },
                  {
                      re_id: 511028,
                      re_parent: 511000,
                      re_name: "隆昌县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511100,
              re_parent: 510000,
              re_name: "乐山市",
              re_level: "2",
              children: [
                  {
                      re_id: 511102,
                      re_parent: 511100,
                      re_name: "市中区",
                      re_level: "3"
                  },
                  {
                      re_id: 511111,
                      re_parent: 511100,
                      re_name: "沙湾区",
                      re_level: "3"
                  },
                  {
                      re_id: 511112,
                      re_parent: 511100,
                      re_name: "五通桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 511113,
                      re_parent: 511100,
                      re_name: "金口河区",
                      re_level: "3"
                  },
                  {
                      re_id: 511123,
                      re_parent: 511100,
                      re_name: "犍为县",
                      re_level: "3"
                  },
                  {
                      re_id: 511124,
                      re_parent: 511100,
                      re_name: "井研县",
                      re_level: "3"
                  },
                  {
                      re_id: 511126,
                      re_parent: 511100,
                      re_name: "夹江县",
                      re_level: "3"
                  },
                  {
                      re_id: 511129,
                      re_parent: 511100,
                      re_name: "沐川县",
                      re_level: "3"
                  },
                  {
                      re_id: 511132,
                      re_parent: 511100,
                      re_name: "峨边彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 511133,
                      re_parent: 511100,
                      re_name: "马边彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 511181,
                      re_parent: 511100,
                      re_name: "峨眉山市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511300,
              re_parent: 510000,
              re_name: "南充市",
              re_level: "2",
              children: [
                  {
                      re_id: 511302,
                      re_parent: 511300,
                      re_name: "顺庆区",
                      re_level: "3"
                  },
                  {
                      re_id: 511303,
                      re_parent: 511300,
                      re_name: "高坪区",
                      re_level: "3"
                  },
                  {
                      re_id: 511304,
                      re_parent: 511300,
                      re_name: "嘉陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 511321,
                      re_parent: 511300,
                      re_name: "南部县",
                      re_level: "3"
                  },
                  {
                      re_id: 511322,
                      re_parent: 511300,
                      re_name: "营山县",
                      re_level: "3"
                  },
                  {
                      re_id: 511323,
                      re_parent: 511300,
                      re_name: "蓬安县",
                      re_level: "3"
                  },
                  {
                      re_id: 511324,
                      re_parent: 511300,
                      re_name: "仪陇县",
                      re_level: "3"
                  },
                  {
                      re_id: 511325,
                      re_parent: 511300,
                      re_name: "西充县",
                      re_level: "3"
                  },
                  {
                      re_id: 511381,
                      re_parent: 511300,
                      re_name: "阆中市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511400,
              re_parent: 510000,
              re_name: "眉山市",
              re_level: "2",
              children: [
                  {
                      re_id: 511402,
                      re_parent: 511400,
                      re_name: "东坡区",
                      re_level: "3"
                  },
                  {
                      re_id: 511403,
                      re_parent: 511400,
                      re_name: "彭山区",
                      re_level: "3"
                  },
                  {
                      re_id: 511421,
                      re_parent: 511400,
                      re_name: "仁寿县",
                      re_level: "3"
                  },
                  {
                      re_id: 511423,
                      re_parent: 511400,
                      re_name: "洪雅县",
                      re_level: "3"
                  },
                  {
                      re_id: 511424,
                      re_parent: 511400,
                      re_name: "丹棱县",
                      re_level: "3"
                  },
                  {
                      re_id: 511425,
                      re_parent: 511400,
                      re_name: "青神县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511500,
              re_parent: 510000,
              re_name: "宜宾市",
              re_level: "2",
              children: [
                  {
                      re_id: 511502,
                      re_parent: 511500,
                      re_name: "翠屏区",
                      re_level: "3"
                  },
                  {
                      re_id: 511503,
                      re_parent: 511500,
                      re_name: "南溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 511521,
                      re_parent: 511500,
                      re_name: "宜宾县",
                      re_level: "3"
                  },
                  {
                      re_id: 511523,
                      re_parent: 511500,
                      re_name: "江安县",
                      re_level: "3"
                  },
                  {
                      re_id: 511524,
                      re_parent: 511500,
                      re_name: "长宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 511525,
                      re_parent: 511500,
                      re_name: "高县",
                      re_level: "3"
                  },
                  {
                      re_id: 511526,
                      re_parent: 511500,
                      re_name: "珙县",
                      re_level: "3"
                  },
                  {
                      re_id: 511527,
                      re_parent: 511500,
                      re_name: "筠连县",
                      re_level: "3"
                  },
                  {
                      re_id: 511528,
                      re_parent: 511500,
                      re_name: "兴文县",
                      re_level: "3"
                  },
                  {
                      re_id: 511529,
                      re_parent: 511500,
                      re_name: "屏山县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511600,
              re_parent: 510000,
              re_name: "广安市",
              re_level: "2",
              children: [
                  {
                      re_id: 511602,
                      re_parent: 511600,
                      re_name: "广安区",
                      re_level: "3"
                  },
                  {
                      re_id: 511603,
                      re_parent: 511600,
                      re_name: "前锋区",
                      re_level: "3"
                  },
                  {
                      re_id: 511621,
                      re_parent: 511600,
                      re_name: "岳池县",
                      re_level: "3"
                  },
                  {
                      re_id: 511622,
                      re_parent: 511600,
                      re_name: "武胜县",
                      re_level: "3"
                  },
                  {
                      re_id: 511623,
                      re_parent: 511600,
                      re_name: "邻水县",
                      re_level: "3"
                  },
                  {
                      re_id: 511681,
                      re_parent: 511600,
                      re_name: "华蓥市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511700,
              re_parent: 510000,
              re_name: "达州市",
              re_level: "2",
              children: [
                  {
                      re_id: 511702,
                      re_parent: 511700,
                      re_name: "通川区",
                      re_level: "3"
                  },
                  {
                      re_id: 511703,
                      re_parent: 511700,
                      re_name: "达川区",
                      re_level: "3"
                  },
                  {
                      re_id: 511722,
                      re_parent: 511700,
                      re_name: "宣汉县",
                      re_level: "3"
                  },
                  {
                      re_id: 511723,
                      re_parent: 511700,
                      re_name: "开江县",
                      re_level: "3"
                  },
                  {
                      re_id: 511724,
                      re_parent: 511700,
                      re_name: "大竹县",
                      re_level: "3"
                  },
                  {
                      re_id: 511725,
                      re_parent: 511700,
                      re_name: "渠县",
                      re_level: "3"
                  },
                  {
                      re_id: 511781,
                      re_parent: 511700,
                      re_name: "万源市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511800,
              re_parent: 510000,
              re_name: "雅安市",
              re_level: "2",
              children: [
                  {
                      re_id: 511802,
                      re_parent: 511800,
                      re_name: "雨城区",
                      re_level: "3"
                  },
                  {
                      re_id: 511803,
                      re_parent: 511800,
                      re_name: "名山区",
                      re_level: "3"
                  },
                  {
                      re_id: 511822,
                      re_parent: 511800,
                      re_name: "荥经县",
                      re_level: "3"
                  },
                  {
                      re_id: 511823,
                      re_parent: 511800,
                      re_name: "汉源县",
                      re_level: "3"
                  },
                  {
                      re_id: 511824,
                      re_parent: 511800,
                      re_name: "石棉县",
                      re_level: "3"
                  },
                  {
                      re_id: 511825,
                      re_parent: 511800,
                      re_name: "天全县",
                      re_level: "3"
                  },
                  {
                      re_id: 511826,
                      re_parent: 511800,
                      re_name: "芦山县",
                      re_level: "3"
                  },
                  {
                      re_id: 511827,
                      re_parent: 511800,
                      re_name: "宝兴县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 511900,
              re_parent: 510000,
              re_name: "巴中市",
              re_level: "2",
              children: [
                  {
                      re_id: 511902,
                      re_parent: 511900,
                      re_name: "巴州区",
                      re_level: "3"
                  },
                  {
                      re_id: 511903,
                      re_parent: 511900,
                      re_name: "恩阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 511921,
                      re_parent: 511900,
                      re_name: "通江县",
                      re_level: "3"
                  },
                  {
                      re_id: 511922,
                      re_parent: 511900,
                      re_name: "南江县",
                      re_level: "3"
                  },
                  {
                      re_id: 511923,
                      re_parent: 511900,
                      re_name: "平昌县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 512000,
              re_parent: 510000,
              re_name: "资阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 512002,
                      re_parent: 512000,
                      re_name: "雁江区",
                      re_level: "3"
                  },
                  {
                      re_id: 512021,
                      re_parent: 512000,
                      re_name: "安岳县",
                      re_level: "3"
                  },
                  {
                      re_id: 512022,
                      re_parent: 512000,
                      re_name: "乐至县",
                      re_level: "3"
                  },
                  {
                      re_id: 512081,
                      re_parent: 512000,
                      re_name: "简阳市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 513200,
              re_parent: 510000,
              re_name: "阿坝藏族羌族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 513221,
                      re_parent: 513200,
                      re_name: "汶川县",
                      re_level: "3"
                  },
                  {
                      re_id: 513222,
                      re_parent: 513200,
                      re_name: "理县",
                      re_level: "3"
                  },
                  {
                      re_id: 513223,
                      re_parent: 513200,
                      re_name: "茂县",
                      re_level: "3"
                  },
                  {
                      re_id: 513224,
                      re_parent: 513200,
                      re_name: "松潘县",
                      re_level: "3"
                  },
                  {
                      re_id: 513225,
                      re_parent: 513200,
                      re_name: "九寨沟县",
                      re_level: "3"
                  },
                  {
                      re_id: 513226,
                      re_parent: 513200,
                      re_name: "金川县",
                      re_level: "3"
                  },
                  {
                      re_id: 513227,
                      re_parent: 513200,
                      re_name: "小金县",
                      re_level: "3"
                  },
                  {
                      re_id: 513228,
                      re_parent: 513200,
                      re_name: "黑水县",
                      re_level: "3"
                  },
                  {
                      re_id: 513229,
                      re_parent: 513200,
                      re_name: "马尔康县",
                      re_level: "3"
                  },
                  {
                      re_id: 513230,
                      re_parent: 513200,
                      re_name: "壤塘县",
                      re_level: "3"
                  },
                  {
                      re_id: 513231,
                      re_parent: 513200,
                      re_name: "阿坝县",
                      re_level: "3"
                  },
                  {
                      re_id: 513232,
                      re_parent: 513200,
                      re_name: "若尔盖县",
                      re_level: "3"
                  },
                  {
                      re_id: 513233,
                      re_parent: 513200,
                      re_name: "红原县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 513300,
              re_parent: 510000,
              re_name: "甘孜藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 513321,
                      re_parent: 513300,
                      re_name: "康定县",
                      re_level: "3"
                  },
                  {
                      re_id: 513322,
                      re_parent: 513300,
                      re_name: "泸定县",
                      re_level: "3"
                  },
                  {
                      re_id: 513323,
                      re_parent: 513300,
                      re_name: "丹巴县",
                      re_level: "3"
                  },
                  {
                      re_id: 513324,
                      re_parent: 513300,
                      re_name: "九龙县",
                      re_level: "3"
                  },
                  {
                      re_id: 513325,
                      re_parent: 513300,
                      re_name: "雅江县",
                      re_level: "3"
                  },
                  {
                      re_id: 513326,
                      re_parent: 513300,
                      re_name: "道孚县",
                      re_level: "3"
                  },
                  {
                      re_id: 513327,
                      re_parent: 513300,
                      re_name: "炉霍县",
                      re_level: "3"
                  },
                  {
                      re_id: 513328,
                      re_parent: 513300,
                      re_name: "甘孜县",
                      re_level: "3"
                  },
                  {
                      re_id: 513329,
                      re_parent: 513300,
                      re_name: "新龙县",
                      re_level: "3"
                  },
                  {
                      re_id: 513330,
                      re_parent: 513300,
                      re_name: "德格县",
                      re_level: "3"
                  },
                  {
                      re_id: 513331,
                      re_parent: 513300,
                      re_name: "白玉县",
                      re_level: "3"
                  },
                  {
                      re_id: 513332,
                      re_parent: 513300,
                      re_name: "石渠县",
                      re_level: "3"
                  },
                  {
                      re_id: 513333,
                      re_parent: 513300,
                      re_name: "色达县",
                      re_level: "3"
                  },
                  {
                      re_id: 513334,
                      re_parent: 513300,
                      re_name: "理塘县",
                      re_level: "3"
                  },
                  {
                      re_id: 513335,
                      re_parent: 513300,
                      re_name: "巴塘县",
                      re_level: "3"
                  },
                  {
                      re_id: 513336,
                      re_parent: 513300,
                      re_name: "乡城县",
                      re_level: "3"
                  },
                  {
                      re_id: 513337,
                      re_parent: 513300,
                      re_name: "稻城县",
                      re_level: "3"
                  },
                  {
                      re_id: 513338,
                      re_parent: 513300,
                      re_name: "得荣县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 513400,
              re_parent: 510000,
              re_name: "凉山彝族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 513401,
                      re_parent: 513400,
                      re_name: "西昌市",
                      re_level: "3"
                  },
                  {
                      re_id: 513422,
                      re_parent: 513400,
                      re_name: "木里藏族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 513423,
                      re_parent: 513400,
                      re_name: "盐源县",
                      re_level: "3"
                  },
                  {
                      re_id: 513424,
                      re_parent: 513400,
                      re_name: "德昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 513425,
                      re_parent: 513400,
                      re_name: "会理县",
                      re_level: "3"
                  },
                  {
                      re_id: 513426,
                      re_parent: 513400,
                      re_name: "会东县",
                      re_level: "3"
                  },
                  {
                      re_id: 513427,
                      re_parent: 513400,
                      re_name: "宁南县",
                      re_level: "3"
                  },
                  {
                      re_id: 513428,
                      re_parent: 513400,
                      re_name: "普格县",
                      re_level: "3"
                  },
                  {
                      re_id: 513429,
                      re_parent: 513400,
                      re_name: "布拖县",
                      re_level: "3"
                  },
                  {
                      re_id: 513430,
                      re_parent: 513400,
                      re_name: "金阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 513431,
                      re_parent: 513400,
                      re_name: "昭觉县",
                      re_level: "3"
                  },
                  {
                      re_id: 513432,
                      re_parent: 513400,
                      re_name: "喜德县",
                      re_level: "3"
                  },
                  {
                      re_id: 513433,
                      re_parent: 513400,
                      re_name: "冕宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 513434,
                      re_parent: 513400,
                      re_name: "越西县",
                      re_level: "3"
                  },
                  {
                      re_id: 513435,
                      re_parent: 513400,
                      re_name: "甘洛县",
                      re_level: "3"
                  },
                  {
                      re_id: 513436,
                      re_parent: 513400,
                      re_name: "美姑县",
                      re_level: "3"
                  },
                  {
                      re_id: 513437,
                      re_parent: 513400,
                      re_name: "雷波县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 520000,
      re_parent: 100000,
      re_name: "贵州省",
      re_level: "1",
      children: [
          {
              re_id: 520100,
              re_parent: 520000,
              re_name: "贵阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 520102,
                      re_parent: 520100,
                      re_name: "南明区",
                      re_level: "3"
                  },
                  {
                      re_id: 520103,
                      re_parent: 520100,
                      re_name: "云岩区",
                      re_level: "3"
                  },
                  {
                      re_id: 520111,
                      re_parent: 520100,
                      re_name: "花溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 520112,
                      re_parent: 520100,
                      re_name: "乌当区",
                      re_level: "3"
                  },
                  {
                      re_id: 520113,
                      re_parent: 520100,
                      re_name: "白云区",
                      re_level: "3"
                  },
                  {
                      re_id: 520115,
                      re_parent: 520100,
                      re_name: "观山湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 520121,
                      re_parent: 520100,
                      re_name: "开阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 520122,
                      re_parent: 520100,
                      re_name: "息烽县",
                      re_level: "3"
                  },
                  {
                      re_id: 520123,
                      re_parent: 520100,
                      re_name: "修文县",
                      re_level: "3"
                  },
                  {
                      re_id: 520181,
                      re_parent: 520100,
                      re_name: "清镇市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 520200,
              re_parent: 520000,
              re_name: "六盘水市",
              re_level: "2",
              children: [
                  {
                      re_id: 520201,
                      re_parent: 520200,
                      re_name: "钟山区",
                      re_level: "3"
                  },
                  {
                      re_id: 520203,
                      re_parent: 520200,
                      re_name: "六枝特区",
                      re_level: "3"
                  },
                  {
                      re_id: 520221,
                      re_parent: 520200,
                      re_name: "水城县",
                      re_level: "3"
                  },
                  {
                      re_id: 520222,
                      re_parent: 520200,
                      re_name: "盘县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 520300,
              re_parent: 520000,
              re_name: "遵义市",
              re_level: "2",
              children: [
                  {
                      re_id: 520302,
                      re_parent: 520300,
                      re_name: "红花岗区",
                      re_level: "3"
                  },
                  {
                      re_id: 520303,
                      re_parent: 520300,
                      re_name: "汇川区",
                      re_level: "3"
                  },
                  {
                      re_id: 520321,
                      re_parent: 520300,
                      re_name: "遵义县",
                      re_level: "3"
                  },
                  {
                      re_id: 520322,
                      re_parent: 520300,
                      re_name: "桐梓县",
                      re_level: "3"
                  },
                  {
                      re_id: 520323,
                      re_parent: 520300,
                      re_name: "绥阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 520324,
                      re_parent: 520300,
                      re_name: "正安县",
                      re_level: "3"
                  },
                  {
                      re_id: 520325,
                      re_parent: 520300,
                      re_name: "道真仡佬族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520326,
                      re_parent: 520300,
                      re_name: "务川仡佬族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520327,
                      re_parent: 520300,
                      re_name: "凤冈县",
                      re_level: "3"
                  },
                  {
                      re_id: 520328,
                      re_parent: 520300,
                      re_name: "湄潭县",
                      re_level: "3"
                  },
                  {
                      re_id: 520329,
                      re_parent: 520300,
                      re_name: "余庆县",
                      re_level: "3"
                  },
                  {
                      re_id: 520330,
                      re_parent: 520300,
                      re_name: "习水县",
                      re_level: "3"
                  },
                  {
                      re_id: 520381,
                      re_parent: 520300,
                      re_name: "赤水市",
                      re_level: "3"
                  },
                  {
                      re_id: 520382,
                      re_parent: 520300,
                      re_name: "仁怀市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 520400,
              re_parent: 520000,
              re_name: "安顺市",
              re_level: "2",
              children: [
                  {
                      re_id: 520402,
                      re_parent: 520400,
                      re_name: "西秀区",
                      re_level: "3"
                  },
                  {
                      re_id: 520421,
                      re_parent: 520400,
                      re_name: "平坝区",
                      re_level: "3"
                  },
                  {
                      re_id: 520422,
                      re_parent: 520400,
                      re_name: "普定县",
                      re_level: "3"
                  },
                  {
                      re_id: 520423,
                      re_parent: 520400,
                      re_name: "镇宁布依族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520424,
                      re_parent: 520400,
                      re_name: "关岭布依族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520425,
                      re_parent: 520400,
                      re_name: "紫云苗族布依族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 520500,
              re_parent: 520000,
              re_name: "毕节市",
              re_level: "2",
              children: [
                  {
                      re_id: 520502,
                      re_parent: 520500,
                      re_name: "七星关区",
                      re_level: "3"
                  },
                  {
                      re_id: 520521,
                      re_parent: 520500,
                      re_name: "大方县",
                      re_level: "3"
                  },
                  {
                      re_id: 520522,
                      re_parent: 520500,
                      re_name: "黔西县",
                      re_level: "3"
                  },
                  {
                      re_id: 520523,
                      re_parent: 520500,
                      re_name: "金沙县",
                      re_level: "3"
                  },
                  {
                      re_id: 520524,
                      re_parent: 520500,
                      re_name: "织金县",
                      re_level: "3"
                  },
                  {
                      re_id: 520525,
                      re_parent: 520500,
                      re_name: "纳雍县",
                      re_level: "3"
                  },
                  {
                      re_id: 520526,
                      re_parent: 520500,
                      re_name: "威宁彝族回族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520527,
                      re_parent: 520500,
                      re_name: "赫章县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 520600,
              re_parent: 520000,
              re_name: "铜仁市",
              re_level: "2",
              children: [
                  {
                      re_id: 520602,
                      re_parent: 520600,
                      re_name: "碧江区",
                      re_level: "3"
                  },
                  {
                      re_id: 520603,
                      re_parent: 520600,
                      re_name: "万山区",
                      re_level: "3"
                  },
                  {
                      re_id: 520621,
                      re_parent: 520600,
                      re_name: "江口县",
                      re_level: "3"
                  },
                  {
                      re_id: 520622,
                      re_parent: 520600,
                      re_name: "玉屏侗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520623,
                      re_parent: 520600,
                      re_name: "石阡县",
                      re_level: "3"
                  },
                  {
                      re_id: 520624,
                      re_parent: 520600,
                      re_name: "思南县",
                      re_level: "3"
                  },
                  {
                      re_id: 520625,
                      re_parent: 520600,
                      re_name: "印江土家族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520626,
                      re_parent: 520600,
                      re_name: "德江县",
                      re_level: "3"
                  },
                  {
                      re_id: 520627,
                      re_parent: 520600,
                      re_name: "沿河土家族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 520628,
                      re_parent: 520600,
                      re_name: "松桃苗族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 522300,
              re_parent: 520000,
              re_name: "黔西南布依族苗族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 522301,
                      re_parent: 522300,
                      re_name: "兴义市 ",
                      re_level: "3"
                  },
                  {
                      re_id: 522322,
                      re_parent: 522300,
                      re_name: "兴仁县",
                      re_level: "3"
                  },
                  {
                      re_id: 522323,
                      re_parent: 522300,
                      re_name: "普安县",
                      re_level: "3"
                  },
                  {
                      re_id: 522324,
                      re_parent: 522300,
                      re_name: "晴隆县",
                      re_level: "3"
                  },
                  {
                      re_id: 522325,
                      re_parent: 522300,
                      re_name: "贞丰县",
                      re_level: "3"
                  },
                  {
                      re_id: 522326,
                      re_parent: 522300,
                      re_name: "望谟县",
                      re_level: "3"
                  },
                  {
                      re_id: 522327,
                      re_parent: 522300,
                      re_name: "册亨县",
                      re_level: "3"
                  },
                  {
                      re_id: 522328,
                      re_parent: 522300,
                      re_name: "安龙县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 522600,
              re_parent: 520000,
              re_name: "黔东南苗族侗族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 522601,
                      re_parent: 522600,
                      re_name: "凯里市",
                      re_level: "3"
                  },
                  {
                      re_id: 522622,
                      re_parent: 522600,
                      re_name: "黄平县",
                      re_level: "3"
                  },
                  {
                      re_id: 522623,
                      re_parent: 522600,
                      re_name: "施秉县",
                      re_level: "3"
                  },
                  {
                      re_id: 522624,
                      re_parent: 522600,
                      re_name: "三穗县",
                      re_level: "3"
                  },
                  {
                      re_id: 522625,
                      re_parent: 522600,
                      re_name: "镇远县",
                      re_level: "3"
                  },
                  {
                      re_id: 522626,
                      re_parent: 522600,
                      re_name: "岑巩县",
                      re_level: "3"
                  },
                  {
                      re_id: 522627,
                      re_parent: 522600,
                      re_name: "天柱县",
                      re_level: "3"
                  },
                  {
                      re_id: 522628,
                      re_parent: 522600,
                      re_name: "锦屏县",
                      re_level: "3"
                  },
                  {
                      re_id: 522629,
                      re_parent: 522600,
                      re_name: "剑河县",
                      re_level: "3"
                  },
                  {
                      re_id: 522630,
                      re_parent: 522600,
                      re_name: "台江县",
                      re_level: "3"
                  },
                  {
                      re_id: 522631,
                      re_parent: 522600,
                      re_name: "黎平县",
                      re_level: "3"
                  },
                  {
                      re_id: 522632,
                      re_parent: 522600,
                      re_name: "榕江县",
                      re_level: "3"
                  },
                  {
                      re_id: 522633,
                      re_parent: 522600,
                      re_name: "从江县",
                      re_level: "3"
                  },
                  {
                      re_id: 522634,
                      re_parent: 522600,
                      re_name: "雷山县",
                      re_level: "3"
                  },
                  {
                      re_id: 522635,
                      re_parent: 522600,
                      re_name: "麻江县",
                      re_level: "3"
                  },
                  {
                      re_id: 522636,
                      re_parent: 522600,
                      re_name: "丹寨县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 522700,
              re_parent: 520000,
              re_name: "黔南布依族苗族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 522701,
                      re_parent: 522700,
                      re_name: "都匀市",
                      re_level: "3"
                  },
                  {
                      re_id: 522702,
                      re_parent: 522700,
                      re_name: "福泉市",
                      re_level: "3"
                  },
                  {
                      re_id: 522722,
                      re_parent: 522700,
                      re_name: "荔波县",
                      re_level: "3"
                  },
                  {
                      re_id: 522723,
                      re_parent: 522700,
                      re_name: "贵定县",
                      re_level: "3"
                  },
                  {
                      re_id: 522725,
                      re_parent: 522700,
                      re_name: "瓮安县",
                      re_level: "3"
                  },
                  {
                      re_id: 522726,
                      re_parent: 522700,
                      re_name: "独山县",
                      re_level: "3"
                  },
                  {
                      re_id: 522727,
                      re_parent: 522700,
                      re_name: "平塘县",
                      re_level: "3"
                  },
                  {
                      re_id: 522728,
                      re_parent: 522700,
                      re_name: "罗甸县",
                      re_level: "3"
                  },
                  {
                      re_id: 522729,
                      re_parent: 522700,
                      re_name: "长顺县",
                      re_level: "3"
                  },
                  {
                      re_id: 522730,
                      re_parent: 522700,
                      re_name: "龙里县",
                      re_level: "3"
                  },
                  {
                      re_id: 522731,
                      re_parent: 522700,
                      re_name: "惠水县",
                      re_level: "3"
                  },
                  {
                      re_id: 522732,
                      re_parent: 522700,
                      re_name: "三都水族自治县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 530000,
      re_parent: 100000,
      re_name: "云南省",
      re_level: "1",
      children: [
          {
              re_id: 530100,
              re_parent: 530000,
              re_name: "昆明市",
              re_level: "2",
              children: [
                  {
                      re_id: 530102,
                      re_parent: 530100,
                      re_name: "五华区",
                      re_level: "3"
                  },
                  {
                      re_id: 530103,
                      re_parent: 530100,
                      re_name: "盘龙区",
                      re_level: "3"
                  },
                  {
                      re_id: 530111,
                      re_parent: 530100,
                      re_name: "官渡区",
                      re_level: "3"
                  },
                  {
                      re_id: 530112,
                      re_parent: 530100,
                      re_name: "西山区",
                      re_level: "3"
                  },
                  {
                      re_id: 530113,
                      re_parent: 530100,
                      re_name: "东川区",
                      re_level: "3"
                  },
                  {
                      re_id: 530114,
                      re_parent: 530100,
                      re_name: "呈贡区",
                      re_level: "3"
                  },
                  {
                      re_id: 530122,
                      re_parent: 530100,
                      re_name: "晋宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 530124,
                      re_parent: 530100,
                      re_name: "富民县",
                      re_level: "3"
                  },
                  {
                      re_id: 530125,
                      re_parent: 530100,
                      re_name: "宜良县",
                      re_level: "3"
                  },
                  {
                      re_id: 530126,
                      re_parent: 530100,
                      re_name: "石林彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530127,
                      re_parent: 530100,
                      re_name: "嵩明县",
                      re_level: "3"
                  },
                  {
                      re_id: 530128,
                      re_parent: 530100,
                      re_name: "禄劝彝族苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530129,
                      re_parent: 530100,
                      re_name: "寻甸回族彝族自治县 ",
                      re_level: "3"
                  },
                  {
                      re_id: 530181,
                      re_parent: 530100,
                      re_name: "安宁市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530300,
              re_parent: 530000,
              re_name: "曲靖市",
              re_level: "2",
              children: [
                  {
                      re_id: 530302,
                      re_parent: 530300,
                      re_name: "麒麟区",
                      re_level: "3"
                  },
                  {
                      re_id: 530321,
                      re_parent: 530300,
                      re_name: "马龙县",
                      re_level: "3"
                  },
                  {
                      re_id: 530322,
                      re_parent: 530300,
                      re_name: "陆良县",
                      re_level: "3"
                  },
                  {
                      re_id: 530323,
                      re_parent: 530300,
                      re_name: "师宗县",
                      re_level: "3"
                  },
                  {
                      re_id: 530324,
                      re_parent: 530300,
                      re_name: "罗平县",
                      re_level: "3"
                  },
                  {
                      re_id: 530325,
                      re_parent: 530300,
                      re_name: "富源县",
                      re_level: "3"
                  },
                  {
                      re_id: 530326,
                      re_parent: 530300,
                      re_name: "会泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 530328,
                      re_parent: 530300,
                      re_name: "沾益县",
                      re_level: "3"
                  },
                  {
                      re_id: 530381,
                      re_parent: 530300,
                      re_name: "宣威市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530400,
              re_parent: 530000,
              re_name: "玉溪市",
              re_level: "2",
              children: [
                  {
                      re_id: 530402,
                      re_parent: 530400,
                      re_name: "红塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 530421,
                      re_parent: 530400,
                      re_name: "江川县",
                      re_level: "3"
                  },
                  {
                      re_id: 530422,
                      re_parent: 530400,
                      re_name: "澄江县",
                      re_level: "3"
                  },
                  {
                      re_id: 530423,
                      re_parent: 530400,
                      re_name: "通海县",
                      re_level: "3"
                  },
                  {
                      re_id: 530424,
                      re_parent: 530400,
                      re_name: "华宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 530425,
                      re_parent: 530400,
                      re_name: "易门县",
                      re_level: "3"
                  },
                  {
                      re_id: 530426,
                      re_parent: 530400,
                      re_name: "峨山彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530427,
                      re_parent: 530400,
                      re_name: "新平彝族傣族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530428,
                      re_parent: 530400,
                      re_name: "元江哈尼族彝族傣族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530500,
              re_parent: 530000,
              re_name: "保山市",
              re_level: "2",
              children: [
                  {
                      re_id: 530502,
                      re_parent: 530500,
                      re_name: "隆阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 530521,
                      re_parent: 530500,
                      re_name: "施甸县",
                      re_level: "3"
                  },
                  {
                      re_id: 530522,
                      re_parent: 530500,
                      re_name: "腾冲县",
                      re_level: "3"
                  },
                  {
                      re_id: 530523,
                      re_parent: 530500,
                      re_name: "龙陵县",
                      re_level: "3"
                  },
                  {
                      re_id: 530524,
                      re_parent: 530500,
                      re_name: "昌宁县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530600,
              re_parent: 530000,
              re_name: "昭通市",
              re_level: "2",
              children: [
                  {
                      re_id: 530602,
                      re_parent: 530600,
                      re_name: "昭阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 530621,
                      re_parent: 530600,
                      re_name: "鲁甸县",
                      re_level: "3"
                  },
                  {
                      re_id: 530622,
                      re_parent: 530600,
                      re_name: "巧家县",
                      re_level: "3"
                  },
                  {
                      re_id: 530623,
                      re_parent: 530600,
                      re_name: "盐津县",
                      re_level: "3"
                  },
                  {
                      re_id: 530624,
                      re_parent: 530600,
                      re_name: "大关县",
                      re_level: "3"
                  },
                  {
                      re_id: 530625,
                      re_parent: 530600,
                      re_name: "永善县",
                      re_level: "3"
                  },
                  {
                      re_id: 530626,
                      re_parent: 530600,
                      re_name: "绥江县",
                      re_level: "3"
                  },
                  {
                      re_id: 530627,
                      re_parent: 530600,
                      re_name: "镇雄县",
                      re_level: "3"
                  },
                  {
                      re_id: 530628,
                      re_parent: 530600,
                      re_name: "彝良县",
                      re_level: "3"
                  },
                  {
                      re_id: 530629,
                      re_parent: 530600,
                      re_name: "威信县",
                      re_level: "3"
                  },
                  {
                      re_id: 530630,
                      re_parent: 530600,
                      re_name: "水富县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530700,
              re_parent: 530000,
              re_name: "丽江市",
              re_level: "2",
              children: [
                  {
                      re_id: 530702,
                      re_parent: 530700,
                      re_name: "古城区",
                      re_level: "3"
                  },
                  {
                      re_id: 530721,
                      re_parent: 530700,
                      re_name: "玉龙纳西族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530722,
                      re_parent: 530700,
                      re_name: "永胜县",
                      re_level: "3"
                  },
                  {
                      re_id: 530723,
                      re_parent: 530700,
                      re_name: "华坪县",
                      re_level: "3"
                  },
                  {
                      re_id: 530724,
                      re_parent: 530700,
                      re_name: "宁蒗彝族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530800,
              re_parent: 530000,
              re_name: "普洱市",
              re_level: "2",
              children: [
                  {
                      re_id: 530802,
                      re_parent: 530800,
                      re_name: "思茅区",
                      re_level: "3"
                  },
                  {
                      re_id: 530821,
                      re_parent: 530800,
                      re_name: "宁洱哈尼族彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530822,
                      re_parent: 530800,
                      re_name: "墨江哈尼族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530823,
                      re_parent: 530800,
                      re_name: "景东彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530824,
                      re_parent: 530800,
                      re_name: "景谷傣族彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530825,
                      re_parent: 530800,
                      re_name: "镇沅彝族哈尼族拉祜族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530826,
                      re_parent: 530800,
                      re_name: "江城哈尼族彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530827,
                      re_parent: 530800,
                      re_name: "孟连傣族拉祜族佤族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530828,
                      re_parent: 530800,
                      re_name: "澜沧拉祜族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530829,
                      re_parent: 530800,
                      re_name: "西盟佤族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 530900,
              re_parent: 530000,
              re_name: "临沧市",
              re_level: "2",
              children: [
                  {
                      re_id: 530902,
                      re_parent: 530900,
                      re_name: "临翔区",
                      re_level: "3"
                  },
                  {
                      re_id: 530921,
                      re_parent: 530900,
                      re_name: "凤庆县",
                      re_level: "3"
                  },
                  {
                      re_id: 530922,
                      re_parent: 530900,
                      re_name: "云县",
                      re_level: "3"
                  },
                  {
                      re_id: 530923,
                      re_parent: 530900,
                      re_name: "永德县",
                      re_level: "3"
                  },
                  {
                      re_id: 530924,
                      re_parent: 530900,
                      re_name: "镇康县",
                      re_level: "3"
                  },
                  {
                      re_id: 530925,
                      re_parent: 530900,
                      re_name: "双江拉祜族佤族布朗族傣族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530926,
                      re_parent: 530900,
                      re_name: "耿马傣族佤族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 530927,
                      re_parent: 530900,
                      re_name: "沧源佤族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 532300,
              re_parent: 530000,
              re_name: "楚雄彝族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 532301,
                      re_parent: 532300,
                      re_name: "楚雄市",
                      re_level: "3"
                  },
                  {
                      re_id: 532322,
                      re_parent: 532300,
                      re_name: "双柏县",
                      re_level: "3"
                  },
                  {
                      re_id: 532323,
                      re_parent: 532300,
                      re_name: "牟定县",
                      re_level: "3"
                  },
                  {
                      re_id: 532324,
                      re_parent: 532300,
                      re_name: "南华县",
                      re_level: "3"
                  },
                  {
                      re_id: 532325,
                      re_parent: 532300,
                      re_name: "姚安县",
                      re_level: "3"
                  },
                  {
                      re_id: 532326,
                      re_parent: 532300,
                      re_name: "大姚县",
                      re_level: "3"
                  },
                  {
                      re_id: 532327,
                      re_parent: 532300,
                      re_name: "永仁县",
                      re_level: "3"
                  },
                  {
                      re_id: 532328,
                      re_parent: 532300,
                      re_name: "元谋县",
                      re_level: "3"
                  },
                  {
                      re_id: 532329,
                      re_parent: 532300,
                      re_name: "武定县",
                      re_level: "3"
                  },
                  {
                      re_id: 532331,
                      re_parent: 532300,
                      re_name: "禄丰县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 532500,
              re_parent: 530000,
              re_name: "红河哈尼族彝族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 532501,
                      re_parent: 532500,
                      re_name: "个旧市",
                      re_level: "3"
                  },
                  {
                      re_id: 532502,
                      re_parent: 532500,
                      re_name: "开远市",
                      re_level: "3"
                  },
                  {
                      re_id: 532503,
                      re_parent: 532500,
                      re_name: "蒙自市",
                      re_level: "3"
                  },
                  {
                      re_id: 532504,
                      re_parent: 532500,
                      re_name: "弥勒市",
                      re_level: "3"
                  },
                  {
                      re_id: 532523,
                      re_parent: 532500,
                      re_name: "屏边苗族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 532524,
                      re_parent: 532500,
                      re_name: "建水县",
                      re_level: "3"
                  },
                  {
                      re_id: 532525,
                      re_parent: 532500,
                      re_name: "石屏县",
                      re_level: "3"
                  },
                  {
                      re_id: 532527,
                      re_parent: 532500,
                      re_name: "泸西县",
                      re_level: "3"
                  },
                  {
                      re_id: 532528,
                      re_parent: 532500,
                      re_name: "元阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 532529,
                      re_parent: 532500,
                      re_name: "红河县",
                      re_level: "3"
                  },
                  {
                      re_id: 532530,
                      re_parent: 532500,
                      re_name: "金平苗族瑶族傣族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 532531,
                      re_parent: 532500,
                      re_name: "绿春县",
                      re_level: "3"
                  },
                  {
                      re_id: 532532,
                      re_parent: 532500,
                      re_name: "河口瑶族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 532600,
              re_parent: 530000,
              re_name: "文山壮族苗族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 532601,
                      re_parent: 532600,
                      re_name: "文山市",
                      re_level: "3"
                  },
                  {
                      re_id: 532622,
                      re_parent: 532600,
                      re_name: "砚山县",
                      re_level: "3"
                  },
                  {
                      re_id: 532623,
                      re_parent: 532600,
                      re_name: "西畴县",
                      re_level: "3"
                  },
                  {
                      re_id: 532624,
                      re_parent: 532600,
                      re_name: "麻栗坡县",
                      re_level: "3"
                  },
                  {
                      re_id: 532625,
                      re_parent: 532600,
                      re_name: "马关县",
                      re_level: "3"
                  },
                  {
                      re_id: 532626,
                      re_parent: 532600,
                      re_name: "丘北县",
                      re_level: "3"
                  },
                  {
                      re_id: 532627,
                      re_parent: 532600,
                      re_name: "广南县",
                      re_level: "3"
                  },
                  {
                      re_id: 532628,
                      re_parent: 532600,
                      re_name: "富宁县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 532800,
              re_parent: 530000,
              re_name: "西双版纳傣族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 532801,
                      re_parent: 532800,
                      re_name: "景洪市",
                      re_level: "3"
                  },
                  {
                      re_id: 532822,
                      re_parent: 532800,
                      re_name: "勐海县",
                      re_level: "3"
                  },
                  {
                      re_id: 532823,
                      re_parent: 532800,
                      re_name: "勐腊县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 532900,
              re_parent: 530000,
              re_name: "大理白族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 532901,
                      re_parent: 532900,
                      re_name: "大理市",
                      re_level: "3"
                  },
                  {
                      re_id: 532922,
                      re_parent: 532900,
                      re_name: "漾濞彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 532923,
                      re_parent: 532900,
                      re_name: "祥云县",
                      re_level: "3"
                  },
                  {
                      re_id: 532924,
                      re_parent: 532900,
                      re_name: "宾川县",
                      re_level: "3"
                  },
                  {
                      re_id: 532925,
                      re_parent: 532900,
                      re_name: "弥渡县",
                      re_level: "3"
                  },
                  {
                      re_id: 532926,
                      re_parent: 532900,
                      re_name: "南涧彝族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 532927,
                      re_parent: 532900,
                      re_name: "巍山彝族回族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 532928,
                      re_parent: 532900,
                      re_name: "永平县",
                      re_level: "3"
                  },
                  {
                      re_id: 532929,
                      re_parent: 532900,
                      re_name: "云龙县",
                      re_level: "3"
                  },
                  {
                      re_id: 532930,
                      re_parent: 532900,
                      re_name: "洱源县",
                      re_level: "3"
                  },
                  {
                      re_id: 532931,
                      re_parent: 532900,
                      re_name: "剑川县",
                      re_level: "3"
                  },
                  {
                      re_id: 532932,
                      re_parent: 532900,
                      re_name: "鹤庆县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 533100,
              re_parent: 530000,
              re_name: "德宏傣族景颇族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 533102,
                      re_parent: 533100,
                      re_name: "瑞丽市",
                      re_level: "3"
                  },
                  {
                      re_id: 533103,
                      re_parent: 533100,
                      re_name: "芒市",
                      re_level: "3"
                  },
                  {
                      re_id: 533122,
                      re_parent: 533100,
                      re_name: "梁河县",
                      re_level: "3"
                  },
                  {
                      re_id: 533123,
                      re_parent: 533100,
                      re_name: "盈江县",
                      re_level: "3"
                  },
                  {
                      re_id: 533124,
                      re_parent: 533100,
                      re_name: "陇川县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 533300,
              re_parent: 530000,
              re_name: "怒江傈僳族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 533321,
                      re_parent: 533300,
                      re_name: "泸水县",
                      re_level: "3"
                  },
                  {
                      re_id: 533323,
                      re_parent: 533300,
                      re_name: "福贡县",
                      re_level: "3"
                  },
                  {
                      re_id: 533324,
                      re_parent: 533300,
                      re_name: "贡山独龙族怒族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 533325,
                      re_parent: 533300,
                      re_name: "兰坪白族普米族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 533400,
              re_parent: 530000,
              re_name: "迪庆藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 533421,
                      re_parent: 533400,
                      re_name: "香格里拉市",
                      re_level: "3"
                  },
                  {
                      re_id: 533422,
                      re_parent: 533400,
                      re_name: "德钦县",
                      re_level: "3"
                  },
                  {
                      re_id: 533423,
                      re_parent: 533400,
                      re_name: "维西傈僳族自治县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 540000,
      re_parent: 100000,
      re_name: "西藏自治区",
      re_level: "1",
      children: [
          {
              re_id: 540100,
              re_parent: 540000,
              re_name: "拉萨市",
              re_level: "2",
              children: [
                  {
                      re_id: 540102,
                      re_parent: 540100,
                      re_name: "城关区",
                      re_level: "3"
                  },
                  {
                      re_id: 540121,
                      re_parent: 540100,
                      re_name: "林周县",
                      re_level: "3"
                  },
                  {
                      re_id: 540122,
                      re_parent: 540100,
                      re_name: "当雄县",
                      re_level: "3"
                  },
                  {
                      re_id: 540123,
                      re_parent: 540100,
                      re_name: "尼木县",
                      re_level: "3"
                  },
                  {
                      re_id: 540124,
                      re_parent: 540100,
                      re_name: "曲水县",
                      re_level: "3"
                  },
                  {
                      re_id: 540125,
                      re_parent: 540100,
                      re_name: "堆龙德庆县",
                      re_level: "3"
                  },
                  {
                      re_id: 540126,
                      re_parent: 540100,
                      re_name: "达孜县",
                      re_level: "3"
                  },
                  {
                      re_id: 540127,
                      re_parent: 540100,
                      re_name: "墨竹工卡县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 540200,
              re_parent: 540000,
              re_name: "日喀则市",
              re_level: "2",
              children: [
                  {
                      re_id: 540202,
                      re_parent: 540200,
                      re_name: "桑珠孜区",
                      re_level: "3"
                  },
                  {
                      re_id: 540221,
                      re_parent: 540200,
                      re_name: "南木林县",
                      re_level: "3"
                  },
                  {
                      re_id: 540222,
                      re_parent: 540200,
                      re_name: "江孜县",
                      re_level: "3"
                  },
                  {
                      re_id: 540223,
                      re_parent: 540200,
                      re_name: "定日县",
                      re_level: "3"
                  },
                  {
                      re_id: 540224,
                      re_parent: 540200,
                      re_name: "萨迦县",
                      re_level: "3"
                  },
                  {
                      re_id: 540225,
                      re_parent: 540200,
                      re_name: "拉孜县",
                      re_level: "3"
                  },
                  {
                      re_id: 540226,
                      re_parent: 540200,
                      re_name: "昂仁县",
                      re_level: "3"
                  },
                  {
                      re_id: 540227,
                      re_parent: 540200,
                      re_name: "谢通门县",
                      re_level: "3"
                  },
                  {
                      re_id: 540228,
                      re_parent: 540200,
                      re_name: "白朗县",
                      re_level: "3"
                  },
                  {
                      re_id: 540229,
                      re_parent: 540200,
                      re_name: "仁布县",
                      re_level: "3"
                  },
                  {
                      re_id: 540230,
                      re_parent: 540200,
                      re_name: "康马县",
                      re_level: "3"
                  },
                  {
                      re_id: 540231,
                      re_parent: 540200,
                      re_name: "定结县",
                      re_level: "3"
                  },
                  {
                      re_id: 540232,
                      re_parent: 540200,
                      re_name: "仲巴县",
                      re_level: "3"
                  },
                  {
                      re_id: 540233,
                      re_parent: 540200,
                      re_name: "亚东县",
                      re_level: "3"
                  },
                  {
                      re_id: 540234,
                      re_parent: 540200,
                      re_name: "吉隆县",
                      re_level: "3"
                  },
                  {
                      re_id: 540235,
                      re_parent: 540200,
                      re_name: "聂拉木县",
                      re_level: "3"
                  },
                  {
                      re_id: 540236,
                      re_parent: 540200,
                      re_name: "萨嘎县",
                      re_level: "3"
                  },
                  {
                      re_id: 540237,
                      re_parent: 540200,
                      re_name: "岗巴县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 540300,
              re_parent: 540000,
              re_name: "昌都市",
              re_level: "2",
              children: [
                  {
                      re_id: 540302,
                      re_parent: 540300,
                      re_name: "卡若区",
                      re_level: "3"
                  },
                  {
                      re_id: 540321,
                      re_parent: 540300,
                      re_name: "江达县",
                      re_level: "3"
                  },
                  {
                      re_id: 540322,
                      re_parent: 540300,
                      re_name: "贡觉县",
                      re_level: "3"
                  },
                  {
                      re_id: 540323,
                      re_parent: 540300,
                      re_name: "类乌齐县",
                      re_level: "3"
                  },
                  {
                      re_id: 540324,
                      re_parent: 540300,
                      re_name: "丁青县",
                      re_level: "3"
                  },
                  {
                      re_id: 540325,
                      re_parent: 540300,
                      re_name: "察雅县",
                      re_level: "3"
                  },
                  {
                      re_id: 540326,
                      re_parent: 540300,
                      re_name: "八宿县",
                      re_level: "3"
                  },
                  {
                      re_id: 540327,
                      re_parent: 540300,
                      re_name: "左贡县",
                      re_level: "3"
                  },
                  {
                      re_id: 540328,
                      re_parent: 540300,
                      re_name: "芒康县",
                      re_level: "3"
                  },
                  {
                      re_id: 540329,
                      re_parent: 540300,
                      re_name: "洛隆县",
                      re_level: "3"
                  },
                  {
                      re_id: 540330,
                      re_parent: 540300,
                      re_name: "边坝县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 542200,
              re_parent: 540000,
              re_name: "山南地区",
              re_level: "2",
              children: [
                  {
                      re_id: 542221,
                      re_parent: 542200,
                      re_name: "乃东县",
                      re_level: "3"
                  },
                  {
                      re_id: 542222,
                      re_parent: 542200,
                      re_name: "扎囊县",
                      re_level: "3"
                  },
                  {
                      re_id: 542223,
                      re_parent: 542200,
                      re_name: "贡嘎县",
                      re_level: "3"
                  },
                  {
                      re_id: 542224,
                      re_parent: 542200,
                      re_name: "桑日县",
                      re_level: "3"
                  },
                  {
                      re_id: 542225,
                      re_parent: 542200,
                      re_name: "琼结县",
                      re_level: "3"
                  },
                  {
                      re_id: 542226,
                      re_parent: 542200,
                      re_name: "曲松县",
                      re_level: "3"
                  },
                  {
                      re_id: 542227,
                      re_parent: 542200,
                      re_name: "措美县",
                      re_level: "3"
                  },
                  {
                      re_id: 542228,
                      re_parent: 542200,
                      re_name: "洛扎县",
                      re_level: "3"
                  },
                  {
                      re_id: 542229,
                      re_parent: 542200,
                      re_name: "加查县",
                      re_level: "3"
                  },
                  {
                      re_id: 542231,
                      re_parent: 542200,
                      re_name: "隆子县",
                      re_level: "3"
                  },
                  {
                      re_id: 542232,
                      re_parent: 542200,
                      re_name: "错那县",
                      re_level: "3"
                  },
                  {
                      re_id: 542233,
                      re_parent: 542200,
                      re_name: "浪卡子县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 542400,
              re_parent: 540000,
              re_name: "那曲地区",
              re_level: "2",
              children: [
                  {
                      re_id: 542421,
                      re_parent: 542400,
                      re_name: "那曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 542422,
                      re_parent: 542400,
                      re_name: "嘉黎县",
                      re_level: "3"
                  },
                  {
                      re_id: 542423,
                      re_parent: 542400,
                      re_name: "比如县",
                      re_level: "3"
                  },
                  {
                      re_id: 542424,
                      re_parent: 542400,
                      re_name: "聂荣县",
                      re_level: "3"
                  },
                  {
                      re_id: 542425,
                      re_parent: 542400,
                      re_name: "安多县",
                      re_level: "3"
                  },
                  {
                      re_id: 542426,
                      re_parent: 542400,
                      re_name: "申扎县",
                      re_level: "3"
                  },
                  {
                      re_id: 542427,
                      re_parent: 542400,
                      re_name: "索县",
                      re_level: "3"
                  },
                  {
                      re_id: 542428,
                      re_parent: 542400,
                      re_name: "班戈县",
                      re_level: "3"
                  },
                  {
                      re_id: 542429,
                      re_parent: 542400,
                      re_name: "巴青县",
                      re_level: "3"
                  },
                  {
                      re_id: 542430,
                      re_parent: 542400,
                      re_name: "尼玛县",
                      re_level: "3"
                  },
                  {
                      re_id: 542431,
                      re_parent: 542400,
                      re_name: "双湖县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 542500,
              re_parent: 540000,
              re_name: "阿里地区",
              re_level: "2",
              children: [
                  {
                      re_id: 542521,
                      re_parent: 542500,
                      re_name: "普兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 542522,
                      re_parent: 542500,
                      re_name: "札达县",
                      re_level: "3"
                  },
                  {
                      re_id: 542523,
                      re_parent: 542500,
                      re_name: "噶尔县",
                      re_level: "3"
                  },
                  {
                      re_id: 542524,
                      re_parent: 542500,
                      re_name: "日土县",
                      re_level: "3"
                  },
                  {
                      re_id: 542525,
                      re_parent: 542500,
                      re_name: "革吉县",
                      re_level: "3"
                  },
                  {
                      re_id: 542526,
                      re_parent: 542500,
                      re_name: "改则县",
                      re_level: "3"
                  },
                  {
                      re_id: 542527,
                      re_parent: 542500,
                      re_name: "措勤县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 542600,
              re_parent: 540000,
              re_name: "林芝地区",
              re_level: "2",
              children: [
                  {
                      re_id: 542621,
                      re_parent: 542600,
                      re_name: "林芝县",
                      re_level: "3"
                  },
                  {
                      re_id: 542622,
                      re_parent: 542600,
                      re_name: "工布江达县",
                      re_level: "3"
                  },
                  {
                      re_id: 542623,
                      re_parent: 542600,
                      re_name: "米林县",
                      re_level: "3"
                  },
                  {
                      re_id: 542624,
                      re_parent: 542600,
                      re_name: "墨脱县",
                      re_level: "3"
                  },
                  {
                      re_id: 542625,
                      re_parent: 542600,
                      re_name: "波密县",
                      re_level: "3"
                  },
                  {
                      re_id: 542626,
                      re_parent: 542600,
                      re_name: "察隅县",
                      re_level: "3"
                  },
                  {
                      re_id: 542627,
                      re_parent: 542600,
                      re_name: "朗县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 610000,
      re_parent: 100000,
      re_name: "陕西省",
      re_level: "1",
      children: [
          {
              re_id: 610100,
              re_parent: 610000,
              re_name: "西安市",
              re_level: "2",
              children: [
                  {
                      re_id: 610102,
                      re_parent: 610100,
                      re_name: "新城区",
                      re_level: "3"
                  },
                  {
                      re_id: 610103,
                      re_parent: 610100,
                      re_name: "碑林区",
                      re_level: "3"
                  },
                  {
                      re_id: 610104,
                      re_parent: 610100,
                      re_name: "莲湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 610111,
                      re_parent: 610100,
                      re_name: "灞桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 610112,
                      re_parent: 610100,
                      re_name: "未央区",
                      re_level: "3"
                  },
                  {
                      re_id: 610113,
                      re_parent: 610100,
                      re_name: "雁塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 610114,
                      re_parent: 610100,
                      re_name: "阎良区",
                      re_level: "3"
                  },
                  {
                      re_id: 610115,
                      re_parent: 610100,
                      re_name: "临潼区",
                      re_level: "3"
                  },
                  {
                      re_id: 610116,
                      re_parent: 610100,
                      re_name: "长安区",
                      re_level: "3"
                  },
                  {
                      re_id: 610122,
                      re_parent: 610100,
                      re_name: "蓝田县",
                      re_level: "3"
                  },
                  {
                      re_id: 610124,
                      re_parent: 610100,
                      re_name: "周至县",
                      re_level: "3"
                  },
                  {
                      re_id: 610125,
                      re_parent: 610100,
                      re_name: "户县",
                      re_level: "3"
                  },
                  {
                      re_id: 610126,
                      re_parent: 610100,
                      re_name: "高陵区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610200,
              re_parent: 610000,
              re_name: "铜川市",
              re_level: "2",
              children: [
                  {
                      re_id: 610202,
                      re_parent: 610200,
                      re_name: "王益区",
                      re_level: "3"
                  },
                  {
                      re_id: 610203,
                      re_parent: 610200,
                      re_name: "印台区",
                      re_level: "3"
                  },
                  {
                      re_id: 610204,
                      re_parent: 610200,
                      re_name: "耀州区",
                      re_level: "3"
                  },
                  {
                      re_id: 610222,
                      re_parent: 610200,
                      re_name: "宜君县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610300,
              re_parent: 610000,
              re_name: "宝鸡市",
              re_level: "2",
              children: [
                  {
                      re_id: 610302,
                      re_parent: 610300,
                      re_name: "渭滨区",
                      re_level: "3"
                  },
                  {
                      re_id: 610303,
                      re_parent: 610300,
                      re_name: "金台区",
                      re_level: "3"
                  },
                  {
                      re_id: 610304,
                      re_parent: 610300,
                      re_name: "陈仓区",
                      re_level: "3"
                  },
                  {
                      re_id: 610322,
                      re_parent: 610300,
                      re_name: "凤翔县",
                      re_level: "3"
                  },
                  {
                      re_id: 610323,
                      re_parent: 610300,
                      re_name: "岐山县",
                      re_level: "3"
                  },
                  {
                      re_id: 610324,
                      re_parent: 610300,
                      re_name: "扶风县",
                      re_level: "3"
                  },
                  {
                      re_id: 610326,
                      re_parent: 610300,
                      re_name: "眉县",
                      re_level: "3"
                  },
                  {
                      re_id: 610327,
                      re_parent: 610300,
                      re_name: "陇县",
                      re_level: "3"
                  },
                  {
                      re_id: 610328,
                      re_parent: 610300,
                      re_name: "千阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610329,
                      re_parent: 610300,
                      re_name: "麟游县",
                      re_level: "3"
                  },
                  {
                      re_id: 610330,
                      re_parent: 610300,
                      re_name: "凤县",
                      re_level: "3"
                  },
                  {
                      re_id: 610331,
                      re_parent: 610300,
                      re_name: "太白县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610400,
              re_parent: 610000,
              re_name: "咸阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 610402,
                      re_parent: 610400,
                      re_name: "秦都区",
                      re_level: "3"
                  },
                  {
                      re_id: 610403,
                      re_parent: 610400,
                      re_name: "杨陵区",
                      re_level: "3"
                  },
                  {
                      re_id: 610404,
                      re_parent: 610400,
                      re_name: "渭城区",
                      re_level: "3"
                  },
                  {
                      re_id: 610422,
                      re_parent: 610400,
                      re_name: "三原县",
                      re_level: "3"
                  },
                  {
                      re_id: 610423,
                      re_parent: 610400,
                      re_name: "泾阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610424,
                      re_parent: 610400,
                      re_name: "乾县",
                      re_level: "3"
                  },
                  {
                      re_id: 610425,
                      re_parent: 610400,
                      re_name: "礼泉县",
                      re_level: "3"
                  },
                  {
                      re_id: 610426,
                      re_parent: 610400,
                      re_name: "永寿县",
                      re_level: "3"
                  },
                  {
                      re_id: 610427,
                      re_parent: 610400,
                      re_name: "彬县",
                      re_level: "3"
                  },
                  {
                      re_id: 610428,
                      re_parent: 610400,
                      re_name: "长武县",
                      re_level: "3"
                  },
                  {
                      re_id: 610429,
                      re_parent: 610400,
                      re_name: "旬邑县",
                      re_level: "3"
                  },
                  {
                      re_id: 610430,
                      re_parent: 610400,
                      re_name: "淳化县",
                      re_level: "3"
                  },
                  {
                      re_id: 610431,
                      re_parent: 610400,
                      re_name: "武功县",
                      re_level: "3"
                  },
                  {
                      re_id: 610481,
                      re_parent: 610400,
                      re_name: "兴平市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610500,
              re_parent: 610000,
              re_name: "渭南市",
              re_level: "2",
              children: [
                  {
                      re_id: 610502,
                      re_parent: 610500,
                      re_name: "临渭区",
                      re_level: "3"
                  },
                  {
                      re_id: 610521,
                      re_parent: 610500,
                      re_name: "华县",
                      re_level: "3"
                  },
                  {
                      re_id: 610522,
                      re_parent: 610500,
                      re_name: "潼关县",
                      re_level: "3"
                  },
                  {
                      re_id: 610523,
                      re_parent: 610500,
                      re_name: "大荔县",
                      re_level: "3"
                  },
                  {
                      re_id: 610524,
                      re_parent: 610500,
                      re_name: "合阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610525,
                      re_parent: 610500,
                      re_name: "澄城县",
                      re_level: "3"
                  },
                  {
                      re_id: 610526,
                      re_parent: 610500,
                      re_name: "蒲城县",
                      re_level: "3"
                  },
                  {
                      re_id: 610527,
                      re_parent: 610500,
                      re_name: "白水县",
                      re_level: "3"
                  },
                  {
                      re_id: 610528,
                      re_parent: 610500,
                      re_name: "富平县",
                      re_level: "3"
                  },
                  {
                      re_id: 610581,
                      re_parent: 610500,
                      re_name: "韩城市",
                      re_level: "3"
                  },
                  {
                      re_id: 610582,
                      re_parent: 610500,
                      re_name: "华阴市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610600,
              re_parent: 610000,
              re_name: "延安市",
              re_level: "2",
              children: [
                  {
                      re_id: 610602,
                      re_parent: 610600,
                      re_name: "宝塔区",
                      re_level: "3"
                  },
                  {
                      re_id: 610621,
                      re_parent: 610600,
                      re_name: "延长县",
                      re_level: "3"
                  },
                  {
                      re_id: 610622,
                      re_parent: 610600,
                      re_name: "延川县",
                      re_level: "3"
                  },
                  {
                      re_id: 610623,
                      re_parent: 610600,
                      re_name: "子长县",
                      re_level: "3"
                  },
                  {
                      re_id: 610624,
                      re_parent: 610600,
                      re_name: "安塞县",
                      re_level: "3"
                  },
                  {
                      re_id: 610625,
                      re_parent: 610600,
                      re_name: "志丹县",
                      re_level: "3"
                  },
                  {
                      re_id: 610626,
                      re_parent: 610600,
                      re_name: "吴起县",
                      re_level: "3"
                  },
                  {
                      re_id: 610627,
                      re_parent: 610600,
                      re_name: "甘泉县",
                      re_level: "3"
                  },
                  {
                      re_id: 610628,
                      re_parent: 610600,
                      re_name: "富县",
                      re_level: "3"
                  },
                  {
                      re_id: 610629,
                      re_parent: 610600,
                      re_name: "洛川县",
                      re_level: "3"
                  },
                  {
                      re_id: 610630,
                      re_parent: 610600,
                      re_name: "宜川县",
                      re_level: "3"
                  },
                  {
                      re_id: 610631,
                      re_parent: 610600,
                      re_name: "黄龙县",
                      re_level: "3"
                  },
                  {
                      re_id: 610632,
                      re_parent: 610600,
                      re_name: "黄陵县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610700,
              re_parent: 610000,
              re_name: "汉中市",
              re_level: "2",
              children: [
                  {
                      re_id: 610702,
                      re_parent: 610700,
                      re_name: "汉台区",
                      re_level: "3"
                  },
                  {
                      re_id: 610721,
                      re_parent: 610700,
                      re_name: "南郑县",
                      re_level: "3"
                  },
                  {
                      re_id: 610722,
                      re_parent: 610700,
                      re_name: "城固县",
                      re_level: "3"
                  },
                  {
                      re_id: 610723,
                      re_parent: 610700,
                      re_name: "洋县",
                      re_level: "3"
                  },
                  {
                      re_id: 610724,
                      re_parent: 610700,
                      re_name: "西乡县",
                      re_level: "3"
                  },
                  {
                      re_id: 610725,
                      re_parent: 610700,
                      re_name: "勉县",
                      re_level: "3"
                  },
                  {
                      re_id: 610726,
                      re_parent: 610700,
                      re_name: "宁强县",
                      re_level: "3"
                  },
                  {
                      re_id: 610727,
                      re_parent: 610700,
                      re_name: "略阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610728,
                      re_parent: 610700,
                      re_name: "镇巴县",
                      re_level: "3"
                  },
                  {
                      re_id: 610729,
                      re_parent: 610700,
                      re_name: "留坝县",
                      re_level: "3"
                  },
                  {
                      re_id: 610730,
                      re_parent: 610700,
                      re_name: "佛坪县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610800,
              re_parent: 610000,
              re_name: "榆林市",
              re_level: "2",
              children: [
                  {
                      re_id: 610802,
                      re_parent: 610800,
                      re_name: "榆阳区",
                      re_level: "3"
                  },
                  {
                      re_id: 610821,
                      re_parent: 610800,
                      re_name: "神木县",
                      re_level: "3"
                  },
                  {
                      re_id: 610822,
                      re_parent: 610800,
                      re_name: "府谷县",
                      re_level: "3"
                  },
                  {
                      re_id: 610823,
                      re_parent: 610800,
                      re_name: "横山县",
                      re_level: "3"
                  },
                  {
                      re_id: 610824,
                      re_parent: 610800,
                      re_name: "靖边县",
                      re_level: "3"
                  },
                  {
                      re_id: 610825,
                      re_parent: 610800,
                      re_name: "定边县",
                      re_level: "3"
                  },
                  {
                      re_id: 610826,
                      re_parent: 610800,
                      re_name: "绥德县",
                      re_level: "3"
                  },
                  {
                      re_id: 610827,
                      re_parent: 610800,
                      re_name: "米脂县",
                      re_level: "3"
                  },
                  {
                      re_id: 610828,
                      re_parent: 610800,
                      re_name: "佳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610829,
                      re_parent: 610800,
                      re_name: "吴堡县",
                      re_level: "3"
                  },
                  {
                      re_id: 610830,
                      re_parent: 610800,
                      re_name: "清涧县",
                      re_level: "3"
                  },
                  {
                      re_id: 610831,
                      re_parent: 610800,
                      re_name: "子洲县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 610900,
              re_parent: 610000,
              re_name: "安康市",
              re_level: "2",
              children: [
                  {
                      re_id: 610902,
                      re_parent: 610900,
                      re_name: "汉滨区",
                      re_level: "3"
                  },
                  {
                      re_id: 610921,
                      re_parent: 610900,
                      re_name: "汉阴县",
                      re_level: "3"
                  },
                  {
                      re_id: 610922,
                      re_parent: 610900,
                      re_name: "石泉县",
                      re_level: "3"
                  },
                  {
                      re_id: 610923,
                      re_parent: 610900,
                      re_name: "宁陕县",
                      re_level: "3"
                  },
                  {
                      re_id: 610924,
                      re_parent: 610900,
                      re_name: "紫阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610925,
                      re_parent: 610900,
                      re_name: "岚皋县",
                      re_level: "3"
                  },
                  {
                      re_id: 610926,
                      re_parent: 610900,
                      re_name: "平利县",
                      re_level: "3"
                  },
                  {
                      re_id: 610927,
                      re_parent: 610900,
                      re_name: "镇坪县",
                      re_level: "3"
                  },
                  {
                      re_id: 610928,
                      re_parent: 610900,
                      re_name: "旬阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 610929,
                      re_parent: 610900,
                      re_name: "白河县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 611000,
              re_parent: 610000,
              re_name: "商洛市",
              re_level: "2",
              children: [
                  {
                      re_id: 611002,
                      re_parent: 611000,
                      re_name: "商州区",
                      re_level: "3"
                  },
                  {
                      re_id: 611021,
                      re_parent: 611000,
                      re_name: "洛南县",
                      re_level: "3"
                  },
                  {
                      re_id: 611022,
                      re_parent: 611000,
                      re_name: "丹凤县",
                      re_level: "3"
                  },
                  {
                      re_id: 611023,
                      re_parent: 611000,
                      re_name: "商南县",
                      re_level: "3"
                  },
                  {
                      re_id: 611024,
                      re_parent: 611000,
                      re_name: "山阳县",
                      re_level: "3"
                  },
                  {
                      re_id: 611025,
                      re_parent: 611000,
                      re_name: "镇安县",
                      re_level: "3"
                  },
                  {
                      re_id: 611026,
                      re_parent: 611000,
                      re_name: "柞水县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 611100,
              re_parent: 610000,
              re_name: "西咸新区",
              re_level: "2",
              children: [
                  {
                      re_id: 611101,
                      re_parent: 611100,
                      re_name: "空港新城",
                      re_level: "3"
                  },
                  {
                      re_id: 611102,
                      re_parent: 611100,
                      re_name: "沣东新城",
                      re_level: "3"
                  },
                  {
                      re_id: 611103,
                      re_parent: 611100,
                      re_name: "秦汉新城",
                      re_level: "3"
                  },
                  {
                      re_id: 611104,
                      re_parent: 611100,
                      re_name: "沣西新城",
                      re_level: "3"
                  },
                  {
                      re_id: 611105,
                      re_parent: 611100,
                      re_name: "泾河新城",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 620000,
      re_parent: 100000,
      re_name: "甘肃省",
      re_level: "1",
      children: [
          {
              re_id: 620100,
              re_parent: 620000,
              re_name: "兰州市",
              re_level: "2",
              children: [
                  {
                      re_id: 620102,
                      re_parent: 620100,
                      re_name: "城关区",
                      re_level: "3"
                  },
                  {
                      re_id: 620103,
                      re_parent: 620100,
                      re_name: "七里河区",
                      re_level: "3"
                  },
                  {
                      re_id: 620104,
                      re_parent: 620100,
                      re_name: "西固区",
                      re_level: "3"
                  },
                  {
                      re_id: 620105,
                      re_parent: 620100,
                      re_name: "安宁区",
                      re_level: "3"
                  },
                  {
                      re_id: 620111,
                      re_parent: 620100,
                      re_name: "红古区",
                      re_level: "3"
                  },
                  {
                      re_id: 620121,
                      re_parent: 620100,
                      re_name: "永登县",
                      re_level: "3"
                  },
                  {
                      re_id: 620122,
                      re_parent: 620100,
                      re_name: "皋兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 620123,
                      re_parent: 620100,
                      re_name: "榆中县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620200,
              re_parent: 620000,
              re_name: "嘉峪关市",
              re_level: "2",
              children: [
                  {
                      re_id: 620201,
                      re_parent: 620200,
                      re_name: "雄关区",
                      re_level: "3"
                  },
                  {
                      re_id: 620202,
                      re_parent: 620200,
                      re_name: "长城区",
                      re_level: "3"
                  },
                  {
                      re_id: 620203,
                      re_parent: 620200,
                      re_name: "镜铁区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620300,
              re_parent: 620000,
              re_name: "金昌市",
              re_level: "2",
              children: [
                  {
                      re_id: 620302,
                      re_parent: 620300,
                      re_name: "金川区",
                      re_level: "3"
                  },
                  {
                      re_id: 620321,
                      re_parent: 620300,
                      re_name: "永昌县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620400,
              re_parent: 620000,
              re_name: "白银市",
              re_level: "2",
              children: [
                  {
                      re_id: 620402,
                      re_parent: 620400,
                      re_name: "白银区",
                      re_level: "3"
                  },
                  {
                      re_id: 620403,
                      re_parent: 620400,
                      re_name: "平川区",
                      re_level: "3"
                  },
                  {
                      re_id: 620421,
                      re_parent: 620400,
                      re_name: "靖远县",
                      re_level: "3"
                  },
                  {
                      re_id: 620422,
                      re_parent: 620400,
                      re_name: "会宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 620423,
                      re_parent: 620400,
                      re_name: "景泰县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620500,
              re_parent: 620000,
              re_name: "天水市",
              re_level: "2",
              children: [
                  {
                      re_id: 620502,
                      re_parent: 620500,
                      re_name: "秦州区",
                      re_level: "3"
                  },
                  {
                      re_id: 620503,
                      re_parent: 620500,
                      re_name: "麦积区",
                      re_level: "3"
                  },
                  {
                      re_id: 620521,
                      re_parent: 620500,
                      re_name: "清水县",
                      re_level: "3"
                  },
                  {
                      re_id: 620522,
                      re_parent: 620500,
                      re_name: "秦安县",
                      re_level: "3"
                  },
                  {
                      re_id: 620523,
                      re_parent: 620500,
                      re_name: "甘谷县",
                      re_level: "3"
                  },
                  {
                      re_id: 620524,
                      re_parent: 620500,
                      re_name: "武山县",
                      re_level: "3"
                  },
                  {
                      re_id: 620525,
                      re_parent: 620500,
                      re_name: "张家川回族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620600,
              re_parent: 620000,
              re_name: "武威市",
              re_level: "2",
              children: [
                  {
                      re_id: 620602,
                      re_parent: 620600,
                      re_name: "凉州区",
                      re_level: "3"
                  },
                  {
                      re_id: 620621,
                      re_parent: 620600,
                      re_name: "民勤县",
                      re_level: "3"
                  },
                  {
                      re_id: 620622,
                      re_parent: 620600,
                      re_name: "古浪县",
                      re_level: "3"
                  },
                  {
                      re_id: 620623,
                      re_parent: 620600,
                      re_name: "天祝藏族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620700,
              re_parent: 620000,
              re_name: "张掖市",
              re_level: "2",
              children: [
                  {
                      re_id: 620702,
                      re_parent: 620700,
                      re_name: "甘州区",
                      re_level: "3"
                  },
                  {
                      re_id: 620721,
                      re_parent: 620700,
                      re_name: "肃南裕固族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 620722,
                      re_parent: 620700,
                      re_name: "民乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 620723,
                      re_parent: 620700,
                      re_name: "临泽县",
                      re_level: "3"
                  },
                  {
                      re_id: 620724,
                      re_parent: 620700,
                      re_name: "高台县",
                      re_level: "3"
                  },
                  {
                      re_id: 620725,
                      re_parent: 620700,
                      re_name: "山丹县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620800,
              re_parent: 620000,
              re_name: "平凉市",
              re_level: "2",
              children: [
                  {
                      re_id: 620802,
                      re_parent: 620800,
                      re_name: "崆峒区",
                      re_level: "3"
                  },
                  {
                      re_id: 620821,
                      re_parent: 620800,
                      re_name: "泾川县",
                      re_level: "3"
                  },
                  {
                      re_id: 620822,
                      re_parent: 620800,
                      re_name: "灵台县",
                      re_level: "3"
                  },
                  {
                      re_id: 620823,
                      re_parent: 620800,
                      re_name: "崇信县",
                      re_level: "3"
                  },
                  {
                      re_id: 620824,
                      re_parent: 620800,
                      re_name: "华亭县",
                      re_level: "3"
                  },
                  {
                      re_id: 620825,
                      re_parent: 620800,
                      re_name: "庄浪县",
                      re_level: "3"
                  },
                  {
                      re_id: 620826,
                      re_parent: 620800,
                      re_name: "静宁县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 620900,
              re_parent: 620000,
              re_name: "酒泉市",
              re_level: "2",
              children: [
                  {
                      re_id: 620902,
                      re_parent: 620900,
                      re_name: "肃州区",
                      re_level: "3"
                  },
                  {
                      re_id: 620921,
                      re_parent: 620900,
                      re_name: "金塔县",
                      re_level: "3"
                  },
                  {
                      re_id: 620922,
                      re_parent: 620900,
                      re_name: "瓜州县",
                      re_level: "3"
                  },
                  {
                      re_id: 620923,
                      re_parent: 620900,
                      re_name: "肃北蒙古族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 620924,
                      re_parent: 620900,
                      re_name: "阿克塞哈萨克族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 620981,
                      re_parent: 620900,
                      re_name: "玉门市",
                      re_level: "3"
                  },
                  {
                      re_id: 620982,
                      re_parent: 620900,
                      re_name: "敦煌市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 621000,
              re_parent: 620000,
              re_name: "庆阳市",
              re_level: "2",
              children: [
                  {
                      re_id: 621002,
                      re_parent: 621000,
                      re_name: "西峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 621021,
                      re_parent: 621000,
                      re_name: "庆城县",
                      re_level: "3"
                  },
                  {
                      re_id: 621022,
                      re_parent: 621000,
                      re_name: "环县",
                      re_level: "3"
                  },
                  {
                      re_id: 621023,
                      re_parent: 621000,
                      re_name: "华池县",
                      re_level: "3"
                  },
                  {
                      re_id: 621024,
                      re_parent: 621000,
                      re_name: "合水县",
                      re_level: "3"
                  },
                  {
                      re_id: 621025,
                      re_parent: 621000,
                      re_name: "正宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 621026,
                      re_parent: 621000,
                      re_name: "宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 621027,
                      re_parent: 621000,
                      re_name: "镇原县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 621100,
              re_parent: 620000,
              re_name: "定西市",
              re_level: "2",
              children: [
                  {
                      re_id: 621102,
                      re_parent: 621100,
                      re_name: "安定区",
                      re_level: "3"
                  },
                  {
                      re_id: 621121,
                      re_parent: 621100,
                      re_name: "通渭县",
                      re_level: "3"
                  },
                  {
                      re_id: 621122,
                      re_parent: 621100,
                      re_name: "陇西县",
                      re_level: "3"
                  },
                  {
                      re_id: 621123,
                      re_parent: 621100,
                      re_name: "渭源县",
                      re_level: "3"
                  },
                  {
                      re_id: 621124,
                      re_parent: 621100,
                      re_name: "临洮县",
                      re_level: "3"
                  },
                  {
                      re_id: 621125,
                      re_parent: 621100,
                      re_name: "漳县",
                      re_level: "3"
                  },
                  {
                      re_id: 621126,
                      re_parent: 621100,
                      re_name: "岷县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 621200,
              re_parent: 620000,
              re_name: "陇南市",
              re_level: "2",
              children: [
                  {
                      re_id: 621202,
                      re_parent: 621200,
                      re_name: "武都区",
                      re_level: "3"
                  },
                  {
                      re_id: 621221,
                      re_parent: 621200,
                      re_name: "成县",
                      re_level: "3"
                  },
                  {
                      re_id: 621222,
                      re_parent: 621200,
                      re_name: "文县",
                      re_level: "3"
                  },
                  {
                      re_id: 621223,
                      re_parent: 621200,
                      re_name: "宕昌县",
                      re_level: "3"
                  },
                  {
                      re_id: 621224,
                      re_parent: 621200,
                      re_name: "康县",
                      re_level: "3"
                  },
                  {
                      re_id: 621225,
                      re_parent: 621200,
                      re_name: "西和县",
                      re_level: "3"
                  },
                  {
                      re_id: 621226,
                      re_parent: 621200,
                      re_name: "礼县",
                      re_level: "3"
                  },
                  {
                      re_id: 621227,
                      re_parent: 621200,
                      re_name: "徽县",
                      re_level: "3"
                  },
                  {
                      re_id: 621228,
                      re_parent: 621200,
                      re_name: "两当县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 622900,
              re_parent: 620000,
              re_name: "临夏回族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 622901,
                      re_parent: 622900,
                      re_name: "临夏市",
                      re_level: "3"
                  },
                  {
                      re_id: 622921,
                      re_parent: 622900,
                      re_name: "临夏县",
                      re_level: "3"
                  },
                  {
                      re_id: 622922,
                      re_parent: 622900,
                      re_name: "康乐县",
                      re_level: "3"
                  },
                  {
                      re_id: 622923,
                      re_parent: 622900,
                      re_name: "永靖县",
                      re_level: "3"
                  },
                  {
                      re_id: 622924,
                      re_parent: 622900,
                      re_name: "广河县",
                      re_level: "3"
                  },
                  {
                      re_id: 622925,
                      re_parent: 622900,
                      re_name: "和政县",
                      re_level: "3"
                  },
                  {
                      re_id: 622926,
                      re_parent: 622900,
                      re_name: "东乡族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 622927,
                      re_parent: 622900,
                      re_name: "积石山保安族东乡族撒拉族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 623000,
              re_parent: 620000,
              re_name: "甘南藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 623001,
                      re_parent: 623000,
                      re_name: "合作市",
                      re_level: "3"
                  },
                  {
                      re_id: 623021,
                      re_parent: 623000,
                      re_name: "临潭县",
                      re_level: "3"
                  },
                  {
                      re_id: 623022,
                      re_parent: 623000,
                      re_name: "卓尼县",
                      re_level: "3"
                  },
                  {
                      re_id: 623023,
                      re_parent: 623000,
                      re_name: "舟曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 623024,
                      re_parent: 623000,
                      re_name: "迭部县",
                      re_level: "3"
                  },
                  {
                      re_id: 623025,
                      re_parent: 623000,
                      re_name: "玛曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 623026,
                      re_parent: 623000,
                      re_name: "碌曲县",
                      re_level: "3"
                  },
                  {
                      re_id: 623027,
                      re_parent: 623000,
                      re_name: "夏河县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 630000,
      re_parent: 100000,
      re_name: "青海省",
      re_level: "1",
      children: [
          {
              re_id: 630100,
              re_parent: 630000,
              re_name: "西宁市",
              re_level: "2",
              children: [
                  {
                      re_id: 630102,
                      re_parent: 630100,
                      re_name: "城东区",
                      re_level: "3"
                  },
                  {
                      re_id: 630103,
                      re_parent: 630100,
                      re_name: "城中区",
                      re_level: "3"
                  },
                  {
                      re_id: 630104,
                      re_parent: 630100,
                      re_name: "城西区",
                      re_level: "3"
                  },
                  {
                      re_id: 630105,
                      re_parent: 630100,
                      re_name: "城北区",
                      re_level: "3"
                  },
                  {
                      re_id: 630121,
                      re_parent: 630100,
                      re_name: "大通回族土族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 630122,
                      re_parent: 630100,
                      re_name: "湟中县",
                      re_level: "3"
                  },
                  {
                      re_id: 630123,
                      re_parent: 630100,
                      re_name: "湟源县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 630200,
              re_parent: 630000,
              re_name: "海东市",
              re_level: "2",
              children: [
                  {
                      re_id: 630202,
                      re_parent: 630200,
                      re_name: "乐都区",
                      re_level: "3"
                  },
                  {
                      re_id: 630221,
                      re_parent: 630200,
                      re_name: "平安县",
                      re_level: "3"
                  },
                  {
                      re_id: 630222,
                      re_parent: 630200,
                      re_name: "民和回族土族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 630223,
                      re_parent: 630200,
                      re_name: "互助土族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 630224,
                      re_parent: 630200,
                      re_name: "化隆回族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 630225,
                      re_parent: 630200,
                      re_name: "循化撒拉族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 632200,
              re_parent: 630000,
              re_name: "海北藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 632221,
                      re_parent: 632200,
                      re_name: "门源回族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 632222,
                      re_parent: 632200,
                      re_name: "祁连县",
                      re_level: "3"
                  },
                  {
                      re_id: 632223,
                      re_parent: 632200,
                      re_name: "海晏县",
                      re_level: "3"
                  },
                  {
                      re_id: 632224,
                      re_parent: 632200,
                      re_name: "刚察县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 632300,
              re_parent: 630000,
              re_name: "黄南藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 632321,
                      re_parent: 632300,
                      re_name: "同仁县",
                      re_level: "3"
                  },
                  {
                      re_id: 632322,
                      re_parent: 632300,
                      re_name: "尖扎县",
                      re_level: "3"
                  },
                  {
                      re_id: 632323,
                      re_parent: 632300,
                      re_name: "泽库县",
                      re_level: "3"
                  },
                  {
                      re_id: 632324,
                      re_parent: 632300,
                      re_name: "河南蒙古族自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 632500,
              re_parent: 630000,
              re_name: "海南藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 632521,
                      re_parent: 632500,
                      re_name: "共和县",
                      re_level: "3"
                  },
                  {
                      re_id: 632522,
                      re_parent: 632500,
                      re_name: "同德县",
                      re_level: "3"
                  },
                  {
                      re_id: 632523,
                      re_parent: 632500,
                      re_name: "贵德县",
                      re_level: "3"
                  },
                  {
                      re_id: 632524,
                      re_parent: 632500,
                      re_name: "兴海县",
                      re_level: "3"
                  },
                  {
                      re_id: 632525,
                      re_parent: 632500,
                      re_name: "贵南县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 632600,
              re_parent: 630000,
              re_name: "果洛藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 632621,
                      re_parent: 632600,
                      re_name: "玛沁县",
                      re_level: "3"
                  },
                  {
                      re_id: 632622,
                      re_parent: 632600,
                      re_name: "班玛县",
                      re_level: "3"
                  },
                  {
                      re_id: 632623,
                      re_parent: 632600,
                      re_name: "甘德县",
                      re_level: "3"
                  },
                  {
                      re_id: 632624,
                      re_parent: 632600,
                      re_name: "达日县",
                      re_level: "3"
                  },
                  {
                      re_id: 632625,
                      re_parent: 632600,
                      re_name: "久治县",
                      re_level: "3"
                  },
                  {
                      re_id: 632626,
                      re_parent: 632600,
                      re_name: "玛多县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 632700,
              re_parent: 630000,
              re_name: "玉树藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 632701,
                      re_parent: 632700,
                      re_name: "玉树市",
                      re_level: "3"
                  },
                  {
                      re_id: 632722,
                      re_parent: 632700,
                      re_name: "杂多县",
                      re_level: "3"
                  },
                  {
                      re_id: 632723,
                      re_parent: 632700,
                      re_name: "称多县",
                      re_level: "3"
                  },
                  {
                      re_id: 632724,
                      re_parent: 632700,
                      re_name: "治多县",
                      re_level: "3"
                  },
                  {
                      re_id: 632725,
                      re_parent: 632700,
                      re_name: "囊谦县",
                      re_level: "3"
                  },
                  {
                      re_id: 632726,
                      re_parent: 632700,
                      re_name: "曲麻莱县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 632800,
              re_parent: 630000,
              re_name: "海西蒙古族藏族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 632801,
                      re_parent: 632800,
                      re_name: "格尔木市",
                      re_level: "3"
                  },
                  {
                      re_id: 632802,
                      re_parent: 632800,
                      re_name: "德令哈市",
                      re_level: "3"
                  },
                  {
                      re_id: 632821,
                      re_parent: 632800,
                      re_name: "乌兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 632822,
                      re_parent: 632800,
                      re_name: "都兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 632823,
                      re_parent: 632800,
                      re_name: "天峻县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 640000,
      re_parent: 100000,
      re_name: "宁夏回族自治区",
      re_level: "1",
      children: [
          {
              re_id: 640100,
              re_parent: 640000,
              re_name: "银川市",
              re_level: "2",
              children: [
                  {
                      re_id: 640104,
                      re_parent: 640100,
                      re_name: "兴庆区",
                      re_level: "3"
                  },
                  {
                      re_id: 640105,
                      re_parent: 640100,
                      re_name: "西夏区",
                      re_level: "3"
                  },
                  {
                      re_id: 640106,
                      re_parent: 640100,
                      re_name: "金凤区",
                      re_level: "3"
                  },
                  {
                      re_id: 640121,
                      re_parent: 640100,
                      re_name: "永宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 640122,
                      re_parent: 640100,
                      re_name: "贺兰县",
                      re_level: "3"
                  },
                  {
                      re_id: 640181,
                      re_parent: 640100,
                      re_name: "灵武市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 640200,
              re_parent: 640000,
              re_name: "石嘴山市",
              re_level: "2",
              children: [
                  {
                      re_id: 640202,
                      re_parent: 640200,
                      re_name: "大武口区",
                      re_level: "3"
                  },
                  {
                      re_id: 640205,
                      re_parent: 640200,
                      re_name: "惠农区",
                      re_level: "3"
                  },
                  {
                      re_id: 640221,
                      re_parent: 640200,
                      re_name: "平罗县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 640300,
              re_parent: 640000,
              re_name: "吴忠市",
              re_level: "2",
              children: [
                  {
                      re_id: 640302,
                      re_parent: 640300,
                      re_name: "利通区",
                      re_level: "3"
                  },
                  {
                      re_id: 640303,
                      re_parent: 640300,
                      re_name: "红寺堡区",
                      re_level: "3"
                  },
                  {
                      re_id: 640323,
                      re_parent: 640300,
                      re_name: "盐池县",
                      re_level: "3"
                  },
                  {
                      re_id: 640324,
                      re_parent: 640300,
                      re_name: "同心县",
                      re_level: "3"
                  },
                  {
                      re_id: 640381,
                      re_parent: 640300,
                      re_name: "青铜峡市",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 640400,
              re_parent: 640000,
              re_name: "固原市",
              re_level: "2",
              children: [
                  {
                      re_id: 640402,
                      re_parent: 640400,
                      re_name: "原州区",
                      re_level: "3"
                  },
                  {
                      re_id: 640422,
                      re_parent: 640400,
                      re_name: "西吉县",
                      re_level: "3"
                  },
                  {
                      re_id: 640423,
                      re_parent: 640400,
                      re_name: "隆德县",
                      re_level: "3"
                  },
                  {
                      re_id: 640424,
                      re_parent: 640400,
                      re_name: "泾源县",
                      re_level: "3"
                  },
                  {
                      re_id: 640425,
                      re_parent: 640400,
                      re_name: "彭阳县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 640500,
              re_parent: 640000,
              re_name: "中卫市",
              re_level: "2",
              children: [
                  {
                      re_id: 640502,
                      re_parent: 640500,
                      re_name: "沙坡头区",
                      re_level: "3"
                  },
                  {
                      re_id: 640521,
                      re_parent: 640500,
                      re_name: "中宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 640522,
                      re_parent: 640500,
                      re_name: "海原县",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 650000,
      re_parent: 100000,
      re_name: "新疆维吾尔自治区",
      re_level: "1",
      children: [
          {
              re_id: 650100,
              re_parent: 650000,
              re_name: "乌鲁木齐市",
              re_level: "2",
              children: [
                  {
                      re_id: 650102,
                      re_parent: 650100,
                      re_name: "天山区",
                      re_level: "3"
                  },
                  {
                      re_id: 650103,
                      re_parent: 650100,
                      re_name: "沙依巴克区",
                      re_level: "3"
                  },
                  {
                      re_id: 650104,
                      re_parent: 650100,
                      re_name: "新市区",
                      re_level: "3"
                  },
                  {
                      re_id: 650105,
                      re_parent: 650100,
                      re_name: "水磨沟区",
                      re_level: "3"
                  },
                  {
                      re_id: 650106,
                      re_parent: 650100,
                      re_name: "头屯河区",
                      re_level: "3"
                  },
                  {
                      re_id: 650107,
                      re_parent: 650100,
                      re_name: "达坂城区",
                      re_level: "3"
                  },
                  {
                      re_id: 650109,
                      re_parent: 650100,
                      re_name: "米东区",
                      re_level: "3"
                  },
                  {
                      re_id: 650121,
                      re_parent: 650100,
                      re_name: "乌鲁木齐县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 650200,
              re_parent: 650000,
              re_name: "克拉玛依市",
              re_level: "2",
              children: [
                  {
                      re_id: 650202,
                      re_parent: 650200,
                      re_name: "独山子区",
                      re_level: "3"
                  },
                  {
                      re_id: 650203,
                      re_parent: 650200,
                      re_name: "克拉玛依区",
                      re_level: "3"
                  },
                  {
                      re_id: 650204,
                      re_parent: 650200,
                      re_name: "白碱滩区",
                      re_level: "3"
                  },
                  {
                      re_id: 650205,
                      re_parent: 650200,
                      re_name: "乌尔禾区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 652100,
              re_parent: 650000,
              re_name: "吐鲁番地区",
              re_level: "2",
              children: [
                  {
                      re_id: 652101,
                      re_parent: 652100,
                      re_name: "吐鲁番市",
                      re_level: "3"
                  },
                  {
                      re_id: 652122,
                      re_parent: 652100,
                      re_name: "鄯善县",
                      re_level: "3"
                  },
                  {
                      re_id: 652123,
                      re_parent: 652100,
                      re_name: "托克逊县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 652200,
              re_parent: 650000,
              re_name: "哈密地区",
              re_level: "2",
              children: [
                  {
                      re_id: 652201,
                      re_parent: 652200,
                      re_name: "哈密市",
                      re_level: "3"
                  },
                  {
                      re_id: 652222,
                      re_parent: 652200,
                      re_name: "巴里坤哈萨克自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 652223,
                      re_parent: 652200,
                      re_name: "伊吾县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 652300,
              re_parent: 650000,
              re_name: "昌吉回族自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 652301,
                      re_parent: 652300,
                      re_name: "昌吉市",
                      re_level: "3"
                  },
                  {
                      re_id: 652302,
                      re_parent: 652300,
                      re_name: "阜康市",
                      re_level: "3"
                  },
                  {
                      re_id: 652323,
                      re_parent: 652300,
                      re_name: "呼图壁县",
                      re_level: "3"
                  },
                  {
                      re_id: 652324,
                      re_parent: 652300,
                      re_name: "玛纳斯县",
                      re_level: "3"
                  },
                  {
                      re_id: 652325,
                      re_parent: 652300,
                      re_name: "奇台县",
                      re_level: "3"
                  },
                  {
                      re_id: 652327,
                      re_parent: 652300,
                      re_name: "吉木萨尔县",
                      re_level: "3"
                  },
                  {
                      re_id: 652328,
                      re_parent: 652300,
                      re_name: "木垒哈萨克自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 652700,
              re_parent: 650000,
              re_name: "博尔塔拉蒙古自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 652701,
                      re_parent: 652700,
                      re_name: "博乐市",
                      re_level: "3"
                  },
                  {
                      re_id: 652702,
                      re_parent: 652700,
                      re_name: "阿拉山口市",
                      re_level: "3"
                  },
                  {
                      re_id: 652722,
                      re_parent: 652700,
                      re_name: "精河县",
                      re_level: "3"
                  },
                  {
                      re_id: 652723,
                      re_parent: 652700,
                      re_name: "温泉县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 652800,
              re_parent: 650000,
              re_name: "巴音郭楞蒙古自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 652801,
                      re_parent: 652800,
                      re_name: "库尔勒市",
                      re_level: "3"
                  },
                  {
                      re_id: 652822,
                      re_parent: 652800,
                      re_name: "轮台县",
                      re_level: "3"
                  },
                  {
                      re_id: 652823,
                      re_parent: 652800,
                      re_name: "尉犁县",
                      re_level: "3"
                  },
                  {
                      re_id: 652824,
                      re_parent: 652800,
                      re_name: "若羌县",
                      re_level: "3"
                  },
                  {
                      re_id: 652825,
                      re_parent: 652800,
                      re_name: "且末县",
                      re_level: "3"
                  },
                  {
                      re_id: 652826,
                      re_parent: 652800,
                      re_name: "焉耆回族自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 652827,
                      re_parent: 652800,
                      re_name: "和静县",
                      re_level: "3"
                  },
                  {
                      re_id: 652828,
                      re_parent: 652800,
                      re_name: "和硕县",
                      re_level: "3"
                  },
                  {
                      re_id: 652829,
                      re_parent: 652800,
                      re_name: "博湖县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 652900,
              re_parent: 650000,
              re_name: "阿克苏地区",
              re_level: "2",
              children: [
                  {
                      re_id: 652901,
                      re_parent: 652900,
                      re_name: "阿克苏市",
                      re_level: "3"
                  },
                  {
                      re_id: 652922,
                      re_parent: 652900,
                      re_name: "温宿县",
                      re_level: "3"
                  },
                  {
                      re_id: 652923,
                      re_parent: 652900,
                      re_name: "库车县",
                      re_level: "3"
                  },
                  {
                      re_id: 652924,
                      re_parent: 652900,
                      re_name: "沙雅县",
                      re_level: "3"
                  },
                  {
                      re_id: 652925,
                      re_parent: 652900,
                      re_name: "新和县",
                      re_level: "3"
                  },
                  {
                      re_id: 652926,
                      re_parent: 652900,
                      re_name: "拜城县",
                      re_level: "3"
                  },
                  {
                      re_id: 652927,
                      re_parent: 652900,
                      re_name: "乌什县",
                      re_level: "3"
                  },
                  {
                      re_id: 652928,
                      re_parent: 652900,
                      re_name: "阿瓦提县",
                      re_level: "3"
                  },
                  {
                      re_id: 652929,
                      re_parent: 652900,
                      re_name: "柯坪县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 653000,
              re_parent: 650000,
              re_name: "克孜勒苏柯尔克孜自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 653001,
                      re_parent: 653000,
                      re_name: "阿图什市",
                      re_level: "3"
                  },
                  {
                      re_id: 653022,
                      re_parent: 653000,
                      re_name: "阿克陶县",
                      re_level: "3"
                  },
                  {
                      re_id: 653023,
                      re_parent: 653000,
                      re_name: "阿合奇县",
                      re_level: "3"
                  },
                  {
                      re_id: 653024,
                      re_parent: 653000,
                      re_name: "乌恰县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 653100,
              re_parent: 650000,
              re_name: "喀什地区",
              re_level: "2",
              children: [
                  {
                      re_id: 653101,
                      re_parent: 653100,
                      re_name: "喀什市",
                      re_level: "3"
                  },
                  {
                      re_id: 653121,
                      re_parent: 653100,
                      re_name: "疏附县",
                      re_level: "3"
                  },
                  {
                      re_id: 653122,
                      re_parent: 653100,
                      re_name: "疏勒县",
                      re_level: "3"
                  },
                  {
                      re_id: 653123,
                      re_parent: 653100,
                      re_name: "英吉沙县",
                      re_level: "3"
                  },
                  {
                      re_id: 653124,
                      re_parent: 653100,
                      re_name: "泽普县",
                      re_level: "3"
                  },
                  {
                      re_id: 653125,
                      re_parent: 653100,
                      re_name: "莎车县",
                      re_level: "3"
                  },
                  {
                      re_id: 653126,
                      re_parent: 653100,
                      re_name: "叶城县",
                      re_level: "3"
                  },
                  {
                      re_id: 653127,
                      re_parent: 653100,
                      re_name: "麦盖提县",
                      re_level: "3"
                  },
                  {
                      re_id: 653128,
                      re_parent: 653100,
                      re_name: "岳普湖县",
                      re_level: "3"
                  },
                  {
                      re_id: 653129,
                      re_parent: 653100,
                      re_name: "伽师县",
                      re_level: "3"
                  },
                  {
                      re_id: 653130,
                      re_parent: 653100,
                      re_name: "巴楚县",
                      re_level: "3"
                  },
                  {
                      re_id: 653131,
                      re_parent: 653100,
                      re_name: "塔什库尔干塔吉克自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 653200,
              re_parent: 650000,
              re_name: "和田地区",
              re_level: "2",
              children: [
                  {
                      re_id: 653201,
                      re_parent: 653200,
                      re_name: "和田市",
                      re_level: "3"
                  },
                  {
                      re_id: 653221,
                      re_parent: 653200,
                      re_name: "和田县",
                      re_level: "3"
                  },
                  {
                      re_id: 653222,
                      re_parent: 653200,
                      re_name: "墨玉县",
                      re_level: "3"
                  },
                  {
                      re_id: 653223,
                      re_parent: 653200,
                      re_name: "皮山县",
                      re_level: "3"
                  },
                  {
                      re_id: 653224,
                      re_parent: 653200,
                      re_name: "洛浦县",
                      re_level: "3"
                  },
                  {
                      re_id: 653225,
                      re_parent: 653200,
                      re_name: "策勒县",
                      re_level: "3"
                  },
                  {
                      re_id: 653226,
                      re_parent: 653200,
                      re_name: "于田县",
                      re_level: "3"
                  },
                  {
                      re_id: 653227,
                      re_parent: 653200,
                      re_name: "民丰县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 654000,
              re_parent: 650000,
              re_name: "伊犁哈萨克自治州",
              re_level: "2",
              children: [
                  {
                      re_id: 654002,
                      re_parent: 654000,
                      re_name: "伊宁市",
                      re_level: "3"
                  },
                  {
                      re_id: 654003,
                      re_parent: 654000,
                      re_name: "奎屯市",
                      re_level: "3"
                  },
                  {
                      re_id: 654004,
                      re_parent: 654000,
                      re_name: "霍尔果斯市",
                      re_level: "3"
                  },
                  {
                      re_id: 654021,
                      re_parent: 654000,
                      re_name: "伊宁县",
                      re_level: "3"
                  },
                  {
                      re_id: 654022,
                      re_parent: 654000,
                      re_name: "察布查尔锡伯自治县",
                      re_level: "3"
                  },
                  {
                      re_id: 654023,
                      re_parent: 654000,
                      re_name: "霍城县",
                      re_level: "3"
                  },
                  {
                      re_id: 654024,
                      re_parent: 654000,
                      re_name: "巩留县",
                      re_level: "3"
                  },
                  {
                      re_id: 654025,
                      re_parent: 654000,
                      re_name: "新源县",
                      re_level: "3"
                  },
                  {
                      re_id: 654026,
                      re_parent: 654000,
                      re_name: "昭苏县",
                      re_level: "3"
                  },
                  {
                      re_id: 654027,
                      re_parent: 654000,
                      re_name: "特克斯县",
                      re_level: "3"
                  },
                  {
                      re_id: 654028,
                      re_parent: 654000,
                      re_name: "尼勒克县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 654200,
              re_parent: 650000,
              re_name: "塔城地区",
              re_level: "2",
              children: [
                  {
                      re_id: 654201,
                      re_parent: 654200,
                      re_name: "塔城市",
                      re_level: "3"
                  },
                  {
                      re_id: 654202,
                      re_parent: 654200,
                      re_name: "乌苏市",
                      re_level: "3"
                  },
                  {
                      re_id: 654221,
                      re_parent: 654200,
                      re_name: "额敏县",
                      re_level: "3"
                  },
                  {
                      re_id: 654223,
                      re_parent: 654200,
                      re_name: "沙湾县",
                      re_level: "3"
                  },
                  {
                      re_id: 654224,
                      re_parent: 654200,
                      re_name: "托里县",
                      re_level: "3"
                  },
                  {
                      re_id: 654225,
                      re_parent: 654200,
                      re_name: "裕民县",
                      re_level: "3"
                  },
                  {
                      re_id: 654226,
                      re_parent: 654200,
                      re_name: "和布克赛尔蒙古自治县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 654300,
              re_parent: 650000,
              re_name: "阿勒泰地区",
              re_level: "2",
              children: [
                  {
                      re_id: 654301,
                      re_parent: 654300,
                      re_name: "阿勒泰市",
                      re_level: "3"
                  },
                  {
                      re_id: 654321,
                      re_parent: 654300,
                      re_name: "布尔津县",
                      re_level: "3"
                  },
                  {
                      re_id: 654322,
                      re_parent: 654300,
                      re_name: "富蕴县",
                      re_level: "3"
                  },
                  {
                      re_id: 654323,
                      re_parent: 654300,
                      re_name: "福海县",
                      re_level: "3"
                  },
                  {
                      re_id: 654324,
                      re_parent: 654300,
                      re_name: "哈巴河县",
                      re_level: "3"
                  },
                  {
                      re_id: 654325,
                      re_parent: 654300,
                      re_name: "青河县",
                      re_level: "3"
                  },
                  {
                      re_id: 654326,
                      re_parent: 654300,
                      re_name: "吉木乃县",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 659000,
              re_parent: 650000,
              re_name: "直辖县级",
              re_level: "2",
              children: [
                  {
                      re_id: 659001,
                      re_parent: 659000,
                      re_name: "石河子市",
                      re_level: "3"
                  },
                  {
                      re_id: 659002,
                      re_parent: 659000,
                      re_name: "阿拉尔市",
                      re_level: "3"
                  },
                  {
                      re_id: 659003,
                      re_parent: 659000,
                      re_name: "图木舒克市",
                      re_level: "3"
                  },
                  {
                      re_id: 659004,
                      re_parent: 659000,
                      re_name: "五家渠市",
                      re_level: "3"
                  },
                  {
                      re_id: 659005,
                      re_parent: 659000,
                      re_name: "北屯市",
                      re_level: "3"
                  },
                  {
                      re_id: 659006,
                      re_parent: 659000,
                      re_name: "铁门关市",
                      re_level: "3"
                  },
                  {
                      re_id: 659007,
                      re_parent: 659000,
                      re_name: "双河市",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 710000,
      re_parent: 100000,
      re_name: "台湾",
      re_level: "1",
      children: [
          {
              re_id: 710100,
              re_parent: 710000,
              re_name: "台北市",
              re_level: "2",
              children: [
                  {
                      re_id: 710101,
                      re_parent: 710100,
                      re_name: "松山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710102,
                      re_parent: 710100,
                      re_name: "信义区",
                      re_level: "3"
                  },
                  {
                      re_id: 710103,
                      re_parent: 710100,
                      re_name: "大安区",
                      re_level: "3"
                  },
                  {
                      re_id: 710104,
                      re_parent: 710100,
                      re_name: "中山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710105,
                      re_parent: 710100,
                      re_name: "中正区",
                      re_level: "3"
                  },
                  {
                      re_id: 710106,
                      re_parent: 710100,
                      re_name: "大同区",
                      re_level: "3"
                  },
                  {
                      re_id: 710107,
                      re_parent: 710100,
                      re_name: "万华区",
                      re_level: "3"
                  },
                  {
                      re_id: 710108,
                      re_parent: 710100,
                      re_name: "文山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710109,
                      re_parent: 710100,
                      re_name: "南港区",
                      re_level: "3"
                  },
                  {
                      re_id: 710110,
                      re_parent: 710100,
                      re_name: "内湖区",
                      re_level: "3"
                  },
                  {
                      re_id: 710111,
                      re_parent: 710100,
                      re_name: "士林区",
                      re_level: "3"
                  },
                  {
                      re_id: 710112,
                      re_parent: 710100,
                      re_name: "北投区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710200,
              re_parent: 710000,
              re_name: "高雄市",
              re_level: "2",
              children: [
                  {
                      re_id: 710201,
                      re_parent: 710200,
                      re_name: "盐埕区",
                      re_level: "3"
                  },
                  {
                      re_id: 710202,
                      re_parent: 710200,
                      re_name: "鼓山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710203,
                      re_parent: 710200,
                      re_name: "左营区",
                      re_level: "3"
                  },
                  {
                      re_id: 710204,
                      re_parent: 710200,
                      re_name: "楠梓区",
                      re_level: "3"
                  },
                  {
                      re_id: 710205,
                      re_parent: 710200,
                      re_name: "三民区",
                      re_level: "3"
                  },
                  {
                      re_id: 710206,
                      re_parent: 710200,
                      re_name: "新兴区",
                      re_level: "3"
                  },
                  {
                      re_id: 710207,
                      re_parent: 710200,
                      re_name: "前金区",
                      re_level: "3"
                  },
                  {
                      re_id: 710208,
                      re_parent: 710200,
                      re_name: "苓雅区",
                      re_level: "3"
                  },
                  {
                      re_id: 710209,
                      re_parent: 710200,
                      re_name: "前镇区",
                      re_level: "3"
                  },
                  {
                      re_id: 710210,
                      re_parent: 710200,
                      re_name: "旗津区",
                      re_level: "3"
                  },
                  {
                      re_id: 710211,
                      re_parent: 710200,
                      re_name: "小港区",
                      re_level: "3"
                  },
                  {
                      re_id: 710212,
                      re_parent: 710200,
                      re_name: "凤山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710213,
                      re_parent: 710200,
                      re_name: "林园区",
                      re_level: "3"
                  },
                  {
                      re_id: 710214,
                      re_parent: 710200,
                      re_name: "大寮区",
                      re_level: "3"
                  },
                  {
                      re_id: 710215,
                      re_parent: 710200,
                      re_name: "大树区",
                      re_level: "3"
                  },
                  {
                      re_id: 710216,
                      re_parent: 710200,
                      re_name: "大社区",
                      re_level: "3"
                  },
                  {
                      re_id: 710217,
                      re_parent: 710200,
                      re_name: "仁武区",
                      re_level: "3"
                  },
                  {
                      re_id: 710218,
                      re_parent: 710200,
                      re_name: "鸟松区",
                      re_level: "3"
                  },
                  {
                      re_id: 710219,
                      re_parent: 710200,
                      re_name: "冈山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710220,
                      re_parent: 710200,
                      re_name: "桥头区",
                      re_level: "3"
                  },
                  {
                      re_id: 710221,
                      re_parent: 710200,
                      re_name: "燕巢区",
                      re_level: "3"
                  },
                  {
                      re_id: 710222,
                      re_parent: 710200,
                      re_name: "田寮区",
                      re_level: "3"
                  },
                  {
                      re_id: 710223,
                      re_parent: 710200,
                      re_name: "阿莲区",
                      re_level: "3"
                  },
                  {
                      re_id: 710224,
                      re_parent: 710200,
                      re_name: "路竹区",
                      re_level: "3"
                  },
                  {
                      re_id: 710225,
                      re_parent: 710200,
                      re_name: "湖内区",
                      re_level: "3"
                  },
                  {
                      re_id: 710226,
                      re_parent: 710200,
                      re_name: "茄萣区",
                      re_level: "3"
                  },
                  {
                      re_id: 710227,
                      re_parent: 710200,
                      re_name: "永安区",
                      re_level: "3"
                  },
                  {
                      re_id: 710228,
                      re_parent: 710200,
                      re_name: "弥陀区",
                      re_level: "3"
                  },
                  {
                      re_id: 710229,
                      re_parent: 710200,
                      re_name: "梓官区",
                      re_level: "3"
                  },
                  {
                      re_id: 710230,
                      re_parent: 710200,
                      re_name: "旗山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710231,
                      re_parent: 710200,
                      re_name: "美浓区",
                      re_level: "3"
                  },
                  {
                      re_id: 710232,
                      re_parent: 710200,
                      re_name: "六龟区",
                      re_level: "3"
                  },
                  {
                      re_id: 710233,
                      re_parent: 710200,
                      re_name: "甲仙区",
                      re_level: "3"
                  },
                  {
                      re_id: 710234,
                      re_parent: 710200,
                      re_name: "杉林区",
                      re_level: "3"
                  },
                  {
                      re_id: 710235,
                      re_parent: 710200,
                      re_name: "内门区",
                      re_level: "3"
                  },
                  {
                      re_id: 710236,
                      re_parent: 710200,
                      re_name: "茂林区",
                      re_level: "3"
                  },
                  {
                      re_id: 710237,
                      re_parent: 710200,
                      re_name: "桃源区",
                      re_level: "3"
                  },
                  {
                      re_id: 710238,
                      re_parent: 710200,
                      re_name: "那玛夏区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710300,
              re_parent: 710000,
              re_name: "基隆市",
              re_level: "2",
              children: [
                  {
                      re_id: 710301,
                      re_parent: 710300,
                      re_name: "中正区",
                      re_level: "3"
                  },
                  {
                      re_id: 710302,
                      re_parent: 710300,
                      re_name: "七堵区",
                      re_level: "3"
                  },
                  {
                      re_id: 710303,
                      re_parent: 710300,
                      re_name: "暖暖区",
                      re_level: "3"
                  },
                  {
                      re_id: 710304,
                      re_parent: 710300,
                      re_name: "仁爱区",
                      re_level: "3"
                  },
                  {
                      re_id: 710305,
                      re_parent: 710300,
                      re_name: "中山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710306,
                      re_parent: 710300,
                      re_name: "安乐区",
                      re_level: "3"
                  },
                  {
                      re_id: 710307,
                      re_parent: 710300,
                      re_name: "信义区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710400,
              re_parent: 710000,
              re_name: "台中市",
              re_level: "2",
              children: [
                  {
                      re_id: 710401,
                      re_parent: 710400,
                      re_name: "中区",
                      re_level: "3"
                  },
                  {
                      re_id: 710402,
                      re_parent: 710400,
                      re_name: "东区",
                      re_level: "3"
                  },
                  {
                      re_id: 710403,
                      re_parent: 710400,
                      re_name: "南区",
                      re_level: "3"
                  },
                  {
                      re_id: 710404,
                      re_parent: 710400,
                      re_name: "西区",
                      re_level: "3"
                  },
                  {
                      re_id: 710405,
                      re_parent: 710400,
                      re_name: "北区",
                      re_level: "3"
                  },
                  {
                      re_id: 710406,
                      re_parent: 710400,
                      re_name: "西屯区",
                      re_level: "3"
                  },
                  {
                      re_id: 710407,
                      re_parent: 710400,
                      re_name: "南屯区",
                      re_level: "3"
                  },
                  {
                      re_id: 710408,
                      re_parent: 710400,
                      re_name: "北屯区",
                      re_level: "3"
                  },
                  {
                      re_id: 710409,
                      re_parent: 710400,
                      re_name: "丰原区",
                      re_level: "3"
                  },
                  {
                      re_id: 710410,
                      re_parent: 710400,
                      re_name: "东势区",
                      re_level: "3"
                  },
                  {
                      re_id: 710411,
                      re_parent: 710400,
                      re_name: "大甲区",
                      re_level: "3"
                  },
                  {
                      re_id: 710412,
                      re_parent: 710400,
                      re_name: "清水区",
                      re_level: "3"
                  },
                  {
                      re_id: 710413,
                      re_parent: 710400,
                      re_name: "沙鹿区",
                      re_level: "3"
                  },
                  {
                      re_id: 710414,
                      re_parent: 710400,
                      re_name: "梧栖区",
                      re_level: "3"
                  },
                  {
                      re_id: 710415,
                      re_parent: 710400,
                      re_name: "后里区",
                      re_level: "3"
                  },
                  {
                      re_id: 710416,
                      re_parent: 710400,
                      re_name: "神冈区",
                      re_level: "3"
                  },
                  {
                      re_id: 710417,
                      re_parent: 710400,
                      re_name: "潭子区",
                      re_level: "3"
                  },
                  {
                      re_id: 710418,
                      re_parent: 710400,
                      re_name: "大雅区",
                      re_level: "3"
                  },
                  {
                      re_id: 710419,
                      re_parent: 710400,
                      re_name: "新社区",
                      re_level: "3"
                  },
                  {
                      re_id: 710420,
                      re_parent: 710400,
                      re_name: "石冈区",
                      re_level: "3"
                  },
                  {
                      re_id: 710421,
                      re_parent: 710400,
                      re_name: "外埔区",
                      re_level: "3"
                  },
                  {
                      re_id: 710422,
                      re_parent: 710400,
                      re_name: "大安区",
                      re_level: "3"
                  },
                  {
                      re_id: 710423,
                      re_parent: 710400,
                      re_name: "乌日区",
                      re_level: "3"
                  },
                  {
                      re_id: 710424,
                      re_parent: 710400,
                      re_name: "大肚区",
                      re_level: "3"
                  },
                  {
                      re_id: 710425,
                      re_parent: 710400,
                      re_name: "龙井区",
                      re_level: "3"
                  },
                  {
                      re_id: 710426,
                      re_parent: 710400,
                      re_name: "雾峰区",
                      re_level: "3"
                  },
                  {
                      re_id: 710427,
                      re_parent: 710400,
                      re_name: "太平区",
                      re_level: "3"
                  },
                  {
                      re_id: 710428,
                      re_parent: 710400,
                      re_name: "大里区",
                      re_level: "3"
                  },
                  {
                      re_id: 710429,
                      re_parent: 710400,
                      re_name: "和平区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710500,
              re_parent: 710000,
              re_name: "台南市",
              re_level: "2",
              children: [
                  {
                      re_id: 710501,
                      re_parent: 710500,
                      re_name: "东区",
                      re_level: "3"
                  },
                  {
                      re_id: 710502,
                      re_parent: 710500,
                      re_name: "南区",
                      re_level: "3"
                  },
                  {
                      re_id: 710504,
                      re_parent: 710500,
                      re_name: "北区",
                      re_level: "3"
                  },
                  {
                      re_id: 710506,
                      re_parent: 710500,
                      re_name: "安南区",
                      re_level: "3"
                  },
                  {
                      re_id: 710507,
                      re_parent: 710500,
                      re_name: "安平区",
                      re_level: "3"
                  },
                  {
                      re_id: 710508,
                      re_parent: 710500,
                      re_name: "中西区",
                      re_level: "3"
                  },
                  {
                      re_id: 710509,
                      re_parent: 710500,
                      re_name: "新营区",
                      re_level: "3"
                  },
                  {
                      re_id: 710510,
                      re_parent: 710500,
                      re_name: "盐水区",
                      re_level: "3"
                  },
                  {
                      re_id: 710511,
                      re_parent: 710500,
                      re_name: "白河区",
                      re_level: "3"
                  },
                  {
                      re_id: 710512,
                      re_parent: 710500,
                      re_name: "柳营区",
                      re_level: "3"
                  },
                  {
                      re_id: 710513,
                      re_parent: 710500,
                      re_name: "后壁区",
                      re_level: "3"
                  },
                  {
                      re_id: 710514,
                      re_parent: 710500,
                      re_name: "东山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710515,
                      re_parent: 710500,
                      re_name: "麻豆区",
                      re_level: "3"
                  },
                  {
                      re_id: 710516,
                      re_parent: 710500,
                      re_name: "下营区",
                      re_level: "3"
                  },
                  {
                      re_id: 710517,
                      re_parent: 710500,
                      re_name: "六甲区",
                      re_level: "3"
                  },
                  {
                      re_id: 710518,
                      re_parent: 710500,
                      re_name: "官田区",
                      re_level: "3"
                  },
                  {
                      re_id: 710519,
                      re_parent: 710500,
                      re_name: "大内区",
                      re_level: "3"
                  },
                  {
                      re_id: 710520,
                      re_parent: 710500,
                      re_name: "佳里区",
                      re_level: "3"
                  },
                  {
                      re_id: 710521,
                      re_parent: 710500,
                      re_name: "学甲区",
                      re_level: "3"
                  },
                  {
                      re_id: 710522,
                      re_parent: 710500,
                      re_name: "西港区",
                      re_level: "3"
                  },
                  {
                      re_id: 710523,
                      re_parent: 710500,
                      re_name: "七股区",
                      re_level: "3"
                  },
                  {
                      re_id: 710524,
                      re_parent: 710500,
                      re_name: "将军区",
                      re_level: "3"
                  },
                  {
                      re_id: 710525,
                      re_parent: 710500,
                      re_name: "北门区",
                      re_level: "3"
                  },
                  {
                      re_id: 710526,
                      re_parent: 710500,
                      re_name: "新化区",
                      re_level: "3"
                  },
                  {
                      re_id: 710527,
                      re_parent: 710500,
                      re_name: "善化区",
                      re_level: "3"
                  },
                  {
                      re_id: 710528,
                      re_parent: 710500,
                      re_name: "新市区",
                      re_level: "3"
                  },
                  {
                      re_id: 710529,
                      re_parent: 710500,
                      re_name: "安定区",
                      re_level: "3"
                  },
                  {
                      re_id: 710530,
                      re_parent: 710500,
                      re_name: "山上区",
                      re_level: "3"
                  },
                  {
                      re_id: 710531,
                      re_parent: 710500,
                      re_name: "玉井区",
                      re_level: "3"
                  },
                  {
                      re_id: 710532,
                      re_parent: 710500,
                      re_name: "楠西区",
                      re_level: "3"
                  },
                  {
                      re_id: 710533,
                      re_parent: 710500,
                      re_name: "南化区",
                      re_level: "3"
                  },
                  {
                      re_id: 710534,
                      re_parent: 710500,
                      re_name: "左镇区",
                      re_level: "3"
                  },
                  {
                      re_id: 710535,
                      re_parent: 710500,
                      re_name: "仁德区",
                      re_level: "3"
                  },
                  {
                      re_id: 710536,
                      re_parent: 710500,
                      re_name: "归仁区",
                      re_level: "3"
                  },
                  {
                      re_id: 710537,
                      re_parent: 710500,
                      re_name: "关庙区",
                      re_level: "3"
                  },
                  {
                      re_id: 710538,
                      re_parent: 710500,
                      re_name: "龙崎区",
                      re_level: "3"
                  },
                  {
                      re_id: 710539,
                      re_parent: 710500,
                      re_name: "永康区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710600,
              re_parent: 710000,
              re_name: "新竹市",
              re_level: "2",
              children: [
                  {
                      re_id: 710601,
                      re_parent: 710600,
                      re_name: "东区",
                      re_level: "3"
                  },
                  {
                      re_id: 710602,
                      re_parent: 710600,
                      re_name: "北区",
                      re_level: "3"
                  },
                  {
                      re_id: 710603,
                      re_parent: 710600,
                      re_name: "香山区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710700,
              re_parent: 710000,
              re_name: "嘉义市",
              re_level: "2",
              children: [
                  {
                      re_id: 710701,
                      re_parent: 710700,
                      re_name: "东区",
                      re_level: "3"
                  },
                  {
                      re_id: 710702,
                      re_parent: 710700,
                      re_name: "西区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 710800,
              re_parent: 710000,
              re_name: "新北市",
              re_level: "2",
              children: [
                  {
                      re_id: 710801,
                      re_parent: 710800,
                      re_name: "板桥区",
                      re_level: "3"
                  },
                  {
                      re_id: 710802,
                      re_parent: 710800,
                      re_name: "三重区",
                      re_level: "3"
                  },
                  {
                      re_id: 710803,
                      re_parent: 710800,
                      re_name: "中和区",
                      re_level: "3"
                  },
                  {
                      re_id: 710804,
                      re_parent: 710800,
                      re_name: "永和区",
                      re_level: "3"
                  },
                  {
                      re_id: 710805,
                      re_parent: 710800,
                      re_name: "新庄区",
                      re_level: "3"
                  },
                  {
                      re_id: 710806,
                      re_parent: 710800,
                      re_name: "新店区",
                      re_level: "3"
                  },
                  {
                      re_id: 710807,
                      re_parent: 710800,
                      re_name: "树林区",
                      re_level: "3"
                  },
                  {
                      re_id: 710808,
                      re_parent: 710800,
                      re_name: "莺歌区",
                      re_level: "3"
                  },
                  {
                      re_id: 710809,
                      re_parent: 710800,
                      re_name: "三峡区",
                      re_level: "3"
                  },
                  {
                      re_id: 710810,
                      re_parent: 710800,
                      re_name: "淡水区",
                      re_level: "3"
                  },
                  {
                      re_id: 710811,
                      re_parent: 710800,
                      re_name: "汐止区",
                      re_level: "3"
                  },
                  {
                      re_id: 710812,
                      re_parent: 710800,
                      re_name: "瑞芳区",
                      re_level: "3"
                  },
                  {
                      re_id: 710813,
                      re_parent: 710800,
                      re_name: "土城区",
                      re_level: "3"
                  },
                  {
                      re_id: 710814,
                      re_parent: 710800,
                      re_name: "芦洲区",
                      re_level: "3"
                  },
                  {
                      re_id: 710815,
                      re_parent: 710800,
                      re_name: "五股区",
                      re_level: "3"
                  },
                  {
                      re_id: 710816,
                      re_parent: 710800,
                      re_name: "泰山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710817,
                      re_parent: 710800,
                      re_name: "林口区",
                      re_level: "3"
                  },
                  {
                      re_id: 710818,
                      re_parent: 710800,
                      re_name: "深坑区",
                      re_level: "3"
                  },
                  {
                      re_id: 710819,
                      re_parent: 710800,
                      re_name: "石碇区",
                      re_level: "3"
                  },
                  {
                      re_id: 710820,
                      re_parent: 710800,
                      re_name: "坪林区",
                      re_level: "3"
                  },
                  {
                      re_id: 710821,
                      re_parent: 710800,
                      re_name: "三芝区",
                      re_level: "3"
                  },
                  {
                      re_id: 710822,
                      re_parent: 710800,
                      re_name: "石门区",
                      re_level: "3"
                  },
                  {
                      re_id: 710823,
                      re_parent: 710800,
                      re_name: "八里区",
                      re_level: "3"
                  },
                  {
                      re_id: 710824,
                      re_parent: 710800,
                      re_name: "平溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 710825,
                      re_parent: 710800,
                      re_name: "双溪区",
                      re_level: "3"
                  },
                  {
                      re_id: 710826,
                      re_parent: 710800,
                      re_name: "贡寮区",
                      re_level: "3"
                  },
                  {
                      re_id: 710827,
                      re_parent: 710800,
                      re_name: "金山区",
                      re_level: "3"
                  },
                  {
                      re_id: 710828,
                      re_parent: 710800,
                      re_name: "万里区",
                      re_level: "3"
                  },
                  {
                      re_id: 710829,
                      re_parent: 710800,
                      re_name: "乌来区",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712200,
              re_parent: 710000,
              re_name: "宜兰县",
              re_level: "2",
              children: [
                  {
                      re_id: 712201,
                      re_parent: 712200,
                      re_name: "宜兰市",
                      re_level: "3"
                  },
                  {
                      re_id: 712221,
                      re_parent: 712200,
                      re_name: "罗东镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712222,
                      re_parent: 712200,
                      re_name: "苏澳镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712223,
                      re_parent: 712200,
                      re_name: "头城镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712224,
                      re_parent: 712200,
                      re_name: "礁溪乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712225,
                      re_parent: 712200,
                      re_name: "壮围乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712226,
                      re_parent: 712200,
                      re_name: "员山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712227,
                      re_parent: 712200,
                      re_name: "冬山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712228,
                      re_parent: 712200,
                      re_name: "五结乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712229,
                      re_parent: 712200,
                      re_name: "三星乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712230,
                      re_parent: 712200,
                      re_name: "大同乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712231,
                      re_parent: 712200,
                      re_name: "南澳乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712300,
              re_parent: 710000,
              re_name: "桃园县",
              re_level: "2",
              children: [
                  {
                      re_id: 712301,
                      re_parent: 712300,
                      re_name: "桃园市",
                      re_level: "3"
                  },
                  {
                      re_id: 712302,
                      re_parent: 712300,
                      re_name: "中坜市",
                      re_level: "3"
                  },
                  {
                      re_id: 712303,
                      re_parent: 712300,
                      re_name: "平镇市",
                      re_level: "3"
                  },
                  {
                      re_id: 712304,
                      re_parent: 712300,
                      re_name: "八德市",
                      re_level: "3"
                  },
                  {
                      re_id: 712305,
                      re_parent: 712300,
                      re_name: "杨梅市",
                      re_level: "3"
                  },
                  {
                      re_id: 712306,
                      re_parent: 712300,
                      re_name: "芦竹市",
                      re_level: "3"
                  },
                  {
                      re_id: 712321,
                      re_parent: 712300,
                      re_name: "大溪镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712324,
                      re_parent: 712300,
                      re_name: "大园乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712325,
                      re_parent: 712300,
                      re_name: "龟山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712327,
                      re_parent: 712300,
                      re_name: "龙潭乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712329,
                      re_parent: 712300,
                      re_name: "新屋乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712330,
                      re_parent: 712300,
                      re_name: "观音乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712331,
                      re_parent: 712300,
                      re_name: "复兴乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712400,
              re_parent: 710000,
              re_name: "新竹县",
              re_level: "2",
              children: [
                  {
                      re_id: 712401,
                      re_parent: 712400,
                      re_name: "竹北市",
                      re_level: "3"
                  },
                  {
                      re_id: 712421,
                      re_parent: 712400,
                      re_name: "竹东镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712422,
                      re_parent: 712400,
                      re_name: "新埔镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712423,
                      re_parent: 712400,
                      re_name: "关西镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712424,
                      re_parent: 712400,
                      re_name: "湖口乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712425,
                      re_parent: 712400,
                      re_name: "新丰乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712426,
                      re_parent: 712400,
                      re_name: "芎林乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712427,
                      re_parent: 712400,
                      re_name: "横山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712428,
                      re_parent: 712400,
                      re_name: "北埔乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712429,
                      re_parent: 712400,
                      re_name: "宝山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712430,
                      re_parent: 712400,
                      re_name: "峨眉乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712431,
                      re_parent: 712400,
                      re_name: "尖石乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712432,
                      re_parent: 712400,
                      re_name: "五峰乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712500,
              re_parent: 710000,
              re_name: "苗栗县",
              re_level: "2",
              children: [
                  {
                      re_id: 712501,
                      re_parent: 712500,
                      re_name: "苗栗市",
                      re_level: "3"
                  },
                  {
                      re_id: 712521,
                      re_parent: 712500,
                      re_name: "苑里镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712522,
                      re_parent: 712500,
                      re_name: "通霄镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712523,
                      re_parent: 712500,
                      re_name: "竹南镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712524,
                      re_parent: 712500,
                      re_name: "头份镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712525,
                      re_parent: 712500,
                      re_name: "后龙镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712526,
                      re_parent: 712500,
                      re_name: "卓兰镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712527,
                      re_parent: 712500,
                      re_name: "大湖乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712528,
                      re_parent: 712500,
                      re_name: "公馆乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712529,
                      re_parent: 712500,
                      re_name: "铜锣乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712530,
                      re_parent: 712500,
                      re_name: "南庄乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712531,
                      re_parent: 712500,
                      re_name: "头屋乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712532,
                      re_parent: 712500,
                      re_name: "三义乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712533,
                      re_parent: 712500,
                      re_name: "西湖乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712534,
                      re_parent: 712500,
                      re_name: "造桥乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712535,
                      re_parent: 712500,
                      re_name: "三湾乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712536,
                      re_parent: 712500,
                      re_name: "狮潭乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712537,
                      re_parent: 712500,
                      re_name: "泰安乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712700,
              re_parent: 710000,
              re_name: "彰化县",
              re_level: "2",
              children: [
                  {
                      re_id: 712701,
                      re_parent: 712700,
                      re_name: "彰化市",
                      re_level: "3"
                  },
                  {
                      re_id: 712721,
                      re_parent: 712700,
                      re_name: "鹿港镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712722,
                      re_parent: 712700,
                      re_name: "和美镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712723,
                      re_parent: 712700,
                      re_name: "线西乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712724,
                      re_parent: 712700,
                      re_name: "伸港乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712725,
                      re_parent: 712700,
                      re_name: "福兴乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712726,
                      re_parent: 712700,
                      re_name: "秀水乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712727,
                      re_parent: 712700,
                      re_name: "花坛乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712728,
                      re_parent: 712700,
                      re_name: "芬园乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712729,
                      re_parent: 712700,
                      re_name: "员林镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712730,
                      re_parent: 712700,
                      re_name: "溪湖镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712731,
                      re_parent: 712700,
                      re_name: "田中镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712732,
                      re_parent: 712700,
                      re_name: "大村乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712733,
                      re_parent: 712700,
                      re_name: "埔盐乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712734,
                      re_parent: 712700,
                      re_name: "埔心乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712735,
                      re_parent: 712700,
                      re_name: "永靖乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712736,
                      re_parent: 712700,
                      re_name: "社头乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712737,
                      re_parent: 712700,
                      re_name: "二水乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712738,
                      re_parent: 712700,
                      re_name: "北斗镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712739,
                      re_parent: 712700,
                      re_name: "二林镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712740,
                      re_parent: 712700,
                      re_name: "田尾乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712741,
                      re_parent: 712700,
                      re_name: "埤头乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712742,
                      re_parent: 712700,
                      re_name: "芳苑乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712743,
                      re_parent: 712700,
                      re_name: "大城乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712744,
                      re_parent: 712700,
                      re_name: "竹塘乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712745,
                      re_parent: 712700,
                      re_name: "溪州乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712800,
              re_parent: 710000,
              re_name: "南投县",
              re_level: "2",
              children: [
                  {
                      re_id: 712801,
                      re_parent: 712800,
                      re_name: "南投市",
                      re_level: "3"
                  },
                  {
                      re_id: 712821,
                      re_parent: 712800,
                      re_name: "埔里镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712822,
                      re_parent: 712800,
                      re_name: "草屯镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712823,
                      re_parent: 712800,
                      re_name: "竹山镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712824,
                      re_parent: 712800,
                      re_name: "集集镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712825,
                      re_parent: 712800,
                      re_name: "名间乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712826,
                      re_parent: 712800,
                      re_name: "鹿谷乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712827,
                      re_parent: 712800,
                      re_name: "中寮乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712828,
                      re_parent: 712800,
                      re_name: "鱼池乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712829,
                      re_parent: 712800,
                      re_name: "国姓乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712830,
                      re_parent: 712800,
                      re_name: "水里乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712831,
                      re_parent: 712800,
                      re_name: "信义乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712832,
                      re_parent: 712800,
                      re_name: "仁爱乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 712900,
              re_parent: 710000,
              re_name: "云林县",
              re_level: "2",
              children: [
                  {
                      re_id: 712901,
                      re_parent: 712900,
                      re_name: "斗六市",
                      re_level: "3"
                  },
                  {
                      re_id: 712921,
                      re_parent: 712900,
                      re_name: "斗南镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712922,
                      re_parent: 712900,
                      re_name: "虎尾镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712923,
                      re_parent: 712900,
                      re_name: "西螺镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712924,
                      re_parent: 712900,
                      re_name: "土库镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712925,
                      re_parent: 712900,
                      re_name: "北港镇",
                      re_level: "3"
                  },
                  {
                      re_id: 712926,
                      re_parent: 712900,
                      re_name: "古坑乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712927,
                      re_parent: 712900,
                      re_name: "大埤乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712928,
                      re_parent: 712900,
                      re_name: "莿桐乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712929,
                      re_parent: 712900,
                      re_name: "林内乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712930,
                      re_parent: 712900,
                      re_name: "二仑乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712931,
                      re_parent: 712900,
                      re_name: "仑背乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712932,
                      re_parent: 712900,
                      re_name: "麦寮乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712933,
                      re_parent: 712900,
                      re_name: "东势乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712934,
                      re_parent: 712900,
                      re_name: "褒忠乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712935,
                      re_parent: 712900,
                      re_name: "台西乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712936,
                      re_parent: 712900,
                      re_name: "元长乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712937,
                      re_parent: 712900,
                      re_name: "四湖乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712938,
                      re_parent: 712900,
                      re_name: "口湖乡",
                      re_level: "3"
                  },
                  {
                      re_id: 712939,
                      re_parent: 712900,
                      re_name: "水林乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713000,
              re_parent: 710000,
              re_name: "嘉义县",
              re_level: "2",
              children: [
                  {
                      re_id: 713001,
                      re_parent: 713000,
                      re_name: "太保市",
                      re_level: "3"
                  },
                  {
                      re_id: 713002,
                      re_parent: 713000,
                      re_name: "朴子市",
                      re_level: "3"
                  },
                  {
                      re_id: 713023,
                      re_parent: 713000,
                      re_name: "布袋镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713024,
                      re_parent: 713000,
                      re_name: "大林镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713025,
                      re_parent: 713000,
                      re_name: "民雄乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713026,
                      re_parent: 713000,
                      re_name: "溪口乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713027,
                      re_parent: 713000,
                      re_name: "新港乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713028,
                      re_parent: 713000,
                      re_name: "六脚乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713029,
                      re_parent: 713000,
                      re_name: "东石乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713030,
                      re_parent: 713000,
                      re_name: "义竹乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713031,
                      re_parent: 713000,
                      re_name: "鹿草乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713032,
                      re_parent: 713000,
                      re_name: "水上乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713033,
                      re_parent: 713000,
                      re_name: "中埔乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713034,
                      re_parent: 713000,
                      re_name: "竹崎乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713035,
                      re_parent: 713000,
                      re_name: "梅山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713036,
                      re_parent: 713000,
                      re_name: "番路乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713037,
                      re_parent: 713000,
                      re_name: "大埔乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713038,
                      re_parent: 713000,
                      re_name: "阿里山乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713300,
              re_parent: 710000,
              re_name: "屏东县",
              re_level: "2",
              children: [
                  {
                      re_id: 713301,
                      re_parent: 713300,
                      re_name: "屏东市",
                      re_level: "3"
                  },
                  {
                      re_id: 713321,
                      re_parent: 713300,
                      re_name: "潮州镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713322,
                      re_parent: 713300,
                      re_name: "东港镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713323,
                      re_parent: 713300,
                      re_name: "恒春镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713324,
                      re_parent: 713300,
                      re_name: "万丹乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713325,
                      re_parent: 713300,
                      re_name: "长治乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713326,
                      re_parent: 713300,
                      re_name: "麟洛乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713327,
                      re_parent: 713300,
                      re_name: "九如乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713328,
                      re_parent: 713300,
                      re_name: "里港乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713329,
                      re_parent: 713300,
                      re_name: "盐埔乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713330,
                      re_parent: 713300,
                      re_name: "高树乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713331,
                      re_parent: 713300,
                      re_name: "万峦乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713332,
                      re_parent: 713300,
                      re_name: "内埔乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713333,
                      re_parent: 713300,
                      re_name: "竹田乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713334,
                      re_parent: 713300,
                      re_name: "新埤乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713335,
                      re_parent: 713300,
                      re_name: "枋寮乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713336,
                      re_parent: 713300,
                      re_name: "新园乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713337,
                      re_parent: 713300,
                      re_name: "崁顶乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713338,
                      re_parent: 713300,
                      re_name: "林边乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713339,
                      re_parent: 713300,
                      re_name: "南州乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713340,
                      re_parent: 713300,
                      re_name: "佳冬乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713341,
                      re_parent: 713300,
                      re_name: "琉球乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713342,
                      re_parent: 713300,
                      re_name: "车城乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713343,
                      re_parent: 713300,
                      re_name: "满州乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713344,
                      re_parent: 713300,
                      re_name: "枋山乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713345,
                      re_parent: 713300,
                      re_name: "三地门乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713346,
                      re_parent: 713300,
                      re_name: "雾台乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713347,
                      re_parent: 713300,
                      re_name: "玛家乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713348,
                      re_parent: 713300,
                      re_name: "泰武乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713349,
                      re_parent: 713300,
                      re_name: "来义乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713350,
                      re_parent: 713300,
                      re_name: "春日乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713351,
                      re_parent: 713300,
                      re_name: "狮子乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713352,
                      re_parent: 713300,
                      re_name: "牡丹乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713400,
              re_parent: 710000,
              re_name: "台东县",
              re_level: "2",
              children: [
                  {
                      re_id: 713401,
                      re_parent: 713400,
                      re_name: "台东市",
                      re_level: "3"
                  },
                  {
                      re_id: 713421,
                      re_parent: 713400,
                      re_name: "成功镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713422,
                      re_parent: 713400,
                      re_name: "关山镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713423,
                      re_parent: 713400,
                      re_name: "卑南乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713424,
                      re_parent: 713400,
                      re_name: "鹿野乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713425,
                      re_parent: 713400,
                      re_name: "池上乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713426,
                      re_parent: 713400,
                      re_name: "东河乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713427,
                      re_parent: 713400,
                      re_name: "长滨乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713428,
                      re_parent: 713400,
                      re_name: "太麻里乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713429,
                      re_parent: 713400,
                      re_name: "大武乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713430,
                      re_parent: 713400,
                      re_name: "绿岛乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713431,
                      re_parent: 713400,
                      re_name: "海端乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713432,
                      re_parent: 713400,
                      re_name: "延平乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713433,
                      re_parent: 713400,
                      re_name: "金峰乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713434,
                      re_parent: 713400,
                      re_name: "达仁乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713435,
                      re_parent: 713400,
                      re_name: "兰屿乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713500,
              re_parent: 710000,
              re_name: "花莲县",
              re_level: "2",
              children: [
                  {
                      re_id: 713501,
                      re_parent: 713500,
                      re_name: "花莲市",
                      re_level: "3"
                  },
                  {
                      re_id: 713521,
                      re_parent: 713500,
                      re_name: "凤林镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713522,
                      re_parent: 713500,
                      re_name: "玉里镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713523,
                      re_parent: 713500,
                      re_name: "新城乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713524,
                      re_parent: 713500,
                      re_name: "吉安乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713525,
                      re_parent: 713500,
                      re_name: "寿丰乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713526,
                      re_parent: 713500,
                      re_name: "光复乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713527,
                      re_parent: 713500,
                      re_name: "丰滨乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713528,
                      re_parent: 713500,
                      re_name: "瑞穗乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713529,
                      re_parent: 713500,
                      re_name: "富里乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713530,
                      re_parent: 713500,
                      re_name: "秀林乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713531,
                      re_parent: 713500,
                      re_name: "万荣乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713532,
                      re_parent: 713500,
                      re_name: "卓溪乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713600,
              re_parent: 710000,
              re_name: "澎湖县",
              re_level: "2",
              children: [
                  {
                      re_id: 713601,
                      re_parent: 713600,
                      re_name: "马公市",
                      re_level: "3"
                  },
                  {
                      re_id: 713621,
                      re_parent: 713600,
                      re_name: "湖西乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713622,
                      re_parent: 713600,
                      re_name: "白沙乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713623,
                      re_parent: 713600,
                      re_name: "西屿乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713624,
                      re_parent: 713600,
                      re_name: "望安乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713625,
                      re_parent: 713600,
                      re_name: "七美乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713700,
              re_parent: 710000,
              re_name: "金门县",
              re_level: "2",
              children: [
                  {
                      re_id: 713701,
                      re_parent: 713700,
                      re_name: "金城镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713702,
                      re_parent: 713700,
                      re_name: "金湖镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713703,
                      re_parent: 713700,
                      re_name: "金沙镇",
                      re_level: "3"
                  },
                  {
                      re_id: 713704,
                      re_parent: 713700,
                      re_name: "金宁乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713705,
                      re_parent: 713700,
                      re_name: "烈屿乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713706,
                      re_parent: 713700,
                      re_name: "乌丘乡",
                      re_level: "3"
                  }
              ]
          },
          {
              re_id: 713800,
              re_parent: 710000,
              re_name: "连江县",
              re_level: "2",
              children: [
                  {
                      re_id: 713801,
                      re_parent: 713800,
                      re_name: "南竿乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713802,
                      re_parent: 713800,
                      re_name: "北竿乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713803,
                      re_parent: 713800,
                      re_name: "莒光乡",
                      re_level: "3"
                  },
                  {
                      re_id: 713804,
                      re_parent: 713800,
                      re_name: "东引乡",
                      re_level: "3"
                  }
              ]
          }
      ]
  },
  {
      re_id: 810000,
      re_parent: 100000,
      re_name: "香港特别行政区",
      re_level: "1",
      children: [
          {
              re_id: 810100,
              re_parent: 810000,
              re_name: "香港特别行政区",
              re_level: "2",
              children: []
          },
      ]
  },
  {
      re_id: 820000,
      re_parent: 100000,
      re_name: "澳门特别行政区",
      re_level: "1",
      children: [
          {
              re_id: 820100,
              re_parent: 820000,
              re_name: "澳门特别行政区",
              re_level: "2",
              children: []
          },
      ]
  },
]